// Japan
export const locale = {
	lang: 'jp',
	data: {
		WHAT_IF: {
			SIMULATION: { ACTUAL_VALUE: '実測値' },
			GRAPH: {
				BASELINE_TIMESTAMP: 'ベースラインのタイムスタンプ',
				NO_DATA: 'データがありません。',
				RUN_SIMULATION_TITLE: 'シミュレーションを実行するとグラフ結果が表示されます',
				RUN_SIMULATION_HINT: 'シミュレーション条件を設定後、「実行」を選択してください。',
				RAW_TAG_DEPENDENCY: '入力タグ依存関係',
				BASELINE: 'ベースライン',
				SIMULATION: 'シミュレーション',
				SIMULATED: 'シミュレーション値',
			},
			SEARCH: {
				PLACEHOLDER: '施設、システム、ユニット、タグを検索',
				SEARCHING: '検索中…',
				NO_RESULTS: '一致する項目がありません',
				ERROR: '検索に失敗しました。もう一度お試しください。',
			},
			TABLE: {
				DELTA_TOOLTIP: '絶対変化（シミュレーション − ベースライン）',
				DELTA_PERCENT_TOOLTIP: 'ベースラインからの変化率',
				IMPACT_PROGRESS: '影響の進捗',
				IMPACT: '影響',
			},
			IMPACTED_KPI: {
				TITLE: '影響を受ける計算済みKPI ({{count}})',
				NO_IMPACTED_KPIS: '影響を受けるKPIはまだありません',
				EMPTY_HINT: '左側で生タグを選択すると、下流のKPIへの影響が表示されます。',
				LOADING: '計算タグを読み込み中...',
				SELECTION_HINT: 'プライマリシステムで{{total}}件中{{checked}}件のKPIが選択されています — シミュレーションから除外するにはチェックを外してください。「Driven by」チップは、どの生タグが各KPIに影響するかを示します。同じタグシグネチャを共有する兄弟システムは、読み取り専用のシステム横断的な影響として以下に表示されます。',
				CROSS_SYSTEM_IMPACT: 'システム横断的な影響',
				KPI_COUNT: '{{count}}件のKPI',
				TAG_PARAMETER: 'タグ / パラメータ',
				CALCULATED_TAG: '計算タグ',
				DRIVEN_BY: '要因:',
			},
			PAGE: {
				TITLE: 'What-If',
				SELECT_RAW_TAGS_TITLE: 'シミュレートする生タグを選択',
				SELECT_RAW_TAGS_SUBTITLE: '下の階層からタグを選択してください',
				SIMULATION_SETUP_TITLE: 'シミュレーション設定',
				SIMULATION_SETUP_SUBTITLE: '上のタグを選択して開始してください',
				RUN: '実行',
				RESET: 'リセット',
				NO_TAGS_SELECTED: 'タグが選択されていません',
				NO_TAGS_SELECTED_DESC: '上の生タグを選択して変更を定義してください。',
				CLICK_TIMESTAMP_HINT: 'プロット上の任意の場所をクリックして、運転状態のタイムスタンプを選択してください。',
				CLICK_RANGE_HINT: 'プロットを2回クリックして、運転状態の範囲を選択してください。',
				SELECTED_OPERATING_STATE: '選択された運転状態:',
				SELECTED_OPERATING_RANGE: '選択された運転範囲:',
				FIRST_POINT_PREFIX: '最初のポイント:',
				FIRST_POINT_SUFFIX: '— 範囲の終点を設定するにはもう一度クリックしてください。',
				SIMULATION_RESULTS: 'シミュレーション結果',
				TABLE_VIEW: 'テーブルビュー',
				RUN_SIMULATION_TABLE_TITLE: 'シミュレーションを実行してテーブル結果を表示',
				TABLE_UNAVAILABLE_PERIOD: '期間シミュレーションではテーブルビューは使用できません',
				SWITCH_TO_SINGLE_POINT: '「単一ポイント」モードに切り替えるか、グラフビュータブを使用してください。',
				NO_KPI_ROWS: '表示するKPI行がありません',
				NO_KPI_ROWS_DESC: '影響を受けるすべてのKPIのチェックが外れています。ここに表示するには、影響を受けるKPIタブでKPIを選択してください。',
				GRAPH_VIEW: 'グラフビュー',
				SIMULATION_TYPE_PERCENT: 'パーセント変化',
				SIMULATION_TYPE_ABSOLUTE: '絶対値',
				TIME_CONTEXT_SINGLE: '単一時点',
				TIME_CONTEXT_PERIOD: '期間',
			},
			IMPACTED_KPIS_TAB_LABEL: '影響を受けるKPI',
			IMPACTED_KPIS_TAB_LABEL_COUNT: '影響を受けるKPI ({{count}})',
			HIERARCHY_TOOLTIP: {
				TAG_NAME: 'タグ名',
				TAG_ID: 'タグID',
				TAG_DESCRIPTION: '説明',
				ASSET_NAME: 'アセット名',
				SYSTEM_NAME: 'システム名',
			},
		},
		TRANSLATOR: {
			SELECT: '表示言語を選択',
		},
		VALIDATION: {
			REQUIRED: 'この項目は必須です',
			PATTERN: '形式が正しくありません',
			MIN: '値が小さすぎます',
			MAX: '値が大きすぎます',
			MIN_LENGTH: '値が短すぎます',
			MAX_LENGTH: '値が長すぎます',
			SELECT_AT_LEAST_ONE: '少なくとも1つのオプションを選択してください',
			INVALID: '無効な値です',
			FIELD_REQUIRED: '{{field}}は必須です',
		},
		COMMON: {
			NO_MATCHES: '"{{keyword}}" の結果が見つかりません',
			TRY_DIFFERENT_KEYWORD_CLEAR_SEARCH: '別のキーワードを試すか、検索をクリアしてください',
			SELECT_A_SYSTEM: 'システムを選択してください。',
			SELECT_DIFF_UNIT: '別のユニットまたは設備を選択してください',
			SELECT_DIFF: '別の設備、ユニット、またはシステムを選択してください',
			NO_TAGS_FOUND: 'タグが見つかりません',
			SELECT_FACILITY: '別の設備を選択してください',
			ADDED_FROM_ROOTY: '{{name}}から追加',
		},
		COMMENT_POPUP: {
			TITLE: 'コメントを残す',
			ENTER_MESSAGE: 'メッセージを入力してください',
			COMMENT_PLACEHOLDER: 'コメントを追加し、@でチームメンバーをタグ付け',
			FILE_SIZE_LIMIT_ERROR: 'ファイルサイズの制限により{{fileName}}をアップロードできませんでした。',
			UPLOAD_FAILED_ERROR: '{{fileName}}のアップロードに失敗しました。',
			INVALID_FILES_ERROR: '有効なファイルが選択されていません。拡張子{{extensions}}のファイルのみ許可されています',
		},
		REGENERATE_HYPOTHESES_POPUP: {
			TITLE: '仮説を再生成',
			DESCRIPTION: '因果連鎖、推奨事項、提案された証拠に対して提供されたフィードバックに基づき、すべての仮説を再生成します。現在のバージョンは履歴に保存されます。',
			REGENERATION_CONTEXT: '再生成コンテキスト',
			TOTAL_FEEDBACKS: 'フィードバック件数',
			ADDED_AS_EVIDENCE: '証拠として追加済み',
			APPROVED: '承認済み',
			RELEARNED: '再学習済み',
			SETTINGS: '設定',
			DOCUMENT_INSIGHTS: 'ドキュメントインサイト',
			SAP_INSIGHTS: 'SAPインサイト',
			CONNECTED_SYSTEMS_REVIEW: '関連システムのレビュー',
			ALERT_REVIEW_WINDOW: 'アラートレビュー期間',
			DAYS: '日',
			RESET_AND_RERUN: 'リセットして再実行',
			RESET_AND_RERUN_INFO: '過去の仮説、フィードバック、推奨事項、提案された証拠を無視します。最新の利用可能なデータのみを使用して、根本原因分析を最初から生成します。',
			VERSION_HISTORY_NOTE: '現在の仮説はバージョン履歴に保存されます。以前のバージョンはいつでも復元できます。',
			USER_CONSENT: '今回の実行では、これまでの根本原因分析コンテキストが使用されないことを理解しています。',
			CANCEL: 'キャンセル',
			REGENERATE_ALL: 'すべて再生成',
			REGENERATE_ALL_TOOLTIP: '既存のコンテキストを使用して現在の根本原因分析を改善します',
			RESET_AND_RERUN_BTN: 'リセットして再実行',
			RESET_AND_RERUN_TOOLTIP: '新しい根本原因分析を最初から生成します',
		},
		SHARE_REPORT_POPUP: {
			TITLE: 'レポートを共有',
			ADD_PEOPLE: 'メンバーを追加',
			MESSAGE: 'メッセージ',
			MESSAGE_PLACEHOLDER: 'メッセージを入力（任意）',
			COPY_LINK: 'リンクをコピー',
			CANCEL: 'キャンセル',
			SEND: '送信',
		},
		FEEDBACK_POPUP: {
			PREVIOUSLY_APPROVED: '以前に承認済み',
			PREVIOUSLY_RELEARNED: '以前に再学習済み',
			SEE_LESS: '表示を減らす',
			SEE_MORE: 'もっと見る...',
			FEEDBACK_LABEL: 'フィードバック',
			FEEDBACK_TOOLTIP: 'このフィードバックはRCAの再実行時に使用されます。',
			CANCEL: 'キャンセル',
			CONFIRM: '確認',
			RELEARNED_BY: '再学習者:',
			NO_REASON_ADDED: '理由が追加されていません',
		},
		ASK_ROOTY_POPUP: {
			ENTER_MESSAGE_TO_START: 'メッセージを入力してチャットを開始してください',
			MESSAGE_PLACEHOLDER: 'メッセージを入力してください...',
		},
		ROOTY_CHAT: {
			FOLLOW_UP_SUGGESTIONS: '次の質問候補',
			ASK_TITLE: '{{name}}に質問',
			UPLOAD_TOOLTIP: '{{name}}が解析できるように、PDF、Word、Excel、PNG、JPG、JPEGファイルをアップロードしてください。',
			DISCLAIMER: '{{name}}はAIによる回答を提供しており、必ずしも正確でない場合があります。実行前にご確認ください。',
			FEEDBACK_SUBTITLE: '今後の{{name}}の回答改善のため、主な問題を選択してください。',
			POPUP_TITLE: '{{name}}に質問',
			NOT_ENABLED: '現在のユーザーには{{name}}が有効になっていません。',
			SHARE: '共有',
			RENAME: '名前を変更',
			DELETE: '削除',
			HISTORY: '履歴',
			CLOSE: '閉じる',
			SEARCH: '検索...',
			UNSAVED: '未保存',
			NO_HISTORY_HEADING: '履歴がありません。',
			NO_HISTORY_DESC: '過去のデータが見つかりませんでした。',
			START_NEW_CHAT: '新しいチャットを開始',
			AGENT_CONTEXT_TOOLTIP: 'エージェントコンテキスト',
			CHAT_HISTORY_TOOLTIP: 'チャット履歴',
			UNPIN: 'ピン留めを解除',
			PIN: 'ピン留め',
			FULL_SCREEN: '全画面表示',
			EXIT_FULL_SCREEN: '全画面表示を終了',
			EXPAND: '展開',
			COLLAPSE: '折りたたむ',
			INTRO_TITLE: 'こんにちは!表示中の内容について何かお手伝いしましょうか?',
			INTRO_DESC: '何でも聞いてください。この画面の要約、傾向の説明、項目の比較、次のステップの提案もできます。',
			SUGGESTIONS: '提案',
			SUGGESTION_1: 'このRCAを30秒で要約してください(何が起きたか、なぜか)。',
			SUGGESTION_2: 'ここに示されている証拠から最も支持される仮説はどれですか?',
			SUGGESTION_3: '仮説を比較してください:それぞれの最も強力な証拠は何ですか?',
			CP_INTRO_TITLE: 'こんにちは!キャパシティ最適化とシナリオプランニングについてお手伝いしましょうか?',
			CP_INTRO_DESC: '計画モデルの構築、ユニットトリップ時の対応検証、ピーク負荷増加のシミュレーション、電力と水の実現可能性の分析をお手伝いします。',
			CP_SUGGESTION_1: 'このランの総発電コスト、燃料消費量、発電所別の内訳を要約してください。',
			CP_SUGGESTION_2: 'スピニングリザーブの余裕はどれくらいですか?不足する時間帯はありますか?',
			CP_SUGGESTION_3: 'ピーク需要時にH5_GTがトリップした場合はどうなりますか?',
			CP_SUGGESTION_4: 'このシナリオでピーク電力需要を+5%増加させてシミュレーションしてください。',
			LOADING_EARLIER: '以前の会話を読み込み中…',
			SHOW_EARLIER: '以前の会話を表示',
			RESPONSE_STOPPED: '応答の生成が停止されました',
			LOADING_ALT: '読み込み中',
			THINKING: '考え中',
			THOUGHT_FOR: '{{seconds}}秒考えました',
			DOWNLOAD_CSV: 'CSVをダウンロード',
			COPY_CSV: 'CSVをコピー',
			DOWNLOAD_IMAGE: '画像をダウンロード',
			COPY_IMAGE: '画像をコピー',
			WHAT_IF_SCENARIO_CREATED: 'What-Ifシナリオが作成されました',
			CHANGE_APPLIED: '適用された変更:',
			NEW_SCENARIO: '新しいシナリオ:',
			VIEW_CONFIGURATION: '構成を表示',
			RUN_OPTIMIZATION: '最適化を実行',
			RESULTS_COMPARISON: '結果の比較',
			ALL_IMPROVED: 'すべて改善',
			KPI: 'KPI',
			BASE: 'ベース',
			WHAT_IF: 'What-If',
			YES: 'はい',
			NO: 'いいえ',
			CHANGED: '変更あり',
			WHATIF_KPI_POWER_FEASIBLE: '電力実現可能性',
			WHATIF_KPI_WATER_FEASIBLE: '水量実現可能性',
			WHATIF_KPI_EST_COST: '概算コスト',
			WHATIF_KPI_POWER_SHORTFALL: '電力不足量',
			WHATIF_KPI_WATER_SHORTFALL: '水量不足量',
			WHATIF_KPI_AVG_GENERATION: '平均発電量',
			WHATIF_KPI_AVG_HEADROOM: '平均余裕度',
			WHATIF_KPI_TOTAL_STARTS: '起動回数合計',
			WHATIF_KPI_AVG_WATER_OUTPUT: '平均送水量',
			WHATIF_KPI_GAP_PERCENT: '差分（%）',
			WHATIF_POWER_BALANCE: '電力収支（MW）',
			WHATIF_TIME_AXIS: '時間',
			WHATIF_POWER_AXIS: '電力（MW）',
			WHATIF_WATER_OUTPUT: '送水量（MIGD）',
			WHATIF_WATER_AXIS: '水量（MIGD）',
			WHATIF_TRACE_DEMAND: '需要',
			WHATIF_TRACE_GEN: '発電',
			WHATIF_TRACE_WATER: '水量',
			NO_MAJOR_DIFF: '2つのシナリオ間でKPIは5%以上変化していません。',
			VIEW_FULL_RESULTS: 'すべての結果を表示',
			APPLY_AS_EVIDENCE: '根拠として適用',
			ADDED_AS_EVIDENCE: '根拠として追加済み',
			ALREADY_ADDED_AS_EVIDENCE: 'すでに根拠として追加されています',
			ADD_AS_EVIDENCE: '根拠として追加',
			BRANCH_VISIBILITY_NOTICE: '新しいメッセージはあなたにのみ表示されます。',
			CONTINUE: '続ける',
			SEARCH_SCENARIOS: 'シナリオを検索...',
			FILTER_SCENARIOS: 'シナリオをフィルター',
			SOURCE: 'ソース',
			ALL_SOURCES: 'すべてのソース',
			HUMAN_MANUAL: '手動(人間)',
			AI_GENERATED: 'AI生成',
			STRATEGY_AUTO: '戦略(自動)',
			DATE_MODIFIED: '更新日',
			ALL_TIME: 'すべての期間',
			TODAY: '今日',
			LAST_7_DAYS: '過去7日間',
			RECENT: '最近',
			OFFICIAL: '公式',
			ALL_SCENARIOS: 'すべてのシナリオ',
			NO_SCENARIOS_MATCH: '「{{query}}」に一致するシナリオはありません',
			DRAFT: '下書き',
			DISMISS: '閉じる',
			CONTEXT_PREFIX: 'コンテキスト:',
			REMOVE_CONTEXT: 'コンテキストを削除',
			SELECT_A_SCENARIO: 'シナリオを選択',
			CLEAR_SCENARIO: 'シナリオをクリア',
			LATEST_RUN_DEFAULT: '最新の実行(デフォルト)',
			DROP_FILES_HERE: 'ここにファイルをドロップ',
			COMPOSER_PLACEHOLDER: '質問やリクエストを入力してください...',
			ADD_FILES_OR_IMAGES: 'ファイルや画像を追加',
			LANGUAGE: '言語',
			MIC_BLOCKED: 'マイクへのアクセスがブロックされています。マイクの許可を有効にしてください',
			USE_VOICE_INPUT: '音声入力を使用',
			VOICE_INPUT_ALT: '音声入力',
			STOP_RECORDING: '録音を停止',
			STOP_RECORDING_ALT: '録音を停止',
			STOP_GENERATION: '生成を停止',
			SEND_ALT: '送信',
			FEEDBACK_WHAT_WENT_WRONG: 'この回答の何が問題でしたか?',
			FEEDBACK_CATEGORY: 'フィードバックカテゴリ',
			SELECT_AN_ISSUE: '問題を選択してください',
			SELECT_CATEGORY_TO_CONTINUE: '続行するにはカテゴリを選択してください',
			ADDITIONAL_DETAILS_OPTIONAL: '追加の詳細(任意)',
			FEEDBACK_COMMENT_PLACEHOLDER: '何が問題だったか詳しく教えてください。',
			CANCEL: 'キャンセル',
			SUBMIT_FEEDBACK: 'フィードバックを送信',
			ERROR: 'エラー',
			FEEDBACK_SUBMIT_ERROR: 'フィードバックを送信できませんでした。もう一度お試しください。',
			TRY_AGAIN: '再試行',
			OPEN_LINK: 'リンクを開く',
			OPEN_DOCUMENT: 'ドキュメントを開く',
			PAGE_PREFIX: 'ページ-{{page}}',
			FEEDBACK_CATEGORY_INCORRECT_ANSWER: '誤った回答',
			FEEDBACK_CATEGORY_DID_NOT_ANSWER: '質問に答えなかった',
			FEEDBACK_CATEGORY_MISSING_DATA: '関連データが不足',
			FEEDBACK_CATEGORY_INCORRECT_REASONING: '誤った分析または推論',
			FEEDBACK_CATEGORY_POOR_CHART: '不十分なチャートまたは可視化',
			FEEDBACK_CATEGORY_POOR_DOCUMENT: '不十分なドキュメント回答',
			FEEDBACK_CATEGORY_TOO_SLOW: 'クエリが遅すぎた',
			FEEDBACK_CATEGORY_INCOMPLETE: '回答が不完全だった',
			FEEDBACK_CATEGORY_OTHER: 'その他',
			CHATBOT_PRIVATE: 'プライベート',
			CHATBOT_INHOUSE_GPT: 'Inhouse GPT',
			LANGUAGE_ENGLISH_US: '英語(米国)',
			LANGUAGE_ARABIC: 'アラビア語',
			MODE_AUTO: '自動',
			MODE_GENERAL: '一般',
			MODE_DOCS: 'ドキュメント',
			MODE_OPTIMIZER: 'オプティマイザー',
			DATE_TODAY: '今日',
			DATE_YESTERDAY: '昨日',
			DATE_THIS_WEEK: '今週',
			DATE_LAST_WEEK: '先週',
			DATE_THIS_MONTH: '今月',
			DATE_LAST_MONTH: '先月',
			DATE_OLDER: 'それ以前',
			CONTEXT: {
				FROM: '{{source}}からのコンテキスト',
				LAUNCHED_FROM: '{{source}}からRootyを起動',
				UPDATED: 'コンテキストが更新されました',
				REMOVED: 'コンテキストが削除されました',
				APPLIED: 'コンテキストが適用されました',
				GENERAL: '現在は一般的なチャットコンテキストを使用しています',
				MORE: 'もっと見る',
				SEE_LESS: '閉じる',
				LABEL: {
					ALERT: 'アラート',
					RCA: 'RCA',
					SCOPE: '範囲',
					SYSTEM: 'システム',
					SCENARIO: 'シナリオ',
					SIMULATION_TYPE: 'シミュレーションタイプ',
					PREVIOUS: '以前',
					NEW: '新規',
					SOURCE: 'ソース',
				},
				SOURCE: {
					ALERT: 'アラート詳細',
					RCA: 'RCA',
					SYSTEM: 'システムビュー',
					WHAT_IF: 'What-if分析',
				},
				SUMMARY: {
					ALERT: 'アラート {{value}}',
					RCA: 'アラート {{value}} のRCA',
					SYSTEM: 'システム {{value}}',
					WHAT_IF: 'What-if: {{value}}',
				},
			},
			TOAST_FEEDBACK_THANKS: 'ありがとうございます。Rootyの改善に活用させていただきます。',
			TOAST_FEEDBACK_POSITIVE_THANKS: 'フィードバックありがとうございます。',
			TOAST_COPIED_MESSAGE: 'メッセージをコピーしました。',
			TOAST_LINK_COPIED: 'コピーしました',
			TOAST_CHAT_DELETED: 'チャットを削除しました',
			TOAST_CHAT_DELETE_FAILED: 'チャットの削除に失敗しました。',
			TOAST_NEW_CHAT_STARTED: '新しいチャットを開始しました',
		},
		AGENT_CONTEXT: {
			CONSIDERED: '考慮されたエージェントコンテキスト',
			ITEMS: '件',
			ADD: 'エージェントコンテキストを追加',
			UPDATED: '更新',
			DIALOG_DESC: '{{name}}とRCAのために再利用可能な運用ガイダンスを記録します。',
			DIALOG_DISCLAIMER: 'このコンテキストは、該当する分析における今後の{{name}}およびRCAの回答に影響する可能性があります。異常検知や予測モデルには影響しません。',
			SIDEPANEL_DESC: '{{name}}とRCAが利用できる再利用可能な運用知識です。',
			SIDEPANEL_EMPTY: '推論ガイダンス、調査プレイブック、用語集など、{{name}}とRCAのために再利用可能な運用知識を記録します。',
			REMOVE_CONFIRM: '「<strong>{{title}}</strong>」は削除され、{{name}}またはRCAで今後考慮されなくなります。<br>この操作は元に戻せません。',
			TITLE: 'エージェントコンテキスト',
			READ_ONLY: '読み取り専用',
			ADD_SHORT: '追加',
			CLOSE: '閉じる',
			SEARCH_PLACEHOLDER: 'タイトルまたは範囲で検索...',
			EDIT: '編集',
			DELETE: '削除',
			EMPTY_HEADING: 'エージェントコンテキストはまだありません',
			LAST_UPDATED_PREFIX: '最終更新',
			BY_PREFIX: '作成者',
			SECTION_CONTEXT_TYPE: '1. コンテキストタイプ',
			SECTION_SCOPE: '2. 範囲',
			SECTION_CONTEXT: '3. コンテキスト',
			SELECT_SCOPE: '範囲を選択',
			CONTEXT_TITLE_LABEL: 'タイトル',
			CONTEXT_TITLE_PLACEHOLDER: 'コンテキストタイトルを入力',
			GUIDANCE_LABEL: 'ガイダンスの説明',
			GUIDANCE_PLACEHOLDER: 'ガイダンスの説明を入力',
			PLAYBOOK_NAME_LABEL: 'プレイブック名',
			PLAYBOOK_NAME_PLACEHOLDER: 'プレイブック名を入力',
			INVESTIGATION_STEPS_LABEL: '調査手順',
			STEP_PLACEHOLDER: '手順の説明を入力',
			ADD_STEP: '+ 手順を追加',
			TERM_HEADER: '用語',
			MEANING_HEADER: '意味',
			TERM_PLACEHOLDER: '用語を追加',
			MEANING_PLACEHOLDER: '意味を入力',
			CANCEL: 'キャンセル',
			CARD_REASONING_GUIDANCE_TITLE: '推論ガイダンス',
			CARD_REASONING_GUIDANCE_DESC: 'AIエージェントが挙動を推論するのに役立つ、プラント固有の解釈ルール。',
			CARD_INVESTIGATION_PLAYBOOK_TITLE: '調査プレイブック',
			CARD_INVESTIGATION_PLAYBOOK_DESC: '繰り返し発生する運用上の問題に対する構造化されたトラブルシューティングワークフロー。',
			CARD_TERMINOLOGY_TITLE: '用語集',
			CARD_TERMINOLOGY_DESC: 'プラント固有のエイリアス、略語、命名規則。',
			SAVE_IN_PROGRESS: '保存中です。お待ちください。',
			SCOPE_REQUIRED: '保存する前に範囲を選択してください。',
			TITLE_REQUIRED: '保存する前にタイトルが必要です。',
			GUIDANCE_DESC_REQUIRED: '保存する前にガイダンスの説明が必要です。',
			PLAYBOOK_NAME_REQUIRED: '保存する前にプレイブック名が必要です。',
			STEPS_REQUIRED: '保存する前にすべての調査手順を入力する必要があります。',
			TERMINOLOGY_REQUIRED: '保存する前に、すべての用語エントリに用語と意味の両方が必要です。',
			SOME_ERROR_OCCURRED: 'エラーが発生しました',
			EDIT_TITLE: 'エージェントコンテキストを編集',
			SAVE_CHANGES: '変更を保存',
			DELETE_CONTEXT_TITLE: 'このコンテキストを削除しますか？',
			DELETED_SUCCESSFULLY: '正常に削除されました。',
		SECTION_GUIDANCE: 'ガイダンス',
		TERMS_LABEL: '用語',
		REASONING_LABEL: '推論',
		PLAYBOOK_LABEL: 'プレイブック',
		},
		MENU: {
			NEW: '新規',
			ACTIONS: '操作',
			CREATE_POST: '新しい投稿を作成',
			PAGES: 'ページ',
			FEATURES: '機能',
			APPS: 'アプリ',
			HOME: 'ホーム',
			SYSTEM: 'システム',
			ANALYSIS: '解析',
			CONFIGURATION: '設定',
			ALERTS: 'アラート',
			ALERT_TRIAGE: 'アラートトリアージ',
			KNOWLEDGE_GRAPH: 'ナレッジグラフ',
			ASSET_EXPLORER: 'アセットエクスプローラー',
			LIBRARY: 'ライブラリ',
			USER_MANAGEMENT: 'ユーザー管理',
			MODEL_WIZARD: 'モデルウィザード',
			DASHBOARD_WIZARD: 'ダッシュボードウィザード',
			IOW: 'IOW',
			PROCESS: 'プロセス',
			GENAI: '生成AI',
			MAINTENANCE_OPTIMIZATION: '保全最適化',
			RCM: 'RCM',
			SETTINGS: '設定',
			HAZOP: 'HAZOP',
			CASES: 'ケース',
			CAPACITY_OPTIMIZATION: '能力最適化',
			WHAT_IF: 'ホワットイフ分析',
			HEALTH_METRICS: '健全性指標',
			PLATFORM_CONFIGURATION: 'プラットフォーム設定',
			DATA_MANAGEMENT: 'データ管理',
			PLATFORM_POLICIES: 'プラットフォームポリシー',
			CONNECTIONS_APIS: '接続・API',
			MODULE_CONFIGURATION: 'モジュール設定',
			AI_MANAGEMENT: 'AI管理',
			ROOTY: '{{name}}',
			NOTIFICATION: '通知',
			HELP: 'ヘルプ',
			PROFILE: 'マイプロフィール',
			LOGOUT: 'ログアウト',
			LANGUAGE: '言語',
			BASIC_USER_GUIDE: 'ベーシックユーザーガイド',
			ADVANCED_USER_GUIDE: 'アドバンストユーザーガイド',
		},
		AUTH: {
			PASSWORD_REQUIREMENTS: {
				TITLE: 'パスワードの要件：',
				MIN_CHARACTERS: '8文字以上',
				UPPERCASE_LETTER: '大文字1文字以上',
				NUMBER: '数字1文字以上',
				SPECIAL_CHARACTER: '記号1文字以上',
			},
			GENERAL: {
				OR: 'または',
				SUBMIT_BUTTON: '送信',
				NO_ACCOUNT: 'アカウントをお持ちでない場合',
				SIGNUP_BUTTON: 'サインアップ',
				FORGOT_BUTTON: 'パスワードをお忘れですか',
				BACK_BUTTON: '戻る',
				PRIVACY: 'プライバシー',
				LEGAL: '法務',
				CONTACT: 'お問い合わせ',
				VERIFY_BUTTON: '確認',
				ENTER_OTP: 'OTPを入力',
				HAVE_ACCOUNT: 'アカウントをお持ちです',
			},
			LOGIN: {
				TITLE: 'ログイン',
				BUTTON: 'サインイン',
				SIGN_IN_MICROSOFT: 'Microsoftでサインイン',
				SIGN_IN_SAML: 'SAMLでサインイン',
				REMEMBER_ME: 'ログイン状態を保持',
				SIGNING_IN: 'サインイン中です。しばらくお待ちください...',
				BPCL_WELCOME: 'BPCLのAIベース資産性能ソリューションへようこそ！',
			},
			RESET: {
				TITLE: 'パスワード再設定',
				SUCCESS: 'パスワードを変更しました。',
				NEWPASSWORD: '新しいパスワード',
				REENTERNEWPASSWORD: 'パスワード確認',
				VERIFICATION_CODE_SENT: '送信先に確認コードを送信しました：',
				NO_CODE_RECEIVED: 'コードが届きませんか？',
				RESEND: '再送信',
				RESEND_IN: '残り',
			},
			FORGOT: {
				TITLE: 'パスワードをお忘れですか',
				DESC: 'パスワード再設定用のメールアドレスを入力してください',
				SUCCESS: 'OTPをメールで送信しました。',
				REQUEST_RESET_BUTTON: 'パスワード再設定をリクエスト',
				BACK_TO_SIGNIN: 'サインインに戻る',
			},
			REGISTER: {
				TITLE: 'サインアップ',
				DESC: 'アカウント作成に必要な情報を入力してください',
				SUCCESS: 'アカウント登録が完了しました。',
				ORGANIZATION_NAME: '組織名',
				NAME: '名前',
				AGREE_PREFIX: '以下に同意します：',
				TERMS_CONDITIONS: '利用規約',
				EMAIL_ALREADY_REGISTERED: 'このメールアドレスは既に登録されています。',
			},
			INPUT: {
				EMAIL: 'メールアドレス',
				EMAIL_ADDRESS: 'メールアドレス',
				FULLNAME: '氏名',
				PASSWORD: 'パスワード',
				CONFIRM_PASSWORD: 'パスワード確認',
				USERNAME: 'ユーザー名'
			},
			PLACEHOLDER:{
				EMAIL: 'メールアドレスを入力',
				PASSWORD: 'パスワードを入力'
			},
			VERIFY:{
				VERIFY_EMAIL: 'メール認証',
				BACK_TO_SIGNIN: 'サインインに戻る',
			},
			SUBSCRIPTION: {
				EXPIRED: 'サブスクリプションの有効期限が切れています。',
				RENEW: '今すぐ更新するか、サポートにお問い合わせください。',
			},
			VALIDATION: {
				INVALID: '{{name}}が正しくありません',
				INVALID_EMAIL: '有効なメールアドレスを入力してください',
				REQUIRED: '{{name}}は必須です',
				MIN_LENGTH: '{{name}}は{{min}}文字以上で入力してください',
				AGREEMENT_REQUIRED: '利用規約への同意が必要です',
				NOT_FOUND: '指定された{{name}}が見つかりません',
				INVALID_LOGIN: 'ログイン情報が正しくありません',
				INVALID_RESET: '入力されたOTPが正しくないか、有効期限が切れています。もう一度お試しください。',
				REQUIRED_FIELD: '必須項目',
				MIN_LENGTH_FIELD: '最小文字数:',
				MAX_LENGTH_FIELD: '最大文字数:',
				INVALID_FIELD: '入力値が正しくありません',
				OTP_REQUIRED: 'メールに送信された確認コードを入力してください。'
			}
		},
		ECOMMERCE: {
			COMMON: {
				SELECTED_RECORDS_COUNT: '選択レコード数: ',
				ALL: 'すべて',
				SUSPENDED: '停止中',
				ACTIVE: '有効',
				FILTER: 'フィルター',
				BY_STATUS: 'ステータス別',
				BY_TYPE: 'タイプ別',
				BUSINESS: '法人',
				INDIVIDUAL: '個人',
				SEARCH: '検索',
				IN_ALL_FIELDS: 'すべての項目'
			},
			ECOMMERCE: 'eコマース',
			CUSTOMERS: {
				CUSTOMERS: '顧客',
				CUSTOMERS_LIST: '顧客一覧',
				NEW_CUSTOMER: '新規顧客',
				DELETE_CUSTOMER_SIMPLE: {
					TITLE: '顧客削除',
					DESCRIPTION: 'この顧客を完全に削除しますか。',
					WAIT_DESCRIPTION: '顧客を削除しています...',
					MESSAGE: '顧客を削除しました'
				},
				DELETE_CUSTOMER_MULTY: {
					TITLE: '顧客一括削除',
					DESCRIPTION: '選択した顧客を完全に削除しますか。',
					WAIT_DESCRIPTION: '顧客を削除しています...',
					MESSAGE: '選択した顧客を削除しました'
				},
				UPDATE_STATUS: {
					TITLE: '選択した顧客のステータスを更新しました',
					MESSAGE: '選択した顧客のステータス更新が完了しました'
				},
				EDIT: {
					UPDATE_MESSAGE: '顧客情報を更新しました',
					ADD_MESSAGE: '顧客を作成しました'
				}
			}
		},
		HEALTH_METRICS: {
			TITLE: '健全性指標',
			SYSTEM_MODEL_METRICS: 'システムおよびモデルの健全性指標',
			DATA_FEED_HEALTH: 'データフィード健全性',
			QC_CHECK: 'QCチェック',
			QC: {
				RAW_TAG_QC: '生タグQC',
				CALCULATED_TAG_QC: '計算タグQC',
				MODEL_QC: 'モデルQC',
				COMING_SOON: '近日公開',
				CONFIGURATION: 'QCチェック設定',
				ALL_TAGS: 'すべてのタグ',
				PROBLEM_TAGS: '問題タグ',
				SEARCH: '検索...',
				COLUMN_CONFIG: '列の設定',
				ADD_TAG: 'タグを追加',
				EXPORT: 'エクスポート',
				UPLOAD: 'タグをアップロード (Excel)',
				DOWNLOAD: 'タグをダウンロード (Excel)',
				VIEW: '表示',
				EDIT: '編集',
				NO_TAGS_FOUND: 'タグが見つかりません',
				ADD_DESCRIPTION: '説明を追加',
				ADD_UOM: '単位を追加',
				COL_INDEX: '#',
				COL_SYSTEM_NAME: 'システム名',
				COL_TAG_NAME: 'タグ名',
				COL_TAG_ID: 'タグID',
				COL_TAG_DESCRIPTION: 'タグ説明',
				COL_UOM: '単位',
				COL_IR_UPPER: 'IR上限',
				COL_TRIP_UPPER: 'トリップ上限',
				COL_ALARM_UPPER: 'アラーム上限',
				COL_THRES_UPPER: '閾値上限',
				COL_OPS_UPPER: '運転上限',
				COL_OPS_LOWER: '運転下限',
				COL_THRES_LOWER: '閾値下限',
				COL_ALARM_LOWER: 'アラーム下限',
				COL_TRIP_LOWER: 'トリップ下限',
				COL_IR_LOWER: 'IR下限',
				COL_FLATLINE: 'フラットライン検出',
				COL_OUTLIER: '外れ値検出',
				COL_RANGE: '範囲外検出',
				COL_MISSING_DATA: '欠損データ検出',
				COL_FLATLINE_ALERT: 'フラットラインアラート生成',
				COL_OUTLIER_ALERT: '外れ値アラート生成',
				COL_RANGE_ALERT: '範囲外アラート生成',
				COL_MISSING_DATA_ALERT: '欠損データアラート生成',
				COL_ATTENTION: '注意',
				COL_THRES_NOT: '閾値通知',
				COL_KPI: 'KPI',
				COL_DIRECTIONALITY: '方向性',
				COL_IOW_LOWER: 'IOW 下限',
				COL_IOW_UPPER: 'IOW 上限',
				COL_ACTIONS: '操作',
				COL_DESCRIPTION: '説明',
				EDIT_TAG: 'タグを編集',
				LOWER: '下限',
				UPPER: '上限',
				INSTRUMENT_RANGE: '計器範囲',
				TRIP_LIMITS: 'トリップ限界',
				ALARM_LIMITS: 'アラーム限界',
				THRESHOLD_LIMITS: '閾値限界',
				DIRECTIONALITY: '方向性',
				IOW_CRITICALITY: 'IOW重要度',
				FLATLINE_DETECTION: 'フラットライン検出',
				THRESHOLD_NOTIFICATION: '閾値通知',
				ASSET: '資産',
				CALCULATED_FLAG: '計算フラグ',
				REMARK: '備考',
				REMARK_PLACEHOLDER: '編集する備考を入力',
				CANCEL: 'キャンセル',
				SAVE: '保存',
			},
			DATA_FEED: {
				TITLE: 'データフィード健全性（ヒストリアン監視）',
				ALL_TAGS: 'すべてのタグ',
				GOOD_TAGS: '正常タグ',
				BAD_TAGS: '不良タグ',
				GROUP_BY: 'グループ化',
				DOWNLOAD: 'ダウンロード',
				NO_TAGS_FOUND_TITLE: 'タグが見つかりませんでした',
				NO_TAGS_FOUND_DESC: 'フィルターと日付範囲を確認してください',
				TAGS: 'タグ',
				SHOW: 'もっと見る',
				MORE_TAGS: '件のタグ',
				NO_TAGS: 'タグが見つかりませんでした。',
				SYSTEM_NAME: 'システム名',
				VALUE: '値',
				QUALITY: '品質',
				TIMESTAMP: 'タイムスタンプ',
				TAG_NAME: 'タグ名',
				TAG_ID: 'タグID',
			},
			MODEL_HEALTH: {
				TITLE: 'システムおよびモデルの健全性指標',
				ALL_SYSTEMS: '全システム',
				PROBLEM_SYSTEMS: '異常システム',
				NO_PROBLEM_SYSTEMS: '異常システムは見つかりませんでした',
				SEARCH: '検索...',
				REFRESH: 'データ更新',
				DOWNLOAD: 'ダウンロード',
				SYSTEM_NAME: 'システム名',
				STATUS: 'ステータス',
				DEPLOYED_VERSION: 'デプロイ済みバージョン',
				LAST_DATA_PULL: '最終データ取得',
				DATA_HEALTH: 'データ健全性',
				MODEL_HEALTH: 'モデル健全性',
				PREDICTION_TIME: '予測時刻',
				LAST_PREDICTION: '最終予測',
				PREDICTIONS_OLDER_THAN_2_HOURS: '最終予測から2時間以上経過したシステムは異常システムとして表示されます',
				LAST_DATA_WRITTEN: '最終データ書き込み',
				LAST_ANOMALY_WRITTEN: '最終異常書き込み',
				FETCH_STATUS: '取得ステータス',
				FETCH_RATE: '取得レート',
				FETCH_SAMPLING_RATE: '取得サンプリングレート',
				PREDICTION_STATUS: '予測状況',
				PREDICTION_RATE: '予測レート',
				SAMPLING_RATE: 'サンプリングレート',
				ACTIONS: '操作',
				CUSTOMIZE_COLUMNS: '表示列のカスタマイズ',
				NO_DATA_MATCHING: '選択された設備に利用可能なデータはありません',
				DEPLOYED_DATE: '展開日',
				DEPLOYED_BY: 'デプロイ担当者',
				DEPLOYMENT_NOTE: 'デプロイノート',
				ACTIVE_ALERTS: 'アクティブなアラート',
				RETRAINING_RECOMMENDED: {
					TITLE: '再トレーニング推奨',
					DESCRIPTION: '最近の評価では、モデルが現在の運転挙動を反映していない可能性があります。以下のタグがこの推奨に最も寄与しています。',
					CONTRIBUTING_TAGS: '寄与タグ（最大5件）',
					TAG_NAME_AND_ID: 'タグ名とID',
					TAG_TOOLTIP: '名前: {{tagName}}\nTagID: {{tagId}}',
					CONTRIBUTION_SCORE: '寄与スコア',
					LAST_EVALUATED: '最終評価',
					MODEL_VERSION: 'モデル',
					COPY_TAGS: 'タグをコピー',
					COPY_FULL_DETAILS: '詳細をすべてコピー',
					RETRAIN_MODEL: 'モデルを再トレーニング',
					RETRAIN: '再トレーニング',
					TIP_PREFIX: 'ヒント：モデルヘルス列の',
					TIP_SUFFIX: 'チップをクリックすると、再トレーニングが推奨される理由を確認できます。',
					NO_TAGS: '寄与タグが見つかりません。',
					TAGS_COPIED: 'タグをコピーしました。\nクリップボードで利用できます。',
					DETAILS_COPIED: '詳細をコピーしました。\nクリップボードで利用できます。',
					RECOMMENDED_DATE_RANGE: '再トレーニング推奨日付範囲',
					RECOMMENDED_DATE_RANGE_HINT: 'この日付範囲を使用して、最も関連性の高いデータでモデルを確認し再トレーニングしてください。',
					NO_DATE_RANGE: 'モデルを再トレーニングするための日付範囲がありません',
					ADD_COMMENT: 'コメントを追加',
					ADD_COMMENT_PLACEHOLDER: '理由を追加',
					START_RETRAINING: '再トレーニング開始',
					BACK: '戻る',
					FORCE_INCLUDE_BANNER: '推奨区間は Force Include 範囲として自動追加されています。',
					TRAINING_PERIOD: '学習期間',
					EXISTING_TRAINING_REGION: '既存の学習区間',
					CURRENT_MODEL_VERSION: '現在のモデルバージョン',
					RECOMMENDED_REGION: '推奨区間',
					FROM_MODEL_HEALTH_EVALUATION: 'モデル健全性評価より',
					NO_TRAINING_RANGES: '学習区間がありません。',
					LOADING_RANGES: '学習区間を読み込み中...',
				}
			}
		},
		SHARED_MODULE: {
			COLUMN_CONFIG: {
				TITLE: '列を表示',
				SEARCH: '検索...',
				SELECT_ALL: 'すべて選択',
				RESET_TO_DEFAULT: '既定値に戻す',
			},
			CALCULATED_TAG_POPUP: {
				EXPRESSION: '式',
				EXPRESSION_DESCRIPTION: '式の説明'
			}
		},
		DATA_MANAGEMENT: {
			QC: {
				RUN_QC: 'QCを実行',
				RUN_QC_SELECTED: '選択項目でQCを実行',
				RUN_QC_TOOLTIP: '現在のレコードに対してデータ品質エージェントを実行します',
				RUNNING: 'QC実行中',
				DETAIL_TITLE: 'メンテナンス記録',
				TAB_DETAILS: '詳細',
				TAB_REVIEW: 'レビュー',
				NO_DETAILS: '詳細はありません。',
				VIEW_DETAILS: '詳細を表示',
				FIELDS: {
					NOTIFICATION_NO: '通知番号',
					ORDER: 'オーダー',
					TYPE: 'タイプ',
					EQUIPMENT: '設備',
					EQUIPMENT_DESC: '設備説明',
					FUNCTIONAL_LOC: '機能ロケーション',
					PLAN_GROUP: '計画グループ',
					PLAN_GROUP_DESC: '計画グループ説明',
					MAINTENANCE_PLANT: '保全プラント',
					MAINTENANCE_PLANT_DESC: '保全プラント説明',
					PLANT_SECTION: 'プラントセクション',
					PRIORITY: '優先度',
					DAMAGE: '損傷',
					DESCRIPTION: '説明',
					STATUS: 'ステータス',
					USER_STATUS: 'ユーザーステータス',
					CREATED_ON: '作成日',
					COMPLETED_ON: '完了日',
					BREAKDOWN_DURATION: '故障時間',
					INTERNAL_LABOUR: '内部労務費',
					EXTERNAL_LABOUR: '外部労務費',
					EXTERNAL_SERVICE: '外部サービス費'
				},
				LAST_RUN: '前回のQC実行',
				VIEW_FINDINGS: '検出結果を表示',
				FINDINGS_TITLE: 'データ品質の検出結果',
				NO_FINDINGS: 'このレコードに問題は見つかりませんでした。',
				BLOCKERS: 'ブロッカー',
				WARNINGS: '警告',
				RULE: 'ルール',
				FIELD: 'フィールド',
				EVIDENCE: '根拠',
				RECOMMENDATION: '推奨事項',
				CONFIG_TITLE: 'データ品質ルール',
				SCOPE_GLOBAL: 'グローバル',
				SCOPE_SYSTEM: 'このシステム',
				RULE_MANDATORY_FIELDS: '必須フィールド',
				MANDATORY_FIELDS_LABEL: '必須項目',
				SEVERITY: '重大度',
				RULE_DESCRIPTION: '説明の長さ',
				MIN_LENGTH: '最小文字数',
				RULE_DATES: '日付の整合性',
				ALLOW_COMPLETION_BEFORE_CREATION: '作成日より前の完了日を許可する',
				RULE_DUPLICATES: '重複検出',
				WINDOW_DAYS: '重複判定期間（日）',
				RULE_PLANNING: '計画',
				REQUIRE_LABOR: '作業指示に工数を必須にする',
				RULE_COMPLETION: '完了',
				REQUIRE_ROOT_CAUSE: '完了レコードに根本原因を必須にする',
				RULE_TEXT_QUALITY: 'テキスト品質（AI）',
				TEXT_QUALITY_HINT: '言語モデルを使用してスペルと説明の品質を確認します',
				CHECK_SPELLING: 'スペルを確認',
				CHECK_DESCRIPTION_MEANING: '説明が意味のある内容か確認',
				CHECK_ROOT_CAUSE: '根本原因の妥当性を確認',
				RULE_WORK_ORDER: '作業指示が必要',
				WORK_ORDER_HINT: '通知が完了しており、かつ下記で選択した通知タイプに該当する場合にのみ、作業指示の欠落を検出します。',
				WORK_ORDER_TYPES_LABEL: '作業指示が必要な通知タイプ',
				RULE_SLA: 'SLA／要求完了日',
				SLA_CHECK_OVERDUE: '要求完了日を過ぎても未完了の通知を検出します',
				SLA_CHECK_LATE: '要求完了日より後に完了した通知を検出します',
				RULE_BREAKDOWN_CONSISTENCY: '故障フラグの整合性',
				BREAKDOWN_CONSISTENCY_HINT: '故障フラグ（Effect）と記録されたダウンタイムを照合します。このサイトで故障を示すEffectの値を選択してください。',
				BREAKDOWN_EFFECT_VALUES_LABEL: '故障を示すEffectの値',
				RULE_AGING: '滞留・古い未処理案件',
				MAX_OPEN_DAYS: '通知を未完了のまま保持できる最大日数',
				RULE_STATUS_CONSISTENCY: 'ステータスクローズの整合性',
				STATUS_CONSISTENCY_HINT: '完了日とワークフローのクローズステータスを照合します。このサイトで「クローズ」を意味するステータスコードを選択してください。',
				CLOSED_KEYWORDS_LABEL: 'クローズを意味するステータスコード',
				RULE_COST_SANITY: 'コストの妥当性チェック',
			},
			TABS: {
				DOCUMENTS: 'ドキュメント',
				TAGS: 'タグ',
				MAINTENANCE: '保全',
				PIDS: 'P&IDs',
				RELIABILITY: '信頼性'
			},
			COMMON: {
				PROCESSING: '処理中',
				READY: '準備完了',
				REVIEW: '要確認',
				BLOCKED: 'ブロック中',
				PENDING: '保留中',
				SEARCH: '検索...',
				SEARCH_RECORDS: 'レコードを検索...',
				ADD_DOCUMENT: 'ドキュメントを追加',
				NO_MATCHING: '一致するドキュメントが見つかりません。',
				LOADING: 'データを読み込んでいます...',
				LOADING_MORE: 'さらにドキュメントを読み込んでいます...',
				LOADING_MORE_RECORDS: 'さらに記録を読み込んでいます...',
				CANCEL: 'キャンセル',
				EDIT: '編集',
				SAVE: '保存',
				SAVING: '保存中...',
				ASK_ROOTY: 'Rootyに質問',
				DOWNLOAD: 'ダウンロード',
				IMPORT_DATA: 'データインポート',
				REPLACE_FILE: 'ファイルを置き換える',
				UPLOAD: 'アップロード'
			},
			FILTERS: {
				ALL_ISSUES: 'すべての課題',
				CHOOSE_ISSUES: '表示する課題を選択',
				ALL_CLASSES: 'すべてのクラス',
				CHOOSE_CLASSES: '表示するクラスを選択',
				GROUP_BY: 'グループ化',
				ALL_TYPES: 'すべてのタイプ',
				EVENT_TYPES: 'イベントタイプ',
				FILTER_ISSUE_TYPE: '課題種別'
			},
			IMPORT_BANNER: {
				IMPORTING: '{{ count }}件のドキュメントをインポート中',
				IMPORTING_AUTO: '{{ uploaded }}件のドキュメントをインポート中、残り{{ remaining }}件（合計：{{ total }}）',
				INITIALIZING_AUTO: 'ドキュメントの同期を初期化中...',
				AUTO_TAKE_MINS: 'バックグラウンドでドキュメントを同期しています。しばらくお待ちください...',
				TAKE_30_MINS: 'これには最大30分かかる場合があります。',
				IMPORTED_SUCCESS: '{{ count }}件のドキュメントがインポートされました',
				SUMMARY: 'インポートの概要：',
				NEEDS_REVIEW: 'レビューが必要',
				ALREADY_PRESENT: '既存',
				REMOVED_AT_SOURCE: 'ソースで削除済み',
				SYNC_FAILED: '同期に失敗しました'
			},
			TABLE_COLUMNS: {
				DOCUMENT: 'ドキュメント',
				CLASS: 'クラス',
				DOC_TYPE: '文書タイプ',
				STATUS: 'ステータス',
				SOURCE: 'ソース',
				ISSUES: '課題',
				LAST_UPDATED: '最終更新',
				ACTIONS: '操作',
				NOTIFICATION: '通知',
				EQUIPMENT: '設備',
				DESCRIPTION: '説明',
				TYPE: 'タイプ',
				MAINTENANCE_PLANT: '保全プラント',
				FAILURE_MODE: '故障モード',
				SECTION: 'セクション',
				DATES: '日付',
				CONTEXT: 'コンテキスト',
				TIME_HRS: '時間（h）',
				RCA: '根本原因分析（RCA）',
				SOURCE_NAME: 'ソース名',
				PATH: 'パス',
				SYNC_FREQUENCY: '同期頻度',
				LAST_SYNCED: '最終同期',
			},
			EMPTY_STATE: {
				NO_DOCS_TITLE: 'ドキュメントはまだインポートされていません',
				NO_DOCS_SUBTITLE: '手動でドキュメントを追加するか、AIアップロードツールを使用してください。',
				NO_MAINT_TITLE: '保全データはまだインポートされていません。',
				NO_MAINT_SUBTITLE: '「データインポート」を選択して、保全データの追加を開始してください。'
			},
			ADD_DOC_DIALOG: {
				FILE_UPLOAD: 'ファイルアップロード',
				UPLOAD_MANUALLY: 'ファイルを手動でアップロード',
				BULK_UPLOAD_TITLE: 'フォルダテンプレートで一括アップロード',
				BULK_UPLOAD_DESC: 'フォルダ構造をダウンロードし、一致するフォルダにドキュメントを配置してから、フォルダ全体をアップロードします。',
				DOWNLOAD_TEMPLATE: 'テンプレートをダウンロード',
				DRAG_DROP: 'ここにファイルをドラッグアンドドロップするか、',
				BROWSE: '参照',
				SUPPORTS: 'PDF、Word、Excel、画像、または一括アップロード用ZIPをサポートします。',
				SELECTED_FILES: '選択済みファイル',
				APPLY_TO_ALL: 'すべてに適用:',
				CLASS: 'クラス',
				DOC_TYPE: '文書タイプ',
				LINKED_TO: 'リンク先',
				SELECT_CLASS: 'クラスを選択',
				SELECT_DOC_TYPE: '文書タイプを選択',
				CHOOSE_LINK: 'リンク先を選択',
				FILE_SELECTED: '件のファイル選択済み',
				FILES_SELECTED: '件のファイル選択済み',
				CONFIRM_IMPORT: '確認・インポート',
				REPLACE_HINT: 'このドキュメントの正しい置き換えファイルをアップロードしてください。理想的には、最初に意図したファイルと同じものであるべきです。',
				DUPLICATE_BADGE: '重複',
				DUPLICATES_SKIPPED_BANNER: '{{count}} 件の重複ファイルが検出されました。これらは除外され、アップロードされません。',
				DUPLICATES_SKIPPED_INLINE: '（{{count}} 件の重複をスキップ）',
				REMOVE_DUPLICATES: '重複を削除'
			},
			DOC_VIEWER: {
				DOC_DETAILS: 'ドキュメントの詳細',
				PREVIEW: 'プレビュー',
				FULL_SCREEN: '全画面表示',
				NO_PREVIEW: 'プレビューは利用できません',
				NO_PREVIEW_DESC: 'このファイル形式はブラウザでプレビューできません。',
				METADATA: 'メタデータ',
				DOC_IDENTIFICATION: 'ドキュメント識別情報',
				DOC_NAME: 'ドキュメント名',
				DOC_ID: 'ドキュメントID',
				DOC_CLASS: 'ドキュメントクラス',
				DOC_TYPE: '文書タイプ',
				MISSING: '未設定',
				DOC_SOURCE: 'ドキュメントソース',
				FILE_SIZE: 'ファイルサイズ',
				FILE_UPLOAD_SOURCE: 'ファイルアップロード',
				EXTERNAL_SOURCE: '外部（SharePoint、Google Driveなど）',
				VERSIONING: 'バージョン管理',
				UPLOADED_ON: 'アップロード日',
				LAST_MODIFIED: '最終更新日',
				EFFECTIVE_DATE: '発効日',
				EXPIRY_DATE: '有効期限',
				REVISION: 'リビジョン',
				VERSION_1: 'バージョン1',
				VERSION_2: 'バージョン2',
				STATUS: 'ステータス',
				STATUS_UPLOADING: 'アップロード中',
				STATUS_QUEUED: 'キュー登録済み',
				STATUS_PROCESSING: '処理中',
				STATUS_READY: '準備完了',
				STATUS_PENDING: '保留中',
				LINKED_TO: 'リンク先',
				FACILITIES: '施設',
				UNITS: 'ユニット',
				SYSTEMS: 'システム',
				CHOOSE_LINK_DESC: 'リンク先を選択（施設、ユニット、システムのいずれかにリンクできます）',
				EXTRACTED_DATA: '抽出データ',
				NO_EXTRACTED_DATA: '抽出データはありません。'
			},
			TOOLTIPS: {
				ISSUE_FILTER: '課題フィルター',
				CLASS_FILTER: 'クラスフィルター',
				CUSTOMIZE_COLUMNS: '列のカスタマイズ',
				VIEW_DETAILS: '詳細を表示',
				DELETE_FILE: 'ファイルを削除',
				STATUS_QUEUED_PROCESSING: 'ドキュメントはキューに入っており、まもなく処理されます。',
				STATUS_READY: 'ドキュメントの処理が完了し、利用可能です。'
			},
			DEDUP_MENU: {
				TRIGGER_LABEL: '重複',
				TITLE: '重複を解決',
				SUMMARY: '選択した {{total}} 件中 {{dupes}} 件のファイルに重複があります',
				DESCRIPTION: 'オリジナルは保持されます。他の {{unaffected}} 件のファイルは変更されません。',
				MERGE_TAGS: '重複を削除し、タグを統合 ({{count}})',
				NO_MERGE_TAGS: '重複を削除し、タグは統合しない ({{count}})',
				FAILURE: '一部の重複の削除に失敗しました',
				TOAST_MERGED: '{{count}} 件の重複ファイルを削除しました。タグはオリジナルファイルと統合されました。',
				TOAST_NOT_MERGED: '{{count}} 件の重複ファイルを削除しました。オリジナルファイルのタグは変更されませんでした。'
			},
			CONNECTED_SOURCES: {
				CLOSE: '閉じる',
				DISCONNECT_MSG: '{{provider}} の連携を解除すると、ドキュメントの同期が停止し、UptimeAI が接続されている {{provider}} アカウントのファイルにアクセスできなくなります。<br/>すでに UptimeAI にインポートされたドキュメントは引き続き利用可能ですが、{{provider}} からの更新は受信しなくなります。',
				DISCONNECT_TITLE: '{{provider}} の連携を解除しますか？',
				DISCONNECT_OK: '{{provider}} の連携を解除',
				FETCH_SOURCES_FAILED: '接続されているソースの取得に失敗しました。',
				SOURCE_UPDATED_SUCCESS: 'ソースが正常に更新されました。',
				SOURCE_CONNECTED_SUCCESS: 'ソースが正常に接続されました。',
				TRIGGERING_SYNC: '同期を開始しています...',
				SYNC_STARTED_SUCCESS: '同期が正常に開始されました。',
				FAILED_TRIGGER_SYNC: '同期の開始に失敗しました。',
				INACTIVE_REASON_COVERED: 'アクティブな親ソース \'{{name}}\' ({{path}}) によってカバーされています',
				REAL_TIME: 'リアルタイム',
				ONE_TIME: '1回のみ',
				DAILY: '毎日',
				HOURLY: '1時間ごと',
				WEEKLY: '毎週',
				MONTHLY: '毎月',
				NA: 'N/A',
				PAUSED: '一時停止',
				INACTIVE: '非アクティブ',
				UNKNOWN: '不明',
				TITLE: '接続されたソース',
				ACTIVE: 'アクティブ',
				CONNECT_SOURCE: 'ソースを接続',
				NO_SOURCES_HEADING: '接続されたソースはまだありません。',
				NO_SOURCES_CONTENT: 'ファイルをインポートするにはソースを接続してください。',
				NEVER: 'なし',
				SYNC_NOW: '今すぐ同期',
				MONITOR: 'モニター',
				SETTINGS: '設定',
				DISCONNECT: '切断',
				SYNC_ACTIVITY: '同期アクティビティ',
				NO_RECENT_ACTIVITY: '最近の同期アクティビティは見つかりませんでした。',
				STATUS_SUCCESS: '成功',
				STATUS_PARTIAL: '部分的',
				STATUS_FAILED: '失敗',
				STATUS_RUNNING: '実行中',
				SYNC_FAILED_ERROR: 'エラーのため同期に失敗しました。',
				SYNC_STATS: '+ {{new}} 新規 · {{updated}} 更新 · {{skipped}} 変更なし',
				SYNC_STATS_PARTIAL: '+ {{new}} 新規 · {{updated}} 更新 · {{skipped}} 変更なし · {{failed}} 失敗',
			},
			CONNECT_SOURCE: {
				PROVIDERS: {
					DOCUMENT_LOCATOR: {
						NAME: 'Document Locator',
						DESC: 'Document Locator データベースに接続してドキュメントを継続的に同期します。'
					}
				},
				PROVIDER_FIELDS: {
					DOCUMENT_LOCATOR: {
						DIALECT: 'データベースの種類',
						HOST: 'サーバーホスト',
						PORT: 'ポート',
						DATABASE: 'データベース名',
						USER: 'ユーザー名',
						PASSWORD: 'パスワード',
						ENCRYPT: '接続を暗号化する',
						TRUST_CERT: 'サーバー証明書を信頼する',
						SP_FILE_INFO: 'ファイル情報プロシージャ',
						SP_FILE_CONTENT: 'ファイル内容プロシージャ',
						SP_PLACEHOLDER: 'ストアドプロシージャ名を入力してください'
					}
				},
				TITLE: 'データソース接続',
				STEP_1: 'ソースに接続',
				STEP_2: 'ソースの認証',
				STEP_3: 'ソース詳細',
				SHAREPOINT: 'SharePoint',
				SHAREPOINT_DESC: 'SharePointライブラリに接続してドキュメントを継続的に同期します。',
				CONNECT_TO_SHAREPOINT: 'SharePointに接続',
				CONNECT_TO_PROVIDER: '{{provider}}に接続',
				CONNECTION_VERIFIED: '接続を確認しました。',
				DESCRIPTOR_LOAD_FAILED: 'このソースの構成を読み込めませんでした。',
				TEST_CONNECTION_REQUIRED: '接続する前に、接続テストを正常に完了してください。',
				API_INTEGRATION: 'API連携',
				API_DESC: 'ドキュメント管理APIに接続してファイルを自動同期します。',
				CMMS: 'CMMS',
				CMMS_DESC: 'CMMS（SAP PM、Maximoなど）に接続して継続的にドキュメントを同期します。',
				COMING_SOON: '近日対応予定',
				OAUTH_TAB: 'Microsoftでサインイン（OAuth）',
				TOKEN_TAB: 'アクセストークン（手動）',
				SIGN_IN_MICROSOFT: 'Microsoftでサインイン',
				OAUTH_DESC: 'Microsoftアカウントを接続してSharePointライブラリを参照し、ドキュメントをインポートします。',
				SECURE_AUTH: '安全な認証',
				SECURE_AUTH_DESC: 'Microsoft OAuthを使用します。認証情報はこのアプリケーションに保存されません。',
				READ_ONLY: '読み取り専用アクセス',
				READ_ONLY_DESC: 'アプリケーションはドキュメントの読み取りのみを行います。SharePointのファイルは変更・削除されません。',
				TOKEN_PLACEHOLDER: 'SharePointアクセストークンを貼り付け',
				TOKEN_WARNING: 'アクセストークンは期限切れになります。中断のない同期にはOAuthをご検討ください。',
				MANUAL_AUTH_DESC: 'Azureアプリの登録資格情報を入力してください。これらはサーバーに安全に保存されます。',
				TENANT_ID_LABEL: 'テナント ID',
				TENANT_ID_PLACEHOLDER: 'xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx',
				CLIENT_ID_LABEL: 'クライアント ID (アプリケーション ID)',
				CLIENT_ID_PLACEHOLDER: 'xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx',
				CLIENT_SECRET_LABEL: 'クライアントシークレット',
				CLIENT_SECRET_PLACEHOLDER: 'クライアントシークレットの値を貼り付けてください',
				SAVE_CREDENTIALS: '保存して続行',
				STEP_CONNECTION_CONFIG: '接続設定',
				APP_CONNECTION_CONFIG: 'アプリ接続設定',
				NEW_CONNECTION: '新しい接続',
				ACTIVE_CONNECTION_CONFIG: 'アクティブな接続設定',
				PROVIDER: 'プロバイダー',
				MICROSOFT_SHAREPOINT: 'Microsoft SharePoint',
				APP_ID: 'アプリ ID (クライアント ID)',
				REGISTER_CONFIG_DESC: '新しいアプリ登録/クライアント資格情報構成を登録するための詳細を入力してください。',
				CONFIG_NAME_LABEL: '設定名',
				CONFIG_NAME_PLACEHOLDER: '例: SharePoint Production',
				BACK_TO_SELECTION: '選択に戻る',
				SAVE_CONNECTION_BTN: '接続を保存',
				PLEASE_SELECT_CONNECTION: 'まず接続設定を選択または登録してください。',
				RESTORED_SESSION_FOR: '認証済みセッションを復元しました: {{user}}',
				PLEASE_COMPLETE_SIGNIN: 'まずMicrosoftのサインインを完了してください。',
				SELECT_APP_REGISTRATION: 'まずアプリ登録接続を選択または登録してください。',
				FAILED_AUTH_URL: 'Microsoft認証URLの取得に失敗しました。',
				ERROR_REQ_AUTH_LINK: '認証リンクの要求中にエラーが発生しました。',
				FILL_ALL_FIELDS: 'すべての接続構成フィールドに入力してください。',
				APP_REG_SAVED: 'アプリ登録構成が正常に保存されました。',
				FAILED_SAVE_CONFIG: '構成の保存に失敗しました。',
				SITE_URL_LABEL: 'SharePointサイトURL（SharePointサイトコレクションの完全なURL）',
				SITE_URL_PLACEHOLDER: 'https://company.sharepoint.com/sites/engineering',
				LIBRARY_PATH_LABEL: 'ライブラリパス',
				LIBRARY_PATH_DESC: '（ドキュメントライブラリへのパス、例：/Shared Documents/Equipment）',
				LIBRARY_PATH_PLACEHOLDER: '/Shared Documents/Equipment',
				FILE_TYPE_LABEL: 'ファイルタイプフィルター（指定したタイプに一致するファイルのみインポート。すべて対象にする場合は空欄）',
				SYNC_FREQUENCY: '同期頻度',
				SYNC_AUTO: '自動（リアルタイム）',
				SYNC_HOURLY: '毎時',
				SYNC_DAILY: '毎日',
				SYNC_DAILY_DESC: '指定時刻に24時間ごとに同期',
				SYNC_WEEKLY: '毎週',
				SYNC_BIWEEKLY: '隔週',
				SYNC_MONTHLY: '毎月',
				CONFLICT_LABEL: '競合解決（システムに既に存在するドキュメントの処理方法）',
				CONFLICT_KEEP_NEWEST: '最新バージョンを保持',
				TEST_CONNECTION: '接続テスト',
				TEST_SUCCESS: '接続成功: 条件に一致するドキュメントが{{count}}件見つかりました',
				CANCEL: 'キャンセル',
				CONNECT_AND_SYNC: '接続して同期開始',
				AUTH_SUCCESS: '正常に認証されました。下の[次へ]をクリックして、ソースの詳細を構成します。',
				APP_ONLY_SYNC_DESC: 'アプリ専用の同期は、選択したアプリケーション登録構成を使用してバックグラウンドで実行されます。個々のユーザーのログインは必要ありません。',
				FILE_TYPE_FILTER_DESC: 'これらのタイプに一致するファイルのみをインポートします。すべてのファイルをインポートする場合は選択を解除してください。',
				NEXT: '次へ',
				AUTHENTICATED_PROFILE: '認証済みMicrosoftプロファイル',
				USER_NAME: 'ユーザー名',
				EMAIL_ADDRESS: 'メールアドレス',
				SIGN_IN_DIFFERENT_ACCOUNT: '別のアカウントでサインイン'
			}
		},
		MODULE_CONFIGURATION: {
			TABS: {
				TRIAGE: 'Alert Triage', MAINTENANCE: '保全', COMING_SOON: '近日対応予定' },
			COMMON: { CANCEL: 'キャンセル', SAVE: '保存', EDIT: '編集', DOWNLOAD: 'ダウンロード', UPLOAD: 'アップロード', DELETE: '削除', SELECT_ALL: 'すべて選択', SEARCH: '作業を検索...', EDIT_CONFIGURATION: '設定を編集', SAVE_CONFIGURATION: '設定を保存', APPLY_TEMPLATE: 'テンプレートを適用', TEMPLATE_MANAGER: 'テンプレート管理', SAVED_CONFIGURATION: '保存済み設定', CONFIGURE: '設定', BETA_ANALYTICS: 'β解析', UPDATE_TEMPLATE: 'テンプレートを更新', SAVE_TEMPLATE: 'テンプレートを保存', FINISH_SAVE_PACKAGE: 'パッケージとして保存', DONE: '完了', RE_GENERATE: '再生成', YES: 'はい', NO: 'いいえ', LOADING: '読み込み中...', COPY: 'コピー', APPLYING_TEMPLATE: 'テンプレートを適用中', LOADING_TEMPLATE: 'テンプレートを読み込み中', TO: 'を' },
			HEADER: { CONFIG_FOR: 'PM、FMEA、CMの設定対象:', SELECT_EQUIPMENT: '設備を選択してください' },
			EQUIPMENT_EMPTY: { TITLE: '設備を選択', DESC: '階層パネルから設定対象の設備を選択してください', ACTIVITIES: 'PM作業、FMEA、CM。', NO_TEMPLATE_TITLE: 'テンプレート未適用', NO_TEMPLATE_DESC: 'この設備のPM作業、FMEA、CMを設定するにはテンプレートを適用してください。' },
			COMING_SOON: { TITLE: '近日対応予定', DESC: 'この機能は現在開発中です。今後のアップデートで利用可能になります。' },
			MANAGER: { TITLE: 'テンプレート管理', EDIT_TEMPLATE: 'テンプレート編集', LINKED_ASSETS: '関連設備', SUB_HEADER: '再利用可能なPM、CM、故障モードテンプレートを管理します', COL_NAME: 'テンプレート名', COL_DESC: '説明', COL_TYPE: 'タイプ', COL_ASSETS: '関連設備', COL_ASSET: '設備', COL_CREATOR: '作成者', COL_DATE: '最終更新', EMPTY_TITLE: 'テンプレートが見つかりません', EMPTY_DESC: '保存済みのPM、CM、故障モードテンプレートがここに表示されます。', SELECT_DESC: '設備に適用する事前定義テンプレートを選択してください。', SEARCH_TEMPLATE: 'テンプレートを検索...', EQ_TEMPLATE_LIBRARY: '設備テンプレートライブラリ', COL_STATUS: 'ステータス', STATUS_IN_PROGRESS: '進行中', STATUS_READY: '使用可能', STATUS_DEPRECATED: '非推奨', LIFECYCLE: 'その他の操作', LOCK: 'ロックして使用可能にする', LOCK_HINT: 'テンプレートを100%完成させるとロックできます。', UNLOCK: 'ロック解除', DEPRECATE: '非推奨にする', REACTIVATE: '再有効化', DUPLICATING: '{{name}} の複製テンプレートを作成中...' },
			UPLOAD: { TITLE_PM: 'PMテンプレートアップロード', TITLE_CM: 'CMテンプレートアップロード', TITLE_FM: '故障モードテンプレートアップロード', TEMPLATE_NAME: 'テンプレート名', ENTER_TEMPLATE: 'テンプレート名を入力', DRAG_DROP: 'ファイルをここにドラッグアンドドロップするか、', BROWSE: '参照', REMOVE_FILE: 'ファイルを削除' },
			PM: { TITLE: 'PM設定', CONFIG_FOR: 'PMチェックリスト設定対象:', SELECT_HOW: 'PM作業の設定方法を選択してください', APPLY_TEMPLATE: 'テンプレートを適用', IMPORT_SAP: 'SAPからインポート', UPLOAD_TEMPLATE: 'テンプレートアップロード', DOWNLOAD_TEMPLATE: 'テンプレートダウンロード', CHECKLIST_TEMPLATE: 'PMチェックリストテンプレート', SAVE_TEMPLATE: 'テンプレートを保存', EDIT_TEMPLATE: 'テンプレート編集', OVERALL_VARS: 'PM全体変数', OVERALL_TIME: '合計時間（h）', MUST_BE_POSITIVE: '0 より大きい数値を入力してください', OVERALL_MANNING: '総要員数', TECH_COUNT: '技術員数', HELPER_COUNT: '補助員数', COST_PARTS: '部品費（該当する場合）（USD）', COST_CONS: '消耗品費（USD）', PM_INTERVAL: '現在のPM周期（日）', PROD_LOSS: '生産損失（USD）', TAB_CHECKLIST: 'PMチェックリスト', ACTIVITIES_CHECKLIST: 'PM作業チェックリスト', ACTIVITIES_CHECKLIST_DESC: 'このチェックリストテンプレートで定義されたすべてのPM作業一覧', ENRICH_ROOTY: 'Rootyでチェックリストを補完', ROOTY_LOADING: 'RootyがPM作業を解析しています...', ROOTY_BUNDLE_TITLE: '作業バンドル候補', ROOTY_BUNDLE_DESC: '以下の提案バンドルを確認してください。確定するとビルドフラグが生成されます。', ROOTY_CONFIRM_BUNDLES: '確認してビルドフラグを生成', ROOTY_CONFIRM_FLAGS: '確認して作業別時間を生成', ROOTY_FLAGS_READY: 'ビルドフラグが生成されました。下のタブを確認してください。', ROOTY_FLAGS_OUTPUT: 'ビルドフラグ解析', ROOTY_NO_SYSTEM: 'エンリッチメントを有効にするにはPM作業を保存してください', TAB_BUNDLES: '作業バンドル', BUN_TITLE: 'PM作業バンドル', BUN_DESC: '効率的なスケジューリングのため、PM作業を論理的なバンドルに分類します', TAB_FLAGS: 'ビルドフラグ', FLAG_TITLE: 'ビルドフラグ', FLAG_DESC: '作業を法規制、手順、運用の観点で分類します', TAB_TIME: '作業別時間', TIME_TITLE: '作業別時間', TIME_DESC: '各PM作業に必要な時間を見積もります', TAB_BETA: 'β定義', BETA_TITLE: 'β定義', BETA_DESC: '各作業について、PM頻度に対するCM/故障の感度を設定します', RE_GENERATE: '再生成', CHECKLIST_CONFIG: 'PMチェックリスト設定', CONFIG_CHECKLIST_FOR: 'チェックリスト設定対象:', ROOTY_CANNED_1: 'チェックリストを読み込み中...', ROOTY_CANNED_2: 'PM作業を解析中...', ROOTY_CANNED_3: '提案を準備中...' },
			PM_APPLY: { TITLE: 'PMチェックリストテンプレートライブラリ', STEP_1: 'テンプレートを選択', STEP_2: '設備を選択', STEP_1_DESC: '設備に適用する事前定義のPMチェックリストテンプレートを選択してください。テンプレートには、ベストプラクティスに基づいて設定されたPM作業手順が含まれます。', EMPTY: 'テンプレートが見つかりません。', CONFIG_FOR: 'PMテンプレート設定対象:', EXEC_SUCCESS: '周期境界をまたぐ実行に成功しました。', PM_ACTIVITIES: 'PM作業', INTERVAL: '周期:', APPLIES_TO: '適用先:', EQ_TITLE: 'テンプレートを適用する設備を選択', EQ_SELECTED: '選択済み設備', SELECT_TEMPLATE: 'テンプレートを選択', APPLY_TEMPLATE: 'テンプレートを適用' },
			CM: { TITLE: 'CM設定', CONFIG_FOR: 'CM作業設定対象:', SELECT_HOW: 'CM作業の設定方法を選択してください', APPLY_TEMPLATE: 'テンプレートを適用', UPLOAD_TEMPLATE: 'テンプレートアップロード', DOWNLOAD_TEMPLATE: 'テンプレートダウンロード', CM_VARS: 'CMレベル変数', EQ_REDUNDANCY: '設備冗長性', PROD_LOSS: '生産損失', TECH_COUNT: '必要技術員数', HELP_COUNT: '必要補助員数', COST_CONS: '消耗品費（該当する場合）', SPARES_COST: '予備品費を考慮', YES: 'はい', NO: 'いいえ', LABOUR_VARS: '工数変数', WRENCH_TIME_VARS: '実作業時間変数', WRENCH_WARNING: '故障停止時間には待機時間が含まれる場合があります。停止時間ベースの値より実作業時間の見積値を優先してください', COL_FAILURE_MODE: '故障モード', COL_ACTIVITY: '作業', COL_CM_COUNT: 'CM件数', COL_WRENCH_TIME: '推定実作業時間（h）', COL_CONFIDENCE: '信頼度', COL_OVERRIDE: '上書き（h）' },
			FM: { TITLE: '故障モード設定', CONFIG_FOR: '故障モード設定対象:', SELECT_HOW: '故障モードの設定方法を選択してください', SAVED_CONF: '保存済み設定', RCM_ANALYSIS: 'RCM解析', APPLY_LIB: 'テンプレートライブラリから適用', APPLY_LIB_DESC: '設備クラスに対応する事前定義の故障モードテンプレートを使用します', APPLY_LIB_AVAIL: '利用可能なテンプレート: ACWポンプテンプレート', UPLOAD_RCM: '既存RCM解析をアップロード', UPLOAD_RCM_DESC: '既存のRCM検討ファイル（Excel/CSV）から故障モードをインポートします', NEW_STUDY: '新規FMEA検討を作成', NEW_STUDY_DESC: 'ガイド付き検討ウィザードを使用して新しいFMEAを開始します', APPLY_TEMPLATE: 'テンプレートを適用', CREATE_ROOTY: 'ROOTYで作成', UPLOAD_EXCEL: 'Excelからアップロード', DOWNLOAD_TEMPLATE: 'テンプレートダウンロード', COL_FM_ID: 'FM ID', COL_SUBSYSTEM: 'サブシステム', COL_COMPONENT: 'コンポーネント', COL_FUNCTION: '機能', COL_FUNC_FAIL: '機能故障', COL_FAILURE_MODE: '故障モード', COL_CONSEQUENCE_CAT: '影響カテゴリ', COL_FAILURE_BEHAVIOR: '故障挙動', COL_PDM_APPLICABILITY: 'PdM適用性', COL_LIKELY_CAUSES: '推定原因', COL_SYMPTOMS: '症状・兆候', COL_LOCAL_EFFECTS: '局所影響', COL_SYSTEM_EFFECTS: 'システム影響', COL_PLANT_EFFECTS: 'プラント影響', COL_EFFECTS: '影響', COL_IMPACTS: '影響度', COL_EFFECT: '影響', COL_TYPE: 'タイプ', COL_STATUS: 'ステータス', COL_EVIDENCES: '根拠資料', COL_TOTAL_COST: '合計コスト', COL_CATEGORY: 'カテゴリ', COF_RATING: 'CoF評価', COF_CATEGORY: 'CoFカテゴリ', COST_SUMMARY: 'コスト概要', REPAIR_COST: '修理費（USD）', SAFETY_RISK_COST: '安全リスクコスト（USD）', PROD_LOSS: '生産損失（USD）', OUTAGE_DURATION: '停止時間（h）', TOTAL_COST_USD: '合計コスト（USD）', CONSEQUENCE_RATING: '影響度評価', SAFETY: '安全', OPERATIONAL: '操業', ENVIRONMENTAL: '環境', REPUTATIONAL: '評判', CLASSIFICATION_HIDDEN: '分類: 潜在故障', SUPPORTING_EVIDENCE: '裏付け根拠', VIEW_EVIDENCE: '根拠パネル全体を表示', NO_FM_FOUND: '故障モード設定が見つかりません...', EXPAND_ADDITIONAL_INFO: '追加情報', PERF_STANDARD: '性能基準', FM_ANCHOR_LEVEL: 'FMアンカーレベル', FM_TYPE: 'FMタイプ', SYMPTOM_CHILDREN: '症状子要素', CURRENT_CONTROLS: '現行管理策', EVIDENCE_SOURCE: '根拠情報源', WO_EVIDENCE_REFS: 'WO根拠参照', VALIDATION_OUTCOME: '検証結果', UNVALIDATED_JUSTIFICATION: '未検証理由', CONFIDENCE: '信頼度', PF_INTERVAL: 'P-F間隔推定' },
			EDITOR: {
				SAVING: '保存中...',
				SAVE_TEMPLATE: 'テンプレートを保存',
				SAVE_ACTIVITY: '作業を保存',
				SAVE_PACKAGE: '設備パッケージを保存',
				CREATE_TEMPLATE: 'テンプレートを作成',
				EMPTY_TEMPLATE: '空のテンプレート',
				CREATE_VIA_ROOTY: 'Rootyで作成',
				SAVE_CONTINUE: '保存して続行',
				SAVE_TO_CONFIGURE: 'テンプレートを保存して、PM・FMEA・CM の構成を開始します。',
				DOWNLOAD: 'テンプレートダウンロード',
				UPLOAD: 'テンプレートアップロード',
				PM_CHECKLIST: 'PMチェックリスト',
				FMEA_CONFIG: '故障モード設定',
				CM_CHECKLIST: 'CMチェックリスト（近日公開）',
				DESC: '説明',
				TEMPLATE_NAME: 'テンプレート名',
				OVERALL_PM_VARS: 'PM全体変数',
				SAVE_PM_ACTIVITY: 'PM作業を保存',
				SAVE_FMEA_CONFIG: 'FMEA設定を保存',
				SAVE_CM_CONFIG: 'CM設定を保存',
					RE_GENERATE: '再生成',
				SAVED_INTERNALLY: '内部保存が完了しました:',
				DEFINE_PM: 'PMチェックリストを定義',
				DEFINE_FM: 'FMEA設定を定義',
				DEFINE_CM: 'CM設定を定義',
				DEFINE_WRENCH_TIME: '実作業時間変数を定義',
				DEFINE_DESC: 'サンプルをダウンロードするか、完成したテンプレートをアップロードして生成します。',
				NO_PM_ATTACHED: 'PM設定が添付されていません',
				NO_FM_ATTACHED: '故障モード設定が添付されていません',
				NO_CM_ATTACHED: 'CM設定が添付されていません',
				PM_CONFIG_TAB: 'PM設定',
				FM_CONFIG_TAB: 'FMEA設定',
				CM_CONFIG_TAB: 'CM設定',
				PM_FM_MAPPING_TAB: 'PM-FMマッピング',
				DEFINE_PM_FM: 'PM-FMマッピングを定義',
				DEFINE_PM_FM_DESC: 'この設備に対して、各PM作業がどの故障モードを抑制するかを設定します。',
				PM_FM_MAPPING_MATRIX: 'PM-FMマッピングマトリクス',
				PM_FM_MAPPING_SUBHEADER: '{{equipment}}に対して、各PM作業がどの故障モードを抑制するかを設定します',
				PM_FM_SEARCH_PM: 'PM作業を検索...',
				PM_FM_SHOW_ALL: 'すべて表示',
				PM_FM_SHOW_MAPPED: 'マッピング済み',
				PM_FM_SHOW_UNMAPPED: '未マッピング',
				PM_FM_SHOW_ZERO_COVERAGE: '未対応',
				PM_FM_LEGEND_FULL: '1 = 完全対応',
				PM_FM_LEGEND_PARTIAL: '0.1-0.9 = 部分的な関連',
				PM_FM_LEGEND_EMPTY: '空欄 = 未マッピング',
				PM_FM_CONFIRM_ALL: '残りをすべて確定',
				PM_FM_CONFIRM_ROW: 'マッピングを確定',
				PM_FM_UNMAP: 'マッピング解除',
				PM_FM_NO_PM_ATTACHED: 'PM作業が設定されていません',
				PM_FM_NO_FM_ATTACHED: '故障モードが設定されていません',
				PM_FM_STALE_BANNER: 'このマッピングの生成後にPMまたはFMEAが変更されました。新規または変更された項目は下記に未マッピングとして表示されます。直接マッピングするか、「再生成」でRootyに最初から再分析させることもできます（確認済みのマッピングは上書きされます）。',
				PM_FM_REGENERATE: '再生成',
				PM_FM_UNMAPPED_COUNT: '未マッピング {{count}} 件',
				PM_FM_ZERO_COVERAGE_HEADING: '未対応の故障モード',
				PM_FM_NEW_PM_PROPOSALS: '新規PM提案',
				PM_FM_ACCEPT_PROPOSAL: '提案を採用'
			}
		},
		CONFIGURATION: {
			CASES: {
				TITLE: 'ケース設定',
				LAST_UPDATED_BY: '最終更新者: {{name}} - {{date}}',
				MATRIX_TITLE: '発生可能性影響マトリクス',
				MATRIX_SUBTITLE: '（定数 M1 — 計算に使用可能）',
				VALUE_INPUT_TITLE: '値入力',
				VALUE_INPUT_SUBTITLE: '（ユーザーがケースの値フィールドに入力できる値）',
				CALCULATIONS_TITLE: '計算',
				CALCULATIONS_SUBTITLE: '（ケース内のユーザー設定値計算）',
				OPTIONAL_TITLE: 'オプション',
				OPTIONAL_SUBTITLE: '（追跡目的でケースに追加できる追加フィールド）',
				COL_CONSTANT: '定数',
				COL_UNIT_FIELD: 'ユニットフィールド',
				COL_FIELD_UOM: 'フィールド単位',
				COL_DEFAULT_VALUE: 'デフォルト値',
				COL_ACTIONS: '操作',
				COL_CALCULATION: '計算',
				COL_UOM: '単位',
				COL_FORMULA: '数式',
				COL_FIELD: 'フィールド',
				COL_VALUE: '値',
				COL_UNIT_OF_MEASURE: '計測単位',
				ADD: '追加',
				ADD_ROW: '行を追加',
				CANCEL: 'キャンセル',
				SAVE: '保存',
				SAVE_SUCCESS: 'ケース設定が正常に保存されました',
				IMPACT: '影響',
				LIKELIHOOD: '発生可能性',
				DELETE_ROW: '行を削除',
				PLACEHOLDER_UNIT_FIELD: 'ユニットフィールドを入力',
				PLACEHOLDER_FIELD_UOM: 'フィールド単位を入力',
				PLACEHOLDER_DEFAULT_VALUE: 'デフォルト値を入力',
				PLACEHOLDER_CALCULATION: '計算名を入力',
				PLACEHOLDER_UOM: '単位を入力',
				PLACEHOLDER_FORMULA: '数式を入力',
				PLACEHOLDER_FIELD_NAME: 'フィールド名を入力',
				DUPLICATE_FIELD_NAME: 'フィールド名は一意である必要があります',
				PLACEHOLDER_VALUE: '値を入力',
				PLACEHOLDER_UNIT_OF_MEASURE: '計測単位を入力',
				RESET_TO_DEFAULTS: 'デフォルトに戻す',
				RESET_MATRIX_CONFIRM_TITLE: 'デフォルトに戻しますか？',
				RESET_MATRIX_CONFIRM_DESC: 'これにより、<strong>可能性・影響度マトリックス</strong>は元のデフォルト値にリセットされます。行ったカスタム変更は失われます。',
				RESET_MATRIX_CONFIRM_OK: '確認',
				LOAD_ERROR: 'ケース設定の読み込みに失敗しました',
				SAVE_ERROR: 'ケース設定の保存に失敗しました',
				RESET_ERROR: 'ケース設定のリセットに失敗しました',
				CONSTANT_USED_IN_FORMULA: 'この定数は数式で使用されています',
				FORMULA: {
					UNDEFINED_CONSTANT: '定数「{{constant}}」は定義されていません',
					INVALID_CHARACTER: '数式にサポートされていない文字または演算子が含まれています',
					UNBALANCED_PARENTHESES: '数式の括弧が対応していません',
					EMPTY_PARENTHESES: '数式に空の括弧があります',
					MISSING_OPERATOR: '数式の値の間に演算子がありません',
					INVALID_OPERATOR_POSITION: '数式の演算子の位置が正しくありません',
					TRAILING_OPERATOR: '数式を演算子で終えることはできません'
				}
			},
			FILTER: {
				TITLE: 'フィルター',
				SEARCH: '検索'
			},
			ASSET_TEMPLATE: {
				TITLE: 'アセットテンプレートリスト',
				SEARCH: '検索',
				TOOLTIP_ADD: '新しいアセットを追加',
				TOOLTIP_DELETE: 'アセットを削除',
				TOOLTIP_SYNC: '同期',
				TOOLTIP_SYNC_PROGRESS: '同期進行中',
				SYNC_STARTED_TOAST: 'アセットテンプレートの同期を開始しました。',
				SYNC_COMPLETED_TOAST: 'アセットテンプレートの同期が完了しました。',
				SYNC_FAILED_TOAST: 'アセットテンプレートの同期に失敗しました{{errorSuffix}}。',
				COL_INDEX: '番号',
				COL_TEMPLATE_NAME: 'テンプレート名',
				COL_APPLICATION: 'アプリケーション',
				COL_CREATED_ON: '作成日',
				COL_ACTIONS: 'アクション',
				NO_RECORDS: 'レコードが見つかりません',
				NO_MATCHES: '"{{keyword}}" の結果が見つかりません',
				TRY_DIFFERENT_KEYWORD_CLEAR_SEARCH: '別のキーワードを試すか、検索をクリアしてください',
				LOADING: '読み込み中...'
			},
			TAGS: {
				TOOLTIP_UPLOAD_SCADA: 'タグSCADAマッピングをアップロード',
				TITLE: 'タグリスト',
				SEARCH: '検索',
				TOOLTIP_ADD: '新しいタグを追加',
				TOOLTIP_UPLOAD: 'タグをアップロード',
				TOOLTIP_DOWNLOAD: 'タグリストをダウンロード',
				TOOLTIP_TAG_MAPPING: 'タグマッピングへ移動',
				TOOLTIP_DELETE: 'タグを削除',
				TOOLTIP_NO_FAILURE_MODES: '関連する故障モードなし',
				TOOLTIP_VIEW_CHANGES: '変更を表示',
				COL_INDEX: '番号',
				COL_NAME: '名前',
				COL_TAG_ID: 'タグID',
				COL_SHARED: '共有',
				COL_UNIT: '単位',
				COL_FAILURE_MODES: '故障モード',
				COL_MODELLING: 'モデリングに使用',
				COL_CALCULATED: '計算済み',
				COL_DESCRIPTION: '説明',
				COL_ASSET: 'アセット',
				COL_ACTIONS: 'アクション',
				NO_TAGS: '選択されたアセットで利用可能なタグはありません',
				NO_MATCHES: '"{{keyword}}" の結果が見つかりません',
				TRY_DIFFERENT_KEYWORD_CLEAR_SEARCH: '別のキーワードを試すか、検索をクリアしてください'
			},
			FAILURE_MODE: {
				TITLE: '故障モードリスト',
				SEARCH: '検索',
				TOOLTIP_UPLOAD: '故障モードをアップロード',
				TOOLTIP_ADD: '新しい故障モードを追加',
				TOOLTIP_EDIT: '故障モードを編集',
				TOOLTIP_FILTER: 'フィルター',
				TOOLTIP_DELETE: '削除',
				TOOLTIP_EDIT_DIRECTIONALITY: 'タグの方向性を編集',
				COL_INDEX: '番号',
				COL_NAME: '名前',
				COL_DESCRIPTION: '説明',
				COL_TAG: 'タグ',
				COL_ASSET: 'アセット',
				COL_RECOMMENDATIONS: '推奨事項',
				COL_ACTIONS: 'アクション',
				NO_RECORDS: 'レコードが見つかりません'
			},
			DIGITIZATION: {
				TITLE: 'デジタル化リスト',
				SEARCH: '検索',
				TOOLTIP_ADD: '新しいデジタル化を追加',
				TOOLTIP_DELETE: 'デジタル化を削除',
				COL_INDEX: '番号',
				COL_MANUFACTURER: 'メーカー',
				COL_MODEL: 'モデル',
				COL_INDUSTRY_TYPE: '業種',
				COL_MODIFIED_ON: '更新日',
				COL_CREATED_ON: '作成日',
				NO_RECORDS: 'レコードが見つかりません',
				NO_MATCHES: '"{{keyword}}" の結果が見つかりません',
				TRY_DIFFERENT_KEYWORD_CLEAR_SEARCH: '別のキーワードを試すか、検索をクリアしてください'
			},
			TABS: {
				ASSET_TEMPLATE: 'アセットテンプレート',
				ASSETS: 'アセット',
				DIGITIZATION: 'デジタル化',
				SETTINGS: '設定',
				CASES: 'ケース'
			},
			SETTINGS: {
				TITLE: '設定を更新',
				COL_INDEX: '#',
				COL_PAGE_NAME: 'ページ名',
				COL_LAST_UPDATED: '最終更新日',
				COL_UPDATED_BY: '更新者',
				TOOLTIP_SETTINGS: '設定',
				LOADING: '設定を読み込んでいます...',
				NO_SETTINGS: '設定が見つかりません'
			},
			ASSETS: {
				TITLE: 'アセット一覧',
				SEARCH: '検索',
				TOOLTIP_FILTER: 'アセットをフィルター',
				TOOLTIP_DELETE: 'アセットを削除',
				TOOLTIP_VIEW_CHANGES: '変更を表示',
				COL_INDEX: '番号',
				COL_NAME: 'アセット名',
				COL_TYPE: 'アセットタイプ',
				COL_UNIT: 'ユニット',
				COL_SYSTEM: 'システム',
				COL_APPLICATION: 'アプリケーション',
				COL_CONFIGURATION: '設定',
				COL_INDUSTRY: '業界',
				COL_AUTHOR: '作成者',
				COL_MAKE_MODEL: 'メーカー & モデル',
				COL_MAINTENANCE: '保全データ',
				NO_RECORDS: 'レコードが見つかりません',
				NO_MATCHES: '"{{keyword}}" の結果が見つかりません',
				TRY_DIFFERENT_KEYWORD_CLEAR_SEARCH: '別のキーワードを試すか、検索をクリアしてください',
			},
			FM_MAPPING_MENU: {
				HIGH: '高',
				LOW: '低',
				STABLE: '安定',
				REFERENCE: '参照',
				UNMAPPED: 'マッピング未設定',
				TOOLTIP_HIGH_PRIMARY: '高 - 主要故障モード',
				TOOLTIP_HIGH_SECONDARY: '高 - 二次故障モード',
				TOOLTIP_LOW_PRIMARY: '低 - 主要故障モード',
				TOOLTIP_LOW_SECONDARY: '低 - 二次故障モード',
				TOOLTIP_STABLE_PRIMARY: '安定 - 主要故障モード',
				TOOLTIP_STABLE_SECONDARY: '安定 - 二次故障モード',
				TOOLTIP_REFERENCE: '参照故障モード',
				FM_LOGIC: 'FMロジック',
				HIGH_INCREASING: '高/増加',
				LOW_DECREASING: '低/減少',
				RULE_BASED: 'ルールベース',
				UNMAP: 'マッピング解除',
				RULE_BASED_CONDITION: 'ルールベース条件',
				OPERATOR: '演算子',
				COMPARE_TO: '比較対象',
				ENTER_VALUE: '値を入力',
				NUMERIC_INPUT_ONLY: '数値入力のみ',
				PREFERENCE: '設定',
				APPLY: '適用'
			},
			QUICK_FILTER: {
				NO_MATCHES: '"{{keyword}}" の結果が見つかりません',
				TRY_DIFFERENT_KEYWORD_CLEAR_SEARCH: '別のキーワードを試すか、検索をクリアしてください',
				CLOSE: '閉じる',
			},
			DIGITIZATION_POPUP: {
				FORM_ERROR: 'おっと！メーカーとモデル名はすでに使用されています。内容を修正して再度送信してください。',
				MANUFACTURER: 'メーカー',
				MANUFACTURER_NAME: 'メーカー名',
				MODEL: 'モデル',
				MODEL_NAME: 'モデル名',
				INDUSTRY_TYPE: '業種',
				ENTER: '入力',
				SELECT: '選択',
				IS: 'は',
				CUT_IN_SPEED: 'カットイン速度(m/s)',
				CUT_IN_SPEED_LABEL: 'カットイン速度',
				CUT_OFF_SPEED: 'カットアウト速度(m/s)',
				CUT_OFF_SPEED_LABEL: 'カットアウト速度',
				CAPACITY_KWH: 'KWHで値を入力',
				CAPACITY: '容量',
				IS_REQUIRED: 'は必須です',
				SMALLER_THAN_CUTOFF: 'カットオフより小さい必要があります',
				GREATER_THAN_CUTIN: 'カットインより大きい必要があります',
				GREATER_THAN_ZERO: '0より大きい必要があります',
				POWER_CURVE: '出力曲線',
				REQUIRED: '必須',
				UPLOAD_POWER_CURVE: '出力曲線をアップロード',
				DOWNLOAD_SAMPLE: 'サンプル/以前アップロードしたファイルをダウンロード',
				VIEW_POWER_CURVE: 'アップロードした出力曲線データを表示',
				ERROR_CODE_MAP: 'エラーコードマップ',
				UPLOAD_SCADA: 'SCADAイベントコードをアップロード',
				VIEW_SCADA: 'アップロードしたSCADAイベントコードデータを表示',
				CANCEL: 'キャンセル',
				CANCEL_TOOLTIP: '変更をキャンセル',
				SAVE: '保存',
				SAVE_TOOLTIP: '変更を保存'
			},
			FAILURE_MODE_POPUP: {
				FORM_ERROR: 'おっと！内容を修正して再度送信してください。',
				NAME: '名前',
				IS: 'は',
				PRIORITY: '優先度',
				REQUIRED: '必須',
				START_TIME: '開始時刻（時間）',
				START_TIME_LABEL: '開始時刻',
				END_TIME: '終了時刻（時間）',
				END_TIME_LABEL: '終了時刻',
				IS_REQUIRED: 'は必須です',
				TIME_RANGE: '範囲は0.1〜48時間である必要があります',
				DESCRIPTION: '説明',
				RELIABILITY_SAVINGS: '信頼性の節約（潜在）',
				MAINTENANCE_SAVINGS: '保全コスト削減（潜在）',
				PERFORMANCE_SAVINGS: 'パフォーマンスの節約（潜在）',
				REMARK: '備考',
				REMARK_TO_EDIT: '編集用備考',
				ENTER: '入力',
				CANCEL: 'キャンセル',
				CANCEL_TOOLTIP: '変更をキャンセル',
				SAVE: '保存',
				SAVE_TOOLTIP: '変更を保存'
			},
			TAG_DIRECTIONALITY_POPUP: {
				FORM_ERROR: 'おっと！内容を修正して再度送信してください。',
				TAG_NAME: 'タグ名',
				DIRECTIONALITY: '方向性',
				SELECT: '選択',
				CANCEL: 'キャンセル',
				CANCEL_TOOLTIP: '変更をキャンセル',
				SAVE: '保存',
				SAVE_TOOLTIP: '変更を保存'
			},
			FM_RECOMMENDATION_POPUP: {
				FORM_ERROR: 'おっと！内容を修正して再度送信してください。',
				RECOMMENDATION: '推奨事項',
				IS: 'は',
				CATEGORY: 'カテゴリ',
				SELECT: '選択',
				SELECT_FAILURE: '故障を選択',
				FAILURE: '故障',
				REMARK: '備考',
				REMARK_TO_EDIT: '編集用備考',
				ENTER: '入力',
				CANCEL: 'キャンセル',
				CANCEL_TOOLTIP: '変更をキャンセル',
				SAVE: '保存',
				SAVE_TOOLTIP: '変更を保存'
			},
			TAGS_POPUP: {
				FORECASTING: '予測',
				PERFORMANCE_DEGRADATION: '性能劣化',
				PERFORMANCE_DEGRADATION_HINT: '（このタグの介入までの時間予測を有効にする）',
				DYNAMIC_DEVIATION_THRESHOLD: '動的偏差しきい値',
				DEVIATION_LOW: '低',
				DEVIATION_MEDIUM: '中',
				DEVIATION_HIGH: '高',
				ERRATIC_DETECTION: '不安定検出',
				ERRATIC_ALERT: '不安定アラート',
				MISSING_DATA_DETECTION: '欠損データ検出',
				OUTLIER_DETECTION: '外れ値検出',
				OUT_OF_RANGE_DETECTION: '範囲外検出',
				DATA_QUALITY_ALERT_GENERATION: 'データ品質アラート生成',
				DATA_QUALITY_ALERT_DESC: '検出されたデータ品質の問題のうち、アラートを生成するものを選択します。アラート生成をオフにしてもデータ品質の計算は停止しません。値は引き続きデータ品質テーブルに表示されます。',
				FLATLINE_ALERT: 'フラットラインアラート',
				MISSING_DATA_ALERT: '欠損データアラート',
				OUTLIER_ALERT: '外れ値アラート',
				OUT_OF_RANGE_ALERT: '範囲外アラート',
				ALERTS_NOTIFICATIONS_KPI: 'アラート、通知、KPI',
				OPERATIONAL_LIMITS: '操業限界',
				ADDITIONAL_SETTINGS: '追加設定',
				NO_TAGS_WITH_TAGID_MAPPED: 'マッピングされたTagIdを持つタグが見つかりません。',
				FUNCTION_NAME: '関数名',
				DATA_QUALITY_DETECTION: 'データ品質検出',
				SELECT_TAG_TO_ADD_MORE: '最初のタグを選択すると、さらにタグを追加できるようになります',
				ENTER_FORMULA: '数式を入力*',
				LOWER: '下限',
				UPPER: '上限',
				START: '開始',
				END: '終了',
				DEADLINE: '期限',
				FORMULA_PLACEHOLDER: '数式を入力してください。例 (t1+t2)*t3',
				SELECT_TAG: 'タグを選択',
				SELECT_KEY: 'キーを選択',
				VALUE: '値',
				FORM_ERROR: 'おっと！内容を修正して再度送信してください。',
				TAG_NAME: 'タグ名',
				DESCRIPTION: '説明',
				TAG_ID: 'タグID',
				UNIT: 'ユニット',
				INSTRUMENT_RANGE: '計器レンジ',
				TRIP_LIMITS: 'トリップ限界',
				THRESHOLD_ALERT: 'しきい値アラート',
				THRESHOLD_ALERT_DELAY: 'しきい値アラート遅延',
				IOW_CRITICALITY: 'IOW重要度',
				DIRECTIONALITY: '方向性',
				DIRECTION: '方向',
				FLATLINE_DETECTION: 'フラットライン検出',
				ATTENTION: '注意',
				THRESHOLD_NOTIFICATION: 'しきい値通知',
				KPI: 'KPI',
				STRING_CURRENT: 'ストリング電流',
				STRING_CAPACITY: 'ストリング容量',
				SCADA_ERROR_CODES: 'SCADAエラーコード',
				COMMA_SEPARATED_ERROR_CODES: 'カンマ区切りのエラーコードを追加',
				ASSET: 'アセット',
				CALCULATED_FLAG: '計算フラグ',
				REMARK: '備考',
				REMARK_TO_EDIT: '編集用備考',
				FUNCTION_TABLE: '関数テーブル',
				PARAMETERS: 'パラメータ',
				CONSTANTS: '定数',
				PLOT_CONTINUOUS: '連続折れ線トレンドとして表示（欠損値を無視）',
				ENTER: '入力',
				SELECT: '選択',
				WRITE_CUSTOM_CODE: 'カスタムコードを記述',
				UPLOAD_TAGS: 'タグをアップロード',
				DOWNLOAD_CORRELATION_CSV: '相関CSVフォーマットをダウンロード',
				UPLOAD_CORRELATION_CSV: '相関CSVをアップロード',
				DELETE: '削除',
				ADD: '追加',
				CANCEL: 'キャンセル',
				CANCEL_TOOLTIP: '変更をキャンセル',
				SAVE: '保存',
				SAVE_TOOLTIP: '変更を保存',
				ALARM_LIMITS: 'アラーム限界',
				THRESHOLD_LIMITS: 'しきい値限界',
				CORRELATION_CSV_UPLOAD_LABEL: '相関CSVアップロード',
				TRIAL_RUN: 'トライアルラン',
				SELECT_PYTHON_FUNCTION: 'Python関数を選択',
				SEARCH_FUNCTIONS_PLACEHOLDER: '関数を検索...',
				NO_MATCHING_FUNCTION_FOUND: '一致する関数が見つかりません',
				SELECT_FUNCTION_ERROR: 'Python関数を選択してください',
				DEPRECATED: '非推奨',
				DEPRECATED_FORMULA_TOOLTIP: 'この関数は非推奨です。更新された関数を選択してください。',
				DEPRECATED_FORMULA_ERROR: 'この関数は非推奨です。更新された関数を選択してください。',
				CUSTOM_FORMULA_INVALID_VARS: '無効な変数が使用されています',
				CUSTOM_FORMULA_INVALID_SYNTAX: '無効な変数/数式です',
				CUSTOM_FORMULA_REQUIRED: '数式は必須です',
				SEARCH_ASSETS_PLACEHOLDER: 'アセットを検索...',
				NO_MATCHING_ASSET_FOUND: '一致するアセットが見つかりません',
				SEARCH_DOTS: '検索...',
				NO_MATCHING_TAG_FOUND: '一致するタグが見つかりません',
				NO_TAGS_FOUND_WITH_TAGID_MAPPED: 'TagId がマッピングされたタグが見つかりません。',
				SEARCH_PLAIN: '検索',
				NO_MATCHING_KEY_FOUND: '一致するキーが見つかりません',
				PARAMETER_NAME_HINT: 'パラメータ名',
				CONSTANT_NAME_HINT: '定数名',
				DISPLAY_EXPRESSION: '表示式',
				DISPLAY_EXPRESSION_PLACEHOLDER: '式を入力してください',
				EXPRESSION_DESCRIPTION: '式の説明',
				EXPRESSION_DESCRIPTION_PLACEHOLDER: '式の説明を入力してください'
			},
			ASSET_TEMPLATE_DELETE: {
				TITLE: 'アセット削除の確認',
				CONFIRM_MSG: 'このアセットを削除してよろしいですか？',
				ASSOCIATED_ITEMS_MSG: 'このアセットに関連する以下の項目も削除しますか？',
				DELETE_TAGS: '関連タグを削除',
				DELETE_FAILURE_MODES: '関連故障モードを削除',
				DELETING: '削除中...',
				CANCEL: 'キャンセル',
				DELETE: '削除'
			},
			FM_INFO: {
				TITLE: '故障モード情報',
				TOOLTIP_ADD: '追加',
				TOOLTIP_EDIT: '編集',
				TOOLTIP_UPLOAD: 'アップロード',
				TOOLTIP_DOWNLOAD: 'ダウンロード',
				TOOLTIP_EDIT_MAPPING: 'マッピングを編集',
				TOOLTIP_DELETE: '削除',
				TOOLTIP_VIEW_CHANGES: '変更を表示',
				UPLOAD_FAILURE_MODES: '故障モードをアップロード',
				UPLOAD_FM_TAG_MAPPINGS: '故障からタグへのマッピングをアップロード',
				DOWNLOAD_FAILURE_MODES: '故障モードをダウンロード',
				DOWNLOAD_FM_TAG_MAPPINGS: '故障からタグへのマッピングをダウンロード',
				COL_FAILURE_MODE: '故障モード',
				COL_START_TIME: '開始時刻',
				COL_END_TIME: '終了時刻',
				COL_PRIORITY: '優先度',
				COL_ACTIONS: 'アクション',
				PRIORITY_DESCRIPTION: '影響優先度の説明',
				NO_RECORDS: '選択されたアセットで利用可能な故障モードはありません'
			},
			RECOMMENDATIONS: {
				TITLE: '推奨事項',
				TOOLTIP_ADD: '追加',
				TOOLTIP_EDIT: '編集',
				TOOLTIP_UPLOAD: 'アップロード',
				TOOLTIP_DOWNLOAD: 'ダウンロード',
				TOOLTIP_EDIT_MAPPING: 'メカニズムから推奨事項へのマッピングを編集',
				TOOLTIP_DELETE: '削除',
				TOOLTIP_VIEW_CHANGES: '変更を表示',
				UPLOAD_RECOMMENDATIONS: '推奨事項をアップロード',
				UPLOAD_REC_FM_MAPPINGS: '推奨事項からFMへのマッピングをアップロード',
				DOWNLOAD_RECOMMENDATIONS: '推奨事項をダウンロード',
				DOWNLOAD_REC_FM_MAPPINGS: '推奨事項からFMへのマッピングをダウンロード',
				COL_RECOMMENDATIONS: '推奨事項',
				COL_CATEGORY: 'カテゴリ',
				NO_RECORDS: '選択されたアセットで利用可能な推奨事項はありません'
			},
			ASSET_TEMPLATE_SYNC: {
				SYNC_MSG: 'アセットテンプレートに以下の変更が加えられました。このテンプレートを使用して作成されたアセットに同期するかどうかを確認してください。',
				ASSETS: 'アセット',
				SELECT_ALL: 'すべて選択',
				TAGS: 'タグ',
				FAILURES: '故障',
				RECOMMENDATIONS: '推奨事項',
				CLOSE_TOOLTIP: 'ポップアップを閉じる',
				CANCEL: '閉じる',
				DONT_SYNC: '同期しない',
				DONT_SYNC_TOOLTIP: '変更を同期しない',
				SYNC: '同期',
				SYNC_TOOLTIP: '変更を同期'
			},
			TAG_TEMPLATE_LIST: {
				TITLE: 'タグ一覧',
				SEARCH: '検索',
				TOOLTIP_SEARCH: '検索',
				TOOLTIP_ADD: '新しいタグを追加',
				TOOLTIP_UPLOAD: 'タグをアップロード',
				TOOLTIP_DOWNLOAD: 'タグリストをダウンロード',
				TOOLTIP_CLONE: 'タグをクローン',
				TOOLTIP_DELETE: 'タグを削除',
				TOOLTIP_VIEW_CHANGES: '変更を表示',
				COL_INDEX: '番号',
				COL_TAG_TYPE: 'タグタイプ',
				COL_NAME: '名前',
				COL_DESCRIPTION: 'タグの説明',
				COL_UNIT: 'ユニット',
				COL_FAILURE_MODES: '故障モード',
				COL_DIRECTIONALITY: '方向性',
				COL_CALCULATED: '計算済み',
				COL_ACTIONS: 'アクション',
				NO_RECORDS: '選択されたアセットで利用可能なタグはありません',
				TOOLTIP_NO_FM: '関連する故障モードがありません',
				NO_MATCHES: '"{{keyword}}" の結果が見つかりません',
				TRY_DIFFERENT_KEYWORD_CLEAR_SEARCH: '別のキーワードを試すか、検索をクリアしてください',
				LOADING: '読み込み中...'
			},
			SUBSYSTEMS: {
				TITLE: 'サブシステム',
				SEARCH: '検索'
			},
			ASSET_TEMPLATE_POPUP: {
				FORM_ERROR: 'おっと！内容を修正して再度送信してください。',
				NAME: '名前',
				IS: 'は',
				ALREADY_TAKEN: '既に使用されています',
				TEMPLATE_NAME: 'テンプレート名',
				APPLICATION: 'アプリケーション',
				TEMPLATE_APPLICATION: 'テンプレートアプリケーション',
				PLEASE_ENTER: '入力してください',
				CANCEL: 'キャンセル',
				CANCEL_TOOLTIP: '変更をキャンセル',
				SAVE: '保存',
				SAVE_TOOLTIP: '変更を保存'
			},
			ASSETS_FM_INFO: {
				TITLE: '故障モード情報',
				TOOLTIP_ADD: '追加',
				TOOLTIP_EDIT: '編集',
				TOOLTIP_UPLOAD: 'アップロード',
				TOOLTIP_DOWNLOAD: 'ダウンロード',
				TOOLTIP_EDIT_MAPPING: 'タグからメカニズムを編集',
				TOOLTIP_DELETE: '削除',
				TOOLTIP_VIEW_CHANGES: '変更を表示',
				UPLOAD_FAILURE_MODES: '故障モードをアップロード',
				UPLOAD_FM_TAG_MAPPINGS: '故障からタグへのマッピングをアップロード',
				DOWNLOAD_FAILURE_MODES: '故障モードをダウンロード',
				DOWNLOAD_FM_TAG_MAPPINGS: '故障からタグへのマッピングをダウンロード',
				COL_STATUS: 'ステータス',
				COL_FAILURE_MODE: '故障モード',
				COL_PRIORITY: '優先度',
				COL_START_TIME: '開始時刻',
				COL_END_TIME: '終了時刻',
				COL_ACTIONS: 'アクション',
				PRIORITY_DESCRIPTION: '影響優先度の説明',
				NO_RECORDS: '選択されたアセットで利用可能な故障モードはありません'
			},
			TAG_FM_POPUP: {
				TITLE: 'タグからメカニズム',
				TAG_NAME: 'タグ名',
				SEARCH_TAG: 'タグを検索',
				CANCEL: 'キャンセル',
				CANCEL_TOOLTIP: '変更をキャンセル',
				SAVE: '保存',
				SAVE_TOOLTIP: '変更を保存',
				NO_RECORDS: "タグおよび故障モードは見つかりません",
				NO_MATCHES: '"{{keyword}}" の結果が見つかりません',
				TRY_DIFFERENT_KEYWORD_CLEAR_SEARCH: '別のキーワードを試すか、検索をクリアしてください',
			},
			ASSETS_RECOMMENDATIONS: {
				TITLE: '推奨事項',
				TOOLTIP_ADD: '追加',
				TOOLTIP_EDIT: '編集',
				TOOLTIP_UPLOAD: 'アップロード',
				TOOLTIP_DOWNLOAD: 'ダウンロード',
				TOOLTIP_EDIT_MAPPING: 'メカニズムから推奨事項へのマッピングを編集',
				TOOLTIP_DELETE: '削除',
				TOOLTIP_VIEW_CHANGES: '変更を表示',
				UPLOAD_RECOMMENDATIONS: '推奨事項をアップロード',
				UPLOAD_REC_FM_MAPPINGS: '推奨事項からFMへのマッピングをアップロード',
				DOWNLOAD_RECOMMENDATIONS: '推奨事項をダウンロード',
				DOWNLOAD_REC_FM_MAPPINGS: '推奨事項からFMへのマッピングをダウンロード',
				COL_RECOMMENDATIONS: '推奨事項',
				COL_CATEGORY: 'カテゴリ',
				COL_ACTIONS: 'アクション',
				NO_RECORDS: '選択されたアセットで利用可能な推奨事項はありません'
			},
			REC_FM_POPUP: {
				TITLE: 'メカニズムから推奨事項',
				RECOMMENDATION: '推奨事項',
				CATEGORY: 'カテゴリ',
				OFFLINE: 'オフライン',
				ONLINE: 'オンライン',
				CANCEL: 'キャンセル',
				CANCEL_TOOLTIP: '変更をキャンセル',
				SAVE: '保存',
				SAVE_TOOLTIP: '変更を保存'
			},
			ASSET_DELETE: {
				TITLE: 'アセット削除確認',
				CONFIRM_MSG: 'このアセットを削除してよろしいですか？',
				ASSOCIATED_ITEMS_MSG: 'このアセットに関連する以下の項目も削除しますか？',
				DELETE_TAGS: '関連タグを削除',
				DELETE_FAILURE_MODES: '関連故障モードを削除',
				DELETING: '削除中...',
				CANCEL: 'キャンセル',
				DELETE: '削除'
			},
			ASSET_POPUP: {
				FORM_ERROR: 'おっと！内容を修正して再度送信してください。',
				ASSET_NAME: 'アセット名',
				ASSET_MODEL: 'アセットモデル',
				ASSET_ID: 'アセットID',
				DEPLOYED_DATE: 'デプロイ日',
				SYSTEM: 'システム',
				MAINTENANCE_DATA: '保全データ',
				PROVIDER_DATA: 'プロバイダデータ',
				ENTER: '入力',
				SELECT: '選択',
				CANCEL: 'キャンセル',
				CANCEL_TOOLTIP: '変更をキャンセル',
				SAVE: '保存',
				SAVE_TOOLTIP: '変更を保存'
			},
			NAME_MAPPING: {
				TITLE_TAG_FM: 'タグからメカニズムのアップロード',
				TITLE_REC_FM: '推奨事項からメカニズムのアップロード',
				TAG_NAME_MAPPING: 'タグ名マッピング',
				REC_NAME_MAPPING: '推奨事項名マッピング',
				TAG_NAME: 'タグ名',
				RECOMMENDATION_NAME: '推奨事項名',
				TAG_NAME_OPTIONS: 'タグ名オプション',
				REC_NAME_OPTIONS: '推奨事項名オプション',
				OPTIONS_PLACEHOLDER: 'オプション',
				NO_TAG_SUGGESTIONS: '候補が見つかりません。このタグは最終的なマッピングで使用されません。',
				TAG_DELETED_FROM_MAPPING: 'タグはマッピングから削除されました',
				NO_REC_SUGGESTIONS: '候補が見つかりません。この推奨事項は最終的なマッピングで使用されません。',
				REC_DELETED_FROM_MAPPING: '推奨事項はマッピングから削除されました',
				FM_DELETED_FROM_MAPPING: '故障モードはマッピングから削除されました',
				ACTIONS: 'アクション',
				FM_MAPPING: '故障モードマッピング',
				FM_NAME: '故障モード名',
				FM_OPTIONS: '故障モードオプション',
				TOOLTIP_CLEAR: '選択をクリア',
				TOOLTIP_DELETE_TAG: 'タグを削除',
				TOOLTIP_UNDO_TAG: 'タグの削除を元に戻す',
				TOOLTIP_DELETE_FM: '故障モードを削除',
				TOOLTIP_UNDO_FM: '故障モードの削除を元に戻す',
				CANCEL: 'キャンセル',
				CANCEL_TOOLTIP: '変更をキャンセル',
				SAVE: '保存',
				SAVE_TOOLTIP: '変更を保存'
			},
			TAG_TEMPLATE_POPUP: {
				ERRATIC_DETECTION: '不安定検出',
				ERRATIC_ALERT: '不安定アラート',
				MISSING_DATA_DETECTION: '欠損データ検出',
				OUTLIER_DETECTION: '外れ値検出',
				OUT_OF_RANGE_DETECTION: '範囲外検出',
				DATA_QUALITY_ALERT_GENERATION: 'データ品質アラート生成',
				DATA_QUALITY_ALERT_DESC: '検出されたデータ品質の問題のうち、アラートを生成するものを選択します。アラート生成をオフにしてもデータ品質の計算は停止しません。値は引き続きデータ品質テーブルに表示されます。',
				FLATLINE_ALERT: 'フラットラインアラート',
				MISSING_DATA_ALERT: '欠損データアラート',
				OUTLIER_ALERT: '外れ値アラート',
				OUT_OF_RANGE_ALERT: '範囲外アラート',
				ALERTS_AND_NOTIFICATIONS: 'アラートと通知',
				OPERATIONAL_LIMITS: '操業限界',
				DATA_QUALITY_DETECTION: 'データ品質検出',
				SELECT_TAG_TO_ADD_MORE: '最初のタグを選択すると、さらにタグを追加できるようになります',
				LOWER_RANGE: '下限範囲',
				UPPER_RANGE: '上限範囲',
				LOWER: '下限',
				UPPER: '上限',
				ALARM_LIMITS: 'アラーム限界',
				THRESHOLD_LIMITS: 'しきい値限界',
				START: '開始',
				END: '終了',
				FORMULA_PLACEHOLDER: '数式を入力してください。例 (t1+t2)*t3',
				SELECT_TAG: 'タグを選択',
				VALUE: '値',
				DELETE: '削除',
				ADD: '追加',
				FORM_ERROR: 'おっと！内容を修正して再度送信してください。',
				TAG_TYPE: 'タグタイプ',
				TAG_NAME: 'タグ名',
				TAG_DESCRIPTION: 'タグの説明',
				DESCRIPTION: '説明',
				UNIT: 'ユニット',
				INSTRUMENT_RANGE: '計器レンジ',
				TRIP_LIMITS: 'トリップ限界',
				THRESHOLD_ALERT: 'しきい値アラート',
				THRESHOLD_ALERT_DELAY: 'しきい値アラート遅延',
				DESIGN_VALUE: 'デザイン値',
				DIRECTIONALITY: '方向性',
				DIRECTION: '方向',
				IOW_CRITICALITY: 'IOW重要度',
				FLATLINE_DETECTION: 'フラットライン検出',
				ATTENTION: '注意',
				THRESHOLD_NOTIFICATION: 'しきい値通知',
				CALCULATED_FLAG: '計算フラグ',
				PARAMETERS: 'パラメータ',
				CONSTANTS: '定数',
				UPLOAD_TAGS: 'タグをアップロード',
				ENTER: '入力',
				SELECT: '選択',
				SELECT_PYTHON_FUNCTION: 'Python関数を選択',
				SEARCH_FUNCTIONS_PLACEHOLDER: '関数を検索...',
				NO_MATCHING_FUNCTION_FOUND: '一致する関数が見つかりません',
				SELECT_FUNCTION_ERROR: 'Python関数を選択してください',
				SEARCH_TAG_TYPE_PLACEHOLDER: 'タグタイプを検索...',
				NO_MATCHING_TAG_TYPE_FOUND: '一致するタグタイプが見つかりません',
				SEARCH_DOTS: '検索...',
				NO_MATCHING_TAG_FOUND: '一致するタグが見つかりません',
				PARAMETER_NAME_HINT: 'パラメータ名',
				CONSTANT_NAME_HINT: '定数名',
				DISPLAY_EXPRESSION: '表示式',
				DISPLAY_EXPRESSION_PLACEHOLDER: '式を入力してください',
				EXPRESSION_DESCRIPTION: '式の説明',
				EXPRESSION_DESCRIPTION_PLACEHOLDER: '式の説明を入力してください',
				CANCEL: 'キャンセル',
				CANCEL_TOOLTIP: '変更をキャンセル',
				SAVE: '保存',
				SAVE_TOOLTIP: '変更を保存'
			},
			TEMPLATE_NAME_MAPPING: {
				TITLE: 'タグからメカニズム',
				TAG_NAME_MAPPING: 'タグ名マッピング',
				TAG_NAME: 'タグ名',
				TAG_NAME_OPTIONS: 'タグ名オプション',
				OPTIONS_PLACEHOLDER: 'オプション',
				NO_TAG_SUGGESTIONS: '候補が見つかりません。このタグは最終的なマッピングで使用されません。',
				TAG_DELETED_FROM_MAPPING: 'タグはマッピングから削除されました',
				FM_DELETED_FROM_MAPPING: '故障モードはマッピングから削除されました',
				ACTIONS: 'アクション',
				FM_MAPPING: '故障モードマッピング',
				FM_NAME: '故障モード名',
				FM_OPTIONS: '故障モードオプション',
				TOOLTIP_CLEAR: '選択をクリア',
				TOOLTIP_DELETE_TAG: 'タグを削除',
				TOOLTIP_UNDO_TAG: 'タグの削除を元に戻す',
				TOOLTIP_DELETE_FM: '故障モードを削除',
				TOOLTIP_UNDO_FM: '故障モードの削除を元に戻す',
				CANCEL: 'キャンセル',
				CANCEL_TOOLTIP: '変更をキャンセル',
				SAVE: '保存',
				SAVE_TOOLTIP: '変更を保存'
			},
			FM_INFO_POPUP: {
				FORM_ERROR: 'おっと！内容を修正して再度送信してください。',
				NAME: '名前',
				PRIORITY: '優先度',
				START_TIME: '開始時刻（時間）',
				START_TIME_LABEL: '開始時刻',
				END_TIME: '終了時刻（時間）',
				END_TIME_LABEL: '終了時刻',
				IS: 'は',
				REQUIRED: '必須',
				DESCRIPTION: '説明',
				RELIABILITY_SAVINGS: '信頼性の節約（潜在）',
				MAINTENANCE_SAVINGS: '保全コスト削減（潜在）',
				PERFORMANCE_SAVINGS: 'パフォーマンスの節約（潜在）',
				CANCEL: 'キャンセル',
				CANCEL_TOOLTIP: '変更をキャンセル',
				SAVE: '保存',
				SAVE_TOOLTIP: '変更を保存'
			},
			TAG_FM_INFO_POPUP: {
				TITLE: "タグテンプレート故障モードマッピング",
				TAG_NAME: "タグ名",
				SEARCH_TAG: "タグを検索",
				NAME: "名前",
				TAG_ID: "タグID",
				CANCEL: "キャンセル",
				CANCEL_TOOLTIP: "変更をキャンセル",
				SAVE: "保存",
				SAVE_TOOLTIP: "変更を保存",
				NO_RECORDS: "タグおよび故障モードは見つかりません",
				NO_MATCHES: '"{{keyword}}" の結果が見つかりません',
				TRY_DIFFERENT_KEYWORD_CLEAR_SEARCH: '別のキーワードを試すか、検索をクリアしてください',
			},
			RECOMMENDATIONS_POPUP: {
				FORM_ERROR: 'おっと！内容を修正して再度送信してください。',
				RECOMMENDATION: '推奨事項',
				IS: 'は',
				CATEGORY: 'カテゴリ',
				SELECT: '選択',
				SELECT_FAILURE: '故障を選択',
				FAILURE: '故障',
				CANCEL: 'キャンセル',
				CANCEL_TOOLTIP: '変更をキャンセル',
				SAVE: '保存',
				SAVE_TOOLTIP: '変更を保存'
			},
			REC_TEMPLATE_FM_POPUP: {
				TITLE: 'メカニズムから推奨事項',
				RECOMMENDATION: '推奨事項',
				CATEGORY: 'カテゴリ',
				OFFLINE: 'オフライン',
				ONLINE: 'オンライン',
				CANCEL: 'キャンセル',
				CANCEL_TOOLTIP: '変更をキャンセル',
				SAVE: '保存',
				SAVE_TOOLTIP: '変更を保存'
			},
			SUBSYSTEM_TEMPLATE: {
				TITLE: 'サブシステムテンプレート一覧',
				SEARCH: '検索',
				TOOLTIP_ADD: '新しいサブシステムテンプレートを追加',
				TOOLTIP_EDIT: 'サブシステムテンプレートを編集',
				TOOLTIP_DELETE: 'サブシステムテンプレートを削除',
				COL_INDEX: '番号',
				COL_NAME: '名前',
				COL_DESCRIPTION: '説明',
				COL_CREATED_ON: '作成日'
			},
			SUBSYSTEM_TEMPLATE_DELETE: {
				TITLE: 'サブシステムテンプレート削除確認',
				CONFIRM_MSG: 'このサブシステムテンプレートを削除してもよろしいですか？',
				DELETING: '削除中...',
				CANCEL: 'キャンセル',
				DELETE: '削除'
			},
			SUBSYSTEM_TEMPLATE_POPUP: {
				ADD_TITLE: 'サブシステムテンプレートを追加',
				EDIT_TITLE_PREFIX: 'サブシステムテンプレートを編集',
				NAME: '名前',
				DESCRIPTION: '説明',
				NAME_TAKEN_ERROR: 'この名前は既に使用されています',
				NAME_REQUIRED_ERROR: '名前は必須です',
				FORM_ERROR: 'おっと！内容を修正して再度送信してください。',
				CANCEL: 'キャンセル',
				CANCEL_TOOLTIP: '変更をキャンセル',
				SAVE: '保存',
				SAVE_TOOLTIP: '変更を保存'
			}

		},
		ADVANCED_ANALYSIS: {
			TABS: {
				ADVANCED_ANALYSIS: '高度な分析',
				RENEWABLES: '再生可能エネルギー',
				SUMMARY: '概要',
				DOWNTIME: 'ダウンタイム',
				UNDERPERFORMANCE: 'パフォーマンス不足',
				CURTAILMENT: '制限',
				SOILING_LOSS: '汚損損失',
				LOSS_BUCKETING: '損失分類',
				MAINTENANCE: '保全'
			},
			TOOLBAR: {
				SELECT_ANALYSIS: '分析を選択',
				SEARCH_ANALYSIS: '分析を検索...',
				NO_MATCHING_ANALYSIS: '一致する分析が見つかりません',
				PUBLIC: '公開',
				SAVE_ALL: 'すべて保存',
				TOOLTIP_SAVE_ALL: 'すべての変更を保存',
				TOOLTIP_DOWNLOAD: 'すべての分析の統計をダウンロード',
				ANALYSIS_TYPE: '分析タイプ'
			},
			HEADER: {
				CREATED_BY: '作成者：',
				CREATED_ON: '作成日：'
			},
			EMPTY_STATE: {
				HEADING: '既存の分析を選択するか、新しく作成してください。',
				CONTENT: '分析を選択または追加してください。'
			},
			DESCRIPTION_LABEL: '説明：',
			POPUP: {
				FORM_ERROR: 'エラーが発生しました。いくつかの項目を変更して再送信してください。',
				NAME_PLACEHOLDER: '名前',
				NAME_ERROR_TAKEN: '既に使用されています',
				NAME_HINT: '入力してください',
				NAME_HINT_STRONG: '分析名',
				DESC_PLACEHOLDER: '説明',
				DESC_ERROR_PREFIX: '説明は',
				DESC_HINT: '入力してください',
				DESC_HINT_STRONG: '分析の説明',
				SELECT_FACILITY: '施設を選択',
				SEARCH_FACILITY: '検索',
				NO_MATCHING_FACILITY: '一致する施設が見つかりません',
				TOOLTIP_CANCEL: '変更をキャンセル',
				TOOLTIP_SAVE: '変更を保存',
				BTN_CANCEL: 'キャンセル',
				BTN_SAVE: '保存'
			},
			SAVE_CONFIRMATION: {
				TITLE: '未保存の変更',
				MESSAGE: '未保存の変更があります。続行しますか？',
				BTN_CANCEL: 'キャンセル',
				BTN_SAVE_CONTINUE: '保存して続行',
				BTN_DISCARD: '変更を破棄して続行'
			},
			COMMON: {
				BTN_OK: 'OK',
				BTN_CANCEL: 'キャンセル',
				BTN_CLOSE: '閉じる',
				BTN_RESET: 'リセット',
				BTN_SAVE: '保存',
				LOADING: '読み込み中...',
				NO_RECORDS: 'レコードが見つかりません',
				SEARCH: '検索',
				SEARCH_PLACEHOLDER: '検索...',
				TOOLTIP_DELETE: '削除',
				TOOLTIP_ADD: '追加',
				TOOLTIP_DOWNLOAD: 'ダウンロード',
				TOOLTIP_CANCEL: '変更をキャンセル',
				TOOLTIP_SAVE: '変更を保存',
				TOOLTIP_REMOVE_CARD: 'カードを削除',
				DATE_RANGE: '日付範囲'
			},
			FILTER: {
				TITLE: 'フィルター',
				UNIT: '単位',
				SYSTEM: 'システム',
				SEARCH_SYSTEM: 'システムを検索...',
				NO_MATCHING_SYSTEM: '一致するシステムが見つかりません'
			},
			BUCKETING_FILTER: {
				FACILITY_TYPE: '施設タイプ',
				SELECT_FACILITY: '施設を選択',
				TOOLTIP_CARD_VIEW: 'カードビュー',
				TOOLTIP_TABLE_VIEW: 'テーブルビュー',
				SEARCH_SYSTEM: 'システムを検索...',
				NO_SYSTEM_FOUND: 'システムが見つかりません',
				GROUP_BY: 'グループ化：',
				ENABLE_CLUSTERING: 'クラスタリングを有効化',
				SELECT_CLUSTER: 'クラスターを選択',
				WIND_DIRECTION: '風向',
				SELECTED_DATE_RANGE: '選択した日付範囲',
				START_DATE: '開始日',
				END_DATE: '終了日',
				CONFIGURE_LOSS: '損失を設定',
				SAP_FILTER_TITLE: 'SAPフィールドフィルター：'
			},
			BUCKETING_TABLE: {
				SEARCH: '検索',
				SORT_BY: '並び替え',
				SORT_NONE: 'なし',
				SORT_ASC: '昇順',
				SORT_DESC: '降順',
				COL_NAME: '名前',
				COL_GENERATION: '発電量（MWh）',
				COL_EFFICIENCY: '性能効率（%）',
				COL_BREAKDOWN_COUNT: '故障件数',
				COL_NOTIFICATION_COUNT: '通知件数',
				COL_CLOSED: 'クローズ',
				COL_OPEN: 'オープン',
				COL_BLOCK: 'ブロック',
				COL_EFF_LOSS: '効率損失',
				COL_INV: 'インバーター',
				COL_TIME: '時間（時:分）',
				COL_CURTAILMENT_LOSS: '出力制限損失（MWh）',
				COL_GEN_LOSS: '発電損失（MWh）',
				COL_GEN_LOSS_NET: '発電純損失（MWh）',
				COL_GEN_LOSS_MWH: '発電損失（MWh）',
				COL_AVAILABILITY: '可用性',
				COL_REV_LOSS: '収益損失',
				COL_MAINTENANCE_COST: '保全コスト',
				COL_DOWNTIME: 'ダウンタイム',
				COL_DURATION_PCT: '期間%',
				COL_MTTR: 'MTTR（時:分）',
				COL_ASSET: '資産',
				COL_MTBF: 'MTBF（時:分）',
				COL_IDEAL_GEN: '理想発電量（KWh）',
				COL_SOILING_LOSS: '汚損損失（KWh）',
				COL_SOILING_LOSS_PCT: '汚損損失（理想発電量の%）',
				COL_SCHEDULED_DATE: '予定清掃日',
				COL_LAST_CLEANED: '最終清掃',
				COL_LAST_CLEANED_DAYS: '（日前）',
				COL_NOTIFICATION_NO: '通知番号',
				COL_EQUIPMENT_ID: '設備ID',
				COL_FUNCTIONAL_LOC: '機能的場所',
				COL_EQUIPMENT: '設備',
				COL_DESCRIPTION: '説明',
				COL_CREATED_BY: '作成者',
				COL_CREATED_ON: '作成日',
				COL_MAINTENANCE_PLANT: '保全プラント',
				COL_PLAN_GROUP: '計画グループ',
				COL_COMPLETED_ON: '完了日',
				COL_COMPLETED_BY: '完了者',
				COL_COMPONENT: 'コンポーネント'
			},
			POWER_CURVE: {
				TITLE_PREFIX: 'パワーカーブ設定：',
				OEM: 'OEMパワーカーブ',
				CALCULATED: '計算済みパワーカーブ',
				START_DATE: '開始日',
				STOP_DATE: '終了日',
				DATE_RANGE_ERROR: '開始日は終了日より前である必要があります。',
				ADD_COMMENT: 'コメントを追加',
				COMMENT_ERROR: '有効なコメントを入力してください。'
			},
			FILTER_MIN_MAX: {
				TOOLTIP: '最小・最大フィルター',
				GREATER_THAN: '以上',
				LESS_THAN: '以下'
			},
			TAG_FILTER: {
				SELECT_TAG: 'タグを選択',
				NO_MATCHING_TAG: '一致するタグが見つかりません'
			},
			LIST_CARD: {
				NO_MATCHING_TAG: '一致するタグが見つかりません'
			},
			LIST_XY_CARD: {
				X_AXIS: 'X軸',
				Y_AXIS: 'Y軸',
				SEARCH_X: 'Xを検索...',
				SEARCH_Y: 'Yを検索...',
				NO_MATCHING_X: '一致するXが見つかりません',
				NO_MATCHING_Y: '一致するYが見つかりません'
			},
			CHART: {
				TOOLTIP_DOWNLOAD_TAG: 'タグデータをダウンロード',
				TOOLTIP_NO_ACCESS: 'この分析項目で使用されているユニットとシステムへのアクセス権がありません。そのため無効化されています。',
				TOOLTIP_REMOVE_FILTER: 'フィルターを削除',
				LOCK_X_AXIS: 'X軸をロック（日付）',
				MULTI_AXIS: '複数軸',
				TRIP_LIMIT: 'トリップ限界',
				ALARM_LIMIT: 'アラーム限界',
				THRESHOLD_LIMIT: 'しきい値限界',
				INSTRUMENT_RANGE: '計器範囲',
				LOCK_X_AXIS_ALERT_TOOLTIP: 'アラート比較ではロック解除できません',
				TYPE_SIGNAL_VS_TIME: '信号 vs 時間 @ 異なる期間',
				TYPE_SIGNAL_VS_SIGNAL: '信号 vs 信号 @ 異なる期間',
				TYPE_STATE_SIGNAL: '運転状態の信号分析',
				TYPE_STATE_SIGNAL_VS_SIGNAL: '運転状態における信号 vs 信号',
				TYPE_MULTISIGNAL: '運転状態における多信号分析',
				TYPE_MULTISIGNAL_VS_SIGNAL: '運転状態における多信号 vs 信号',
				TYPE_FULL_SYSTEM: 'システム/設備比較',
				TYPE_ALERT_COMPARISON: 'アラート比較'
			},
			TAG_DIALOG: {
				TITLE_PLACEHOLDER: 'タイトル',
				DESC_PLACEHOLDER: '説明',
				PLOT_TYPE_LABEL: 'グラフタイプ',
				QUICK_PLOT: 'クイックプロット',
				AXIS_TYPE_LABEL: '軸タイプ',
				AXIS_MULTI: '複数',
				AXIS_SINGLE: '単一'
			},
			SUMMARY: {
				LOADING: 'データを処理中です。しばらくお待ちください！',
				NO_DATA: 'データがありません。',
				NO_RENEWABLE_ASSETS: '再生可能エネルギー設備が見つかりませんでした',
				NO_RENEWABLE_ASSETS_SUBTITLE: '選択されたフィルターに一致する設備はありません',
				NO_SYSTEMS: 'システムが見つかりませんでした',
				NO_SYSTEMS_SUBTITLE: '選択されたフィルターと日付範囲に一致するシステムはありません。',
				NO_DOWNTIME_DATA: 'ダウンタイムデータがありません',
				NO_DOWNTIME_DATA_SUBTITLE: '選択されたフィルターと日付範囲にダウンタイムデータはありません。',
				NO_PERFORMANCE_DATA: 'パフォーマンスデータがありません',
				NO_PERFORMANCE_DATA_SUBTITLE: '選択されたフィルターと日付範囲にパフォーマンスデータはありません。',
				NO_CURTAILMENT_DATA: '出力制限データがありません',
				NO_CURTAILMENT_DATA_SUBTITLE: '選択されたフィルターと日付範囲に出力制限データはありません。',
				NO_LOSS_DATA: '損失データがありません',
				NO_LOSS_DATA_SUBTITLE: '選択されたフィルターと日付範囲に損失データはありません。',
				NO_MAINTENANCE_DATA: '保全時間データがありません',
				NO_MAINTENANCE_DATA_SUBTITLE: '選択されたフィルターと日付範囲に保全時間データはありません。',
				NO_SOILING_LOSS_DATA: '汚損損失データがありません',
				NO_SOILING_LOSS_DATA_SUBTITLE: '選択されたフィルターと日付範囲に汚損損失データはありません。',
			},
			AVAILABILITY: {
				TIME_BASED: '時間ベース可用性',
				ENERGY_BASED: 'エネルギーベース可用性',
				TARGET_SUFFIX: '目標',
				TOTAL_LOSS_TITLE: '総損失（MWh）',
				ROW_DOWNTIME: 'ダウンタイム（時:分）',
				ROW_LOST_PRODUCTION: '発電損失（MWh）',
				ROW_LOST_REVENUE: '収益損失',
				ROW_MTBF: 'MTBF（平均故障間隔 - 時:分）',
				ROW_MTTR: 'MTTR（平均修復時間 - 時:分）',
				COL_NAME: '名前',
				COL_VALUE: '値'
			},
			PERFORMANCE: {
				LOST_GENERATION: '発電損失（MWh）',
				LOST_REVENUE: '収益損失',
				BEST_PERFORMING: '最高パフォーマンス',
				WORST_PERFORMING: '最低パフォーマンス',
				SHOW_TOP: '上位表示：',
				TOTAL_LOSS_TITLE: '総損失（MWh）',
				PERF_CURVE_TITLE: 'パワーカーブ',
				WIND_ROSE_TITLE: '風配図'
			},
			CURTAILMENT: {
				LOST_GENERATION: '発電損失（MWh）',
				LOST_REVENUE: '収益損失',
				SHOW_TOP: '上位表示：',
				TOTAL_LOSS_TITLE: '総損失（MWh）'
			},
			SOILING: {
				TOTAL_LOSS_TITLE: '総損失（MWh）',
				SOILING_CURVE_SUFFIX: '汚損損失曲線',
				TOOLTIP_SAVE: '保存',
				TOOLTIP_CANCEL: 'キャンセル',
				SECTION_SOILING: '汚損',
				SECTION_TEMPERATURE: '温度',
				SECTION_OTHERS: 'その他',
				REF_SETTING: '参照設定',
				CRS: 'CRS',
				SRS: 'SRS',
				SELECT_UNIT: 'ユニットを選択',
				SELECT_SYSTEM: 'システムを選択',
				SELECT_ASSET: '資産を選択',
				SELECT_TAG: 'タグを選択',
				SEARCH: '検索',
				SEARCH_SYSTEM: 'システムを検索...',
				NO_MATCHING_UNIT: '一致するユニットが見つかりません',
				NO_MATCHING_SYSTEM: '一致するシステムが見つかりません',
				NO_MATCHING_ASSET: '一致する資産が見つかりません',
				NO_MATCHING_TAG: '一致するタグが見つかりません',
				APPLY_ON: '適用先',
				CLEANING_CYCLE: '清掃サイクル',
				CLEANING_CYCLE_HINT: '（日数）',
				BTN_START_EXPERIMENT: '実験を開始',
				TOOLTIP_FORCE_STOP: '進行中の実験を強制停止',
				TOOLTIP_UPLOAD_SOILING: '汚損比率をアップロード',
				CLEANING_UPDATE: '清掃更新',
				TOOLTIP_UPLOAD_CLEANING: '清掃スケジュールをアップロード',
				TOOLTIP_DOWNLOAD_CLEANING: '清掃更新レポートをダウンロード',
				CHOOSE_DATE: '日付を選択',
				DATE_HINT: '月/日/年',
				BTN_UPDATE: '更新'
			},
			LOSS: {
				LOST_GENERATION: '発電損失（MWh）',
				LOST_REVENUE: '収益損失',
				EFFECTIVE_PR: '有効PR',
				HIGHEST_LOSS_BUCKET: '最大損失カテゴリ',
				LOSS_BUCKETING_TITLE: '損失分類（MWh）'
			},
			MAINTENANCE: {
				CHART_TITLE: '保全時間（時:分）',
				BAD_ACTORS_TITLE: 'トップ不良要因',
				NOTIFICATION_STATUS: '通知ステータス',
				SHDJ_DISTRIBUTION: 'ユニット別SHDJ分布',
				PENDING_DEFECTS_TITLE: '未処理欠陥・老朽化レポート',
				COL_GROUP_SECTION: 'グループ/セクション',
				COL_0_30: '0 - 30日',
				COL_31_90: '31 - 90日',
				COL_91_180: '91 - 180日',
				COL_181_365: '181 - 365日',
				COL_365_500: '365 - 500日',
				COL_GRAND_TOTAL: '総計',
				MONTHLY_DEFECTS_PREFIX: '月次欠陥状況 -',
				TOTAL_MTD: '月累計欠陥総数',
				YEARLY_DEFECTS_PREFIX: '年次欠陥状況 - FY',
				TOTAL_YTD: '年累計欠陥総数',
				PM_COMPLIANCE_PREFIX: 'PMコンプライアンスレポート -',
				COL_EQUIPMENT: '設備',
				COL_SCHEDULED: '予定',
				COL_PENDING: '保留中',
				COL_COMPLETED: '完了',
				COL_COMPLIANCE: 'コンプライアンス（%）'
			},
			MESSAGES: {
				SERVER_ERROR: '内部サーバーエラー',
				SAVE_SUCCESS: '分析は正常に保存されました。',
				UPDATE_SUCCESS: '分析が更新されました。',
				ADD_SUCCESS: '分析が追加されました。',
				COPY_SUCCESS: '分析がコピーされました。',
				CARD_GENERATED: '新しい分析カードが正常に生成されました',
				POWER_CURVE_STARTED: 'パワーカーブの計算を開始しました：',
				POWER_CURVE_FAILED: 'パワーカーブの計算に失敗しました：'
			}
		},
		NOTIFICATION_WIZARD: {
			HEADER_TITLE: '通知',
			MARK_ALL_READ: 'すべて既読にする',
			SETTINGS: '設定',
			TAB_ALL: 'すべて',
			TAB_UNREAD: '新着未読',
			TAB_ASSIGNED: '自分に割り当て',
			NOTIFICATIONS_SUFFIX: '件の通知',
			TOOLTIP_MARK_READ: '既読にする',
			TOOLTIP_MARK_UNREAD: '未読にする',
			TOOLBAR_ITEM: '件',
			TOOLBAR_ITEMS: '件',
			TOOLBAR_SELECTED: '選択済み',
			TOOLBAR_MARK_READ: '既読にする',
			TOOLBAR_MARK_UNREAD: '未読にする',
			TOOLBAR_CLEAR: 'メッセージを削除',
			ERROR_TITLE: '通知を読み込めませんでした',
			ERROR_DESC: '通知の取得中にエラーが発生しました。もう一度お試しください。',
			NOTIF_OFF_TITLE: '通知がオフになっています',
			NOTIF_OFF_DESC: '通知を有効にすると、ここで更新を受け取ることができます。',
			EMPTY_DEFAULT_TITLE: '通知なし',
			EMPTY_DEFAULT_DESC: 'まだ通知はありません。通知が届くと、ここに表示されます。',
			EMPTY_CAUGHT_UP_TITLE: 'すべて確認済みです。',
			EMPTY_UNREAD_DESC: 'アラートや更新の新着通知がここに表示されます。',
			EMPTY_ASSIGNED_DESC: '自分に割り当てられた通知がここに表示されます。',
			EMPTY_ALL_TITLE: 'まだ通知はありません',
			EMPTY_ALL_DESC: '更新がここに表示されます',
			GROUP_TODAY: '今日',
			GROUP_YESTERDAY: '昨日',
			GROUP_THIS_WEEK: '今週の初め',
			GROUP_THIS_MONTH: '今月の初め',
			GROUP_LAST_MONTH: '先月',
			GROUP_OLDER: '先々月以前',
			SETTINGS_HEADER: 'ユーザー設定',
			SETTINGS_TAB_NOTIFICATIONS: '通知',
			SETTINGS_TAB_AUDIBLE: '音声アラーム',
			SETTINGS_COL_TYPE: '種類',
			SETTINGS_COL_EMAIL: 'メール',
			SETTINGS_COL_PLATFORM: 'プラットフォーム',
			SETTINGS_COL_AUDIBLE: '音声',
			SETTINGS_ALERTS_HEADER: 'アラート',
			SETTINGS_ALERTS_DESC: '新しいアラートが生成されたときに発生する通知。',
			SETTINGS_AUDIBLE_ALERTS_DESC: 'これらのアラートが生成されたときに音声アラームを再生します。',
			SETTINGS_NEW_ANOMALY: '新規異常アラート',
			SETTINGS_NEW_HIGH_ANOMALY: '新規高アノマリーアラーム',
			SETTINGS_NEW_LOW_ANOMALY: '新規低アノマリーアラーム',
			SETTINGS_NEW_THRESHOLD: '新規閾値アラート',
			SETTINGS_OWNERSHIP_HEADER: 'アラートの所有と割り当て',
			SETTINGS_OWNERSHIP_DESC: 'アラートの責任に関する通知。',
			SETTINGS_ALERT_OWNER: 'アラートオーナーとして割り当て',
			SETTINGS_ALERT_WATCHER: 'アラート監視者として割り当て',
			SETTINGS_ACTIVITY_HEADER: 'アラート履歴',
			SETTINGS_ACTIVITY_DESC: '割り当て後にユーザーが継続的な更新を受け取るかどうかを制御します。',
			SETTINGS_OWNED_ALERTS: '所有アラートの更新',
			SETTINGS_WATCHED_ALERTS: '監視アラートの更新',
			SETTINGS_SYSTEM_HEADER: 'システム更新',
			SETTINGS_SYSTEM_DESC: 'AI / システム操作に関する通知。',
			SETTINGS_MODEL_RETRAINING: 'モデル再学習完了',
			SETTINGS_AUDIBLE_FOOTER_NOTE: '音声アラームは1回鳴るか、アラームをクリックして詳細を表示するまで指定された頻度で通知し続けます。',
			PDF_HEADER: 'ケース管理 - PDF生成完了',
			PDF_GENERATED_BEFORE: 'ケース管理のPDFが正常に生成されました。',
			PDF_DOWNLOAD_LINK: 'PDFをダウンロード',
			PDF_GENERATED_AFTER: 'またはメールで送信されたリンクからアクセスしてください。ダウンロードリンクの有効期限は {{expiry}} です。',
			PDF_LINK_EXPIRED_TOOLTIP: 'このダウンロードリンクは期限切れです。ダウンロードするにはPDFを再生成してください。',
			ASSET_TEMPLATE_SYNC_STARTED_TITLE: 'アセットテンプレートの同期を開始しました – {{templateName}}',
			ASSET_TEMPLATE_SYNC_COMPLETED_TITLE: 'アセットテンプレートの同期が完了しました – {{templateName}}',
			ASSET_TEMPLATE_SYNC_FAILED_TITLE: 'アセットテンプレートの同期に失敗しました – {{templateName}}'
		},
		MAINTENANCE_OPTIMIZATION: {
			// Main component
			HEADER_TITLE: '保全最適化',
			TAB_RESULTS: '結果と価値',
			TAB_SCHEDULES: 'PMスケジュール',
			TAB_RUN_HISTORY: '実行履歴',

			// Run History
			RH_COL_SL_NO: '番号',
			RH_COL_RUN_DATE: '実行日',
			RH_COL_NAME: '名前',
			RH_COL_CREATOR: '作成者',
			RH_COL_SCOPE: '範囲',
			RH_COL_STATUS: 'ステータス',
			RH_COL_TOTAL_VALUE: '合計金額',
			RH_COL_APPROVED: '承認済み',
			RH_COL_ACTIONS: '操作',
			RH_VIEW: '表示',
			RH_EQUIPMENTS: '設備',
			RH_SEARCH_PLACEHOLDER: '実行を検索...',
			RH_EMPTY: '現在の選択に対する最適化の実行が見つかりません。',
			RH_STATUS_PENDING: '保留中',
			RH_STATUS_RUNNING: '実行中',
			RH_STATUS_PROCESSING: '処理中',
			RH_STATUS_COMPLETED: '完了',
			RH_STATUS_FAILED: '失敗',
			BTN_RUN_OPTIMIZATION: '最適化を実行',
			LAST_RUN_PREFIX: '最終最適化実行：',

			// PM Schedules
			PM_DOWNLOAD_TITLE: 'ダウンロードオプション',
			PM_DOWNLOAD_SUBTITLE: '以下のボタンを使用して、SAPまたはCMMSにアップロードできる形式でPMスケジュールをエクスポートしてください：',
			PM_DOWNLOAD_ALL_TITLE: 'すべてダウンロード（CSV）',
			PM_DOWNLOAD_ALL_DESC: 'すべてのPM活動の統合リスト',
			PM_DOWNLOAD_PER_EQ_TITLE: '設備別レポート',
			PM_DOWNLOAD_PER_EQ_DESC: '階層で選択したアセットにフィルタリング',
			PM_DOWNLOAD_CONSOLIDATED_TITLE: '統合スケジュール',
			PM_DOWNLOAD_CONSOLIDATED_DESC: '新しい間隔でグループ化',
			PM_SEARCH_PLACEHOLDER: '検索...',
			PM_GROUP_BY_INTERVAL: 'グループ化：間隔',
			PM_FILTER: 'フィルター',
			PM_COL_ID: 'ID',
			PM_COL_NAME: 'PMスケジュール名',
			PM_COL_ACCESS_CLASS: 'アクセスクラス',
			PM_COL_BUNDLE_NAME: 'バンドル名',
			PM_COL_BUNDLE_ID: 'バンドルID',
			PM_COL_PREV_INTERVAL: '前回のPM間隔',
			PM_COL_CURR_INTERVAL: '現在のPM間隔',
			PM_EACH: '毎',
			PM_DAYS: '日',

			// Results & Values
			RV_TOTAL: '合計',
			RV_POTENTIAL_VALUE: '潜在的価値',
			RV_PM_SCHEDULING: 'PMスケジューリング',
			RV_CM_REDUCTION: 'CM削減',
			RV_FAILURE_REDUCTION: '故障 / 停止削減',
			RV_BY_REC_TYPE: '推奨タイプ別',
			RV_TOTAL_ACTIVITIES: '検査済み活動合計',
			RV_INCREASES: '増加',
			RV_DECREASES: '減少',
			RV_NO_CHANGES: '変更なし',
			RV_REMOVE: '削除',
			RV_ADD: '追加',
			RV_WHERE_VALUE: '価値の所在',
			RV_BY_STATUS: 'ステータス別',
			RV_TOTAL_SCHEDULES: 'スケジュール合計',
			RV_PENDING: '保留中',
			RV_APPROVED: '承認済み',
			RV_REJECTED: '却下済み',
			RV_SEARCH_PLACEHOLDER: '検索...',
			RV_GROUP_BY_SYSTEM: 'グループ化：システム',
			RV_FILTER: 'フィルター',
			RV_COL_FREQ_REC: '頻度推奨',
			RV_COL_HIERARCHY: '階層 / PM名',
			RV_COL_REC_INTERVAL: '推奨間隔（日）',
			RV_COL_SAVINGS: '総節約額（$/年）',
			RV_COL_PM: 'PM（$/年）',
			RV_COL_CM: 'CM（$/年）',
			RV_COL_FAILURE_RISK: '故障リスク（$/年）',
			RV_COL_APPROVE: '承認 / 却下',
			RV_COL_PM_ID: 'PM ID',
			RV_COL_ACTIVITY: 'アクティビティ',
			RV_COL_ROLE: '役割',
			RV_COL_STANDALONE: 'スタンドアロン',
			RV_COL_EFFECTIVE: '実効',
			RV_COL_EVIDENCE: 'エビデンス',
			RV_COL_VALUE: '価値',
			RV_COL_STATUS: 'ステータス',
			RV_BH_CURRENT: '現在',
			RV_BH_EFFECTIVE: '実効',
			RV_BH_OUTCOME: '結果',
			RV_BH_DRIVER: 'ドライバー',
			RV_BH_VALUE: '価値',
			RV_BH_CONFIDENCE: '信頼度',
			RV_BH_STATUS: 'ステータス',
			RV_BH_ACTIVITIES: '件のアクティビティ',
			RV_BH_DRIVERS: '件のドライバー',
			RV_BH_OVERRIDES: '件のオーバーライド',
			RV_BH_UNCHANGED: '変更なし',
			RV_BH_NONE: 'なし',
			RV_BH_NO_CHANGE: '変更なし',
			RV_BH_NA: 'n/a',
			RV_DEEP_DIVE: '詳細分析',
			RV_BUNDLE_SUMMARY: 'バンドル概要',
			RV_LAST_RUN: '前回の実行',
			RV_NO_RESULTS: 'この選択に最適化結果はありません。',
			RV_SELECT_NODE: '結果を表示するには、施設、ユニット、またはシステムを選択してください。',
			RV_LOADING: '結果を読み込んでいます...',

			// MC Recommendation panel
			MC_PANEL_TITLE: '詳細分析パネル — 推奨',
			MC_ASK_ROOTY: 'Rootyに質問',
			MC_APPROVE: '承認',
			MC_REJECT: '却下',
			MC_CURRENT_FREQ: '現在の頻度',
			MC_REC_FREQ: '推奨頻度',
			MC_SHOW: '表示',
			MC_COMPACT: 'コンパクト',
			MC_ADVANCED: '詳細',
			MC_TAB_DECISION: '意思決定',
			MC_TAB_OBSERVATIONS: '観察',
			MC_TAB_FAILURE_MODES: '故障モード',
			MC_DECISION_TITLE: '意思決定',
			MC_WHY_NOW: '今なぜ',
			MC_EXPECTED_VALUE: '期待値',
			MC_SECONDARY_ACTION: '二次アクション',
			MC_REC_CONFIDENCE: '推奨信頼度',
			MC_SAVINGS_BREAKDOWN: '節約内訳',
			MC_TOTAL_ANNUAL_SAVINGS: '年間総節約額',
			MC_PREDICTIONS: '予測',
			MC_EXPECTED_OUTCOME: '推奨が受け入れられた場合の期待される結果',
			MC_INTERVAL_SENSITIVITY: '間隔感度（β / η）',
			MC_ANNUAL_CM_COUNT: '年間CM件数',
			MC_CURRENT_CM_COUNT: '現在のCM件数：',
			MC_PREDICTED_CM_COUNT: '予測新CM件数：',
			MC_ANNUAL_BD_COUNT: '年間停止件数',
			MC_CURRENT_BD_COUNT: '現在の停止件数：',
			MC_PREDICTED_BD_COUNT: '予測新停止件数：',
			MC_PM_FREQUENCY: 'PM頻度',
			MC_CURRENT: '現在：',
			MC_RECOMMENDED: '推奨：',
			MC_FM_LINK: '故障モードタブ',
			MC_OBS_REACTIVE_VS_PREVENTIVE: '事後対予防コスト比',
			MC_OBS_CM_TIMING: 'CMイベントタイミング分析',
			MC_OBS_EARLY: '早期',
			MC_OBS_MID: '中期',
			MC_OBS_LATE: '後期',
			MC_OBS_POST_PM: 'PM後再発',
			MC_OBS_EVIDENCE_LOG: '完全なエビデンスログを開く →',
			MC_FM_SERVED_BY: 'このPMが対応',
			MC_FM_SORT: '並べ替え',
			MC_FM_BY_ROLE: '役割別',
			MC_FM_EXPAND_ALL: 'すべて展開',
			MC_FM_PRIMARY: 'プライマリ',
			MC_FM_SUPPORTING: 'サポート',
			MC_FM_INCIDENTAL: '付随',
			MC_FM_AGG_B: '集計B',
			MC_FM_CM_COUNT: 'CM件数/年',
			MC_FM_BREAKDOWNS: '停止/年',
			MC_FM_DIAGNOSIS: '診断',
			MC_FM_TIMING: 'タイミング',
			MC_FM_SENSITIVITY: '感度（β）',
			MC_FM_IMPACT: '影響',
			MC_FM_EVENTS: 'イベント',
			MC_FM_DATE_COL: '日付',
			MC_FM_EVENT_COL: 'イベント',
			MC_FM_COST_COL: 'コスト',
			MC_FM_CLASS_COL: 'クラス',
			MC_TAG_INCREASE_FREQ: '頻度を増やす',
			MC_TAG_TIMING: 'タイミング駆動',
			MC_TAG_CASE2: 'ケース2',
			MC_TAG_CBM: '+ CBMセーフティネット',
			MCB_OPEN_EVIDENCE_LOG: 'エビデンスログを開く',
			MCB_DECISION_STANDALONE: 'スタンドアロン推奨',
			MCB_DECISION_EFFECTIVE: '実効バンドル推奨',
			MCB_EFFECTIVE_IS_STANDALONE: 'スタンドアロンの結果が実効結果でもあります',
			MCB_EXPECTED_IMPACT: '予想される影響',
			MCB_EFFECTIVE_BUNDLE_RESULT: '実効バンドル結果',
			MCB_PM_COST: 'PMコスト',
			MCB_PM_COST_SUB: '年間追加PM支出',
			MCB_CM_SAVINGS: 'CM削減',
			MCB_CM_SAVINGS_SUB: '予想される年間削減',
			MCB_BD_SAVINGS: '故障削減',
			MCB_BD_SAVINGS_SUB: '予想される年間削減',
			MCB_NET_VALUE: '年間正味価値',
			MCB_NET_VALUE_SUB: 'バンドル伝播後',
			MCB_CONFIDENCE: '信頼度',
			MCB_DRIVER_BASED: 'ドライバーベース',
			MCB_WHY: 'この推奨の理由',
			MCB_ADVANCED_PENDING: '詳細情報は近日公開予定です。',
			MCB_OBS_WHAT: 'エンジンが観測した内容',
			MCB_OBS_ECONOMIC: '経済スクリーニング',
			MCB_OBS_TIMING: 'タイミング',
			MCB_OBS_POSTPM: 'PM後の再発',
			MCB_TIMING_DISTRIBUTION: 'タイミング分布',
			MCB_EARLY: '早期',
			MCB_MIDDLE: '中期',
			MCB_LATE: '後期',
			MCB_FM_BUILDUP: '故障モードの構築',
			MCB_FM_BUILDUP_SUB: 'コンパクトは結論を表示します。詳細では各FMの診断、予測、信頼度、エビデンストレースを表示します。',
			MCB_DETAILS: '詳細',
			MCB_FM_DIAGNOSIS: '診断',
			MCB_FM_EVIDENCE: 'エビデンス',
			MCB_FM_TIMING: 'タイミング',
			MCB_FM_CONTRIBUTION: '寄与',
			MCB_FM_STANDALONE: 'スタンドアロン',
			MCB_FM_EFFECTIVE: '実効',
			MCB_FM_ROUTE: 'ルート',
			MCB_FM_INTERVAL_CONTRIB: '間隔への寄与',
			MCB_FM_VALUE: '価値',
			MCB_FM_STATUS: 'ステータス',
			MCB_FM_ADMIN_INTERPRETATION: '管理者の解釈',
			MCB_FM_INTERVAL_DRIVER: '間隔ドライバー',
			MCB_FM_OVERRIDDEN: 'オーバーライドされたFM',
			MCB_FM_NON_INTERVAL: '非間隔',
			MCB_STANDALONE_NOT_REALIZED: 'スタンドアロンの {{code}} 削減は実現されず、設備またはポートフォリオの合計に加算してはいけません。',
			MCB_CONF_DATA_SUFFICIENCY: 'データ充足性',
			MCB_CONF_TIMING_QUALITY: 'タイミング品質',
			MCB_CONF_MAPPING_QUALITY: 'マッピング品質',
			MCB_CONF_PRIOR_CONFIRMATION: '事前確認',
			MCB_OBS_ACTIONABILITY: '実行可能性',
			MCB_OBS_CONDITION_MODIFIER: '状態修飾子',
			MCB_OBS_DATA_GATE: 'データゲート',
			MCB_PRED_DETAILS: '予測詳細',
			MCB_PRED_B_BASE: 'B ベース',
			MCB_PRED_ASSET_MODIFIER: 'アセット修飾子',
			MCB_PRED_B_OPTIMIZATION: 'B 最適化',
			MCB_PRED_CM: 'CM 予測',
			MCB_PRED_BD: 'BD 予測',
			MCB_D_SEC_A: 'A. データゲートと分類',
			MCB_D_SEC_B: 'B. タイミングパターン',
			MCB_D_SEC_C: 'C. 負担、状態、実行可能性',
			MCB_D_SEC_D: 'D. 経済スクリーニングと診断',
			MCB_D_SEC_E: 'E. B 構築',
			MCB_D_SEC_F: 'F. 予測と価値',
			MCB_D_SEC_G: 'G. イベントエビデンス',
			MCB_D_ROUTE: 'ルート',
			MCB_D_PM_CYCLES: 'PM サイクル',
			MCB_D_QUALIFYING_EVENTS: '適格イベント',
			MCB_D_MAPPING_CONFIDENCE: 'マッピング信頼度',
			MCB_D_MEAN_MX: '平均 Mx',
			MCB_D_SPREAD: 'ばらつき Σx',
			MCB_D_EML: 'E/M/L',
			MCB_D_POSTPM: 'PostPM',
			MCB_D_RWCM_RAW: 'RWCM 生値',
			MCB_D_EFF_CM_BURDEN: '実効 CM 負担',
			MCB_D_HM: 'Hm',
			MCB_D_GM: 'Gm',
			MCB_D_PM_BURDEN: 'PM 負担',
			MCB_D_CM_BD_BURDEN: 'CM + BD 負担',
			MCB_D_RA_COST: 'Ra コスト',
			MCB_D_DIAGNOSIS: '診断',
			MCB_D_B_BASE: 'B ベース',
			MCB_D_DIRECTION: '方向',
			MCB_D_CONCENTRATION: '集中度',
			MCB_D_B_OPT: 'B 最適化',
			MCB_D_INTERVAL: '間隔',
			MCB_D_CM_PREDICTION: 'CM 予測',
			MCB_D_STANDALONE_NET: 'スタンドアロン正味',
			MCB_D_EFF_BUNDLE_NET: '実効バンドル正味',
			MCB_D_COL_EVENT: 'イベント',
			MCB_D_COL_DATE: '日付',
			MCB_D_COL_CLASS: 'クラス',
			MCB_D_COL_BD: 'BD',
			MCB_D_COL_XE: 'x<sub>e</sub>',
			MCB_D_COL_COST: 'コスト',

			// Run Configuration Dialog
			RC_TITLE: '実行設定',
			RC_TAB_SCOPE: 'スコープ',
			RC_TAB_CONFIGURE: '設定',
			RC_TAB_IMPORT: 'データインポート',
			RC_TAB_DATA_QC: 'データQC',
			RC_TAB_MAPPING: 'マッピング',
			RC_SAVE: '保存',
			RC_CANCEL: 'キャンセル',
			RC_PREVIOUS: '前へ',
			RC_NEXT: '次へ',
			RC_RUN: '実行',
			RC_CONFIGURE_TITLE: '分析の設定',
			RC_CONFIGURE_DESC: '分析プロファイル、しきい値、チューニングパラメータを設定します。ほとんどのユーザーはプロファイルを選択し、主要なパラメータのみを調整してください。詳細パラメータは内部アルゴリズムの動作を制御します。',
			RC_ASSET_CLASS_TITLE: 'アセットクラスの上書き',
			RC_ASSET_CLASS_DESC: 'リスク許容パラメータのクラス別A/B/C入力',
			RC_ANALYSIS_WINDOW_TITLE: '分析ウィンドウ',
			RC_ANALYSIS_WINDOW_DESC: 'CMSデータ分析の期間を定義します',
			RC_DURATION: '期間',
			RC_INITIAL_DATE: '開始日',
			RC_END_DATE: '終了日',
			RC_ANALYSIS_PERIOD_PREFIX: '分析期間：',
			RC_MONTHS: 'ヶ月',
			RC_SAP_NOTIFICATIONS: 'SAP通知：',
			RC_FETCHING: '取得中...',
			RC_RECORDS: '件',
			RC_ANALYSIS_PROFILE_TITLE: '分析プロファイル',
			RC_ANALYSIS_PROFILE_DESC: 'すべてのパラメータを事前調整済みのデフォルト値に設定します。以下で個別の値を上書きできます。',
			RC_DATA_SUFFICIENCY_TITLE: 'データ充足性要件',
			RC_DATA_SUFFICIENCY_DESC: 'アルゴリズムが動作する前にどれだけの証拠が必要か',
			RC_MIN_PM_CYCLES: '最小PMサイクル数',
			RC_MIN_FM_EVENTS: '最小FMイベント数',
			RC_RECENCY_HALF_LIFE: '最新性半減期（h）',
			RC_POST_PM_WINDOW: 'PM後ウィンドウ（d）',
			RC_CYCLES: 'サイクル',
			RC_RESET_TO_BASE: 'ベースにリセット',
			RC_PM_CM_RATIO_TITLE: 'PM/CM比率しきい値（Ra）',
			RC_PM_CM_RATIO_DESC: 'PM支出が故障負担に対して高すぎるまたは低すぎる場合はいつか？両方の比率は常に計算され報告されます。',
			RC_PRIMARY_RATIO_LABEL: '診断ロジックの主要比率',
			RC_OVER_MAINTAINED: '過剰保守（ケース1）',
			RC_UNDER_MAINTAINED: '保守不足（ケース2）',
			RC_INTERVAL_ADJ_TITLE: '間隔調整制限',
			RC_INTERVAL_ADJ_DESC: '推奨サイクルごとの最大間隔変更。延長と短縮の個別制限。',
			RC_INTERVAL_ROUNDING: '間隔丸め',
			RC_ROUND_TO: '丸め先',
			RC_DIRECTION: '方向',
			RC_ADJ_MODE: '調整モード：パーセント',
			RC_ADVANCED_PARAMS_TITLE: '詳細パラメータ',
			RC_ADVANCED_PARAMS_DESC: '内部アルゴリズム調整 — タイミング分析、ルーティング、感度、信頼度層',
			RC_ADVANCED_WARNING: 'これらのパラメータは内部信号処理を制御します。数式を理解せずに変更すると誤解を招く結果が生じる可能性があります。上のプロファイルセレクターはそれぞれに合理的なデフォルト値を設定します。特定の理由がある場合にのみ上書きしてください。',
			RC_PARAM_COL_PARAM: 'パラメータ',
			RC_PARAM_COL_DESC: '説明',
			RC_PARAM_COL_EFFECT: '効果',
			RC_PARAM_COL_VALUE: '値',
			RC_GOAL_SEEKER_TITLE: 'ゴールシーカーモード',
			RC_GOAL_SEEKER_DESC: '特定の予算削減目標を達成するために最適化',
			RC_GOAL_SEEKER_CURRENT: '現在',
			RC_GOAL_SEEKER_TARGET: '目標削減：',
			RC_CONSTRAINTS: '制約条件',
			RC_EXCLUDE_CRITICALITY: 'アセット重要度を除外',
			RC_EXCLUDE_EQ_TYPES: '設備タイプを除外',
			RC_SCOPE_TITLE: 'スコープ',
			RC_SCOPE_DESC: '最適化実行のスコープを定義します。',
			RC_IMPORT_TITLE: 'データインポート',
			RC_IMPORT_DESC: '設定された分析ウィンドウにおける選択システムのSAP通知。',
			RC_PM_EVENTS: 'PMイベント',
			RC_CM_EVENTS: 'CMイベント',
			RC_FAILURE_EVENTS: '故障イベント',
			RC_NO_RECORDS: '選択したウィンドウでこのイベントタイプのレコードが見つかりません',
			RC_COL_NOTIFICATION: '通知',
			RC_COL_EQUIPMENT: '設備',
			RC_COL_DESCRIPTION: '説明',
			RC_COL_TYPE: 'タイプ',
			RC_COL_CREATED_ON: '作成日',
			RC_COL_COMPLETED_ON: '完了日',
			RC_COL_PLAN_GROUP: 'プラングループ',
			RC_DATA_QC_TITLE: 'データQC',
			RC_DATA_QC_DESC: 'データ品質チェックを確認します。',
			RC_MAPPING_TITLE: 'マッピング',
			RC_MAPPING_DESC: 'CM-FMマッピングを設定します。',
			RC_MAPPING_GROUP_BY: 'グループ化',
			RC_MAPPING_GROUP_FM: '故障モード',
			RC_MAPPING_GROUP_PREVENTABILITY: '予防可能性',
			RC_MAPPING_SEARCH_PLACEHOLDER: '通知、指図、設備、説明を検索',
			RC_MAPPING_LOW_CONFIDENCE: '低信頼度',
			RC_MAPPING_EDITED: '編集済み',
			RC_MAPPING_REGENERATE: '再生成',
			RC_MAPPING_DOWNLOAD: 'ダウンロード',
			RC_MAPPING_UPLOAD: 'アップロード',
			RC_MAPPING_RESET_ALL: 'すべてリセット',
			RC_MAPPING_COL_ORDER: '指図番号',
			RC_MAPPING_COL_EQUIPMENT_ID: '設備ID',
			RC_MAPPING_COL_WO_DESC: '作業指図の説明',
			RC_MAPPING_COL_WO_TYPE: '作業指図タイプ',
			RC_MAPPING_COL_MAPPED_FM: 'マッピングされた故障モード',
			RC_MAPPING_COL_PREVENTABILITY: '予防可能性',
			RC_MAPPING_EVENT: '件',
			RC_MAPPING_EVENTS: '件',
			RC_MAPPING_AVG_FM_CONF: '平均FM信頼度',
			RC_MAPPING_AVG_PREV_CONF: '平均予防可能性信頼度',
			RC_MAPPING_NO_RECORDS: 'マッピング可能なCM/BD通知がありません',
			RC_MAPPING_NO_FILTERED_RESULTS: '現在のフィルタに一致するマッピングがありません',
			RC_MAPPING_GENERATING: 'CM/ブレークダウンイベントを故障モードにマッピングしています...',
			RC_MAPPING_GENERATION_ERROR: 'CM/BD→故障モードのマッピングの生成に失敗しました。',
			RC_MAPPING_UNMAPPED: '未マッピング',
			RC_MAPPING_SYMPTOM_ONLY: '症状のみ',
			RC_MAPPING_SYMPTOM_ONLY_TOOLTIP: '根本原因の故障モードに再割り当てできませんでした — 最適化計算から除外されます。',
			RC_MAPPING_UNMAPPED_CONF_TOOLTIP: '特定の故障モードではなく、「一致なし」という判断自体に対する信頼度です。',
			RC_MAPPING_NO_RATIONALE: '根拠が提供されていません。',
			RC_MAPPING_DETAIL_IDENTITY_SOURCE: '識別情報と発生源',
			RC_MAPPING_DETAIL_WO_CONTENT: '作業指図の内容',
			RC_MAPPING_DETAIL_DURATION: '所要時間',
			RC_MAPPING_DETAIL_FM_MAPPING: '故障モードマッピング',
			RC_MAPPING_DETAIL_PREVENTABILITY: '予防可能性',
			RC_MAPPING_DETAIL_AUDIT: '監査',
			RC_MAPPING_DETAIL_EVENT_CLASS: '指図タイプ / イベント区分',
			RC_MAPPING_DETAIL_SCHED_START: '予定開始',
			RC_MAPPING_DETAIL_SCHED_FINISH: '予定終了',
			RC_MAPPING_DETAIL_ACTIVITY_CODE: '作業コード',
			RC_MAPPING_DETAIL_DAMAGE_CODE: '損傷コード',
			RC_MAPPING_DETAIL_CAUSE_CODE: '原因コード',
			RC_MAPPING_DETAIL_MATERIAL_COST: '材料費',
			RC_MAPPING_DETAIL_PERMIT_ISSUED: '許可証発行',
			RC_MAPPING_DETAIL_PERMIT_CLOSED: '許可証終了',
			RC_MAPPING_DETAIL_CM_DURATION: 'CM所要時間 (h)',
			RC_MAPPING_DETAIL_DURATION_SOURCE: '所要時間の出所',
			RC_MAPPING_DETAIL_FM_ID_NAME: '故障モードID / 名称',
			RC_MAPPING_DETAIL_FM_TYPE: '故障モードタイプ',
			RC_MAPPING_DETAIL_FAILURE_MODE_TYPE: '故障モード種別',
			RC_MAPPING_DETAIL_CONFIDENCE: '信頼度',
			RC_MAPPING_DETAIL_SOURCE: '出所',
			RC_MAPPING_DETAIL_RE_ATTRIBUTED_FROM: '再割り当て元',
			RC_MAPPING_DETAIL_SYMPTOM_ONLY: '症状のみ',
			RC_MAPPING_DETAIL_RATIONALE: '根拠',
			RC_MAPPING_DETAIL_CLASS: '分類',
			RC_MAPPING_DETAIL_KEY_SIGNALS: '主要シグナル',
			RC_MAPPING_DETAIL_EDITED_BY: '編集者',
			RC_MAPPING_DETAIL_EDITED_AT: '編集日時',
			RC_MAPPING_DETAIL_FM_AGENT_RUN: '故障モードエージェント実行',
			RC_MAPPING_DETAIL_PREVENTABILITY_AGENT_RUN: '予防可能性エージェント実行',
			RC_MAPPING_DETAIL_EXISTING: '既存',
			RC_MAPPING_DETAIL_NOT_AVAILABLE: '利用不可',
			RC_MAPPING_REGEN_CONFIRM_TITLE: 'マッピングを再生成しますか?',
			RC_MAPPING_REGEN_CONFIRM_MESSAGE: '手動で編集された{{count}}件の行が、あなたの修正を新しい実行のガイドとして再生成されます。',

			// Select option labels
			OPT_6_MONTHS: '6ヶ月',
			OPT_12_MONTHS: '12ヶ月',
			OPT_15_MONTHS: '15ヶ月',
			OPT_24_MONTHS: '24ヶ月',
			OPT_36_MONTHS: '36ヶ月',
			OPT_1_CYCLE: '1サイクル（積極的）',
			OPT_2_CYCLES: '2サイクル（基準）',
			OPT_3_CYCLES: '3サイクル（保守的）',
			OPT_WEEKLY: '毎週（7日）',
			OPT_BIWEEKLY: '隔週（14日）',
			OPT_MONTHLY: '毎月（30日）',
			OPT_NEAREST: '最近値',
			OPT_UP: '切り上げ',
			OPT_DOWN: '切り捨て',
			OPT_CRIT_A: 'A（重要）',
			OPT_CRIT_B: 'B（重要度高）',
			OPT_CRIT_C: 'C（標準）',
			OPT_CRIT_D: 'D（低）',
			OPT_PROFILE_BASE_NAME: '基準',
			OPT_PROFILE_BASE_SUBTITLE: 'バランス型、デフォルト',
			OPT_PROFILE_CONSERVATIVE_NAME: '保守的',
			OPT_PROFILE_CONSERVATIVE_SUBTITLE: '推奨数少、信頼度高',
			OPT_PROFILE_AGGRESSIVE_NAME: '積極的',
			OPT_PROFILE_AGGRESSIVE_SUBTITLE: '推奨数多、高い潜在節約',
			OPT_PCT_SHORTER_10: '10%短縮',
			OPT_PCT_SHORTER_20: '20%短縮',
			OPT_PCT_SHORTER_25: '25%短縮',
			OPT_PCT_SHORTER_50: '50%短縮',
			OPT_PCT_LONGER_10: '10%延長',
			OPT_PCT_LONGER_20: '20%延長',
			OPT_PCT_LONGER_25: '25%延長',
			OPT_PCT_LONGER_50: '50%延長'
		},
		USER_MANAGEMENT: {
			FORM_ERROR: 'エラーが発生しました。内容を修正して再送信してください。',
			CANCEL: 'キャンセル',
			SAVE: '保存',
			CANCEL_CHANGES: '変更をキャンセル',
			SAVE_CHANGES: '変更を保存',
			NO_RECORDS: 'レコードが見つかりません',
			PLEASE_WAIT: 'お待ちください....',
			SEARCH: '検索',
			ACTIONS: '操作',
			NAME: '名前',
			EMAIL: 'メール',
			PHONE: '電話',
			FACILITY: 'ファシリティ',
			UNITS: 'ユニット',
			SYSTEMS: 'システム',
			SYSTEM: 'システム',
			UNIT: 'ユニット',
			USER: 'ユーザー',
			SELECT_FACILITY: 'ファシリティを選択',
			SELECT_FACILITIES: 'ファシリティを選択',
			SELECT_UNITS: 'ユニットを選択',
			SELECT_SYSTEMS: 'システムを選択',
			SELECT_SYSTEM: 'システムを選択',
			SELECT_UNIT: 'ユニットを選択',
			SELECT_USER: 'ユーザーを選択',
			SEARCH_UNIT: 'ユニットを検索...',
			NO_MATCHING_UNIT: '一致するユニットが見つかりません',
			SEARCH_SYSTEM: 'システムを検索...',
			NO_MATCHING_SYSTEM: '一致するシステムが見つかりません',
			ROLES: {
				LIST_TITLE: 'ロール一覧',
				NEW_ROLE: '新しいロール',
				CREATE_ROLE_TOOLTIP: '新しいロールを作成',
				SEARCH_USER: 'ユーザーを検索',
				FETCH_SELECTED: '選択を取得',
				FETCH_SELECTED_TOOLTIP: '選択されたロールを取得',
				COL_TITLE: 'タイトル',
				VIEW_ROLE: '表示',
				EDIT_ROLE: '編集',
				ROLE_SUFFIX: 'ロール',
				DELETE_ROLE: 'ロールを削除',
				PERMISSIONS_HEADING: '権限：',
				ENTER_TITLE: 'タイトルを入力',
				TITLE_REQUIRED: 'タイトルは',
				TITLE_REQUIRED_STRONG: '必須です',
				TITLE_HINT: '入力してください',
				TITLE_HINT_STRONG: 'タイトル',
			},
			USERS: {
				TAB_USERS: 'ユーザー',
				TAB_USER_GROUPS: 'ユーザーグループ',
				USER_LIST: 'ユーザーリスト',
				FILTERED_USER_LIST: 'フィルター済みユーザーリスト',
				SHOW_DEACTIVATED: '無効化済みを表示',
				DOWNLOAD_TOOLTIP: 'ユーザーリストをダウンロード',
				DOWNLOAD: 'ダウンロード',
				NEW_USER: '新しいユーザー',
				NEW_USER_TOOLTIP: '新しいユーザーを作成',
				UPLOAD_USER: 'ユーザーをアップロード',
				UPLOAD_USER_TOOLTIP: '複数ユーザーを作成',
				SEARCH_USER: 'ユーザーを検索',
				COL_SL_NO: '番号',
				COL_USERNAME: 'ユーザー名',
				COL_EMAIL: 'メール',
				COL_NAME: '名前',
				COL_ROLES: 'ロール',
				COL_ADMIN: '管理者',
				COL_ENTERPRISE_ADMIN: 'エンタープライズ管理者',
				COL_PHONE: '電話',
				COL_LAST_ACTIVE: '最終アクティブ日時',
				COL_STATUS: 'ステータス',
				STATUS_ACTIVE: 'アクティブ',
				STATUS_DEACTIVATED: '無効化済み',
				EDIT_USER: 'ユーザーを編集',
				DELETE_USER: 'ユーザーを削除',
			},
			USER_GROUPS: {
				TITLE: 'ユーザーグループ',
				ADD_TOOLTIP: 'ユーザーグループを追加',
				NEW_GROUP: '新しいユーザーグループ',
				COL_SL_NO: '番号',
				EDIT_TOOLTIP: 'ユーザーを編集',
				DELETE_TOOLTIP: 'ユーザーを削除',
				NAME_REQUIRED: '名前は',
				NAME_REQUIRED_STRONG: '必須です',
				NAME_HINT: '入力してください',
				NAME_HINT_STRONG: '名前',
				NO_USER_GROUPS: 'ユーザーグループはまだ作成されていません',
				CREATE_GROUP_GET_STARTED: '開始するには、新しいユーザーグループを作成してください',
			},
			USER_EDIT: {
				USER_INFO_HEADING: 'ユーザー情報',
				SYSTEM_ACCESS_HEADING: 'システムアクセス',
				FACILITY_ADMIN_HEADING: 'ファシリティ管理者アクセス',
				MODULE_ACCESS_HEADING: 'モジュールアクセス',
				EMAIL_LABEL: 'メール',
				EMAIL_HINT: 'メールを入力',
				PASSWORD_LABEL: 'パスワード',
				PASSWORD_HINT: '（最低8文字、特殊文字・大文字・数字を各1文字以上含む）',
				PASSWORD_REQUIRED: 'パスワードは',
				PASSWORD_REQUIRED_STRONG: '必須です',
				NAME_LABEL: '名前',
				NAME_HINT: '名前を入力',
				PHONE_LABEL: '電話',
				PHONE_HINT: '電話番号を入力',
				PHONE_REQUIRED: '電話番号は',
				PHONE_REQUIRED_STRONG: '必須です',
				ENTERPRISE_ADMIN: 'エンタープライズ管理者',
				OPT_WHATSAPP: 'WhatsAppを有効化',
				INTERNAL: '内部',
				MODEL_RETRAINING: 'モデル再トレーニング',
				FACILITIES_LABEL: 'ファシリティ',
				SELECT_ALL: 'すべて選択',
				MODULE_LABEL: 'モジュール',
				SELECT_MODULES_HINT: 'モジュールを選択',
				SEARCH_MODULES: 'モジュールを検索...',
				NO_MATCHING_MODULE: '一致するモジュールが見つかりません',
				MODULE_REQUIRED: '少なくとも1つのモジュールを選択してください。',
				SAVE_TOOLTIP: '保存',
				CANCEL_TOOLTIP: 'キャンセル',
			},
			UPLOAD_USERS: {
				TITLE: 'ユーザーリストをアップロード',
				SELECT_CSV: 'CSVファイルを選択',
				CSV_REQUIRED: 'CSVファイルは',
				CSV_REQUIRED_STRONG: '必須です',
				SELECT_FILE: 'ファイルを選択',
				DOWNLOAD_FORMAT_TOOLTIP: 'CSV形式をダウンロード',
				SUBMIT: '送信',
			},
			USER_POPUP: {
				EMAIL_REQUIRED: 'メールは',
				EMAIL_REQUIRED_STRONG: '必須です',
				EMAIL_HINT: '入力してください',
				EMAIL_HINT_STRONG: 'メール',
				PASSWORD_REQUIRED: 'パスワードは',
				PASSWORD_REQUIRED_STRONG: '必須です',
				PASSWORD_HINT: '入力してください',
				PASSWORD_HINT_STRONG: 'パスワード',
				NAME_REQUIRED: '名前は',
				NAME_REQUIRED_STRONG: '必須です',
				NAME_HINT: '入力してください',
				NAME_HINT_STRONG: '名前',
				PHONE_REQUIRED: '電話番号は',
				PHONE_REQUIRED_STRONG: '必須です',
				PHONE_HINT: '入力してください',
				PHONE_HINT_STRONG: '電話',
				FACILITY_HINT: '選択',
				SYSTEM_HINT: '選択',
				SYSTEMS_PLACEHOLDER: 'システム',
				SYSTEM_HINT_STRONG: 'システム',
				FACILITY_HINT_STRONG: 'ファシリティ',
			},
			CONFIRMATION: {
				REASON_REQUIRED: '理由は必須です。',
			},
			USER_ROLES: {
				SELECT_ROLE: 'ロールを選択',
				ASSIGN_TOOLTIP: 'ロールを割り当て',
				ASSIGN: '割り当て',
				ASSIGNED_ROLES: '割り当て済みロール：',
				REMOVE_TOOLTIP: 'ロールを削除',
			},
			ADDRESS: {
				FORM_ERROR: 'エラーが発生しました。内容を修正して再送信してください。',
				ADDRESS_LINE: '住所行を入力',
				ADDRESS_LINE_REQUIRED: '住所行は',
				ADDRESS_LINE_REQUIRED_STRONG: '必須です',
				ADDRESS_LINE_HINT: '入力してください',
				ADDRESS_LINE_HINT_STRONG: '住所行',
				CITY: '市区町村',
				CITY_REQUIRED: '市区町村は',
				CITY_REQUIRED_STRONG: '必須です',
				CITY_HINT: '入力してください',
				CITY_HINT_STRONG: '市区町村',
				STATE: '都道府県を入力',
				STATE_REQUIRED: '都道府県は',
				STATE_REQUIRED_STRONG: '必須です',
				STATE_HINT: '入力してください',
				STATE_HINT_STRONG: '都道府県',
				POSTCODE: '郵便番号を入力',
				POSTCODE_REQUIRED: '郵便番号は',
				POSTCODE_REQUIRED_STRONG: '必須です',
				POSTCODE_HINT: '入力してください',
				POSTCODE_HINT_STRONG: '郵便番号',
			},
			SOCIAL: {
				FORM_ERROR: 'エラーが発生しました。内容を修正して再送信してください。',
				LINKEDIN: 'LinkedInアドレスを入力',
				LINKEDIN_HINT: '入力してください',
				LINKEDIN_HINT_STRONG: 'LinkedIn',
				FACEBOOK: 'Facebookアドレスを入力',
				FACEBOOK_HINT: '入力してください',
				FACEBOOK_HINT_STRONG: 'Facebook',
				TWITTER: 'Twitterアドレスを入力',
				TWITTER_HINT: '入力してください',
				TWITTER_HINT_STRONG: 'Twitter',
				INSTAGRAM: 'Instagramアドレスを入力',
				INSTAGRAM_HINT: '入力してください',
				INSTAGRAM_HINT_STRONG: 'Instagram',
				ADDRESS_SUFFIX: 'アドレス',
			},
			CHANGE_PASSWORD: {
				FORM_ERROR: 'エラーが発生しました。パスワードが一致しません。',
				PASSWORD: 'パスワードを入力',
				PASSWORD_REQUIRED: 'パスワードは',
				PASSWORD_REQUIRED_STRONG: '必須です',
				PASSWORD_HINT: '入力してください',
				PASSWORD_HINT_STRONG: 'パスワード',
				CONFIRM_PASSWORD: 'パスワードを確認',
				CONFIRM_REQUIRED: '確認用パスワードは',
				CONFIRM_REQUIRED_STRONG: '必須です',
				CONFIRM_HINT: '確認してください',
				CONFIRM_HINT_STRONG: 'パスワード',
				CHANGE_BUTTON: 'パスワードを変更',
				SAVE_CHANGES: '変更を保存',
			},
		},
		SYSTEM_VIEW: {
			PARTS: 'パーツ',
			ACTIVE: 'アクティブ',
			SYSTEM: 'システム',
			SEARCH_SYSTEM: 'システムを検索...',
			NO_MATCHING_SYSTEM: '一致するシステムが見つかりません',
			OPEN_ALERTS: 'オープンアラート',
			ACTIVE_ALERTS: 'アクティブアラート',
			UNACK_ALERTS: '未確認アラート',
			RELIABILITY: '信頼性',
			MEAN_TIME_BETWEEN_ALERTS: 'アラート平均間隔時間',
			UPTIME: '稼働率',
			DAYS: '日',
			PERFORMANCE_CURVES: 'パフォーマンス曲線',
			OPEN_IN_NEW_TAB: '新しいタブで開く',
			TAB_ANOMALY: '異常',
			TAB_SYSTEM_DETAILS: 'システム詳細',
			TAB_DATA_QUALITY: 'データ品質',
			TAB_PERFORMANCE: 'パフォーマンス',
			CLEAR_SIMULATION: 'シミュレーションをクリア',
			SIMULATION: 'シミュレーション',
			CLICK_TO_START_PREDICTION: 'クリックして予測を開始',
			PREDICTION_RUNNING: '予測実行中',
			NO_OF_DAYS: '日数',
			OK: 'OK',
			RESET: 'リセット',
			RETRAINING: '再トレーニング',
			MORE: 'その他',
			TAGS: 'タグ',
			SEARCH_TAG: 'タグを検索...',
			NO_MATCHING_TAG: '一致するタグが見つかりません',
			ASSET_LABEL: 'アセット:',
			NAME_LABEL: '名前:',
			TAG_ID_LABEL: 'タグID:',
			CANCEL: 'キャンセル',
			ASSETS: 'アセット',
			SEARCH_ASSET: 'アセットを検索...',
			NO_MATCHING_ASSET: '一致するアセットが見つかりません',
			RESET_ASSET_SELECTION: 'アセット選択をリセット',
			DATA_QUALITY: {
				SEARCH_TAG: 'タグを検索',
				DOWNLOAD_TOOLTIP: 'タグデータ品質レポートをダウンロード',
				DOWNLOAD: 'ダウンロード',
				COL_TAG_NAME: 'タグ名',
				COL_MISSING_DATA: '欠損データ',
				COL_FLAT_LINE: 'フラットライン',
				COL_OUTLIER: '外れ値',
				COL_OUT_OF_RANGE: '範囲外',
				COL_TOTAL_INVALID_DATA: '無効データ合計',
				COL_ACTIONS: '操作',
				MORE_ACTIONS: 'その他の操作',
				NO_RECORDS: '選択された期間のデータ品質イベントは見つかりませんでした',
				LOADING: '読み込み中...',
				SHUTDOWN_TAG: 'シャットダウンタグ',
				TRIP: 'トリップ',
				TRIP_LIMIT: 'トリップ制限',
				ALARM: 'アラーム',
				ALARM_LIMIT: 'アラーム制限',
				THRESHOLD: 'しきい値',
				THRESHOLD_LIMIT: 'しきい値制限',
				INSTRUMENT: '計器',
				INSTRUMENT_RANGE: '計器レンジ',
			},
			SYSTEM_DETAILS: {
				NO_IMAGE_FOUND: '画像が見つかりません',
				ASSET_DETAILS: 'アセット詳細',
				CURRENT_ALERTS_EQUIPMENT: '現在のアラート/設備',
				EQUIPMENT_DISTRIBUTION: '設備別分布',
				TOP_FAILURE_MODES: '設備別主要故障モード',
				CUSTOM_INPUTS: 'カスタム入力',
				SELECT_TAG: 'タグを選択',
				UPDATE: '更新',
				SPECIFY_VALUE: '値を指定',
				TIMESTAMP: 'タイムスタンプ',
				LAB_DATA: 'ラボデータ',
				NO_DATA_FOUND: 'データが見つかりません',
			},
			ALERT_SETTINGS: {
				TITLE: 'アラート設定',
				CANCEL: 'キャンセル',
				FAILURE_MODE: '故障モード',
				AGGREGATED_ANOMALY_SCORE: '集計異常スコア',
				INSTRUMENT_HEALTH: '計器健全性/データ品質',
				FLATLINE: '1: フラットライン',
				MISSING_DATA: '2: 欠損データ',
				OUT_OF_RANGE: '3: 範囲外',
				OUTLIERS: '4: 外れ値',
			},
			DIAGNOSTICS: {
				TITLE: 'システム診断',
				CANCEL: 'キャンセル',
				ROOT_CAUSE_ICON_ALT: '根本原因アイコン',
				NOT_GENERATED_YET: 'まだシステム診断が生成されていません。',
				RUN_TO_PROCEED: '診断を実行して続行してください。',
				GENERATION_FAILED: '前回のシステム診断生成が失敗しました。',
				RUN_AGAIN: '診断を再実行して続行してください。',
				GENERATE_NOW: '今すぐ生成',
				REGENERATE: '再生成',
				FAILED_AT: 'システム診断生成が失敗しました',
				LAST_GENERATED: '最終生成',
				GENERATING: 'システム診断を生成中',
				SEVERITY: '重大度:',
				ISSUE: '問題:',
				IMPACT: '影響:',
				ACTION: 'アクション:',
				PRIORITY: '優先度:',
			},
			PERFORMANCE_CURVE: {
				TAG: 'タグ',
				FILTER_TAG_VALUE: 'タグ値をフィルタ',
				SEARCH_TAG: 'タグを検索...',
				NO_TAG_FOUND: 'タグが見つかりません',
				GREATER_THAN: '以上',
				LESS_THAN: '以下',
				OK: 'OK',
				DATE_RANGE: '日付範囲',
				START_DATE: '開始日',
				END_DATE: '終了日',
				SELECT: '選択',
			},
		},
		PLATFORM_CONFIGURATION: {
			HEADER_TITLE: 'プラットフォーム設定',
			TABS: {
				ORGANISATION_SETUP: '組織設定',
				ASSET_REGISTRY: '資産登録',
				MODULE_HIERARCHY: 'モジュール階層',
				PROPERTY_TEMPLATES: 'プロパティテンプレート',
			},
			COMING_SOON: '近日公開',
		},
		CUSTOMER_SETUP: {
			TABS: {
				CLIENT_SETUP: '組織詳細',
				FACILITY_SETUP: '施設',
				PLANT_ECONOMICS: '経済パラメータ',
			},
			COMMON: {
				SAVE_CHANGES: '変更を保存',
				CANCEL: 'キャンセル',
				CONFIRM: '確認',
				EDIT: '編集',
				DELETE: '削除',
				LOADING: '読み込み中...',
				SEARCH: '検索...',
				CLOSE: '閉じる',
				SAVED_SUCCESSFULLY: '正常に保存されました',
				ERROR_SAVING: '変更の保存中にエラーが発生しました',
				TIMEZONE: 'タイムゾーン',
				LATITUDE: '緯度',
				LONGITUDE: '経度',
				SELECT_TIMEZONE: 'タイムゾーンを選択',
			},
			CLIENT: {
				TITLE: '組織詳細',
				SUBTITLE: '組織の詳細を設定します',
				LOGO: 'ロゴ',
				UPLOAD_LOGO: 'ロゴをアップロード',
				HQ_ADDRESS: '本社住所',
				ENTERPRISE_NAME: 'エンタープライズ名',
				INDUSTRY_SECTOR: '業種セクター',
				STREET_ADDRESS: '番地',
				CITY: '市区町村',
				STATE: '都道府県',
				COUNTRY: '国',
				ZIP_CODE: '郵便番号',
				ZOOM_LEVEL: 'ズームレベル',
				BUSINESS: 'ビジネス',
				NOTES: 'メモ',
				SELECT_INDUSTRY_SECTOR: '業種セクターを選択',
				PLACEHOLDER_BUSINESS: 'ビジネス詳細を入力してください',
				PLACEHOLDER_NOTES: 'メモを入力してください',
			},
			FACILITY: {
				TITLE: '施設',
				SUBTITLE: '施設の場所とパラメータを定義します',
				ADD_FACILITY: '施設を追加',
				GROUP_BY: 'グループ化',
				COL_NAME: '名前',
				COL_LOCATION: '場所',
				COL_CAPACITY: '容量（MW）',
				COL_REGION: '地域',
				COL_INDUSTRY: '業種',
				NO_FACILITIES_SEARCH: '施設が見つかりません。',
				TRY_ADJUSTING: '検索クエリを調整してください。',
				NO_FACILITIES_YET: 'まだ施設が設定されていません。',
				CLICK_TO_GET_STARTED: '「施設を追加」をクリックして開始します。',
				DELETE_TITLE: '施設の削除',
				DELETE_DESCRIPTION: '施設「{{name}}」を完全に削除してもよろしいですか？',
				DELETE_WAIT: '施設を削除中...',
				DELETED_SUCCESS: '施設が正常に削除されました',
				DELETE_ERROR: '施設の削除中にエラーが発生しました',
			},
			ADD_FACILITY_DIALOG: {
				TITLE_ADD: '施設を追加',
				TITLE_EDIT: '施設を編集',
				UPDATED_SUCCESS: '施設が正常に更新されました',
				UPDATE_ERROR: '施設の更新中にエラーが発生しました',
				CREATED_SUCCESS: '施設が正常に作成されました',
				CREATE_ERROR: '施設の作成中にエラーが発生しました',
				FACILITY_NAME: '施設名',
				FACILITY_CODE: '施設コード',
				LOCATION: '場所',
				REGION: '地域',
				CURRENCY: '通貨',
				INSTALLED_CAPACITY: '設置容量（MW）',
				INDUSTRY: '業種',
				GIS_LOCATION: 'GIS位置',
				PLACEHOLDER_FACILITY_NAME: 'プラント名',
				PLACEHOLDER_LOCATION: '市区町村、都道府県',
				SELECT_REGION: '地域を選択',
				SELECT_CURRENCY: '通貨を選択',
				SELECT_INDUSTRY: '業種を選択',
			},
			FACILITY_FORM: {
				TAB_FACILITY_INFO: '施設情報',
				TAB_HISTORIAN_INFO: 'ヒストリアン情報',
				TAB_SAP_INFO: 'SAP情報',
				ENTERPRISE: '企業',
				ADDRESS: '住所',
				CITY: '都市',
				STATE: '州',
				COUNTRY: '国',
				ZIP: '郵便番号',
				ZOOM_LEVEL: 'ズームレベル',
				APPLICATION: '用途',
				NOTES: 'メモ',
				CUSTOMER_ADVOCATE: '顧客担当者',
				HISTORIAN_TYPE: 'ヒストリアンタイプ',
				ACCESS_METHOD: 'アクセス方法',
				ACCESS_URL: 'アクセスURL',
				RESOURCE_URL: 'リソースURL',
				DATA_FETCH_SETTINGS: 'データ取得設定',
				FORWARD_AGGREGATE: '集計を転送',
				FETCH_RATE: '取得レート',
				FETCH_RATE_UNIT: '取得レート単位',
				ENABLE_SAMPLING: 'サンプリングを有効化',
				SAMPLING_RATE: 'サンプリングレート',
				SAMPLING_RATE_UNIT: 'サンプリングレート単位',
				PREDICTION_SETTINGS: '予測設定',
				PREDICTION_RATE: '予測レート',
				PREDICTION_RATE_UNIT: '予測レート単位',
				DQ_ALERTS: 'データ品質アラート',
				START_DELAY: '開始遅延（時間）',
				END_DELAY: '終了遅延（時間）',
				FUNCTIONAL_LOC_MAPPING: '機能位置/機器IDマッピング',
				UPLOAD_FUNCTIONAL_LOC: '機能位置/機器IDデータをアップロード',
				DOWNLOAD_FUNCTIONAL_LOC: '機能位置/機器IDマッピングをダウンロード',
				SAP_DATA: 'SAPデータ',
				UPLOAD_SAP_DATA: 'SAPデータをアップロード',
				DOWNLOAD_SAP_FORMAT: 'SAPデータ形式をダウンロード',
				UPDATE_SAP_DATA: 'SAP許可データ更新',
				UPLOAD_UPDATE_SAP_DATA: 'SAP許可データ更新をアップロード',
				DOWNLOAD_UPDATE_SAP_FORMAT: 'SAP許可データ更新形式をダウンロード',
				CMMS_WRITE_INTEGRATION: 'CMMS書き込み連携',
				CMMS_LAST_DATA_PULL: 'CMMS 最終データ取得',
				IP_ADDRESS: 'IPアドレス',
				USER_NAME: 'ユーザー名',
				PASSWORD: 'パスワード',
				TEST: 'テスト',
				TEST_WRITE_INTEGRATION: '書き込み連携をテスト',
			},
			PLANT_ECONOMICS: {
				TITLE: '経済パラメータ',
				SUBTITLE: '経済的要因とコストパラメータを設定します',
				SELECT_FACILITY_MSG: '経済パラメータを管理する施設を選択してください。',
				SECTION_TITLE: '生産経済パラメータ',
				CHOOSE_FACILITY: '施設を選択してください...',
				PRODUCTION_DETAILS: '生産詳細',
				LABOR_SALARY: '労働賃金パラメータ（時間当たり）',
				UPDATED_SUCCESS: 'プラント経済が正常に更新されました',
				UPDATE_ERROR: 'プラント経済の更新中にエラーが発生しました',
				COST_PER_UNIT: '生産単位あたりのコスト',
				CAPACITY_HOUR: '時間あたりの容量（例：MWh）',
				REVENUE_HOUR: '時間あたりの収益',
				MARGIN_PERCENT: 'マージン（%）',
				OTHER_COSTS: 'その他の固定アイドルコスト',
				TECHNICIAN: '技術者',
				HELPER: '補助員',
				SUPERVISOR: '監督者',
				MANAGER: 'マネージャー',
			},
		},
		MODEL_EXPLAIN: {
			TITLE: 'タグを説明',
			SELECTED_TAG: '選択されたタグ',
			CAUSAL_TAGS: '因果タグ',
			TAG_SINGULAR: 'タグ',
			TAG_PLURAL: 'タグ',
			CONTRIBUTOR_SCORE: 'スコア',
			NO_CONTRIBUTORS: 'このタイムスタンプに寄与タグが見つかりませんでした。',
			LOADING_CAUSAL_TAGS: '因果タグを読み込み中...',
			CLOSE: '閉じる',
			ASSET: 'アセット',
			FULLSCREEN: '全画面',
			EXIT_FULLSCREEN: '全画面を終了',
			EXPAND: '展開',
			COLLAPSE: '折りたたむ',
			EXPLAIN: '説明',
		},
		FILE_PREVIEW: {
			LOADING_REPORT: "レポートを読み込んでいます…",
			REPORT_IN_PROGRESS: "レポートを生成中です。5分後に再度ご確認ください。",
			REPORT_FAILED: "レポートを生成できませんでした。もう一度共有してください。",
		},
		ALERT_V2: {
			FORECAST: {
				TTF_SHORT: 'TTF',
				TTI_SHORT: 'TTI',
				DETAILS: '{{kind}} の詳細',
				NO_VALUES: '有効な {{kind}} の値がありません。',
				ON_DEMAND_NO_FORECAST: '選択した時点から利用できる予測がありません。マーカーを別の時点にドラッグして、もう一度お試しください。',
				MIN: '最小 =',
				CURRENT_VALUE: '現在値',
				VS_BASELINE: 'ベースライン比',
				ACTIVE_DURATION: '継続時間',
				SAMPLE_DENSITY: 'サンプル密度',
				FORECAST: '予測 {{kind}} =',
				TTF: {
					ALERT: {
						TITLE: 'アラートレベル TTF',
						DESCRIPTION: 'TTF = min（寄与する各タグの TTF）。最も早く予測される超過が、以下に表示される集約値を決定します。',
					},
					ALERT_LIST: {
						TITLE: 'アラートレベル TTF',
						DESCRIPTION: 'TTF = min（各故障モードの TTF）。最も早く予測される超過が、以下に表示される集約値を決定します。',
					},
					FAILURE_MODE: {
						TITLE: '故障モード TTF',
						DESCRIPTION: 'TTF = min（寄与する各タグの TTF）。最も早く予測される超過が、以下に表示される集約値を決定します',
					},
					TAG: {
						TITLE: 'タグレベル TTF',
						DESCRIPTION: '直近の変化率を外挿し、タグの予測値が運転限界を超えるまでの日数を予測します。',
					},
				},
				TTI: {
					ALERT_LIST: {
						TITLE: 'アラートレベル — 介入までの時間',
						DESCRIPTION: 'このアラートの故障モードのうち、最も早い介入予測です。',
					},
					ALERT: {
						TITLE: 'アラートレベル — 介入までの時間',
						DESCRIPTION: '監視対象の性能劣化指標における、このアラートの最も早い介入予測です。',
					},
					FAILURE_MODE: {
						TITLE: '故障モード — 介入までの時間',
						DESCRIPTION: 'この故障モードに関連する性能指標に基づく、最も早く予測される運用上の介入です。',
					},
					TAG: {
						TITLE: 'タグレベル — 介入までの時間',
						DESCRIPTION: 'このタグに対して予測される最も早い運用介入です。',
					},
				},
			},
			DQ_SETTINGS: {
				TITLE: "データ品質設定",
				DETECTION_TITLE: "データ品質検出",
				ALERT_GEN_TITLE: "データ品質アラート生成",
				ALERT_GEN_DESC: "検出されたDQ問題のうち、どのアラートを生成するかを選択します。アラート生成をオフにしてもDQ計算は停止しません。",
				FLATLINE_DETECTION: "フラットライン検出",
				MISSING_DATA_DETECTION: "欠損データ検出",
				OUTLIER_DETECTION: "外れ値検出",
				OUT_OF_RANGE_DETECTION: "範囲外検出",
				ERRATIC_DETECTION: "不安定検出",
				FLATLINE_ALERT: "フラットラインアラート",
				MISSING_DATA_ALERT: "欠損データアラート",
				OUTLIER_ALERT: "外れ値アラート",
				OUT_OF_RANGE_ALERT: "範囲外アラート",
				ERRATIC_ALERT: "不安定アラート",
				CLOSE_TOOLTIP: "閉じる"
			},
			DETAIL: {
				NO_DATA_URL: "指定されたURLのデータが見つかりません。",
				NO_DATA_URL_DESC: "入力したURLを確認して再試行してください。",
				FAILURE_MODES: "故障モード",
				SEARCH: "検索...",
				SORT_FAILURE_SCORE: "故障スコアでソート",
				SORT_CREATION_DATE: "作成日でソート",
				OTHER_ACTIVE_ALERTS: "その他のアクティブなアラート",
				NEW_FAILURE: "新しい故障が追加されました",
				ALERT_TITLE_PLACEHOLDER: "アラートタイトル",
				SEARCH_OWNER: "担当者を検索...",
				SEARCH_WATCHERS: "監視者を検索..",
				ASSIGN_OWNER: "担当者を割り当て",
				ADD_WATCHERS: "監視者を追加",
				VERSION_HISTORY: "バージョン履歴",
				COPY_LINK: "アラートリンクをコピー",
				BOOKMARK: "アラートをブックマーク",
				REMOVE_BOOKMARK: "ブックマークを削除",
				FETCHING_SYSTEM_DETAILS: "系統詳細を取得中",
				RESTORE_VERSION: "バージョンを復元",
				CANNOT_DELETE_VERSION: "根本原因分析の進行中はバージョンを削除できません",
				DELETE_VERSION: "バージョンを削除",
				EDIT: "編集",
				CLOSE: "閉じる",
				DOWNLOAD: "ダウンロード",
				SHARE: "共有",
				ANOMALY_SCORE: "異常スコア",
				TIMELINE: "タイムライン",
				VERSIONS: "バージョン",
				NO_DATA_AVAILABLE: "データがありません",
				EXPORT_REPORT: "レポートをエクスポート",
				TIME_TO_FAILURE_IN: "故障までの時間 ({{unit}})",
				TIME_TO_INTERVENTION_IN: "介入までの時間 ({{unit}})",
				SWITCH_TO_FM_VIEW: 'FMビューに切り替え',
				SWITCH_TO_RCA_VIEW: 'RCAビューに切り替え',
				CREATED_ON: '作成日',
				MENU_CREATED_ON: '作成日',
				STATE: '状態',
				DUE_DATE: '期限日',
				STATUS: 'ステータス',
				OWNER: '所有者',
				WATCHERS: 'ウォッチャー',
				WATCHER: 'ウォッチャー',
				LAST_RUN_PREFIX: '最終実行:',
				MENU_LAST_RUN: '最終実行',
				RUN_NOW: '今すぐ実行',
				MENU_RUN_NOW: '今すぐ実行',
				MORE: 'その他',
				REPORT_ISSUE: '問題を報告',
				NAV: {
					THRESHOLD: 'しきい値',
					DATA_QUALITY: 'データ品質',
					ACTIVITY_LOGS: 'アクティビティログ',
					DISCUSSION: 'ディスカッション',
					ANALYSIS_VIEWS: '分析とビュー',
					RETRAIN_MODEL: 'モデルを再学習',
					FEEDBACK: 'フィードバック',
					DISPLAY_TAGS: 'タグを表示',
					PREFERRED_SETTINGS: '優先設定',
					DOCUMENTS: 'ドキュメント',
					WORK_ORDERS: '作業指示書',
					ROOT_CAUSE_ANALYSIS: '根本原因分析',
				},
				TAGS_TOOLTIP: "タグ",
				TIME_TO_TRIP: "故障までの時間",
				DAYS: "日",
				CMMS_NUMBER: "CMMS番号",
				STACKED_VIEW: "積み重ねビュー",
				OVERLAY_VIEW: "オーバーレイビュー",
				GRID_VIEW: "グリッドビュー",
				NO_RECOMMENDATIONS: "表示する推奨事項はありません",
				RECOMMENDATIONS: "推奨事項",
				RECOMMENDATION_POPUP: {
					ADD_PLACEHOLDER: "推奨事項を追加",
					ADD: "追加",
					CANCEL: "キャンセル",
					UPDATE: "更新",
					EMPTY_TITLE: "推奨事項はありません",
					EMPTY_HINT: "推奨事項を追加すると、ここに表示されます。",
				},
				SEARCH_CATEGORY: "カテゴリを検索...",
				NO_CATEGORY: "一致するカテゴリが見つかりません",
				SELECT_CATEGORY: "カテゴリを選択",
				SEARCH_COMPONENT: "コンポーネントを検索...",
				NO_COMPONENT: "一致するコンポーネントが見つかりません",
				SELECT_COMPONENT: "コンポーネントを選択",
				SEARCH_ERROR: "エラーを検索...",
				NO_ERROR_FOUND: "一致するエラーが見つかりません",
				SELECT_ERROR: "エラーを選択",
				ALERT_DETAILS_TITLE: "アラート詳細",
				EMPTY_DATA_ALT: "データなし",
				NO_OPEN_FAILURE_MODES: "未対応の故障モードはありません。",
				RELATED_ALERTS: "関連アラート",
				TOP_CONTRIBUTING_TAGS: "異常スコアへの主な寄与タグ",
				NO_TAGS_TO_DISPLAY: "表示するタグがありません。",
				NO_DATA_ALT: "データなし",
				SELECT_FM_OR_ADD_TAGS: "故障モードを選択するか、タグを追加してグラフを表示してください。",
				BREAKDOWN_CATEGORY_LABEL: "内訳カテゴリ",
				BREAKDOWN_COMPONENT_LABEL: "内訳コンポーネント",
				BREAKDOWN_ERROR_LABEL: "エラー",
				SAVE: "保存",
				FILTER_TAGS: "タグをフィルター",
				NO_MATCHING_RESULT: "一致する結果なし",
				START_TYPING: "入力を開始すると一致するタグが表示されます。",
				NO_MATCHING_RESULTS: "一致する結果なし",
				CLOSE_TOOLTIP: "閉じる",
				EDIT_DISABLED: "この施設では表示専用モードです",
				MULTI_SELECT_DISABLED: "アラートの担当者のみが複数の故障モードを選択できます",
				SPLIT_MERGE_OWNER: "アラートの担当者のみが故障モードを分離できます。",
				SPLIT_MERGE_STATUS: "特定のステータスのアラートのみ分離または統合できます。",
				SPLIT_MERGE_APPROVED: "承認済みまたは未処理の故障モードのみ、新しいアラートに分離したり既存のアラートと統合したりできます。",
				SPLIT_MERGE_ACTION: "故障モードを新しいアラートに移動するか、既存のアラートと統合します。",
				SPLIT_MERGE_IN_PROGRESS: "このアラートで分離または統合が進行中です。完了するまでお待ちください。",
				SPLIT_MERGE_DISMISS: "閉じる",
				TITLE_EMPTY: "続行するにはタイトルを入力してください。",
				TITLE_TOO_LONG: "タイトルは60文字を超えることはできません。",
				MAINTENANCE_RECORDS_DIALOG: "既存の保全記録が検出されました。<br>再学習を続行するために削除しますか？",
				FAILURE_DELETED: "故障モード\"{{name}}\"を正常に削除しました",
				FAILURE_DELETE_ERROR: "\"{{name}}\"の削除中にエラーが発生しました。もう一度お試しください。",
				FAILURE_ADDED: "故障モード\"{{name}}\"を正常に追加しました",
				USED_IN_MODEL: "モデルおよび計算タグで使用中",
				ONGOING: "進行中",
				FAILURE_TIMELINE: {
					TITLE: "「{{name}}」のタイムライン",
					SORT_BY: "並べ替え",
					SORT_TIMELINE: "タイムライン",
					SORT_ASSETS: "アセット",
					LIMIT_TO_SYSTEM: "このシステムの結果に限定",
					ASSET: "アセット",
					REASON: "理由",
					RECOMMENDATIONS: "推奨事項",
					NOT_AVAILABLE: "NA",
					NO_DATA: "データが見つかりません。",
					MENU_LABEL: "故障タイムライン",
				},
			},
			RCA: {
				CREATE_WORK_ORDER: "作業指示を作成",
				GENERATING: "根本原因分析を生成中",
				GENERATE: "根本原因分析を生成",
				PERCENT_COMPLETED: "% 完了",
				GO_BACK: "戻る",
				RUN_NOW: "今すぐ実行",
				CANCEL: "キャンセル",
				NOTIFY_ME: "通知する",
				ALREADY_IN_PROGRESS: "根本原因分析の生成はすでに進行中です",
				RERUN: "再実行",
				VIEW_TRACES: "トレースを表示",
				TITLE: "根本原因分析",
				HYPOTHESES: "仮説",
				COMMENTS: "コメント",
				EVIDENCE_POINTS: "根拠ポイント",
				DISCUSSION_TOOLTIP: "チームとの内部討議用",
				APPROVED: "承認済み",
				APPROVE: "承認",
				EDIT: "編集",
				RELEARNED: "再学習済み",
				RELEARN: "再学習",
				SUSPECTED_CAUSE: "推定原因",
				CAUSAL_CHAIN: "因果連鎖",
				STEPS: "ステップ",
				RECOMMENDATIONS: "推奨事項",
				CHART_TAGS: "チャートタグ",
				EXPORT_AS_PDF: "PDFとして出力",
				PROPOSED_EVIDENCE: "提案された根拠",
				ADD_TO_EVIDENCE: "根拠として追加",
				EVIDENCE_ADDED_BY: "{{date}} {{time}} に {{user}} が追加",
				EVIDENCE_ADDED: "{{date}} {{time}} に追加",
				ALREADY_ADDED: "すでに根拠として追加済み",
				DRAG_TO_REORDER: "クリックしてドラッグで並び替え",
				TABS: {
					TAGS: "タグ",
					WORK_ORDERS: "作業指示",
					DOCUMENTS: "文書",
					SYSTEM_DETAILS: "系統詳細",
				},
				EMPTY: {
					NO_TAGS_EVIDENCE: "根拠として追加されたタグはありません",
					NO_TAGS_EVIDENCE_DESC: "タグが根拠として提案されると、タググラフと詳細がここに表示されます。",
					NO_WORK_ORDERS: "作業指示が関連付けられていません",
					NO_WORK_ORDERS_DESC: "保全記録がこの根本原因に関連付けられると、作業指示がここに表示されます。",
					NO_DOCUMENT_EVIDENCE: "文書根拠なし",
					NO_DOCUMENT_EVIDENCE_DESC: "既存の文書を追加するか、新しい文書をアップロードして根拠として使用してください。",
					UPLOAD_NEW_DOCUMENT: "新しいドキュメントをアップロード",
					NO_PROPOSED_EVIDENCE: "提案された根拠はまだありません",
					NO_PROPOSED_EVIDENCE_DESC: "タグ、作業指示、文書、またはP&ID参照を追加してこの仮説を裏付けてください。",
					NO_TAGS_LINKED: "タグが関連付けられていません",
					NO_TAGS_LINKED_DESC: "タグがこの仮説に追加されると、タググラフと詳細がここに表示されます。",
					SELECT_TAG_HEADING: "タグが選択されていません",
					SELECT_TAG_DESC: "左側の仮説からタグをクリックするか、ここにタグをドラッグすると、グラフが表示されます。",
					NO_DOCUMENTS: "文書がありません",
					NO_DOCUMENTS_DESC: "技術マニュアル、レポート、PDFがこの仮説に関連付けられるとここに表示されます。",
					NO_SYSTEM_DETAILS: "系統詳細がありません",
					NO_SYSTEM_DETAILS_DESC: "設備データが関連付けられると、P&ID、系統仕様、技術詳細がここに表示されます。",
				},
				WO: {
					WORK_ORDER: "作業指示",
					MANUALLY_ADDED: "手動追加",
					DESCRIPTION: "説明",
					NOTIFICATION_NO: "通知番号",
					TYPE: "種別",
					EQUIPMENT: "設備",
					PLANNING_GROUP: "計画グループ",
					STATUS: "ステータス",
					USER_STATUS: "ユーザーステータス",
					CREATED_BY: "作成者",
					COMPLETED_BY: "完了者",
					CREATED_ON: "作成日",
					COMPLETED_ON: "完了日",
					CAUSE: "原因",
					CAUSE_DESC: "原因詳細",
					ACTIVITY_GROUP: "作業グループ",
					ACTIVITY_DESC: "作業詳細",
					SEE_LESS: "折りたたむ",
					SEE_MORE: "さらに表示",
					ADDED_WITH_ROOTY: "{{name}}で追加",
					ADDED_MANUALLY: "手動追加",
				},
				PDF: {
					ALERT_REPORT: "アラートレポート",
					HYPOTHESIS: "仮説",
					TITLE_LABEL: "タイトル",
					SYSTEM: "系統",
					TYPE: "種別",
					CREATED_ON: "作成日",
					OWNER: "担当者",
					STATE: "状態",
					DUE_DATE: "期日",
					STATUS: "ステータス",
					WATCHERS: "監視者",
					HYPOTHESES_PREFIX: "仮説",
					PAGE: "ページ",
					ZOOM: "ズーム：",
					SIZE: "サイズ：",
				},
				FEEDBACK: {
					APPROVE_HEADER: "仮説を承認",
					RELEARN_HEADER: "仮説を再学習",
					COMMENT_PLACEHOLDER: "フィードバックやメモを追加...",
					REVISION_INFO: "修正に必要",
				},
				SNACKBAR: {
					REPORT_QUEUED: "レポートをリクエストしました。準備が完了しましたら、ダウンロードリンクを {{email}} にメールでお送りします。",
					RCA_COMPLETED: "根本原因分析の生成が正常に完了しました。",
					RCA_NOTIFY: "根本原因分析の生成が完了次第、通知します。",
					RCA_FAILED: "根本原因分析の生成に失敗しました。",
					REPORT_REQUEST_FAILED: "レポートをリクエストできませんでした。もう一度お試しください。",
					REMOVE_WO_ERROR: "根拠から作業指示を削除中にエラーが発生しました。",
					NO_RCA_DATA_AVAILABLE: "根本原因分析データがありません。インサイトを生成するには根本原因分析を実行してください。",
				},
				POPUP: {
					APPROVE_HYPOTHESES: "仮説を承認",
					APPROVE_CAUSAL: "因果連鎖ステップを承認",
					APPROVE_RECOMMENDATION: "推奨事項を承認",
					RELEARN_HYPOTHESES: "仮説を再学習",
					RELEARN_CAUSAL: "因果連鎖ステップを再学習",
					RELEARN_RECOMMENDATION: "推奨事項を再学習",
				},
				DIALOG: {
				ADD_TAG_EVIDENCE: "このタグを提案された根拠として追加しますか？",
				ADD_DOCS_EVIDENCE: "{{count}}件の文書を提案された根拠として追加しますか？",
				ADD_WOS_EVIDENCE: "この作業指示を根拠として追加しますか？",
				REMOVE_RC_EVIDENCE_DESC: "この根本原因根拠を削除しますか？この操作は取り消せません。",
					REMOVE_EVIDENCE_TITLE: "確認",
					REMOVE_EVIDENCE_DESC: "この根拠を削除しますか？この操作は取り消せません。",
					ERROR_TITLE: "エラー！",
					OK: "OK",
					CONFIRM: "確認",
					CANCEL: "キャンセル",
					EVIDENCE_LOCKED: "RCA根拠を提案された根拠セクションに移動できません。",
				},
				EVIDENCE_CONTEXT: {
					ADD_TITLE: "この根拠のコンテキストを追加",
					EDIT_TITLE: "この根拠のコンテキストを編集",
					CLOSE: "閉じる",
					SUBTITLE: "この根拠が関連する理由と、次回の再実行でどのように使用すべきかをRCAが理解できるようにしてください。",
					FIELD_LABEL: "この根拠はなぜ関連していますか?",
					FIELD_LABEL_OPTIONAL: "この根拠はなぜ関連していますか?(任意)",
					FIELD_PLACEHOLDER: "例:この作業指示書には、ポンプ停止前のシール漏れについて記載されています。",
					FIELD_ERROR: "続行するにはコンテキストを入力してください",
					CANCEL: "キャンセル",
					UPDATE_CONTEXT: "コンテキストを更新",
					ADD_EVIDENCE: "根拠を追加",
					ABORT_TITLE: "根拠は追加されません",
					ABORT_DESC: "この根拠をどのように使用すべきかをRCAが理解するには、簡単な説明が必要です。今キャンセルすると、この根拠は次回のRCA再実行で考慮されません。",
					ABORT_CANCEL: "根拠の追加をキャンセル",
					ABORT_GO_BACK: "戻る",
				},
			},
			METRICS2: {
				PENDING_DEFECT: "不具合保留",
			},
			METRICS: {
				HEALTH_SCORE: "健全性スコア",
				TOTAL_ALERTS: "アラート合計",
				UNACKNOWLEDGED: "未確認",
				REVIEWING: "確認中",
				PENDING: "保留中",
				UNKNOWN: "不明",
			},
			OVERVIEW: {
				SYSTEM_OVERVIEW: "システム概要",
				SYSTEM_HEALTH_INDICATORS: "システム健全性指標",
				PRIORITY_ACTIONS: "優先対応",
				PRIORITY_TOOLTIP: "今すぐ対応が必要な項目。未確認および保留 - 不具合報告済みの異常アラート。",
				NO_PRIORITY_ACTIONS: "優先対応はありません",
				ALL_CAUGHT_UP: "すべて対応済み - 早急な対応は不要です ",
				MONITORING_TRACKING: "監視と追跡",
				MONITORING_TOOLTIP: "追跡中の優先度の低い項目。ステータスが処理中および監視中の異常アラート。",
				IN_PROCESS: "処理中",
				ON_WATCH: "監視中",
				RUNNING_STATE: "稼働状態",
				AT_RISK: "リスクあり",
				REVIEW: "要確認",
				HEALTHY: "正常",
				CURRENT: "現在",
				THRESHOLD: "しきい値",
				NO_DATA_FOUND: "データが見つかりません",
				VIEW_ALL: "すべて表示 →",
				NO_ALERTS_ARE: "{{title}}のアラートはありません",
				NO_DATA: "データなし",
			},
			TABLE: {
				HEADERS: {
					STATUS: "ステータス",
					ALERT_NAME: "アラート名",
					SYSTEM_NAME: "システム名",
					TYPE: "種別",
					LOSS: "損失（kWh）",
					START: "開始",
					STOP: "停止",
					DURATION: "継続時間",
					LAST_ACTIVE: "最終アクティブ",
					CREATED_ON: "作成日",
					STATE: "状態",
					OWNER: "担当者",
					WATCHERS: "ウォッチャー",
					FORECAST: "予測",
					CATCH: "キャッチ",
					UPPER_LIMIT: "上限",
					VALUE: "値",
					LOWER_LIMIT: "下限",
					LAST_SYSTEM_UPDATE: "最終システム更新",
					LAST_USER_UPDATE: "最終ユーザー更新",
					DISCUSSION: "ディスカッション",
					TOTAL_VALUE: "合計値",
					RELIABILITY_SAVING: "信頼性削減効果",
					MAINTENANCE_SAVING: "保全削減効果",
					PERFORMANCE_SAVING: "性能削減効果",
					ALERT_DRIVEN_MAINTENANCE: "アラート起因保全",
				},
				NEW_FAILURE_ADDED: "新しい故障モードが追加されました",
				TIME_TO_TRIP_DAYS: "故障まで{{n}}日",
				OPEN_IN_NEW_TAB: "新しいタブで開く",
				RCA_AVAILABLE: "根本原因分析が利用可能",
				ASSIGN_OWNER: "担当者を割り当て",
				ADD_WATCHERS: "ウォッチャーを追加",
				SEARCH_OWNER: "担当者を検索...",
				SEARCH_WATCHERS: "ウォッチャーを検索...",
				NO_APPROVED_FM: "承認済みの故障モードが見つかりません",
				EXTRA_MORE: "＋{{count}}件",
				CUSTOMIZE_COLUMNS: "列をカスタマイズ",
				BOOKMARK_ALERT: "アラートをブックマーク",
				REMOVE_BOOKMARK: "ブックマークを解除",
				VIEW_ONLY_MODE: "この施設では閲覧専用モードです",
				SYSTEM_TOOLTIP: "システム：{{system}}\nユニット：{{unit}}\n施設：{{facility}}",
			},
			UTILS: {
				STATUS: {
					UNACK: "未確認",
					IN_PROCESS: "処理中",
					ON_WATCH: "監視中",
					PENDING_DEFECT: "保留 - 不具合報告済み",
					CLOSED_MAINT_DEFERRED: "クローズ - 保全延期",
					CLOSED_NO_ACTION: "クローズ - 対応予定なし",
					CLOSED_RESOLVED: "クローズ - 解決済み",
					REJECTED: "却下",
				},
				STATE: {
					TENTATIVE: "暫定",
					ACTIVE: "アクティブ",
					RETURNED_TO_NORMAL: "正常復帰",
					CLOSED: "クローズ",
					NOISE_DISCARDED: "ノイズ／破棄",
				},
				TYPE: {
					H_ANOMALY: "高異常",
					L_ANOMALY: "低異常",
					DATA_QUALITY: "データ品質",
					USER_REPORTED: "ユーザー報告",
					THRESHOLD: "しきい値",
					DIAGNOSIS: "診断",
					DIGITAL: "デジタル",
				},
				SUBTYPE: {
					OUTLIER: "外れ値",
					OUT_OF_RANGE: "範囲外",
					FLATLINE: "フラットライン",
					MISSING: "欠損",
					UNKNOWN: "不明",
					PAINT_BRUSHING: "ペイントブラッシング",
				},
				THRESHOLD_ALERT: "しきい値アラート",
				DATA_QUALITY_ALERT: "データ品質アラート",
				TITLE_TOOLTIP: "タイトル：{{title}}",
				TITLE_ID_TOOLTIP: "タイトル：{{title}}\nアラートID：{{id}}",
				DAYS: "{{n}}日",
				HOURS: "{{n}}時間",
				DAYS_SHORT: "{{n}}日",
				HOURS_SHORT: "{{n}}時間",
				POTENTIAL: "（潜在）",
			},
			DOC_PREVIEW: {
				PREVIEW_DOCUMENT: "ドキュメントをプレビュー",
				CLOSE: "閉じる",
				DOWNLOAD_FILE: "ファイルをダウンロード",
			},
			LIST: {
				ALERTS_COUNT: "{{count}}件のアラート",
				SHOW_MORE_ALERTS: "さらに{{count}}件のアラートを表示",
				COLUMN_SAVED: "列ビューが保存されました",
				SOMETHING_WENT_WRONG: "問題が発生しました。もう一度お試しください",
				TAKES_FEW_SECONDS: "数秒かかる場合があります...",
				BULK_RESULT: "{{total}}件中{{success}}件のアラートに{{msg}}",
				STATUS_CLOSED_NO_ACTION: "ステータスを「クローズ - 対応予定なし」に設定",
				ACTION_UPDATED: "{{action}}を更新しました",
				ACTION_STATUS: "ステータス",
				ACTION_BOOKMARK: "ブックマーク",
				ACTION_SUBSCRIBERS: "ウォッチャー",
			},
			DIALOG: {
				ADD_COMMENT: "コメントを追加*",
				COMMENT_REQUIRED: "続行するにはコメントを追加してください",
				ADD_A_REASON: "理由を入力",
				SELECTED_FAILURE_MODES: "選択した故障モード",
				SELECT_ALL: "すべて選択",
				CANCEL: "キャンセル",
				CLOSE: "閉じる",
				ADD: "追加",
				OK: "OK",
				MARK_AS_CATCH: "キャッチとしてマーク",
			},
			APPROVE: {
				TITLE: "故障モードを承認",
				EDIT_TITLE: "編集 - 故障モードを承認",
				RECOMMENDATIONS_FOR: "{{name}}の推奨事項",
				ADD_RECOMMENDATION_PLACEHOLDER: "推奨事項を追加...",
				APPROVE: "承認",
				UPDATE: "更新",
			},
			RELEARN: {
				TITLE: "故障モードを再学習",
				RELEARN: "再学習",
			},
			BULK_UPDATE: {
				PROCESSING: "処理中",
				COMPLETED: "一括更新が完了しました！",
				DOWNLOAD_REPORT: "レポートをダウンロード",
				SELECT_DUE_DATE: "期日を選択",
				DUE_DATE_HINT: "期日は本日から28日後がデフォルトで、必要に応じて調整できます。",
				DUE_DATE_TOOLTIP: "選択したアラートの期日を選択",
				UPDATED_SUCCESSFULLY: "更新成功",
				UPDATE_FAILED: "更新失敗",
				SHOWING: "{{shown}}/{{total}}件を表示",
			},
			SPLIT_MERGE: {
				TITLE: "故障モードの分割／統合",
				SUBTITLE: "承認済みまたは未処理の故障モードを新規アラートに移動するか、既存のアラートに統合します。",
				APPROVED: "承認済み",
				APPROVED_ON: "{{date}}に承認済み",
				APPROVED_FAILURE_MODES: "承認済み故障モード",
				FAILURE_MODES: "故障モード",
				TAB_CREATE: "新規アラートを作成",
				TAB_MERGE: "既存に統合",
				ALERT_TITLE: "アラートタイトル",
				SYSTEM: "システム",
				UNIT: "ユニット",
				SEVERITY: "重大度",
				SELECT_SEVERITY: "重大度を選択",
				OWNER: "担当者",
				CREATED_ON: "作成日",
				STATUS: "ステータス",
				SELECT_TARGET_ALERT: "対象アラートを選択",
				SEARCH_PLACEHOLDER: "検索...",
				LOADING: "読み込み中...",
				NOT_OWNER_MESSAGE: "ステータスが「処理中」「監視中」「対応予定なし」「不具合報告保留中」のアラートの担当者ではありません。",
				PROCESSING_TOOLTIP: "処理中です。お待ちください！",
				PROCESSING: "処理中...",
				SUBMIT_CREATE: "新規アラートを作成",
				SUBMIT_MERGE: "アラートに統合",
				VIEW_CREATE: "新規アラートを開く",
				VIEW_MERGE: "アラートを開く",
				GO_BACK: "戻る",
				SUCCESS_CREATE: "新規アラートが正常に作成されました。",
				SUCCESS_MERGE: "既存のアラートに正常に統合されました。",
				FAILED_CREATE: "アラートの作成に失敗しました。もう一度お試しください。",
				FAILED_MERGE: "アラートの統合に失敗しました。もう一度お試しください。",
				PENDING: "リクエストはキューに登録されました。現在の予測バッチの完了後に処理されます。",
				CONFLICT: "このアラートでは、分割/統合リクエストがすでに処理中です。",
				CONFLICT_DESTINATION: "宛先アラートでは、分割/統合リクエストがすでに処理中です。",
				TITLE_PLACEHOLDER_EXAMPLE: 'CESR-C-20250807-IPNK',
				SYSTEM_PLACEHOLDER_EXAMPLE: 'GAS TURBINE TRAIN D',
				UNIT_PLACEHOLDER_EXAMPLE: 'COGEN',
				OWNER_PLACEHOLDER_EXAMPLE: 'Ronald Richards',
				CREATED_ON_PLACEHOLDER_EXAMPLE: '2025年8月25日',
			},
			FILTER: {
				FILTER_BY: "フィルタ条件",
				SEARCH_BY_ALERT_NAME: "アラート名で検索...",
				CLEAR_SEARCH: "検索をクリア",
				STATE: "状態",
				ANOMALY: "異常",
				ACTIVE: "アクティブ",
				RETURNED_TO_NORMAL: "正常復帰",
				OTHER_ALERT_TYPES: "その他のアラート種別",
				CATCH: "キャッチ",
				TRUE: "はい",
				FALSE: "いいえ",
				AGENTS: "エージェント",
				HAS_RCA: "根本原因分析あり",
				NO_RCA: "根本原因分析なし",
				BOOKMARK_AND_CASES: "ブックマークとケース",
				ONLY_TRACKED_CASES: "追跡中のケースがあるアラートのみ",
				DIAGNOSIS_CONDITIONS: "診断条件",
				TRIP_BREAKDOWN: "トリップ／故障",
				UNDER_PERFORMANCE: "性能低下",
				SMB_DOWN: "SMBダウン",
				SMB_UNDER_PERF: "SMB性能低下",
				CURTAILMENT: "出力抑制",
				OUT_OF_ENV_SCOPE: "環境範囲外",
				DATA_QUALITY_TYPE: "データ品質種別",
				OUTLIER: "外れ値",
				OUT_OF_RANGE: "範囲外",
				FLATLINE: "フラットライン",
				MISSING: "欠損",
				TAG_STATUS: "タグステータス",
				TAG_STATUS_INFO: "DQアラートのみに適用",
				USED_IN_MODEL: "モデルで使用",
				DROPPED_TAGS: "除外されたタグ",
				WATCHERS: "ウォッチャー",
				SEARCH_PLACEHOLDER: "入力して検索",
				CLEAR_ALL: "すべてクリア",
			},
			COLUMNS: {
				NUMBER: "番号",
				ALERT_NAME: "アラート名",
				STATUS: "ステータス",
				SYSTEM: "システム",
				TYPE: "種別",
				DATE: "日付",
				CREATED_ON: "作成日",
				STATE: "状態",
				OWNER: "担当者",
				WATCHERS: "ウォッチャー",
				CATCH: "キャッチ",
				FORECAST: "予測",
				UPPER_LIMIT: "上限",
				VALUE: "値",
				LOWER_LIMIT: "下限",
				LAST_SYSTEM_UPDATE: "最終システム更新",
				LAST_USER_UPDATE: "最終ユーザー更新",
				TOTAL_VALUE: "合計値",
				RELIABILITY_SAVINGS: "信頼性削減効果",
				MAINTENANCE_SAVINGS: "保全削減効果",
				PERFORMANCE_SAVINGS: "性能削減効果",
				ALERT_DRIVEN_MAINTENANCE: "アラート起因保全",
				DISCUSSION: "ディスカッション",
				LOSS: "損失（kWh）",
				START: "開始",
				STOP: "停止",
				DURATION: "継続時間",
			},
			NO_ALERTS: {
				TITLE: "アラートが見つかりません",
				SUBTITLE: "結果を表示するには、フィルターまたは日付範囲を変更してください",
			},
			COLUMN_CONFIG: {
				SHOW_COLUMNS: "列を表示",
				SEARCH_PLACEHOLDER: "入力して検索",
				SELECT_ALL: "すべて選択",
				RESET_TO_DEFAULT: "デフォルトに戻す",
			},
			PAGE_TITLE: "アラート",
			OVERVIEW_TAB: "概要",
			SEARCH_PLACEHOLDER: "検索...",
			NO_MATCHING_RESULTS: "一致する結果がありません",
			SEARCH_OWNER_PLACEHOLDER: "担当者を検索...",
			SELECT_OWNERS: "担当者を選択",
			ALL_STATUSES: "すべてのステータス",
			STATUS_FILTER: "ステータスフィルタ",
			CHOOSE_STATUSES: "表示するステータスを選択",
			FILTERS: "フィルタ",
			GROUP_BY: "グループ化",
			MORE: "その他",
			SELECT_ALERTS_FOR_CASE: "このケースにタグ付けするアラートを選択してください",
			SHOWING_RESULTS_FOR: '"{{term}}" の検索結果を表示中',
			CHIP: {
				THRESHOLD: "しきい値",
				HIGH_ANOMALY_SHORT: "高異常",
				LOW_ANOMALY_SHORT: "低異常",
				DATA_QUALITY: "データ品質",
				DIAGNOSIS: "診断",
			},
			TYPE: {
				THRESHOLD: "しきい値",
				HIGH_ANOMALY: "高異常",
				LOW_ANOMALY: "低異常",
				DATA_QUALITY: "データ品質",
				DIAGNOSIS: "診断",
			},
			AUTO_REFRESH: {
				LABEL: "自動更新",
				OFF: "オフ",
				LIVE: "ライブ",
				MIN_5: "5分",
				MIN_15: "15分",
				MIN_30: "30分",
				HOUR_1: "1時間",
			},
			MORE_MENU: {
				EXPORT_DATA: "データをエクスポート",
				EXPAND_ALL_GROUPED: "すべてのグループを展開",
				COLLAPSE_ALL_GROUPED: "すべてのグループを折りたたむ",
				EXPAND_ALL_WITHIN_GROUP: "グループ内のすべてを展開",
				COLLAPSE_ALL_WITHIN_GROUP: "グループ内のすべてを折りたたむ",
				SWITCH_TO_CLASSIC: "クラシック表示に切り替え",
			},
			TOOLTIP: {
				TYPE_NEW_EVENTS: "{{type}}の新規イベント",
				TYPE_ALERTS: "{{type}}アラート{{count}}件",
				COUNT_NEW_EVENTS: "新規イベント{{count}}件",
				COUNT_TYPE_NEW_EVENTS: "{{type}}の新規イベント{{count}}件",
				SYSTEM_OPEN_ALERTS: "システム：{{name}}\n未対応アラート：{{count}}件",
				UNIT_OPEN_ALERTS: "ユニット：{{name}}\n未対応アラート：{{count}}件",
				FACILITY_OPEN_ALERTS: "施設：{{name}}\n未対応アラート：{{count}}件",
				EDIT_DISABLED_CLOSED: "クローズ/却下されたアラートの編集操作は無効です。",
			},
		},
		MODEL_WIZARD: {
		NO_CUSTOMER_TAGS_AVAILABLE: 'カスタマータグはありません',
		MAP_CUSTOMER_TAGS_CONTENT: 'アセットタグとマッピングするために、カスタマータグを追加またはインポートしてください。',
		SYSTEM_SUMMARY: {
			TITLE: "システム技術サマリー",
			GENERATE: "サマリーを生成",
			PLACEHOLDER: "システムの詳細な技術サマリーを入力するか、利用可能なドキュメントと接続システムから生成してください。",
			HELPER: "生成されたサマリーは編集できます。手動で入力することもできます。",
			DRAWER_TITLE: "システム技術サマリーの生成",
			SOURCE_DOCS: "ソースドキュメント",
			SOURCE_DOCS_DESC: "システム設計、運転、制御ロジック、または機器の挙動を説明するドキュメントを選択します。",
			DOCS_SELECTED: "件のドキュメントを選択",
			SELECT_DOCUMENTS: "ドキュメントを選択",
			UPLOAD_TITLE: "補足ドキュメントをアップロード",
			UPLOAD_DESC: "ドキュメントマネージャーにまだ存在しない追加ファイルをアップロードします。",
			UPLOAD_FAILED: "アップロードに失敗しました",
			VIEW_FILE: "ファイルを表示",
			PROCESSING: "処理中...",
			COMPLETED: "完了",
			FAILED: "失敗",
			DUPLICATE_UPLOAD: "「{{name}}」は既に追加されています。重複アップロードをスキップしました。",
			ALREADY_UPLOADED_USED: "「{{name}}」は既にアップロードされ、トレーニングに使用されています。",
			CONNECTED_SYSTEMS: "接続システム",
			CONNECTED_DESC: "このシステムの挙動に影響する上流、下流、または並列のシステムを追加します。",
			UPSTREAM: "上流システム",
			SELECT_UPSTREAM: "上流システムを選択",
			DOWNSTREAM: "下流システム",
			SELECT_DOWNSTREAM: "下流システムを選択",
			PARALLEL: "並列システム",
			SELECT_PARALLEL: "並列システムを選択",
			SEARCH_SYSTEM: "システムを検索",
			SEARCH_FACILITY: "施設を検索",
			SEARCH_UNIT: "ユニットを検索",
			NO_SYSTEMS: "システムが見つかりません",
			OPTIONAL_META: "任意のシステムメタデータ",
			OPTIONAL_META_DESC: "任意の詳細を入力すると、生成される技術サマリーの品質が向上します。",
			PRIMARY_COMPONENT: "主要コンポーネント",
			FLUID_MEDIUM: "流体 / 媒体",
			CRITICAL_CONTROL_NODES: "重要制御ノード",
			AUXILIARY_SYSTEMS: "補助システム",
			DIAG_UPSTREAM: "診断マーカー - 上流障害",
			DIAG_DOWNSTREAM: "診断マーカー - 下流障害",
			ADDITIONAL_CONTEXT: "追加コンテキストを追加",
			OPTIONAL: "任意",
			DOCUMENTS_COUNT: "件のドキュメント",
			CONNECTED_COUNT: "件の接続システム",
			VIEW_SOURCES: "ソースを表示",
			VIEW_SOURCES_DESC: "この説明の生成に使用されたドキュメントと接続システム。",
			NO_DOCS_USED: "この説明の生成に使用されたドキュメントはありません。",
			NO_SYSTEMS_USED: "この説明の生成に使用された接続システムはありません。",
			NO_SOURCES: "利用可能なソースがありません",
			NO_SOURCES_DESC: "この説明の生成に使用されたドキュメントや接続システムはありません。",
			REGENERATE: "再生成",
			GENERATION_STARTED: "システム説明を生成しています… しばらくお待ちください。",
			CLICK_TO_EDIT: "クリックして編集",
			ALREADY_IN_PROGRESS: "このシステムの説明は既に生成中です。完了するまで待ってから再生成してください。",
			GENERATION_FAILED: "システム説明の生成に失敗しました。",
			GENERATION_FAILED_TEXT: "システム生成に失敗しました。",
			LAST_UPDATED: "最終更新",
			BY: "更新者",
			DOCUMENTS: "ドキュメント",
			SELECT_DOCS_TITLE: "ソースドキュメントを選択",
			SELECT_DOCS_DESC: "システム設計、運転、制御ロジック、または機器の挙動を説明する施設、ユニット、またはシステムレベルのドキュメントを選択します。",
			DOCUMENT_SCOPE: "ドキュメント範囲",
			SCOPE_FACILITY: "施設",
			SCOPE_UNIT: "ユニット",
			SCOPE_SYSTEM: "システム",
			SEARCH_SCOPE_FACILITY: "施設を検索",
			SEARCH_SCOPE_UNIT: "施設、ユニットを検索",
			SEARCH_SCOPE_SYSTEM: "施設、ユニット、システムを検索",
			SEARCH_SCOPE: "範囲を検索",
			NO_SCOPES: "一致する範囲が見つかりません。別のキーワードをお試しください。",
			ALL_TYPES: "すべてのタイプ",
			SEARCH_DOCS: "ドキュメントを検索...",
			UPDATED: "更新日",
			NO_DOCS_TITLE: "ドキュメントが見つかりません",
			NO_DOCS_DESC: "一致するドキュメントがありません。フィルターを変更してください。",
			LOADING_MORE: "追加のドキュメントを読み込んでいます...",
			SELECTED_DOCS: "選択済みドキュメント",
			ADD: "追加",
			DOCUMENTS_WORD: "件のドキュメント",
			ADD_DOCUMENTS: "ドキュメントを追加",
			CANCEL: "キャンセル",
			REGENERATE_CONFIRM_TITLE: "システム説明を再生成しますか？",
			REGENERATE_CONFIRM_MESSAGE: "再生成すると、現在のシステム説明が新しく生成されたものに置き換えられます。この操作は元に戻せません。",
		},
			ESCALATION_CONFIG: {
				TITLE: "エスカレーション設定",
				DELAY_LABEL: "エスカレーション遅延（日数）",
				LEVEL_LABEL: "レベル",
				LEVEL_PLACEHOLDER: "レベルを入力",
				SELECT_USERS: "ユーザーを選択",
				SEARCH_USERS_PLACEHOLDER: "メールIDで検索",
				NO_MATCHING_EMAIL: "一致するメールIDが見つかりません",
				EMAILS_LABEL: "カンマ区切りのメールIDを追加",
				EMAILS_PLACEHOLDER: "abc@gmail.com, def@gmail.com",
				ADD_LEVEL: "+ レベルを追加",
				ADD_LEVEL_TOOLTIP: "レベルを追加",
				REMOVE_TOOLTIP: "削除",
				CONFIG_TYPE_UNIT: "ユニット設定を使用",
				CONFIG_TYPE_CUSTOM: "カスタム設定を使用",
				CONFIG_TYPE_NONE: "エスカレーション設定なし",
			},
			NO_ASSET_TAGS_FOUND: '設備タグがありません',
			NO_MAPPED_TAGS_FOUND: 'マッピングされたタグがありません',
		ASSET_INFORMATION: "設備情報",
		NO_ASSET_FOUND: "設備が見つかりません",
		EQUIPMENT: "設備",
		TEMPLATE: "テンプレート",
		APPLICATION: "アプリケーション",
		INDUSTRY: "業種",
		CONFIGURATION_COL: "設定",
		MODEL_CONFIGURATION: "モデル設定",
		MODELING_TECHNIQUE: "モデリング手法",
		SCALER: "スケーラー",
		SMOOTHING: "平滑化",
		SELECT_SMOOTHING_FUNCTION: "平滑化関数を選択",
		SMOOTHING_FUNCTION: "平滑化関数",
		WINDOW_SIZE: "ウィンドウサイズ",
		IN_HOURS: "（時間単位）",
		IN_DAYS: "（日単位）",
		SIGMA: "シグマ",
		POLYNOMIAL_ORDER: "多項式次数",
		VALUE_REQUIRED: "値は必須です",
		VALUE_MIN_1: "値は1以上で入力してください",
		NONE: "なし",
		ANOMALY_SCORE_CALC_METHOD: "異常スコア計算方法",
		ANOMALY_CALC_DEFAULT: "デフォルト（全タグのRMS）",
		ANOMALY_CALC_NEW: "新方式（設備タグのRMS合計）",
		PREDICTION_TIME_PERIOD: "予測期間",
		TRAINING_TIME_PERIOD: "学習期間",
		CALENDAR_SELECTION: "カレンダー選択",
		CHART_BASED_SELECTION: "チャート選択",
		START_TIME: "開始日時",
		END_TIME: "終了日時",
		START_TIME_REQUIRED: "開始日時は必須です",
		END_TIME_REQUIRED: "終了日時は必須です",
		STARTUP_TRAINING_BUFFER: "起動時学習バッファ",
		SHUTDOWN_TRAINING_BUFFER: "停止時学習バッファ",
		TRAINING_BUFFER_GROUP: "学習バッファ",
		TRAINING_BUFFER_STARTUP_SHORT: "起動時（日）",
		TRAINING_BUFFER_SHUTDOWN_SHORT: "停止時（日）",
		TRAINING_CONDITIONS: "学習条件",
		METHOD1_RANGE_FILTER: "方法1：範囲フィルタ",
		METHOD2_CONDITION_FILTER: "方法2：条件フィルタ",
		LOAD_TAG: "負荷タグ",
		REFERENCE_TAG: "参照タグ",
		NUM_OF_BINS: "ビン数",
		QUANTILE_CONDITION: "分位条件",
		LESS_THAN: "未満",
		GREATER_THAN: "超過",
		EQUAL_TO: "等しい",
		VALUE: "値",
		TAG: "タグ",
		MIN: "最小",
		MAX: "最大",
		CONDITION: "条件",
		AND: "かつ",
		OR: "または",
		ADD: "追加",
		CLOSE: "閉じる",
		ADD_NOTE: "メモを追加",
		VIEW_NOTE: "メモを表示",
		VIEW_EDIT_NOTE: "メモを表示・編集",
		NOTE_FOR_DATE_RANGE: "対象期間：{{range}}",
		ENTER_NOTES: "メモを入力してください",
		SEARCH_TAGS: "タグを検索...",
		NO_MATCHING_TAGS: "一致するタグが見つかりません",
		SELECT_TRAINING_REGIONS: "学習領域を自動選択",
		ADD_TRAINING_RANGE: "学習範囲を追加",
		DELETE_TRAINING_RANGE: "学習範囲を削除",
		NAME: "名前",
		TAG_ID: "タグID",
		UNIT_SETUP: "ユニット設定",
		SCHEMATIC: "系統図",
		EQUIPMENT_LIST: "設備リスト",
		UNITS: 'ユニット',
		CAPACITY: '容量',
		SYSTEM_INFORMATION: 'システム情報',
		DESCRIPTION: '説明',
		CRITICALITY: '重要度',
		COMMENTS: 'コメント',
		SEARCH: '検索',
		NO_UNIT_FOUND: 'ユニットが見つかりません',
		NO_SYSTEM_FOUND: 'システムが見つかりません',
		CUSTOMER: '顧客',
		FACILITY: '施設',
		UNIT: 'ユニット',
		SYSTEM: 'システム',
		ORIGINAL_AUTHOR: '元の作成者',
		TRAINING_DATASET: 'トレーニングデータセット',
		VALIDATION_LOSS: '検証損失',
		LAST_DEPLOYED: '最終デプロイ',
		ON: 'オン',
		SELECTED_VERSION: '選択されたバージョン',
		DEPLOYED_PERIOD: 'デプロイ期間',
		STATUS: 'ステータス',
		MARK_AS_IMPORTANT: '重要としてマーク',
		DISABLE: '無効化',
		DELETE: '削除',
		DELETE_VERSION_TOOLTIP: 'バージョンを削除',
		TAB_FACILITY_SETUP: '施設設定',
		TAB_TAG_MAPPING: 'タグマッピング',
		TAB_DATA_SYNC: 'データ同期',
		TAB_DATA_IMPORT: 'データのインポートと処理',
		TAG_MAPPING_REQUIRED_TOOLTIP: 'タグマッピングを完了してから、このタブが有効になります。',
		TAB_MODEL_BUILDING: 'モデル構築',
		RECALCULATING_TOOLTIP: '再計算中',
		CUSTOMER_TAG_LIST: '顧客タグリスト',
		TAGS_BTN: 'タグ',
		MODEL_BUILDING_CONFIG_TOOLTIP: 'モデル構築ステップ設定',
		TAGS_TO_BE_MAPPED: 'マッピング待ちタグ',
		UPLOAD_SYSTEM_TAGS: 'システムタグをアップロード',
		DOWNLOAD_FACILITY_TAGS: '施設タグをダウンロード',
		ASSETS_PLACEHOLDER: 'アセット',
		SEARCH_IN_ALL_FIELDS: 'すべてのフィールドで検索',
		COL_NAME: '名前',
		COL_DESCRIPTION: '説明',
		COL_UNIT: 'ユニット',
		CUSTOMER_TAGS: '顧客タグ',
		UPLOAD_TAGS_TOOLTIP: 'タグをアップロード',
		DOWNLOAD_TAGS_TOOLTIP: 'タグをダウンロード',
		TAG_MAPPING_NO_ASSET_TOOLTIP: 'タグマッピングを実行するには少なくとも1つのアセットを作成する必要があります',
		MAP_SELECTED: '選択をマッピング',
		IMPORT_WO_MAPPING: 'WOマッピングをインポート',
		TAGS_MAPPED: 'マッピング済みタグ',
		SAVE_CHANGES: '変更を保存',
		UNMAP_SELECTED: '選択のマッピングを解除',
		UNMAPPED_TAGS: '未マッピングタグ',
		COL_TAG_NAME: 'タグ名',
		COL_ASSET: 'アセット',
		COL_TAG_ID: 'タグID',
		COL_THRESHOLD_HIGH: '閾値上限',
		COL_THRESHOLD_LOW: '閾値下限',
		COL_TRIP_HIGH: 'トリップ上限',
		COL_TRIP_LOW: 'トリップ下限',
		COL_ALARM_HIGH: 'アラーム上限',
		COL_ALARM_LOW: 'アラーム下限',
		COL_DIRECTIONALITY: '方向性',
		COL_FLATLINE_DETECTION: 'フラットライン検出',
		COL_MISSING_DATA_DETECTION: '欠損データ検出',
		COL_OUTLIER_DETECTION: '外れ値検出',
		COL_RANGE_DETECTION: '範囲外検出',
		COL_FLATLINE_ALERT_GENERATION: 'フラットラインアラート生成',
		COL_MISSING_DATA_ALERT_GENERATION: '欠損データアラート生成',
		COL_OUTLIER_ALERT_GENERATION: '外れ値アラート生成',
		COL_RANGE_ALERT_GENERATION: '範囲外アラート生成',
		COL_ATTENTION: 'アテンション',
		COL_THRESHOLD_NOTIFICATION: '閾値通知',
		COL_KPI: 'KPI',
		SHOW_COLUMNS_TOOLTIP: '列を表示',
		VIEW_CHANGES_TOOLTIP: '変更を表示',
		EDIT_TAG_TOOLTIP: 'タグを編集',
		VIEW_PIDS_TOOLTIP: 'PIDを表示',
		IN_PROGRESS: '処理中',
		CORRECT_RECORDS_MSG: 'エラーのあるレコードを修正して再度アップロードしてください。',
		DOWNLOAD_ERROR_RECORDS: 'エラーレコードをダウンロード',
		RELEVANT_INFORMATION: '関連情報',
		PIDS_PANEL: 'P&IDs',
		IMAGES_PANEL: '画像',
		TEST_REPORTS_PANEL: 'テストレポート',
		PROCEDURES_PANEL: '手順',
		TAG_DATA: 'タグデータ',
		SEARCH_TAG: 'タグを検索',
		SEARCH_ASSET: 'アセットを検索',
		EXPORT_DQ_METRICS_TOOLTIP: 'DQメトリクスをエクスポート',
		EXPORT: 'エクスポート',
		TAG_SELECTION_PLACEHOLDER: 'タグ選択',
		PREPROCESSING_STATS_PLACEHOLDER: '前処理統計',
		TAG_MAPPING_PLACEHOLDER: 'タグマッピング',
		TAG_TYPE_PLACEHOLDER: 'タグタイプ',
		OPERATING_REGION_PLACEHOLDER: '運転領域',
		COL_PLOT: 'グラフ',
		COL_CORR: '相関',
		COL_MODEL: 'モデル',
		COL_TAGS: 'タグ',
		SHUTDOWN_TAG_TOOLTIP: 'シャットダウンタグ',
		COL_MAX: '最大',
		COL_MIN: '最小',
		COL_STD_DEV: '標準偏差',
		COL_AGGREGATE_TAG: '集計タグ',
		COL_MEAN_SHIFT: '平均シフト',
		COL_VARIANCE: '分散',
		COL_MEAN: '平均',
		COL_DEVIATION_SCORE: '偏差スコア',
		COL_OP_UPPER: '運転上限',
		COL_OP_LOWER: '運転下限',
		COL_NANS: 'NaNs',
		COL_OUTLIERS: '外れ値',
		COL_FLATLINE: 'フラットライン',
		COL_OUT_OF_RANGE: '範囲外',
		COL_TOTAL_INVALID_DATA: '総無効データ',
		NO_RECORDS_FOUND: 'レコードが見つかりません',
		NO_DATA_AVAILABLE_SYSTEM: '選択したシステムのデータがありません。新しいデータを取得するかアップロードしてください',
		CHOOSE_MODEL_VERSION_MSG: 'タグのグラフを表示するにはモデルバージョンを選択してください',
		SELECT_PLOT_CHECKBOX_MSG: 'グラフを表示するにはタグのプロットチェックボックスを選択してください',
		TAG_CORRELATION_TITLE: 'タグ相関',
		TAG_CORRELATION_CONDITION_PLACEHOLDER: 'タグ相関条件',
		CORR_GREATER_THAN_OPTION: '以下より大きい相関のタグを表示',
		CORR_LESS_THAN_OPTION: '以下より小さい相関のタグを表示',
		CORR_VALUE_PLACEHOLDER: '相関値',
		SELECT_RANGE_LABEL: '範囲を選択',
		SELECT_RANGE_TOOLTIP: 'チャート上をドラッグして日付範囲を選択',
		REMOVE_RANGE_LABEL: '範囲を削除',
		REMOVE_RANGE_TOOLTIP: 'チャート上をドラッグしてモデリングから日付範囲を除外',
		SYSTEM_DATA_FILTER_LABEL: 'システムデータフィルター',
		SELECTED_DATE_RANGES_LABEL: '選択した日付範囲：',
		CONFIRM_SELECTION: '選択を確認',
		REMOVED_DATE_RANGES_LABEL: '削除した日付範囲：',
		EDIT_MODEL_TITLE: 'モデルを編集',
		FORM_ERROR_MSG: 'エラーが発生しました。いくつかの項目を変更して再送信してください。',
		OP_LOWER_PLACEHOLDER: '運転下限',
		OP_UPPER_PLACEHOLDER: '運転上限',
		REQUIRED: '必須',
		CANCEL_CHANGES_TOOLTIP: '変更をキャンセル',
		CANCEL: 'キャンセル',
		SAVE_DATA_TOOLTIP: 'データを保存',
		SAVE: '保存',
		SIMULATION: 'シミュレーション',
		SHOW_FAILURE_INFO: '故障情報を表示',
		OK: 'OK',
		RESET_ASSET_SELECTION_TOOLTIP: 'アセット選択をリセット',
		CLOSE_CROSSHAIR_TOOLTIP: 'クロスヘアを閉じる',
		CROSSHAIR: 'クロスヘア',
		LOADING: '読み込み中...',
		NO_FAILURE_MODE_FOUND: '故障モードが見つかりません。',
		MODEL_PARAMETERS_PANEL: 'モデルパラメータ',
		BOILER_HEALTH_PANEL: 'ボイラー健全性',
		ALERT_PARAMETERS_PANEL: 'アラートパラメータ',
		FAILURE_PARAMETERS_PANEL: '故障パラメータ',
		APPLY_SOURCE_VERSION_FEEDBACK: 'ソースバージョンフィードバックを適用',
		COMMENT_PLACEHOLDER: 'コメント',
		SAVE_MODEL: 'モデルを保存',
		SAVE_MODEL_TOOLTIP: 'モデルを保存',
		RESAVE: '再保存',
		RESAVE_TOOLTIP: 'モデルを再保存',
		DEPLOY_MODEL_TOOLTIP: 'モデルをデプロイ',
		DEPLOY_TAG_UNMAPPED_TOOLTIP: 'モデル {{version}} には、システムからマッピング解除されたタグが含まれているため、デプロイは許可されていません',
		DEPLOY: 'デプロイ',
		GO_LIVE_CSV_TOOLTIP: 'CSVストリーミング/Historianでライブ公開',
		GO_LIVE: 'ライブ公開',
		GO_LIVE_OPTIONS_TITLE: 'ライブオプション',
		DATA_SOURCE_TYPE_PLACEHOLDER: 'データソースタイプ',
		HISTORIAN_OPTION: 'Historian',
		START_PREDICTION_FROM: '予測開始日',
		FROM_DATE_REQUIRED: '開始日は',
		GO_LIVE_BTN: 'ライブ公開',
		GO_LIVE_TOOLTIP: 'ライブ公開',
		THRESHOLD_PLACEHOLDER: '閾値',
		AUTOMATIC_OPTION: '自動',
		MANUAL_OPTION: '手動',
		RISK_PROFILE_PLACEHOLDER: 'リスクプロファイル',
		CREATE_CONDITION: '条件を作成',
		RETURN_CONDITION: '復帰条件',
		EXCEED_FOR_PLACEHOLDER: '超過期間',
		OUT_OF_PLACEHOLDER: '総計',
		DOWN_FOR_PLACEHOLDER: '降下期間',
		ALARM_THRESHOLD_PLACEHOLDER: 'アラーム閾値',
		ADD_TOOLTIP: '追加',
		GENERATE_ALERT_TOOLTIP: 'アラートを生成',
		UPDATE: '更新',
		SELECT_DATE_PLACEHOLDER: '日付を選択',
		DATE_REQUIRED_ERROR: '日付は',
		HEALTH_PLACEHOLDER: '健全性',
		REMOVE_TOOLTIP: '削除',
		GENERATE_BOILER_HEALTH_TOOLTIP: 'ボイラー健全性を生成',
		ANOMALY_WT_THRESHOLD_PLACEHOLDER: '異常加重閾値',
		LOW_OPTION: '低',
		MEDIUM_OPTION: '中',
		HIGH_OPTION: '高',
		CUTOFF_PARTIAL_MATCH: '部分一致のカットオフ',
		IN_PERCENTAGE_HINT: 'パーセントで',
		CUTOFF_FULL_MATCH: '完全一致のカットオフ',
		UPDATE_FAILURE_TOOLTIP: '故障を更新',
		START_DELAY_PLACEHOLDER: '開始遅延',
		NO_OF_HOURS_HINT: '（時間数）',
		END_DELAY_PLACEHOLDER: '終了遅延',
		GROUPING: 'グループ化',
		DOWN_CONDITION_PLACEHOLDER: '降下条件',
		ANOMALY_SCORE_THRESHOLD: '異常スコア閾値',
		FILTER_FAILURE_PLACEHOLDER: '故障をフィルタ',
		VALUE_BETWEEN_0_1: '0から1の間の値を入力',
		FEEDBACKS: 'フィードバック',
		LIVE_FEEDBACKS: 'ライブフィードバック',
		PREVIOUS_FEEDBACKS: '過去のフィードバック',
		BAND_LEARNING_BEHAVIOUR: 'バンド学習動作',
		CONSERVATIVE: 'コンサバティブ',
		CONSERVATIVE_TOOLTIP: '選択したトレーニング領域の周りに狭いバンドを作成',
		MODERATE: 'モデレート',
		MODERATE_TOOLTIP: '選択したトレーニング領域の周りにバランスのとれたバンドを作成',
		AGGRESSIVE: 'アグレッシブ',
		AGGRESSIVE_TOOLTIP: '選択したトレーニング領域の周りに広いバンドを作成',
		UPDATE_FEEDBACK: 'フィードバックを更新',
		UPDATE_PARAMETERS_TOOLTIP: 'パラメータを更新',
		DATA_IMPORT_PANEL: 'データインポート',
		PRE_PROCESSING_PANEL: '前処理',
		CSV_OPTION: 'CSV',
		UPLOADED_CSV_OPTION: 'アップロード済みCSV',
		SELECT_SOURCE_HINT: 'データをインポートするソースを選択',
		SAMPLING_RATE_PLACEHOLDER: 'サンプリングレート',
		SAMPLING_RATE_REQUIRED: 'サンプリングレート',
		IN_MINUTES_HINT: '（分）',
		SELECT_CSV_FILE_PLACEHOLDER: 'CSVファイルを選択',
		CSV_FILE_REQUIRED: 'CSVファイルは',
		SELECT_FILE_BTN: 'ファイルを選択',
		DATA_SYNC_MORE_DATA_TOOLTIP: '詳細なデータを取得するには、データ同期タブに移動してデータ取得リクエストを送信してください。',
		DATA_SET_NAME_PLACEHOLDER: 'データセット名',
		IMPORT_TOOLTIP: 'インポート',
		IMPORT_DATA: 'データをインポート',
		STATE_IDENTIFICATION_PANEL: '状態識別',
		EXCLUDE_REGION_PANEL: '領域を除外',
		PRE_PROCESSING_CONFIG_PANEL: '前処理設定',
		MODEL_TAG_SELECTION_PANEL: 'モデルタグ選択',
		PROCESS_TOOLTIP: '処理',
		PROCESS_DATA: 'データを処理',
		SHUTDOWN_TAG_PLACEHOLDER: 'シャットダウンタグ',
		CONDITION_PLACEHOLDER: '条件',
		LESS_THAN_OPTION: '未満',
		GREATER_THAN_OPTION: '超過',
		EQUAL_TO_OPTION: '等しい',
		VALUE_PLACEHOLDER: '値',
		SHUTDOWN_CONDITION_PLACEHOLDER: 'シャットダウン条件',
		AND_OPTION: 'かつ',
		OR_OPTION: 'または',
		SHUTDOWN_SPAN_PLACEHOLDER: 'シャットダウン期間',
		IN_HOURS_HINT: '（時間）',
		SHUTDOWN_TRANSITION_PLACEHOLDER: 'シャットダウン移行',
		STARTUP_TRANSITION_PLACEHOLDER: '起動移行',
		EXCLUDE_REGION_TAG_PLACEHOLDER: '除外領域タグ',
		EXCLUDE_CONDITION_PLACEHOLDER: '除外条件',
		OUTLIER_DETECTION_METHOD: '外れ値検出方法',
		OUTLIER_DETECTION_THRESHOLD: '外れ値検出閾値',
		SIGMA_HINT: 'シグマ',
		INTERPOLATION_METHOD: '補間方法',
		INTERPOLATION_CONFIG: '補間設定',
		FLATLINE_THRESHOLD_TIME: 'フラットライン閾値時間',
		FLATLINE_TIME_BASE: 'フラットライン時間ベース',
		HOURS_OPTION: '時間',
		MINUTES_OPTION: '分',
		SECONDS_OPTION: '秒',
		CROSS_CORRELATION: '相互相関',
		// pre-processing-configuration-form: row group titles + short field labels
		OUTLIER_DETECTION_GROUP: '外れ値検出',
		INTERPOLATION_GROUP: '補間',
		FLATLINE_GROUP: 'フラットライン',
		LABEL_METHOD: '方法',
		LABEL_THRESHOLD: '閾値',
		LABEL_CONFIGURATION: '設定',
		FLATLINE_DETECTION_SHORT: '検出',
		FLATLINE_THRESHOLD_TIME_SHORT: '閾値時間',
		FLATLINE_TIME_BASE_SHORT: '時間ベース',
		DATA_DENSITY_THRESHOLD: 'タグ選択のデータ密度閾値',
		DATA_DENSITY_REQUIRED: 'データ密度閾値は',
		GLOBAL_PREPROCESSING: 'グローバル前処理',
		RANGE_PREPROCESSING: '範囲前処理',
		DENSITY_HINT: '密度',
		REFRESH_TABLE_DATA_TOOLTIP: 'テーブルデータを更新',
		LAST_DATA_PULL_LABEL: '最終データ取得：',
		UPLOAD_CSV_TOOLTIP: 'CSVをアップロード',
		NO_RAW_TAGS_TOOLTIP: 'このシステムに生タグがないためファイルをアップロードできません',
		UPLOAD_BTN: 'アップロード',
		ANOTHER_PROCESS_RUNNING_TOOLTIP: '別のプロセスが実行中',
		NO_RAW_TAG_MAPPED_TOOLTIP: 'このシステムにマッピングされた生タグがありません',
		NEW_DATA_PULL_REQUEST: '新規データ取得リクエスト',
		ADD_NEW_DATA_PULL_TOOLTIP: '新規データ取得リクエストを追加',
		DELETE_SYSTEM_DATA_TOOLTIP: 'システムデータを削除',
		STOP_DATA_PULL_TOOLTIP: 'データ取得を停止',
		COL_SERIAL_NO: '番号',
		COL_DATA_REQUESTED_FOR: 'リクエストされたデータ期間',
		COL_REQUESTED_ON: 'リクエスト日',
		COL_ACCESS_METHOD: 'アクセス方法',
		COL_REQUEST_TYPE: 'リクエストタイプ',
		COL_FILE_NAME: 'ファイル名',
		COL_PULLED_BY: '取得者',
		COL_DATA_RECEIVED: '受信データ',
		COL_ACTIONS: 'アクション',
		DATA_REPULL_TOOLTIP: 'データの再取得',
		TAG_PULL_REQUEST: 'タグ取得リクエスト',
		COL_VALUE: '値',
		COL_MISSING: '欠損',
		COL_OUTLIER: '外れ値',
		TRIP_LIMIT_TOOLTIP: 'トリップ制限',
		TRIP_LABEL: 'トリップ',
		ALARM_LIMIT_TOOLTIP: 'アラーム制限',
		ALARM_LABEL: 'アラーム',
		THRESHOLD_LIMIT_TOOLTIP: '閾値制限',
		THRESHOLD_LABEL: '閾値',
		INSTRUMENT_RANGE_TOOLTIP: '計器レンジ',
		INSTRUMENT_LABEL: '計器',
		HIGH_LABEL: '高：',
		LOW_LABEL: '低：',
		AVG_LABEL: '平均：',
		DATA_PULL_REQUEST: 'データ取得リクエスト',
		SELECT_TAGS_PLACEHOLDER: 'タグを選択',
		FROM_DATE_PLACEHOLDER: '開始日',
		SELECT_FROM_DATE_HINT: '開始日',
		TO_DATE_PLACEHOLDER: '終了日',
		TO_DATE_REQUIRED: '終了日は',
		SELECT_TO_DATE_HINT: '終了日',
		PULL_DATA_TOOLTIP: 'データを取得',
		PULL_DATA: 'データを取得',
		STATUS_PANEL: {
			SUMMARY: 'サマリー',
			TAG_SUMMARY: 'タグサマリー',
			RECORDS: '件',
			TOTAL_TAGS: 'タグ総数',
			TAGS_IN_MODEL: 'モデル内タグ',
			TAGS_MAPPED_TO_FM: '故障モードに紐付くタグ',
			TAGS_WITH_NO_FM: '故障モード未紐付けタグ',
			PROCESSING_TIME: '処理時間',
			TRAINING_TIME: '学習時間',
			TOTAL_TAGS_DROPPED: '除外タグ総数',
			ALERTS_GENERATED: '生成されたアラート',
			PRECISION_PREVIOUS: '前回の精度',
			PRECISION_CURRENT: '現在の精度',
			PHASE_DATA_IMPORT: 'データインポート',
			PHASE_PREPROCESSING: 'データ前処理',
			PHASE_MODELING: 'モデリング',
			PHASE_ALERT_FEEDBACK: 'アラートフィードバック',
			PHASE_READY_TO_DEPLOY: 'デプロイ準備完了',
			DROPPED_TAGS: '除外タグ',
			CALCULATED_TAGS_DROPPED: '除外された計算タグ',
			RAW_TAGS_DROPPED: '除外された生タグ',
			TAGS_DROPPED_PREPROCESSING: '前処理で除外されたタグ',
			TAGS_DROPPED_MANUALLY: '手動で除外されたタグ',
			HIGH_DEVIATION_TAGS: '高偏差タグ',
			EXPORT: 'エクスポート',
			COL_TAG_NAME: 'タグ名',
			COL_TAG_ID: 'タグ ID',
			COL_DESCRIPTION: '説明',
			COL_UNIT: '単位',
			COL_CALCULATED: '計算タグ',
			COL_DROPPED_DUE_TO: '除外区分',
			COL_REASON: '理由',
			YES: 'はい',
			NO: 'いいえ',
			DROPPED_DUE_IMPORT: 'インポート',
			DROPPED_DUE_PREPROCESSING: '前処理',
			DROPPED_DUE_MANUAL: '手動',
			DROPPED_DUE_UNKNOWN: '—',
			NO_TAGS_DROPPED: '除外されたタグはまだありません',
			NO_HIGH_DEVIATION: 'モデル構築を実行して高偏差タグを表示します',
			NO_HIGH_DEVIATION_EMPTY: '高偏差タグは見つかりませんでした',

			PHASE_DEPLOYED: 'デプロイ済み',
			DROPPED_DUE_CALCULATED: '計算タグ',
			STEP_STATUS: 'ステータス',
			STEP_STATUS_COMPLETED: '完了',
			STEP_PREPROCESSING_TIME: '前処理時間',
			STEP_TRAINING_TIME: '学習時間',
			STEP_PREDICTION_TIME: '予測時間',
			STEP_ALERTS_GENERATED: '生成されたアラート',
			STEP_PRECISION_CURRENT: '現在の精度',
			STEP_PRECISION_PREVIOUS: '前回の精度',
			REASON_UNSELECTED_FROM_MODEL: 'モデルから選択解除',
			REASON_INVALID_DATA: '{{percent}}%無効データ',
			STEP_SECONDS_VALUE: '{{value}}秒',
		},
		UPLOAD_CSV_TITLE: 'CSVをアップロード',
		},
		CASES: {
			WORK_ORDER: {
				CREATE_TITLE: '作業指示通知の作成',
				CREATE_DESC: 'このケースの作業指示通知を作成します',
				DESCRIPTION: '説明',
				DESCRIPTION_PLACEHOLDER: '実施する作業を記述してください（必須）',
				DESCRIPTION_REQUIRED: '説明は必須です',
				PRIORITY: '優先度',
				DUE_DATE: '期日',
				ASSIGNED_TO: '担当者',
				ESTIMATED_HOURS: '見積時間',
				HOURS_PLACEHOLDER: '時間を入力',
				CANCEL: 'キャンセル',
				CONFIRM: '確認',
				UNASSIGNED: '未割り当て',
				CREATED: '作業指示 {{number}} を作成しました',
				CREATED_PLAIN: '作業指示を作成しました',
				FAILED: '作業指示を作成できませんでした',
				CREATE_BUTTON: '作業指示を作成',
				NONE_YET: '作業指示はまだありません',
				VIEW_TITLE: '作業指示 {{number}}',
				VIEW_SUB: 'このケースから作成された作業指示',
				CREATED_BY: '作成者: {{name}}',
			},
			TRIAGE: {
				FROM_TRIAGE: 'アラートトリアージからのケース',
				FROM_TRIAGE_DESC: 'このケースのアラートはアラートトリアージにあります。テレメトリとエビデンスはそちらで確認してください',
				HIERARCHY: 'アラートトリアージ階層',
				NO_FLOC: '機能場所なし',
				ALERTS: 'トリアージアラート',
				ADD_ALERTS: 'アラートを追加',
				ADD_ALERTS_TIP: 'トリアージアラートを検索してこのケースに追加',
				AUTO_FIND: '自動検索',
				AUTO_FIND_TIP: 'このケースのアラートとバッチされた、またはイベント前後で同じFLOCのアラート',
				AUTO_FIND_DESC: 'ソースアラート前後のウィンドウ内のバッチグループまたは同じFLOC',
				EVENT_START: 'イベント開始',
				VIA_SOURCE: 'ソース',
				VIA_MANUAL: '追加',
				VIA_AUTO: '自動検出',
				ALERT_MISSING: 'トリアージキューにありません',
				OPEN_TRIAGE: 'アラートトリアージで開く',
				REMOVE_ALERT: 'ケースから削除',
				SEARCH_PLACEHOLDER: 'アラートID、タグ、名前、FLOCで検索…',
				SEARCHING: '検索中…',
				NO_MATCH: '一致するアラートはありません',
				ADD: '追加',
				NO_SUGGESTIONS: 'このウィンドウに他のアラートはありません',
				REASON_GROUP: '同じバッチグループ',
				REASON_FLOC: '同じFLOC（±{{hours}} 時間以内）',
				SELECT_ALL: 'すべて選択',
				ADD_SELECTED: '選択項目を追加（{{count}}）',
				EVIDENCE: 'エビデンス',
				KIND_FACT: '事実',
				KIND_TAG: 'タグ',
				KIND_MAINTENANCE: '保全',
				KIND_REPORT: 'レポート',
				KIND_NOTE: 'メモ',
				NO_EVIDENCE: 'エビデンスはまだありません',
				REMOVE_EVIDENCE: 'エビデンスを削除',
				ADD_EVIDENCE_PLACEHOLDER: '{{kind}} に追加…',
				BY_AGENT: 'トリアージエージェント',
				BY_ENGINEER: 'エンジニア',
				ALERT_REMOVED: 'アラートをケースから削除しました',
				ALERTS_ADDED: '{{count}} 件のアラートを追加しました',
				EVIDENCE_ADDED: 'エビデンスを追加しました',
				EVIDENCE_REMOVED: 'エビデンスを削除しました',
				ACTION_FAILED: '操作に失敗しました',
				HIERARCHY_SOURCE: '階層',
				SOURCE_TRIAGE: 'アラートトリアージ',
				SOURCE_PLATFORM: 'プラットフォームシステム',
				SELECT_FLOC: '機能場所',
				ROOT: 'すべて',
				FLOC_SEARCH: 'FLOCコードまたは名前を検索…',
				FLOC_REQUIRED: '機能場所を選択してください',
				NO_CHILDREN: '下位レベルはありません',
				RELATED_TRIAGE_ALERTS: 'トリアージアラート（任意）',
				SELECT_ALERTS: 'アラートを選択',
			},
			SELECT_STATUS: 'ステータスを選択',
			SELECT_CATEGORY: 'カテゴリを選択',
			UNASSIGNED: '未割り当て',
			UNKNOWN_CREATOR: '作成者不明',
			ALL_CASES: 'すべてのケース',
			CREATE_CASE: 'ケースを作成',
			CASE_MANAGEMENT: 'ケース管理',
			UNKNOWN: '不明',
			UNCATEGORIZED: '未分類',
			TITLE: 'ケース',
			SEARCH_PLACEHOLDER: '検索...',
			NO_MATCHING_RESULTS: '一致する結果がありません',
			SEARCH_OWNER_PLACEHOLDER: '担当者を検索...',
			SEARCH_WATCHERS_PLACEHOLDER: '監視者を検索...',
			SELECT_OWNERS: '担当者を選択',
			FILTERS: 'フィルタ',
			GROUP_BY: 'グループ化',
			MORE: 'その他',
			CASES_COUNT: '{{count}} 件のケース',
			NO_CASES_FOUND: '利用可能なケースはありません',
			SYSTEM_TAGS: 'システムタグ',
			CHECK_FILTERS_DATE_RANGE: '結果を表示するには、フィルターまたは日付範囲を変更してください',
			CHIP: {
				OPEN: 'オープン',
				PENDING: '保留中',
				CLOSED: 'クローズ',
			},
			TOOLTIP: {
				OPEN_IN_NEW_TAB: '新しいタブで開く',
				CUSTOMIZE_COLUMNS: '列をカスタマイズ',
				ONLY_OWNER_CATCH_TOOLTIP: 'ケースの担当者のみがこれをキャッチとしてマークできます',
				ONLY_OWNER_EDIT_TOOLTIP: 'ケースの担当者または作成者のみがこれを変更できます',
				MARKED_AS_CATCH_TOOLTIP: 'キャッチとしてマークされました。ケース詳細を開いて更新してください。',
				NOT_MARKED_AS_CATCH_TOOLTIP: 'キャッチとしてマークされていません。ケース詳細を開いて変更してください。',
				OPEN_CASE: 'オープンケース {{count}} 件',
				OPEN_CASES: 'オープンケース {{count}} 件',
				PENDING_CASE: '保留中のケース {{count}} 件',
				PENDING_CASES: '保留中のケース {{count}} 件',
				OPEN_TOOLTIP: "オープン（以下を含む）:\n顧客への通知\n現場への通知\n現場調査",
				PENDING_TOOLTIP: "保留中（以下を含む）:\n保全待ち\n保全延期\nシャットダウン待ち",
				CLOSED_TOOLTIP: "クローズ（以下を含む）:\nケース解決済み\n対応不要"
			},
			GROUP_BY_OPTION: {
				NONE: 'なし',
				STATUS: 'ステータス',
				CATEGORY: 'カテゴリ',
				SYSTEM: 'システム',
				OWNER: '担当者',
				CREATOR: '作成者'
			},
			STATUS_OPTION: {
				1: '顧客への通知',
				2: '現場への通知',
				3: '現場調査',
				4: '保全待ち',
				5: '保全延期',
				6: 'シャットダウン待ち',
				7: 'ケース解決済み',
				8: '対応不要'
			},
			CATEGORY_OPTION: {
				1: '信頼性',
				2: 'プロセス',
				3: 'インスツルメンテーション',
				4: '機械',
				5: '電気',
				6: '起動／停止',
				7: 'その他'
			},
			COLUMNS: {
				SELECT: '選択',
				NUMBER: '番号',
				CASE_ID: 'ケースID',
				CASE_NAME: 'ケース名',
				SYSTEM_NAME: 'システム名',
				ALERT_NAME: 'アラート名',
				CATEGORY: 'カテゴリ',
				STATUS: 'ステータス',
				CATCH: 'キャッチ',
				SOURCE: 'ソース',
				OWNER: '担当者',
				WATCHERS: '監視者',
				CREATED_BY: '作成者',
				CREATED_ON: '作成日',
				SYSTEM_ANALYSIS: 'システム分析・解釈',
				DUE_DATE: '期日',
				ESTIMATED_VALUE: '見積価値',
				AGREED_VALUE: '合意価値',
				LAST_MODIFIED: '最終更新',
				RCH: '根本原因仮説',
				FEEDBACK_OUTCOME: 'フィードバック・結果',
				WORK_ORDER: '作業指示書',
				POTENTIAL_IMPACT: '潜在的影響',
			},
			MANAGEMENT: {
				FAILURE_MODE: '故障モード',
				SELECTED_VIEW: '選択したビュー',
				USER_PREFERENCE_SETTINGS: 'ユーザー環境設定',
				CASES_LAYOUT: 'ケースレイアウト',
				SIMPLIFIED: '簡易',
				ADVANCED_DEFAULT: '詳細（デフォルト）',
				LINKED_ALERT_REMOVED: 'リンクされたアラートが削除されました',
				LINKED_ALERT_REMOVED_DESC: "このケースのリンクされたアラートは利用できなくなりました",
				LINK_NEW_ALERT: '新しいアラートをリンク',
				DRAG_TO_REORDER: 'クリックしてドラッグし、並べ替えます',
				NO_TAGS_AVAILABLE_FOR_FM: 'この故障モードで使用できるタグはありません。',
				NO_TAGS_AVAILABLE_FOR_ALERT: 'このアラートで使用できるタグはありません。',
				NO_TAGS_ADDED: 'タグが追加されていません',
				ADD_TAGS_FROM_DISPLAY_TAGS: '右側の「タグを表示」パネルから、このケースにタグを追加してください',
				VIEW_SETTINGS: '表示設定',
				DISPLAY_TAGS: 'タグを表示',
				ASSET: '設備',
				SELECT_STATUS: 'ステータスを選択',
				SELECT_CATEGORY: 'カテゴリを選択',
				SEARCH_OWNER: '担当者を検索...',
				SEARCH_WATCHERS: 'ウォッチャーを検索...',
			},
			COMMON_DIALOG: {
				SELECT_ALL: 'すべて選択',
				REPORT_PDF_FILE_NAME: 'レポートPDFファイル名',
				INCLUDE_EVIDENCE_ATTACHMENTS: 'エビデンスの添付ファイルを含める',
				GENERATING_REPORT_FOR: '{{count}} 件の追跡ケースのレポートを生成しています',
				SELECT_FMS_TIMELINE: 'ケースに追加する故障モードをタイムラインから選択してください。',
				SELECT_FMS_FOR_RECOMMENDATIONS: '推奨事項の故障モードを選択',
				RECOMMENDATIONS_FOR: '{{name}} の推奨事項',
				NO_RECS_FOR_FM: 'この故障モードの推奨事項はありません。',
				NO_OPEN_FMS: 'オープン状態の故障モードはありません。',
				NO_FMS_SELECTED: '故障モードが選択されていません。続行するには1つ以上選択してください。',
				FMS_SELECTED: '{{count}} 件の故障モードが選択されています',
				SELECT_FMS_TO_CONTINUE: '続行するには、少なくとも1つの故障モードを選択してください',
				SELECT_RECS_TO_CONTINUE: '続行するには、少なくとも1つの推奨事項を選択してください',
				SELECT_ANALYSIS_TO_CONTINUE: '続行するには、少なくとも1つの分析を選択してください',
				SELECT_VIEW_TO_CONTINUE: '続行するには、少なくとも1つの表示を選択してください',
				SELECT_ITEM_TO_CONTINUE: '続行するには、少なくとも1つの項目を選択してください',
				ADD_SELECTED_RECOMMENDATIONS: '選択した推奨事項を追加',
				ADD_SELECTED_ANALYSIS: '選択した分析を追加',
				ADD_SELECTED_VIEWS: '選択した表示を追加',
				ADD_SELECTED_FAILURE_MODES: '選択した故障モードを追加',
			},
			FILTER: {
				FILTER_BY: 'フィルタ条件',
				SEARCH_PLACEHOLDER: '名前またはIDで検索...',
				STATUS: 'ステータス',
				CATEGORY: 'カテゴリ',
				CATCH: 'キャッチ',
				CREATED_BY: '作成者',
				WATCHERS: '監視者',
				CLEAR_ALL: 'すべてクリア'
			},
			DETAILS: {
				CASE_NARRATIVE: 'ケースの説明',
				SYSTEM_ANALYSIS: 'システム分析・解釈',
				RCH: '根本原因仮説',
				POTENTIAL_IMPACT: '潜在的影響',
				PROPOSED_ACTIONS: '提案されたアクション',
				FEEDBACK_OUTCOME: 'フィードバック・結果',
				WORK_ORDER: '作業指示書',
				MARK_AS_CATCH: 'キャッチとしてマーク',
				SYSTEM_ANALYSIS_PLACEHOLDER: '観察された内容、開始時間、現在の運転状況を要約します...',
				RCH_PLACEHOLDER: '疑わしいまたは確認された根本原因を説明します。関連する場合は故障モード（FM）またはイベントにリンクします...',
				TAG_RELATED_FAILURE_MODES: '関連する故障モードをタグ付け',
				ADD_FAILURE_MODES_TOOLTIP: '故障モードを追加',
				ADD_FMS: '故障モード（FM）を追加',
				RECOMMENDED_ACTIONS: '推奨アクション',
				ADD_SELECTED: '選択したものを追加',
				ADD_SELECTED_RECOMMENDATIONS_TOOLTIP: '選択した推奨アクションを追加',
				ADD_RECOMMENDATIONS_TOOLTIP: '推奨アクションを追加',
				ADD_MORE: 'さらに追加',
				ADD_MORE_RECOMMENDATIONS_TOOLTIP: 'さらに推奨アクションを追加',
				PROPOSED_ACTIONS_PLACEHOLDER: '提案されたアクション、スケジュール、実行しない場合のリスク...',
				POTENTIAL_IMPACT_PLACEHOLDER: '潜在的なビジネス・運用への影響（ダウンタイムリスク、品質低下、安全性、コストなど）を説明します...',
				FEEDBACK_OUTCOME_PLACEHOLDER: '現場からのメモ、実施されたアクション、学んだ教訓...',
				WORK_ORDER_PLACEHOLDER: '例: WO-2026-001248（保守システムの作業指示番号または参照番号を入力してください。）',
				CANCEL: 'キャンセル',
				SAVE: '保存',
				EVIDENCE_ATTACHMENTS: 'エビデンスと添付ファイル',
				SAVED_ANALYSIS: '保存された分析',
				NO_SAVED_ANALYSIS_AVAILABLE: '保存された分析はありません',
				ADD_SAVED_ANALYSIS: '保存された分析を追加',
				ADD_ANALYSIS: '分析を追加',
				LINK_ALERT_TO_ADD_ANALYSIS: '保存された分析を追加するには、関連アラートをタグ付けしてください',
				SAVED_VIEWS: '保存されたビュー',
				ONLY_OWNERS_SAVE_TAG_VIEWS: 'アラートの担当者またはケースの担当者のみがタグビューを保存または変更できます。',
				SAVE_CURRENT_TAG_VIEW: '現在のタグビューを保存',
				SAVE_CURRENT_VIEW: '現在のビューを保存',
				NO_SAVED_VIEWS_AVAILABLE: '保存されたビューはありません',
				ADD_SAVED_VIEWS: '保存されたビューを追加',
				ADD_VIEW: 'ビューを追加',
				LINK_ALERT_TO_ADD_VIEWS: '保存されたビューを追加するには、関連アラートをタグ付けしてください',
				TAG_RELATED_ALERTS: '関連するアラートをタグ付け',
				ADD_ALERTS: 'アラートを追加',
				UPLOAD_EVIDENCES: 'エビデンスをアップロード',
				UPLOAD_PLACEHOLDER: 'エビデンスを添付、ドラッグ＆ドロップ、または貼り付け...',
				VALUE_IMPACT: '価値影響',
				VALUE_CALCULATION_INPUTS: '価値計算の入力項目',
				LIKELIHOOD: '可能性（%）',
				IMPACT: '影響度',
				LIKELIHOOD_IMPACT_MATRIX: '可能性・影響度マトリックス',
				SAVINGS: '削減効果',
				CONTRIBUTION_FACTOR: '寄与率',
				ESTIMATED_VALUE: '見積価値（USD）',
				AGREED_VALUE: '合意価値（USD）',
				TOTAL_PRODUCTION_LOST: '総生産損失（KBOE）',
				TOTAL_FLARING_AVOIDED: '回避されたフレアリング量（MT CO2）',
				PRODUCTIVITY: '生産性（時間）',
				EMISSIONS: '排出量（トン）',
				SELECT_VALUE: '値を選択',
				ENTER_VALUE: '値を入力',
				EXPORT_AS_PDF: 'PDFとしてエクスポート',
				SAVE_CASE_FIRST: '最初にケースを保存してください',
				GENERATE_PDF: 'PDFを生成',
				SEND_VIA_EMAIL: 'メールで送信',
				SHARE_VIA_EMAIL: 'メールで共有',
				CLEAR_ALL: 'すべてクリア',
				CLEAR_ALL_TOOLTIP: 'すべての情報をクリア',
				SAVE_TOOLTIP: '情報を保存',
				OPTIONAL_FIELD_SAVE_ERROR: 'オプションフィールドの変更の保存に失敗しました'
			},
			EMAIL: {
				SEND_VIA_MAIL: 'メールで送信',
				RECEIVER_EMAIL_IDS: '受信者メールアドレス',
				SEARCH_USER: 'ユーザーを検索',
				SELECT_ENTER_EMAIL_IDS: 'メールアドレスを選択または入力',
				DONE: '完了',
				SELECT: '選択',
				PLEASE_SELECT_RECIPIENTS: '受信者を選択してください',
				SUBJECT: '件名',
				DEFAULT_SUBJECT: 'Uptime AI: ケースが作成されました',
				ASSET: 'アセット',
				OWNER: '担当者',
				CREATED_BY: '作成者',
				CREATED_ON: '作成日',
				CASE_STATUS: 'ケースステータス',
				CATEGORY: 'カテゴリ',
				MODIFIED_ON: '最終更新',
				CASE_NAME: 'ケース名',
				USERS: 'ユーザー',
				CANCEL: 'キャンセル',
				SEND_EMAIL: 'メールで送信',
				PLEASE_SELECT_RECIPIENTS_TOOLTIP: '受信者を選択してください',
			},
			NOTIFICATION: {
				FMS_ADDED_SUCCESS: '故障モードが正常に追加されました',
				ANALYSIS_ADDED_SUCCESS: '選択した分析が正常に追加されました',
				VIEWS_ADDED_SUCCESS: '選択したビューが正常に追加されました',
				FMS_ADDED_SUCCESS_ALT: '選択した故障モードが正常に追加されました',
				ALL_RECOMMENDATIONS_ADDED: '承認された故障モードのすべての推奨事項が追加されました',
				RECOMMENDATIONS_ADDED_SUCCESS: '選択した推奨事項が正常に追加されました',
				GENERATING_PDF: 'PDFを生成しています… 準備ができたらメールでお知らせします。',
				NO_VALID_FILES: '有効なファイルが選択されていません。拡張子が {{extensions}} のファイルのみが許可されます',
				UPLOAD_SIZE_LIMIT: 'ファイルサイズ制限のため、{{name}} のアップロードに失敗しました。',
				UPLOAD_FAILED: '{{name}} のアップロードに失敗しました。',
				FAILED_TO_GENERATE_PDF: 'PDFの生成に失敗しました',
				BULK_REPORT_TITLE: '統合ケースレポートの作成',
				PREPARING_DOWNLOAD: 'ダウンロードを準備しています。しばらくお待ちください。',
				CSV_DOWNLOAD_SUCCESS: 'CSVが正常にダウンロードされました',
				CSV_DOWNLOAD_FAILED: 'CSVの出力に失敗しました',
				SELECT_STATUS_TO_SAVE: 'ケースを保存するにはステータスを選択してください',
				SELECT_CATEGORY_TO_SAVE: 'ケースを保存するにはカテゴリを選択してください',
				CASE_ADDED_SUCCESS: 'ケースが正常に追加されました',
				CASE_UPDATED_SUCCESS: 'ケースが正常に更新されました',
				ENTER_TITLE_TO_PROCEED: '続行するにはタイトルを入力してください'
			}
		},
		IOW: {
			FACILITY: '施設',
			SELECT_FACILITY: '施設を選択',
			SEARCH_FACILITY: '施設を検索...',
			NO_FACILITY_FOUND: '一致する施設が見つかりません',
			UNIT: 'ユニット',
			SELECT_UNIT: 'ユニットを選択',
			SEARCH_UNIT: 'ユニットを検索...',
			NO_UNIT_FOUND: '一致するユニットが見つかりません',
			SYSTEM: 'システム',
			SELECT_SYSTEM: 'システムを選択',
			SEARCH_SYSTEM: 'システムを検索...',
			NO_SYSTEM_FOUND: '一致するシステムが見つかりません',
			TAGS: 'タグ',
			SELECT_TAGS: 'タグを選択',
			SEARCH_TAG: 'タグを検索...',
			NO_TAG_FOUND: '一致するタグが見つかりません',
			CASE_STATUS: 'ケースステータス',
			EXCEEDANCE_TYPE: '超過タイプ',
			SELECT_EXCEEDANCE_TYPE: '超過タイプを選択',
			SELECT_ALL: 'すべて選択',
			ANALYSE_TOP_TRENDS: 'トップ20トレンドを分析',
			SAVE: '保存',
			COPY: 'コピー',
			ADD_NEW: '新規追加',
			EDIT: '編集',
			DELETE: '削除',
			DOWNLOAD: 'ダウンロード',
			ACTIVE_EXCEEDANCES: 'アクティブな超過',
			DATE_RANGE_DISABLED_TOOLTIP: 'アクティブな超過フィルターが選択されている場合、日付範囲の選択は適用されません。',
			SELECT_DATE_RANGE: '日付範囲を選択',
			ENTER_DATE_RANGE: '日付範囲を入力',
			START_DATE: '開始日',
			END_DATE: '終了日',
			APPLY_TIME_CHANGE: '期間の変更を適用',
			SUMMARY: 'サマリー',
			SELECT_SYSTEM_MESSAGE: '超過を表示するにはシステムを選択してください。',
			LOADING: '読み込み中...',
			NO_EXCEEDANCE_FOUND: '超過は見つかりませんでした。',
			NO_ACTIVE_EXCEEDANCE_FOUND: 'アクティブな超過は見つかりませんでした。',
			NO_DATA_AVAILABLE: '選択された時間範囲のデータはありません。',
			TRY_SELECTING_DIFFERENT_RANGE: '別の期間を選択してください。',
			CRUNCHING_DATA: 'データを処理中です。お待ちください！',
			TOTAL_EXCEEDANCES: 'システム超過の合計数',
			GROUP_TRENDS: 'トレンドをグループ化',
			TRENDS_PER_CHART: 'トレンド / チャート（最大8件）',
			CANCEL: 'キャンセル',
			PROCEED: '続行',
			SELECT: '選択',
			SELECT_DATE_RANGE_LABEL: '日付範囲を選択',
			DATE_RANGE: '日付範囲',
			DATE_RANGE_REQUIRED: '日付範囲は必須です。',
			REGROUP_EXCEEDENCES: '超過を再グループ化',
			DURATION_MINUTES: '期間（分）',
			DURATION_REQUIRED: '期間は必須です。',
			ENTER_VALID_NUMBER: '有効な数値を入力してください。',
			DOWNLOAD_TITLE: 'IOWレポートをダウンロード',
			GROUP_BY_SYSTEM: 'システムでグループ化',
			GROUP_BY_UOM: '測定単位でグループ化',
			GROUP_COUNT_REQUIRED: 'グループ数は必須です。',
			MIN_VALUE_2: '最小値は2です。',
			MAX_VALUE_8: '最大値は8です。',
			GROUP_COUNT_INVALID: 'グループ数が無効です。',
			WATCHERS: '監視者',
			CLOSE: '閉じる',
		},
		CAPACITY_OPTIMIZATION: {
			COMMON: {
				SAVE: '保存',
				CANCEL: 'キャンセル',
				DELETE: '削除',
				EDIT: '編集',
				CLOSE: '閉じる',
				LOADING: '読み込み中...',
				SEARCH: '検索...',
				ACTIONS: 'アクション',
				NAME: '名前',
				DESCRIPTION: '説明',
				STATUS: 'ステータス',
				TYPE: 'タイプ',
				CREATED: '作成日時',
				LAST_UPDATED: '最終更新',
				DOWNLOAD: 'ダウンロード',
				UPLOAD: 'アップロード',
				IMPORT: 'インポート',
				EXPORT: 'エクスポート',
				RUN: '実行',
				STOP: '停止',
				YES: 'はい',
				NO: 'いいえ',
				APPLY: '適用',
				RESET: 'リセット',
				CONFIRM: '確認',
				BACK: '戻る',
				NEXT: '次へ',
			},
			NAV: {
				SCENARIOS: 'シナリオ',
				DASHBOARD: 'ダッシュボード',
				COMPARISON: '比較',
				SETTINGS: '設定',
				MODELS: 'モデル',
				SIMULATION: 'シミュレーション',
				REALTIME: 'リアルタイム',
				TOPOLOGY: 'トポロジー',
				STRATEGIC: '戦略的',
			},
			LANDING: {
				TITLE: '能力最適化',
				SUBTITLE: '設備全体の電力・水生産を最適化する',
			},
			SCENARIO: {
				TITLE: 'シナリオライブラリ',
				NEW_SCENARIO: '新規シナリオ',
				SEARCH_SCENARIO: 'シナリオを検索',
				DUPLICATE: '複製',
				RUN_OPTIMIZATION: '最適化を実行',
				FORCE_STOP: '強制停止',
				VIEW_RESULTS: '結果を表示',
				SCENARIO_NAME: 'シナリオ名',
				CLASSIFICATION: '分類',
				SOLVER: 'ソルバー',
				RUN_MODE: '実行モード',
				STATUS_READY: '準備完了',
				STATUS_RUNNING: '実行中',
				STATUS_COMPLETED: '完了',
				STATUS_FAILED: '失敗',
				PROMOTE: '昇格',
				ALTERNATIVE_SOLVER: '代替ソルバー',
			},
			CONFIG: {
				TITLE: 'シナリオ設定',
				TABS: {
					AVAILABILITY: '設備の稼働状況',
					DEMAND: '需要予測',
					CONSTRAINTS: '制約条件',
					SOLVER: 'ソルバーと実行',
					TESTING: 'テストプロファイル',
					GROWTH_FACTOR: '成長係数',
					SWRO_AVAILABILITY: 'SWRO稼働状況',
				},
				HORIZON: 'ホライズン（時間）',
				STEP: 'ステップ（分）',
				START_HOUR: '開始時刻',
				TARGET_DATE: '目標日付',
				LATITUDE: '緯度',
				LONGITUDE: '経度',
				PERF_CURVE: '性能曲線ソース',
				OEM_CURVES: 'OEM設計曲線',
				HISTORICAL_ML: '履歴データ（ML）',
				PLANNING_OFFLINE: '計画（オフライン）',
				LIVE_REALTIME: 'ライブ（リアルタイム）',
				UPLOAD_CSV: 'CSVをアップロード',
				DOWNLOAD_CSV: 'CSVをダウンロード',
				POWER_MW: '電力（MW）',
				WATER_MIGD: '水量（MIGD）',
				POWER_IMPORT: '電力輸入',
				POWER_EXPORT: '電力輸出',
				WATER_IMPORT: '水輸入',
				WATER_EXPORT: '水輸出',
				INITIAL_STATUS: '初期状態',
				DURATION_IN_STATE: '状態継続時間（時間）',
				ON: 'オン',
				OFF: 'オフ',
			},
			CONSTRAINTS: {
				TITLE: '制約設定',
				ANCILLARY_SERVICES: '補助サービス',
				MIN_UP_DOWN_TIME: '最短起動・停止時間',
				RAMP_LIMITS: 'ランプ制限',
				FIXED_LOADS: '固定負荷',
				AGC_DISPATCH: 'AGCディスパッチ',
				ALLOW_LOAD_SHEDDING: '負荷制限を許可',
				ALLOW_WATER_SHORTAGE: '水不足を許可',
				ENFORCE_FUEL_LIMITS: '燃料制限を適用',
				SPINNING_RESERVE: '瞬動予備力（MW）',
				OPERATING_RESERVE: '運転予備力（MW）',
				WATER_RESERVE: '水貯備（MIGD）',
			},
			GROWTH_FACTOR: {
				TITLE: '成長係数設定',
				ADJUSTMENT_TYPE: '調整タイプ',
				VALUE: '成長係数値',
				TARGET_METRIC: '目標指標',
				START_TIME: '開始時刻',
				END_TIME: '終了時刻',
			},
			SWRO: {
				TITLE: 'SWRO稼働状況設定',
				SELECT_PLANTS: 'SWRO設備を選択',
				FLAT_VALUE: '一定稼働率値',
			},
			DASHBOARD: {
				TITLE: '最適化結果',
				STATION_FILTER: 'ステーションフィルター',
				ALL_STATIONS: '全ステーション',
				TOTAL_COST: '総コスト',
				POWER_GENERATION: '発電量',
				WATER_PRODUCTION: '水生産量',
				FUEL_CONSUMPTION: '燃料消費量',
			},
			COMPARISON: {
				TITLE: 'シナリオ比較',
				SEARCH_SCENARIO: 'シナリオを検索',
				BASELINE: 'ベースライン',
				SELECT_BASELINE: 'ベースラインを選択',
			},
			SETTINGS: {
				TITLE: '設定',
				PLATFORM: 'プラットフォーム設定',
				DATA_MGMT: 'データ管理',
				MODULE_CONFIG: 'モジュール設定',
				TAGS: 'タグ',
				TEMPLATES: 'テンプレート',
				TOPOLOGY: 'トポロジー',
				TRAINING: 'トレーニング',
				USERS: 'ユーザー',
			},
			PLATFORM_SETUP: {
				TITLE: 'プラットフォームと施設の設定',
				ENTERPRISE_NAME: '企業名',
				STREET_ADDRESS: '住所',
				CITY: '市区町村',
				STATE: '都道府県',
				COUNTRY: '国',
				ZIP_CODE: '郵便番号',
				LATITUDE: '緯度',
				LONGITUDE: '経度',
				INDUSTRY: '業種',
				TIMEZONE: 'タイムゾーン',
				BUSINESS: '事業',
				NOTES: 'メモ',
				COST_PER_UNIT: '単位コスト（$）',
				CAPACITY_PER_HOUR: '時間当たり能力',
				REVENUE_PER_HOUR: '時間当たり収益（$）',
				OPERATIONAL_MARGIN: '運用マージン（%）',
				TECHNICIAN_SALARY: '技術者給与（$/時）',
				HELPER_SALARY: '補助者給与（$/時）',
			},
			USER_MGMT: {
				TITLE: 'ユーザー管理',
				ADD_USER: 'ユーザーを追加',
				USERNAME: 'ユーザー名',
				DISPLAY_NAME: '表示名',
				PASSWORD: 'パスワード',
				ROLE: 'ロール',
				ADMIN: '管理者',
				SUPER_USER: 'スーパーユーザー',
				USER: 'ユーザー',
				NO_PERMISSION: 'このセクションにアクセスする権限がありません。',
			},
			SIMULATION: {
				TITLE: '感度シミュレーション',
				TARGET_EQUIPMENT: '対象設備',
				SWEEP_PARAMETER: 'スイープパラメーター',
				START_VALUE: '開始値',
				END_VALUE: '終了値',
				STEPS: 'ステップ数',
				RUN_SWEEP: 'スイープを実行',
			},
			REALTIME: {
				TITLE: 'リアルタイムダッシュボード',
				CONFIRMED_TARGET: '確定目標',
				SELECT_DATE: '日付を選択',
				SCENARIO_NAME: 'シナリオ名',
				HORIZON_HOURS: 'ホライズン（時間）',
				SOLVER: 'ソルバー',
				PERF_CURVE: '性能曲線',
				START_MODE: '起動モード',
				RAMP_LIMITS: 'ランプ制限',
				MIN_UP_DOWN: '最短起動・停止時間',
				ANCILLARY: '補助サービス',
				IMPORT_SCENARIO: 'シナリオからインポート',
			},
			TOPOLOGY: {
				TITLE: 'SCADAトポロジー',
				POWER_VIEW: '電力',
				WATER_VIEW: '水',
				AUTO_CORRECT: '自動補正',
				FLEET_OVERVIEW: '設備群概要',
			},
			DEMAND: {
				HORIZON: 'ホライズン（時間）',
				STEP: 'ステップ（分）',
				START_HOUR: '開始時刻',
				UPDATE_PLAN: '需要計画を更新',
				UPDATE_PLAN_TOOLTIP: 'すべてのスケジュール表を新しい時間グリッドに再サンプリングし、入力済みの値を補間します。',
				UPDATE_PLAN_HINT: 'スケジュールパラメータが変更されました — 「需要計画を更新」をクリックして表を再サンプリングしてください。',
				SOLAR_INPUT: '太陽光入力',
				SOLAR_PHASES_ACTIVE: 'フェーズが有効',
			},
			TAG_EXPLORER: {
				TITLE: 'タグエクスプローラー',
				SUBTITLE: 'マッピング済みの任意のタグについて実績値を表示します。データ点はサーバー側で集約されるため、長期間を指定しても表示速度を維持できます。',
				TAGS: 'タグ',
				TAGS_PLACEHOLDER: '最大10件のタグを選択',
				TAGS_SEARCH_PLACEHOLDER: 'パラメータ名またはタグ名で検索...',
				START_DATE: '開始日',
				END_DATE: '終了日',
				PLOT: '表示',
				LOADING_TAGS: 'タグ一覧を読み込み中...',
				QUERYING: '実績データを取得中...',
				NO_DATA_FOR: 'この期間にデータがないタグ：',
				UNITS_DROPPED: 'グラフには同時に2種類の単位のみ表示されます。単位が {{units}} の系列は表示されていません。',
				BUCKET_HINT: '{{bucket}} 間隔で集約しています。',
				COL_PARAMETER: 'パラメータ',
				COL_TAG: 'タグ',
				COL_UNIT: '単位',
				COL_POINTS: 'データ点数',
				COL_MIN: '最小',
				COL_MAX: '最大',
				COL_AVERAGE: '平均',
				GROUP_SYSTEM_DEMAND: 'システム需要',
				GRID_POWER_DEMAND: '系統電力需要',
				GRID_WATER_DEMAND: '系統給水需要',
				AXIS_TIME: '時間',
				AXIS_VALUE: '値',
				REQUEST_FAILED: 'リクエストに失敗しました（{{status}}）',
				SERVER_UNREACHABLE: 'サーバーに接続できません。',
			},
			PUMP_HYDRO: {
				TITLE: '揚水発電設定',
				SUBTAB_LABEL: '揚水発電',
				FIXED_MODE: '固定負荷プロファイル',
				FIXED_DESC: 'ハッタ号機（ユニット1およびユニット2）の固定発電（放流）および揚水（充電）スケジュールを指定します。',
				OPTIMIZE_MODE: '充放電レートの最適化',
				OPTIMIZE_DESC: '最適化ソルバーがハッタ揚水発電の充放電レートを動的に計画します。',
				FUTURE_RELEASE: '将来のリリース',
				HATTA_U1: 'ハッタ ユニット 1',
				HATTA_U2: 'ハッタ ユニット 2',
				RANGE_ASSIGN_TITLE: '時間範囲へのプロファイル割り当て',
				FROM_TIME: '開始時間',
				TO_TIME: '終了時間',
				TARGET_UNIT: '対象ユニット',
				BOTH_UNITS: '両ユニット（ハッタ 1 & 2）',
				VALUE_MW: '負荷 / 放電値 (MW)',
				APPLY_RANGE: '範囲に適用',
				UPLOAD_SCHEDULE: 'スケジュールをアップロード',
				DOWNLOAD_TEMPLATE: 'テンプレートをダウンロード',
			},
		},
		DISPLAY_TAGS: {
			HEADER: 'その他のタグを表示',
			CLOSE: '閉じる',
			SEARCH_PLACEHOLDER: '検索...',
			FILTER_TOOLTIP: 'タグをフィルター',
			SELECT_SYSTEM: 'システムを選択',
			ALL_SYSTEMS: 'すべてのシステム',
			FILTER_BY: 'フィルター条件',
			ALL_TAGS: 'すべてのタグ',
			MODELED_TAGS: 'モデル化されたタグ',
			SHOW_CALCULATED_TAGS: '計算済みタグを表示',
			NO_MATCHING_RESULTS: '一致する結果がありません',
			START_TYPING: '入力すると一致するタグが表示されます。',
		},
		PROCESS: {
      LIST_TABLE: {
				NO_CURRENT_BATCHES_TITLE: '現在のバッチが見つかりません',
				NO_CURRENT_BATCHES_CONTENT: 'プロセスが開始されると、稼働中のバッチがここに表示されます。',
				NO_PAST_BATCHES_TITLE: '過去のバッチが見つかりません',
				NO_PAST_BATCHES_CONTENT: 'バッチ実行が完了すると、完了・停止・失敗したバッチがここに表示されます。'
			},
			LIST: {
				PAGE_TITLE: 'プロセス',
				SEARCH_PLACEHOLDER: 'バッチIDで検索',
				CURRENT_BATCHES_TAB: '稼働中バッチ',
				PAST_BATCHES_TAB: '完了バッチ',
				FILTER: {
					SYSTEM: 'システム',
					SEARCH_SYSTEM: 'システム検索',
					CREATED_BETWEEN: '作成期間',
					STARTED_ON: '開始日',
					CLEAR_DATE: '日付クリア',
					OWNER: '担当者',
					SEARCH_OWNER: '担当者検索',
				},
			},
			TABLE: {
				COL_BATCH_NAME_ID: 'バッチ名 / ID',
				COL_START_DATE_TIME: '開始日時',
				COL_END_DATE_TIME: '終了日時',
				COL_LAST_UPDATED: '最終更新',
				COL_DURATION: '所要時間',
				COL_RUN_TIME: '稼働時間',
				COL_STATUS: 'ステータス',
				COL_OWNER: '担当者',
				COL_WATCHERS: '監視者',
				COL_PERCENT_COMPLETE: '進捗率',
				COL_PROJECTED_PRODUCT: '生産予定量',
				COL_FINAL_PRODUCT: '最終生産量',
				SELECT_COLUMNS: '列選択',
				SAVE_VIEW: 'ビュー保存',
				APPLY: '適用',
				LOADING: '読み込み中...',
				NO_RECORDS: 'データが見つかりません',
			},
			DETAILS: {
				TITLE_PREFIX: 'プロセス詳細',
				BATCH_NAME: 'バッチ名',
				FACILITY: '拠点',
				UNIT: 'ユニット',
				SYSTEM: 'システム',
				STATUS: 'ステータス',
				START_DATE_TIME: '開始日時',
				LAST_UPDATED: '最終更新',
				OVERLAY: 'オーバーレイ',
				STACKED: 'スタック',
				GRID: 'グリッド',
				SELECT_OWNER: '担当者選択',
				WATCHERS_TOOLTIP: '監視者',
				FILTER: {
					LAB_PARAMETERS: '分析パラメータ',
					BATCH: 'バッチ',
					OTHERS: 'その他',
					SEARCH_BATCH: 'バッチ検索',
				},
				GOLDEN_BATCH_BAND: 'ゴールデンバッチ帯',
				PREDICTION: '予測',
			},
		},
		DYNAMIC_DASHBOARD: {
			DASHBOARD_WIZARD: 'ダッシュボードウィザード',
			ADD_NEW_DASHBOARD: '新しいダッシュボードを追加',
			CREATE_DASHBOARD: 'ダッシュボードを作成',
			SEARCH: '検索',
			EDIT_MODE: '編集モード',
			SAVE_DASHBOARD: 'ダッシュボードを保存',
			PUBLIC: '公開',
			PRIVATE: '非公開',
			SENSOR_DATA: 'センサーデータ',
			NON_SENSOR_DATA: '非センサーデータ',
			ENTER_DATE_RANGE: '日付範囲を入力',
			START_DATE: '開始日',
			END_DATE: '終了日',
			APPLY_TIME_CHANGE: '時間変更を適用',
			MORE: 'その他',
			NOTHING_CREATED: 'まだ何も作成されていません',
			LOADING: '読み込み中...',
			NO_DATA: '選択した属性のデータがありません',
			CONFIGURE_ATTRIBUTES: 'レンダリングする属性を設定',
			SELECT_CHART_TYPE: 'グラフの種類を選択',
			CONFIG_ONLY_WIDGET: 'これは設定専用ウィジェットです。グラフは表示されません。',
			TYPE_OF_CONFIG: '設定の種類：',
			GROUP_KEY: 'グループキー：',
			SPECIFICATION_LIMIT: '仕様限界',
			PLEASE_ADD_STATS: 'ステータスカードを追加してください',
			ADD_ATTRIBUTES: '表示する属性を追加',
			PROCESSING_DATA: 'データを処理中です。しばらくお待ちください...',
			EDIT: '編集',
			DUPLICATE: '複製',
			REMOVE: '削除',
			CANCEL: 'キャンセル',
			SAVE: '保存',
			BACK: '戻る',
			PERFORMANCE_CURVE_OF: 'パフォーマンス曲線',
			NO_WIDGETS_AVAILABLE: '利用可能なウィジェットがありません。開始するにはウィジェットを追加してください',
			TAB_EMPTY_STATES: {
				ALL: {
					HEADING: 'まだダッシュボードがありません',
					CONTENT: '最初のダッシュボードを作成して、主要な指標、トレンド、インサイトを1か所で確認しましょう。',
				},
				MY_DASHBOARD: {
					HEADING: 'あなたが作成したダッシュボードはありません',
					CONTENT: 'あなたが作成したダッシュボードはここに表示されます。',
				},
				SHARED: {
					HEADING: '共有されたダッシュボードはまだありません',
					CONTENT: '他のユーザーがあなたに共有したダッシュボードはここに表示されます。',
				},
				PRIVATE: {
					HEADING: '非公開ダッシュボードはまだありません',
					CONTENT: 'あなたが作成して非公開にしたダッシュボードはここに表示されます。',
				},
				SEARCH: {
					HEADING: 'ダッシュボードが見つかりませんでした',
					CONTENT: '別のキーワードをお試しいただくか、検索をクリアしてください。',
				},
			},
			SLICER_POPUP: {
				SELECT_ALL: 'Select All',
				PREVIEW: 'Preview',
				APPLY_AND_CLOSE: 'Apply & Close',
				APPLYING: 'Applying...',
      		},
			COLLABORATOR: {
				TITLE_SUFFIX: 'コラボレーター',
				SEARCH_PLACEHOLDER: '名前またはメールで検索',
				COLLABORATED_WITH: 'コラボレート済み：',
				USERS: 'ユーザー',
				ALL_USERS: '全ユーザー',
				OWNER: 'オーナー',
				CANCEL: 'キャンセル',
				SAVE: '保存',
				CANCEL_CHANGES: '変更をキャンセル',
				SAVE_CHANGES: '変更を保存',
				ROLE: {
					FULL: 'フル',
					FULL_DESC: 'フルアクセス',
					EDIT: '編集',
					EDIT_DESC: '閲覧・編集アクセス',
					VIEW: '閲覧',
					VIEW_DESC: '閲覧のみ',
				},
			},
			EDIT_PANEL: {
				CREATE_PANEL: 'パネルを作成',
				EDIT_PANEL: 'パネルを編集',
				CANCEL: 'キャンセル',
				SAVE: '保存',
				SELECT_CHART_TYPE: 'グラフの種類',
				ADD_TITLE: 'タイトル',
				PANEL_NAME: 'パネル名',
				ADDITIONAL_GRAPH_OPTIONS: '追加グラフオプション',
				SETTINGS: '設定',
			},
			DASHBOARD_POPUP: {
				TITLE: 'ダッシュボード',
				SELECT_TYPE: 'ダッシュボードの種類を選択',
				TYPE_DASHBOARD: 'ダッシュボード',
				TYPE_CONFIG: '設定',
				TYPE_PERFORMANCE_CURVES: 'パフォーマンス曲線',
				NAME: '名前',
				NAME_TAKEN: '名前はすでに使用されています',
				NAME_REQUIRED: '名前は必須です',
				LEVEL: 'レベル',
				SELECT_LEVEL: 'レベルを選択',
				FACILITY: '施設',
				SELECT_FACILITY: '施設を選択',
				FACILITY_REQUIRED: '施設は必須です',
				UNIT: 'ユニット',
				SELECT_UNIT: 'ユニットを選択',
				UNIT_REQUIRED: 'ユニットは必須です',
				CANCEL: 'キャンセル',
				SAVE: '保存',
			},
			TAG_PANEL: {
				ENABLE_QUICK_PLOT: 'クイックプロットを有効化',
				SELECT_UNITS: 'ユニットを選択',
				SEARCH_UNIT: 'ユニットを検索...',
				NO_UNIT_FOUND: '一致するユニットが見つかりません',
				SELECT_SYSTEMS: 'システムを選択',
				SEARCH_SYSTEM: 'システムを検索...',
				NO_SYSTEM_FOUND: '一致するシステムが見つかりません',
				ADD: '追加',
				PREVIEW: 'プレビュー',
				PREVIEW_CHART: 'グラフのプレビュー',
				DRAG_AND_DROP: 'ドラッグ＆ドロップ',
				COPY: 'コピー',
				DELETE: '削除',
				EDIT: '編集',
				LABEL: 'ラベル',
				TAG: 'タグ',
				X_TAG: 'Xタグ',
				Y_TAG: 'Yタグ',
				Z_TAG: 'Zタグ',
				SEARCH_TAG: 'タグを検索...',
				NO_TAG_FOUND: '一致するタグが見つかりません',
				DESIGN_VALUE_TAG: '設計値タグ',
				CALC_TYPE: '計算タイプ',
				CALC_ORIGINAL: '元の値',
				CALC_AVERAGE: '平均',
				CALC_MOVING_AVG: '移動平均',
				CALC_MAX: '最大値',
				CALC_MIN: '最小値',
				CALC_SUM: '合計',
				CALC_MEDIAN: '中央値',
				CALC_MOVING_DELTA: '移動デルタ',
				CALC_COUNT_EVENT: 'イベント件数',
				AGGREGATE: '集計',
				AGGREGATE_WINDOW: '集計ウィンドウ',
				COUNT_WINDOW: 'カウントウィンドウ',
				AGGREGATE_WINDOW_UNIT: '集計ウィンドウ単位',
				COUNT_WINDOW_UNIT: 'カウントウィンドウ単位',
				WINDOW_SIZE: 'ウィンドウサイズ',
				MINUTES: '分',
				HOURS: '時間',
				DAYS: '日',
				WEEKS: '週',
				GREATER_THAN: '以上',
				LESS_THAN: '以下',
				EQUAL_TO: '等しい',
				RESET_FILTER: 'フィルターをリセット',
				SELECT_AXIS: '軸を選択',
				X_AXIS: 'X軸',
				Y_AXIS: 'Y軸',
				SPEC_LABEL: 'ラベル（最大6文字）',
				DESCRIPTION: '説明',
				VALUE: '値',
				ENABLE_TREND_CHART: 'トレンドグラフを有効化',
				ADD_TITLE: 'タイトルを追加',
				ADD_SUBTITLE: 'サブタイトルを追加',
				UNIT: '単位',
				SELECT_ICON: 'アイコンを選択',
				SEARCH_ICONS: 'アイコンを検索...',
				FORMULA: '数式',
				FORMULA_PLACEHOLDER: '数式を入力（例：(A+B)*C）',
				ERROR_INVALID_VARS: '無効な変数が使用されています',
				ERROR_INVALID_SYNTAX: '無効な数式です',
				ERROR_FORMULA_REQUIRED: '数式は必須です',
				ERROR_LESS_THAN_THRESHOLD: '「以下」のしきい値より小さい値を入力してください。',
				ERROR_GREATER_THAN_THRESHOLD: '「以上」のしきい値より大きい値を入力してください。',
				SELECT_CHILDREN: '子要素を選択',
				AT_LEAST_ONE: '少なくとも1つのオプションを選択してください',
				TITLE_REQUIRED: 'タイトルは必須です',
				TITLE_DUPLICATE: 'このタイトルは別の数式で既に使用されています',
				ADD_A_TITLE: 'タイトルを追加',
				DELETE_BUTTON: '削除',
			},
			SENSOR_TABLE_CONFIG: {
				ADD_ROW: '行を追加',
				ADD_COLUMN: '列を追加',
				COLUMN_NAME: '列名',
				DELETE_COLUMN: '列を削除',
				DATE_FILTER: '日付フィルター',
				ROWS: '行',
				NUMBER_OF_ROWS: '行数',
				SELECT_TAG: 'タグを選択',
				CONFIGURE_TAG: 'タグを設定',
				DELETE_ROW: '行を削除',
				APPLY_DATE_FILTERS: '列に日付フィルターを適用',
				NONE: 'なし',
				SELECT_FY_START: '会計年度の初日を選択',
				CANCEL: 'キャンセル',
				APPLY: '適用',
				SEARCH_TAG: 'タグを検索...',
				NO_TAG_FOUND: '一致するタグが見つかりません',
				GREATER_THAN: '以上',
				LESS_THAN: '以下',
				EQUAL_TO: '等しい',
				LESS_GREATER_ERROR: '「以下」の値は「以上」の値より大きくなければなりません。',
				IGNORE_NULLS: 'ヌルを無視',
				AGGREGATION: '集計',
				DEFINE_COLOR: 'テキスト色を設定するタグ値を定義',
				LESSER_THAN: '未満',
				PICK_COLOR: '色を選択',
				COLOR: '色',
				LESSER_THAN_ERROR: '値は定義した上限値より小さくなければなりません。',
				GREATER_THAN_ERROR: '値は定義した下限値より大きくなければなりません。',
				BETWEEN: '範囲内',
				AND: 'と',
				BETWEEN_RANGE_ERROR: '有効な範囲を入力してください。下限は上限より小さくなければなりません。',
			},
			RECENT: '最近',
			FAVOURITES: 'お気に入り',
			CREATED_BY_ME: '自分が作成',
			TAB_ALL: 'すべて',
			TAB_MY_DASHBOARD: 'マイダッシュボード',
			TAB_SHARED: '共有',
			TAB_PRIVATE: 'プライベート',
			ALL_DASHBOARDS: 'すべてのダッシュボード',
			MY_DASHBOARDS: 'マイダッシュボード',
			SHARED_DASHBOARDS: '共有ダッシュボード',
			PRIVATE_DASHBOARDS: 'プライベートダッシュボード',
			COL_NAME: '名前',
			COL_CREATED_ON: '作成日',
			COL_UPDATED_ON: '更新日',
			COL_OWNED_BY: '所有者',
			COL_SHARED: '共有',
			COPY_LINK: 'リンクをコピー',
			RENAME: '名前を変更',
			OPEN_IN_NEW_TAB: '新しいタブで開く',
			SELECT: '選択',
			SELECT_PERFORMANCE_CURVE: '性能曲線を選択',
			MENU_EDIT_DASHBOARD: 'ダッシュボードを編集',
			MENU_COPY_DASHBOARD: 'ダッシュボードをコピー',
			MENU_PUBLISH: '公開',
			MENU_UNPUBLISH: '公開解除',
			MENU_DELETE_DASHBOARD: 'ダッシュボードを削除',
			MONGO: {
				SELECT_GRAPH_FIRST: '*最初にグラフタイプを選択してください',
				LABEL_USED: 'ラベルはすでに使用されています',
				REQUIRED: '*必須',
				DEFINE_RELATION: 'リレーションを定義',
				INVALID_VARIABLE: '数式に無効な変数があります。',
				INVALID_RELATION: 'ソースとのリレーションが無効です。',
				INVALID_FORMULA_SYNTAX: '数式の構文が無効です。',
				SOURCE: 'ソース',
				ATTRIBUTE: '属性',
				DISPLAY_ATTRIBUTE: '属性を表示',
				GROUP_BY_ATTR: 'グループ化',
				AGGREGATION: '集計',
				OPEN_FILTERS: 'フィルターを開く',
				REMOVE_COLUMN: '列を削除',
				ADD_ATTRIBUTE: '属性を追加',
				RAW_ATTRIBUTE: '生属性',
				CALC_ATTRIBUTE: '計算属性',
				ADD_RAW_ATTRIBUTE_COL: '生属性列を追加',
				ADD_CALC_ATTRIBUTE_COL: '計算属性列を追加',
				GROUP_BY: 'グループ化',
				GROUP_DISPLAY_TYPE: 'グループ表示タイプ',
				SORT_BY: '並び替え',
				SORT_ASC: 'A → Z',
				SORT_DESC: 'Z → A',
				SIDE_BY: '並列',
				NA: 'なし',
				STACK_BY: 'スタック',
				NO_OF_BINS: 'ビン数',
				SLICERS: 'スライサー（最大{{limit}}個選択）',
				SELECT_UP_TO: '最大選択数',
				DRILL_DOWN: 'ドリルダウン',
				DRILL_DOWN_ATTRS: 'ドリルダウン属性（最大{{limit}}個選択）',
				SELECT_ATTRS: '属性を選択',
			},
			TAG_AGG: {
				SELECT_TAG: 'タグを選択',
				SELECT_AGGREGATE_TYPE: '集計タイプを選択',
				ENABLE_AGGREGATE: '集計を有効にする',
			},
			SIDE_PANEL: {
				SETTINGS: '設定',
				SAVE: '保存',
				CLOSE: '閉じる',
				PANEL: 'パネル',
				AXIS: '軸',
				GRAPH_OPTIONS: 'グラフオプション',
				SELECT_CONFIG_TYPE: '設定タイプを選択',
				EXCEL_CONFIG: 'Excel設定',
				TAG_GROUP: 'タググループ',
				PANEL_DESCRIPTION: 'パネルの説明',
				X_AXIS_MIN: 'X軸最小値',
				X_AXIS_MAX: 'X軸最大値',
				X_AXIS_UNIT: 'X軸単位',
				Y_AXIS_UNIT: 'Y軸単位',
				SHOW_LEGEND: '凡例を表示',
				OVERLAP_LEGENDS: '凡例を重ねる',
				TABLE_MODE: 'テーブルモード',
				TITLE_COLOR: 'タイトルの色',
				BORDER_COLOR: '境界線の色',
				TREND_CHART_COLOR: 'トレンドチャートの色',
				UPLOAD: 'アップロード',
				DOWNLOAD: 'ダウンロード',
				UPLOAD_BASE_CURVE: 'ベース曲線をアップロード',
				BASE_CURVE_FORMAT: 'ベース曲線フォーマット',
				DELETE_CURVE_GRAPH: '曲線グラフを削除',
			},
			SINGLE_STATS: {
				ADD_STAT: '統計を追加',
				COLOR_PICKER: 'カラーピッカー',
				COLOR_TITLE: 'タイトル',
				COLOR_BORDER: 'ボーダー',
				COLOR_ICON: 'アイコン',
				COLOR_ICON_OUTLINE: 'アイコンアウトライン',
				NO_ICON_FOUND: '一致するアイコンが見つかりません',
			},
		},
		SCHEDULER: {
			LIST: {
				TITLE: 'スケジューラー一覧',
				HEADER_TITLE: 'レポートスケジューラー',
				NEW_SCHEDULER_TOOLTIP: '新しいスケジュールを作成',
				NEW_SCHEDULER: '新しいスケジュール',
				COL_TITLE: 'タイトル',
				COL_MEDIUM: '媒体',
				COL_SUBJECT: '件名',
				COL_RUNS: '実行',
				COL_MODIFIED_ON: '更新日',
				COL_CREATED_ON: '作成日',
				COL_ACTIONS: '操作',
				EDIT_TOOLTIP: 'スケジュールを編集',
				DELETE_TOOLTIP: 'スケジュールを削除',
				MEDIUM_EMAIL: 'メール',
				MEDIUM_SMS: 'SMS',
				MEDIUM_CALL: '電話',
				SCHEDULER_DELETED: 'スケジュールを削除しました',
				DELETE_FAILED: '削除に失敗しました',
				OKAY: 'OK',
				NO_REPORT: 'レポートが見つかりません'
			},
			DETAILS: {
				TITLE: 'スケジュール',
				CREATE_TITLE: 'スケジュールを作成',
				EDIT_DETAILS_TITLE: '詳細を編集',
				SCHEDULE_DETAILS_TITLE: 'スケジュール詳細',
				CANCEL: 'キャンセル',
				SAVE: '保存',
				SELECT_FACILITY: '施設を選択',
				LOADING: '読み込み中...',
				SCHEDULE_RECURRING_REPORTS: '定期レポートのスケジュール',
				MONTHS: '月',
				ALL: 'すべて',
				DAY: '日',
				EVERY: '毎',
				TH_DAY: '日',
				WEEKDAYS: '曜日',
				TIME: '時間',
				SELECT_TIME: '時間を選択',
				HOUR: '時間',
				MINUTE: '分',
				FILE_NAME_LABEL: 'ファイル名',
				REPORT_NAME_LABEL: 'レポート名',
				ENTER_NAME: '名前を入力',
				REPORT_TITLE: 'レポートタイトル（最大20文字）',
				ENTER_TITLE: 'タイトルを入力',
				REPORTING_INTERVAL: 'レポート間隔',
				MEDIUM: '媒体',
				TEMPLATE_NAME: 'テンプレート名',
				SUBJECT: '件名',
				ENTER_SUBJECT: '件名を入力',
				SELECT_USERS: 'ユーザーを選択',
				SEARCH_BY_EMAIL: 'メールIDで検索',
				NO_MATCHING_EMAIL: '一致するメールIDが見つかりません',
				ADD_EMAILS_LABEL: 'カンマ区切りでメールIDを追加',
				OKAY: 'OK',
				SELECT_AT_LEAST_ONE_UNIT: '少なくとも1つのユニットを選択してください',
				SELECT_AT_LEAST_ONE_SYSTEM: '少なくとも1つのシステムを選択してください',
				SELECT_USER_OR_EMAIL: '少なくとも1人のユーザーを選択するか、メールIDを追加してください',
				INVALID_EMAILS: '無効なメールIDが入力されました',
			},
			TEMPLATES: {
				DAILY_REPORT: '日次レポート',
				BIWEEKLY_REPORT: '隔週レポート',
				KPI_REPORT_THERMAL: 'KPIレポート - サーマル',
				ALERT_STATUS_UPDATE_REPORT: 'アラートステータス更新レポート',
				DATA_QUALITY_REPORT: 'データ品質レポート',
				DATA_LAG_REPORT: 'データ遅延レポート',
				IOW_REPORT: 'IOWレポート',
				SERVER_EXCEPTION_REPORT: 'サーバー例外レポート',
			},
			REPORTING_INTERVALS: {
				LAST_8_HOURS: '過去8時間',
				LAST_12_HOURS: '過去12時間',
				LAST_24_HOURS: '過去24時間',
				TODAY: '今日',
				YESTERDAY: '昨日',
				LAST_7_DAYS: '過去7日間',
				THIS_WEEK: '今週',
				PREVIOUS_WEEK: '先週',
				LAST_15_DAYS: '過去15日間',
				LAST_30_DAYS: '過去30日間',
				THIS_MONTH: '今月',
				PREVIOUS_MONTH: '先月',
				THIS_QUARTER: '今四半期',
				PREVIOUS_QUARTER: '前四半期',
				LAST_3_MONTHS: '過去3ヶ月',
				LAST_6_MONTHS: '過去6ヶ月',
				LAST_12_MONTHS: '過去12ヶ月',
				THIS_YEAR: '今年',
				PREVIOUS_YEAR: '昨年',
			},
		},
		ANALYSIS_VIEWS: {
			UNABLE_TO_CREATE_ANALYSIS_TEMPLATE: '複数の施設から分析テンプレートを作成することはできません',
			TITLE: '分析とビュー',
			CLOSE: '閉じる',
			EXPORT_TO_EXTERNAL: '選択したタグを外部システムにエクスポート',
			SAVED_ANALYSIS: '保存された分析',
			CREATE_NEW: '新規作成',
			SAVED_VIEWS: '保存されたビュー',
			SAVE_CURRENT_VIEW: '現在のビューを保存',
			SAVE_DISABLED_TOOLTIP: 'アラートの所有者のみがタグビューを保存または変更できます。',
			TEMPLATE_TAG: '[テンプレート]',
			SNAPSHOT_TAG: '[スナップショット]',
			EDIT: '編集',
			DELETE: '削除',
			SAVED_DASHBOARDS: '保存されたダッシュボード',
			NO_DASHBOARDS: '保存されたダッシュボードはありません',
		},
		THRESHOLD_PANEL: {
			TITLE: 'しきい値',
			CLOSE: '閉じる',
			ONGOING: '進行中',
			SHOW_LESS: '表示を減らす',
			SEE_MORE: 'もっと見る',
		},
		ACTIVITY_LOGS: {
			TITLE: 'アクティビティログ',
			ACTIONS: 'アクション ({{count}})',
			CLOSE: '閉じる',
			SEARCH_PLACEHOLDER: '検索...',
		},
		FEEDBACK_RIGHT_NAV: {
			TITLE: 'フィードバック',
			CLOSE: '閉じる',
			APPROVED: '承認済み',
			RELEARNED: '再学習済み',
			QUOTE_APPROVED_HYPOTHESIS: '承認された仮説',
			QUOTE_RELEARNED_HYPOTHESIS: '再学習された仮説',
			QUOTE_APPROVED_CAUSAL: '承認された因果連鎖ステップ',
			QUOTE_RELEARNED_CAUSAL: '再学習された因果連鎖ステップ',
			QUOTE_APPROVED_RECOMMENDATION: '承認された推奨事項',
			QUOTE_RELEARNED_RECOMMENDATION: '再学習された推奨事項',
			QUOTE_OTHER: 'その他',
			FILE_ALT: 'ファイル',
			EMPTY_HEADING: 'フィードバックはありません',
			EMPTY_CONTENT: '承認または再学習してフィードバックを追加してください。',
		},
		DISCUSSION: {
			TITLE: 'ディスカッション',
			COMMENTS_COUNT: 'コメント ({{count}})',
			CLOSE: '閉じる',
			CREATE_CASE_TITLE: 'フォローアップを管理するケースを作成',
			CREATE_CASE: 'ケースを作成',
			BACK: '戻る',
			THREAD_BY: 'スレッド作成者:',
			SEARCH_PLACEHOLDER: '検索...',
			NO_COMMENTS_HEADING: 'コメントはまだありません',
			NO_COMMENTS_BODY: 'このトピックについての議論を始めるには、最初のコメントを残してください。',
			EDITED: '編集済み',
			RCA_VERSION_DELETED: 'RCAバージョンが削除されました',
			COMMENT_DELETED: 'このコメントは削除されました。',
			COMMENT_DELETED_ALT: 'このコメントは削除されました。',
			REPLY_SINGULAR: '件の返信',
			REPLY_PLURAL: '件の返信',
			LAST_REPLY: '最終返信',
			REPLY_PROMPT: '返信...',
			COMMENT_PLACEHOLDER: 'コメントを追加し、@でチームメンバーをタグ付け',
			REPLY_TO_COMMENT_PLACEHOLDER: 'コメントに返信...',
		},
		RETRAIN_MODEL: {
			TITLE: 'モデルを再学習',
			CLOSE: '閉じる',
			CURRENT_MODEL_DETAILS: '現在のモデル詳細',
			DEPLOYED_VERSION_LABEL: 'デプロイされたバージョン - 日付/時刻',
			LAST_PREDICTION_LABEL: '最終予測 - 日付/時刻',
			FORM_ERROR: 'おっと!いくつか変更してもう一度お試しください。',
			TRAINING_PERIOD: 'トレーニング期間',
			DATE_RANGE_SELECTION_METHOD: '日付範囲選択方法',
			SELECT_TRAINING_MODE_ARIA: 'トレーニング選択モードを選択',
			CALENDAR_SELECTION: 'カレンダー選択',
			CHART_BASED_SELECTION: 'チャートベースの選択',
			VIEW_EDIT_NOTE: 'メモを表示/編集',
			ADD_NOTE: 'メモを追加',
			ADD_TRAINING_RANGE: 'トレーニング範囲を追加',
			DELETE_TRAINING_RANGE: 'トレーニング範囲を削除',
			ADVANCED_SETTINGS: '詳細設定',
			BAND_LEARNING_BEHAVIOUR: 'バンド学習動作',
			SELECT_BAND_LEARNING_ARIA: 'バンド学習動作を選択',
			CONSERVATIVE_TOOLTIP: '選択したトレーニング領域の周りに狭いバンドを作成します',
			CONSERVATIVE: '保守的',
			MODERATE_TOOLTIP: '選択したトレーニング領域の周りにバランスの取れたバンドを作成します',
			MODERATE: '中程度',
			AGGRESSIVE_TOOLTIP: '選択したトレーニング領域の周りに広いバンドを作成します',
			AGGRESSIVE: '積極的',
			PREDICTION_SMOOTHING_SETTINGS: '予測平滑化設定',
			SMOOTHING: '平滑化',
			WINDOW_SIZE: 'ウィンドウサイズ',
			WINDOW_SIZE_PLACEHOLDER: 'ウィンドウサイズ(時間単位)',
			VALUE_IS: '値は',
			REQUIRED: '必須です',
			VALUE_MIN: '値は次の値以上である必要があります:',
			POLYNOMIAL_ORDER: '多項式次数',
			SIGMA: 'シグマ',
			SELECT_ATTENTION_TAGS: '注目タグを選択',
			SEARCH_PLACEHOLDER: '検索...',
			NO_MATCHING_TAGS: '一致するタグが見つかりません',
			SHOW_ALL_TAGS: 'すべてのタグを表示',
			SHOW_ATTENTION_TAGS_ONLY: '注目タグのみ表示',
			MODELING_TECHNIQUE: 'モデリング手法',
			AUTO_ENCODER: 'オートエンコーダー',
			ATTENTION_AUTO_ENCODER: 'アテンションオートエンコーダー',
			CANCEL_TOOLTIP: '変更をキャンセル',
			CANCEL: 'キャンセル',
			RETRAIN_DEPLOY_TOOLTIP: '再学習してデプロイ',
		},
		ROOT_CAUSE_RECOMMENDATION: {
			CLOSE: '閉じる',
			ICON_ALT: '根本原因アイコン',
			NOT_GENERATED_MESSAGE: 'まだ根本原因分析を生成していません。続行するには生成してください。',
			FAILED_MESSAGE: '前回の根本原因分析は失敗しました。<br> 続行するには再度生成してください。',
			GENERATE_NOW: '今すぐ生成',
			REFRESH: '更新',
			LAST_GENERATED: '最終生成日時',
			GENERATING: '根本原因分析を生成中',
			LOADER_ALT: '読み込み中',
			LIKE_ALT: 'いいね',
			DISLIKE_ALT: 'よくないねアイコン',
			MONETARY_VALUE: '金銭的価値',
			FAILURE_HISTORY: '故障履歴',
			INFO_CARD_ARIA: '情報カード',
			PREVIOUS_FAILURE_MODES: '過去の故障モード',
			HYPOTHESIS_PREFIX: '仮説',
			MOST_LIKELY: '(最も可能性が高い)',
			CASCADES_AS_FOLLOWS: '.この根本原因はおそらく次のように連鎖します:',
			AGREE: '同意する',
			PARTIALLY_AGREE: '部分的に同意する',
			DISAGREE: '同意しない',
			TELL_US_MORE: '詳しく教えてください:',
			FEEDBACK_PLACEHOLDER: '具体的な詳細をお気軽にご記入ください',
			CANCEL: 'キャンセル',
			SUBMIT: '送信',
		},
		RIGHT_PANEL_DOCUMENTS: {
			TITLE: 'ドキュメント',
			CLOSE: '閉じる',
			SEARCH_PLACEHOLDER: '検索...',
			FILTER_TAGS: 'タグをフィルター',
			EMPTY_HEADING: 'ドキュメントはありません',
		},
		MONETORY_VALUE_DIALOG: {
			TITLE: '金額の価値',
			CURRENCY_HINT: '金額は{{currency}}で入力されます',
			RELIABILITY: '信頼性',
			MAINTENANCE: 'メンテナンス',
			PERFORMANCE: 'パフォーマンス',
			POTENTIAL_SUFFIX: '（潜在的）',
			ENTER_VALUE: '値を入力',
			COMMENT_REQUIRED_ERROR: 'コメントを空にすることはできません。',
			AMOUNT_REQUIRED_ERROR: '少なくとも1つの値を入力してください。',
			COMMENT: 'コメント',
			COMMENT_PLACEHOLDER: 'コメントを追加',
			CANCEL: 'キャンセル',
			SAVE: '保存',
		},
		FAILURE_MODE_DETAILS: {
			TITLE: '故障モードの詳細',
			OPEN_ALERT: 'アラートを開く',
			TTF_ALT: 'TTF',
			ADD_MONETARY_VALUE: '金銭的価値を追加',
			CMMS_NUMBER_TOOLTIP: 'CMMS番号',
			MORE_SUFFIX: '件以上',
			ADD_CMMS_NUMBER: 'CMMS番号を追加',
			BREAKDOWN_CATEGORY: '内訳カテゴリ',
			BREAKDOWN_COMPONENT: '内訳コンポーネント',
			ERROR_LABEL: 'エラー',
			TAG_CHARTS_SUFFIX: 'タグチャート',
		},
		DATA_QUALITY_PANEL: {
			TITLE: 'データ品質',
			CLOSE: '閉じる',
			SEE_LESS: '表示を減らす',
			SEE_MORE: 'もっと見る',
		},
		FAILURE_TIMELINE_PANEL: {
			SORT_BY: '並べ替え:',
			ASSET: 'アセット:',
			REASON: '理由:',
			RECOMMENDATIONS: '推奨事項:',
			NA: '該当なし',
		},
		REPORT_ISSUE_SIDEPANEL: {
			TITLE: '問題を報告',
			SUBTITLE: 'RCAエージェントで何が問題だったかをお知らせください。',
			CLOSE: '閉じる',
			WARNING_BANNER: 'これは現在のRCAを更新または再実行するものではありません。仮説、因果連鎖、または推奨事項を改善するには、RCA内のフィードバックオプションを使用してください。',
			SECTION_TITLE: '何が問題でしたか？',
			SECTION_HINT: '該当するものをすべて選択してください。',
			ISSUES_ERROR: '少なくとも1つのオプションを選択してください。',
			DETAILS_ERROR: '経験した問題の詳細を追加してください。',
			DETAILS_LABEL_REQUIRED: '追加の詳細（必須）',
			DETAILS_LABEL_OPTIONAL: '追加の詳細（任意）',
			DETAILS_PLACEHOLDER: '例：RCAは正しい圧力トレンドを特定しましたが、メンテナンス履歴がバルブの故障を示していたにもかかわらず、ポンプが事象の原因であると結論付けました。',
			DISCLAIMER: 'このレポートを送信すると、関連するRCAデータとアクティビティログが調査のために認可されたUptimeAIチームと共有されます。',
			CANCEL: 'キャンセル',
			SUBMIT_REPORT: 'レポートを送信',
			RUN_RCA_FIRST: 'エージェントの問題を報告する前にRCAを実行してください。',
			SUBMITTED_SUCCESS: '問題が正常に報告されました',
			SUBMIT_FAILED: '問題の報告に失敗しました。もう一度お試しください。',
			OPT_PLATFORM_DATA_LABEL: '関連するプラットフォームデータが考慮されなかった',
			OPT_PLATFORM_DATA_HINT: 'RCAはプラットフォームで利用可能なすべての関連アラート、タグ、トレンド、イベント、その他のデータを使用しませんでした。',
			OPT_EVIDENCE_LABEL: '文書または証拠が正しく考慮されなかった',
			OPT_EVIDENCE_HINT: 'アップロードされた文書、提案された証拠、またはその他の裏付け情報が無視されたか、誤って解釈されました。',
			OPT_USER_INPUT_LABEL: '私の入力が適切に考慮されなかった',
			OPT_USER_INPUT_HINT: 'RCAは、この調査中または以前の再実行で私が提供したコンテキスト、指示、メモ、またはフィードバックを適切に考慮しませんでした。',
			OPT_CAUSAL_LABEL: '因果推論が誤っていた',
			OPT_CAUSAL_HINT: 'RCAは関連情報を考慮しましたが、誤った結論に達しました。',
			OPT_WEIGHTED_LABEL: '証拠の重み付けが誤っていた',
			OPT_WEIGHTED_HINT: 'RCAは1つのデータポイントに重点を置きすぎ、他の重要な証拠を十分に考慮しませんでした。',
			OPT_UNSUPPORTED_LABEL: '結論が証拠に裏付けられていなかった',
			OPT_UNSUPPORTED_HINT: 'RCAは十分な裏付けデータや証拠なしに主張や結論を生成しました。',
			OPT_RECOMMENDATION_LABEL: '推奨事項が実行可能でなかった',
			OPT_RECOMMENDATION_HINT: '推奨事項が一般的すぎる、非実用的、または運用上役に立たないものでした。',
			OPT_UNCLEAR_LABEL: '説明が不明確だった',
			OPT_UNCLEAR_HINT: '推論が理解しにくく、十分な根拠が示されていませんでした。',
			OPT_OTHER_LABEL: 'その他',
			OPT_OTHER_HINT: '上記に記載されていない問題を報告します。',
		},
		LIBRARY: {
			TITLE: 'ライブラリ',
			SUBTITLE: 'P&ID 図面とエンジニアリング文書（マニュアル、データシート、警報/トリップリスト）を一か所に。',
			SEARCH: '図面、文書、設備、タグ（例: PT-0940）を検索…',
			TAB_PIDS: 'P&ID',
			TAB_DOCS: 'マニュアルとデータ',
			PIDS: {
				LOADING: '図面を読み込み中…',
				FAILED: '図面を読み込めませんでした。',
				LOCATED: '{{tag}} を含む図面',
				NOT_LOCATED: '{{tag}} はインデックス済みの図面にありません。',
				NO_MATCH: '検索に一致する図面はありません。',
				TAGS: '{{count}} タグ',
				PICK: '左から図面を選ぶか、タグを検索してそのタグを含む図面を探してください。',
				VIEW_DRAWING: '図面',
				VIEW_PDF: 'PDF 全体',
				PDF_LOADING: 'PDF を読み込み中…',
				PDF_FAILED: 'この図面の PDF は利用できません。',
				OTHER: 'その他の図面',
				REFERENCE: '凡例と図面索引',
			},
			DOCS: {
				LOADING: 'ドキュメントを読み込み中…',
				FAILED: 'ドキュメントを読み込めませんでした。',
				EMPTY: 'ドキュメントはありません。',
				NO_MATCH: '検索に一致するドキュメントはありません。',
				PICK: 'ここで読むドキュメントを選択してください。',
				GROUP_ITEM: 'このロケーション',
				GROUP_ABOVE: '{{floc}} から',
				GROUP_BELOW: 'このロケーションの下位',
				GROUP_TYPE: '{{type}}',
			},
		},
		ASSET_EXPLORER: {
			FLOC: {
				TITLE: '{{facility}} 設備ツリー（SAP 機能ロケーション）',
				SEARCH_PLACEHOLDER: '機能ロケーション、設備、ヒストリアンタグを検索…',
				SEARCH_HINT: '一致する設備は下に表示されます。タグ候補を選ぶと P&ID 上に表示します。',
				HIDE_EMPTY: 'タグのないロケーションを非表示',
				HIDE_EMPTY_HINT: 'サブツリーにヒストリアンタグがない機能ロケーションを非表示にします。パッケージと未割り当てグループは常に表示されます。',
				NODE_HITS: '一致する設備（{{count}}）',
				CLOSE_HITS: '結果を閉じる',
				NODE_SEARCH_FAILED: '設備の検索に失敗しました。もう一度お試しください。',
				NO_NODE_HITS: '「{{query}}」に一致する設備はありません。',
				REVEAL_FAILED: 'この設備をツリーで開けませんでした。',
				TREE_EMPTY: '設備ツリーは空です。',
				TREE_HIDDEN: 'タグのないロケーション {{count}} 件を非表示',
				CHILDREN_FAILED: 'このノードの子を読み込めませんでした。',
				CHILDREN_HIDDEN: 'ヒストリアンタグのない子ロケーション {{count}} 件を非表示にしています。',
				COUNT_TIP: 'このサブツリーのヒストリアンタグ {{count}} 件',
				PATH: '設備パス',
				UNASSIGNED_NAME: '未割り当てタグ',
				UNASSIGNED_TIP: '機能ロケーションやパッケージに割り当てられていないヒストリアンタグ（タグ名のシステムコードでグループ化）',
				UNASSIGNED_NOTE: 'これらのヒストリアンタグには SAP 機能ロケーションも設備パッケージもありません。タグ名のシステムコード（ない場合はサイト）だけでグループ化しており、所属する設備は不明です。',
				PACKAGE_NOTE: '回転機パッケージ：タグは個々の SAP 機能ロケーションではなく、パッケージ全体に割り当てられています。',
				LEVEL_SITE: 'サイト',
				LEVEL_SYSTEM: 'システム',
				LEVEL_SUBSYSTEM: 'サブシステム',
				LEVEL_EQUIPMENT: '設備',
				LEVEL_PACKAGE: 'パッケージ',
				LEVEL_UNASSIGNED: '未割り当て',
				KIND_FLOC: 'SAP 機能ロケーション',
				KIND_PACKAGE: '設備パッケージ',
				KIND_UNASSIGNED: '未割り当てタググループ',
				SUBTREE_TAGS: 'サブツリーのタグ {{count}} 件',
				LOOP_TAGS_BADGE: '同じループのパッケージタグ {{count}} 件',
				PIDS_SHOWING: '{{count}} 件の P&ID に表示',
				PROP_FLOC: '機能ロケーションコード',
				PROP_CODE: 'パッケージコード',
				PROP_LEVEL: 'レベル',
				PROP_KIND: '種別',
				PROP_LOOP: 'ループ番号',
				PROP_OWN_TAGS: 'このノードのタグ',
				PROP_SUBTREE_TAGS: 'サブツリーのタグ',
				WITH_DATA: 'データあり {{count}} 件',
				N_TAGS: '{{count}} タグ',
				INCLUDE_SUBTREE: 'サブツリーを含める',
				TAGS_OWN_NOTE: 'このノードに直接配置されたタグです。',
				TAGS_SUBTREE_NOTE: 'このノードとその配下のすべてのノードに配置されたタグです。',
				DETAIL_FAILED: 'このノードを読み込めませんでした。もう一度お試しください。',
				NO_OWN_TAGS: 'このノードに配置されたヒストリアンタグはありません。',
				NO_OWN_TAGS_LOOP: 'この機能ロケーション自体に配置されたヒストリアンタグはありません。同じループ番号を持つパッケージタグを下に表示します。',
				TRUNCATED: '{{total}} 件中、最初の {{shown}} 件のタグを表示しています。',
				FILTER_TAGS: 'タグを絞り込み…',
				NO_FILTER_MATCH: '条件に一致するタグはありません。',
				COL_RULE: '配置ルール',
				COL_DATA: 'データ',
				PLACED_AT: '配置先',
				LOOP_TITLE: 'このループ番号を共有するパッケージタグ（{{count}}）',
				LOOP_EXPLAIN: 'これらのタグはこの機能ロケーションではなく回転機パッケージに属します。タグ名にこの設備と同じループ番号 {{loop}} が含まれるため表示しています。このノードのタグ数には含まれません。',
				LOOP_GROUP: 'ループ {{loop}} · パッケージ {{package}}（{{count}}）',
				OPEN_PACKAGE: 'パッケージを開く',
				PID_GROUP_NODE: '{{name}} を表示',
				PID_NODE_FOUND: '{{name}}（設備シンボルまたはタグ）は {{count}} 件の図面に表示されています。',
				PID_NODE_NONE: '{{name}} とその主なタグを表示するデジタル化 P&ID はありません。',
				CHIPS_MORE: 'ノードのタグ {{total}} 件中 {{shown}} 件を表示。その他は概要の表または検索から追加してください。',
				RULE_FLOC_CURATED: '機能ロケーション（精査済み）',
				RULE_FLOC_CURATED_HINT: '精査済みのタグ–設備対応表による機能ロケーションです。',
				RULE_FLOC_BACKFILLED: '機能ロケーション（補完）',
				RULE_FLOC_BACKFILLED_HINT: '精査済みの表にない場合に、ヒストリアンのタグ–資産対応から補完した機能ロケーションです。',
				RULE_FLOC_WELL: '海底坑井で配置',
				RULE_FLOC_WELL_HINT: 'タグ名の坑井番号から、海底タグをその坑井の生産ツリーの機能ロケーション（または坑井の機能ロケーション）に配置しました。',
				RULE_FLOC_LOOP: 'ループ番号で配置',
				RULE_FLOC_LOOP_HINT: 'コードがタグのループ番号で終わる唯一の設備機能ロケーションに配置しました。',
				RULE_PACKAGE_PREFIX: 'タグ接頭辞でパッケージ',
				RULE_PACKAGE_PREFIX_HINT: '設備パッケージに割り当て、タグ名のサブシステムの下に配置しました。',
				RULE_PACKAGE_SITE: 'パッケージ（サイト）',
				RULE_PACKAGE_SITE_HINT: '設備パッケージに割り当て済み。タグ名にサブシステムがないためサイトレベルに配置しています。',
				RULE_UNASSIGNED: '未割り当て（タグ接頭辞）',
				RULE_UNASSIGNED_HINT: '機能ロケーションもパッケージもなく、タグ名のサブシステムでグループ化しています。',
				RULE_SITE: 'サイト',
				RULE_SITE_HINT: '機能ロケーション、パッケージ、サブシステムコードがなく、サイトレベルに置いています。',
			},
			TITLE: '{{facility}} 資産階層',
			BREADCRUMB: '資産エクスプローラー',
			RELOAD: '再読み込み',
			LOADING_TREE: '資産階層を読み込み中…',
			LOAD_FAILED: '資産階層を読み込めませんでした。もう一度お試しください。',
			SEARCH_PLACEHOLDER: '機器またはヒストリアンタグを検索…',
			SEARCH_HINT: '入力するとツリーを絞り込みます。タグを選ぶと P&ID 上に表示します。',
			TREE_EMPTY: '検索に一致する資産はありません。',
			EXPAND: '展開',
			COLLAPSE: '折りたたむ',
			LEVEL_KICKER: 'レベル {{level}}',
			NODE_ID: 'ID',
			TAGS_MAPPED: 'ヒストリアンタグ {{count}} 件',
			PIDS_LINKED: '関連 P&ID {{count}} 件',
			TAB_OVERVIEW: '概要',
			TAB_PID: 'P&ID',
			TAB_TELEMETRY: '時系列',
			TAB_DOCS: 'ドキュメント',
			DOCS: {
				VIEW: 'ドキュメント ({{count}})',
				HINT: '{{name}} とその上位ロケーションのマニュアル、データシート、警報/トリップリスト。',
				ALSO_PIDS: '{{count}} 枚の P&ID シートにも記載',
				OPEN_LIBRARY: 'ライブラリを開く',
				EMPTY: 'このロケーションまたは上位ロケーションにリンクされたドキュメントはありません。',
			},
			OPEN_KG: 'ナレッジグラフで開く',
			VIEW_ALERTS: 'アラートを表示',
			VIEW_PID: 'P&ID を表示',
			VIEW_TELEMETRY: '時系列を表示',
			DESCRIPTION: '説明',
			NO_DESCRIPTION: 'この資産の説明は登録されていません。',
			CHILDREN: '子資産（{{count}}）',
			PROPERTIES: 'プロパティ',
			TAGS_TITLE: 'ヒストリアンタグ（{{count}}）',
			NO_TAGS: 'この資産にマッピングされたヒストリアンタグはありません。',
			COL_TAG: 'タグ',
			COL_COMPONENT: 'コンポーネント',
			COL_RANGE: '運転範囲',
			COL_UNIT: '単位',
			COL_ACTIONS: '操作',
			LOCATE_ON_PID: 'P&ID 上に表示',
			PLOT: 'プロット',
			NO_SELECTION: '階層から資産を選択するか、タグを検索してください。',
			LEVEL: {
				FACILITY: '施設',
				SYSTEM: 'システム',
				SUBSYSTEM: 'サブシステム',
				EQUIPMENT: '機器',
				COMPONENT: 'コンポーネント',
				INSTRUMENT: '計器',
			},
			PID: {
				SHEET: '図面',
				SEARCH_SHEETS: '図面を検索…',
				SEARCH_ON_DRAWING: 'この図面でタグを検索…',
				NO_MATCHES: 'この図面に一致するタグはありません。',
				FILTER_ALL: 'すべて',
				FILTER_INSTRUMENTS: '計器',
				FILTER_EQUIPMENT: '機器',
				FILTER_NONE: 'なし',
				GROUP_LOCATED: '{{tag}} を含む図面',
				GROUP_NODE: '{{name}} に関連',
				GROUP_ALL: 'すべての図面（{{count}}）',
				SOURCE_DIGITISED: 'デジタル化済み',
				SOURCE_TEXT: 'テキスト索引',
				SOURCE_NEEDS_OCR: 'OCR が必要',
				SOURCE_CATALOGUED: '登録済み',
				SOURCE_BLANK: 'テキストなし',
				DETECTIONS: '{{count}} 件',
				LOCATING: 'P&ID 上で {{tag}} を検索中…',
				LOCATE_FAILED: 'P&ID 上で {{tag}} を検索できませんでした。',
				NOT_ON_PID: '{{tag}} はデジタル化済みのどの P&ID にもありません。',
				FOUND_ON: '{{tag}} は {{count}} 枚の図面にあります',
				CLEAR_LOCATE: 'クリア',
				TYPE_INSTRUMENT: '計器',
				TYPE_EQUIPMENT: '機器',
				CONFIDENCE: '信頼度 {{pct}}%',
				CANONICAL: '正規タグ',
				HISTORIAN_TAG: 'ヒストリアンタグ',
				NOT_LINKED: 'ヒストリアンタグに未リンク',
				PLOT: '時系列にプロット',
			},
			PID_VIEWER: {
				ZOOM_IN: '拡大',
				ZOOM_OUT: '縮小',
				FIT: '全体表示',
				FOCUS_HIGHLIGHT: 'ハイライトされたタグへ移動',
				FULLSCREEN: '全画面',
				EXIT_FULLSCREEN: '全画面を終了',
				LOADING: '図面を読み込み中…',
				NO_DRAWING: '図面が選択されていません。',
				LOAD_FAILED: 'この図面を読み込めませんでした。',
				NO_IMAGE: 'この図面の画像はありません',
				NO_IMAGE_HINT: '図面はデジタル化されています（{{count}} 件、ハイライト {{highlighted}} 件）が、画像がありません。',
				PAN_HINT: 'ドラッグで移動・スクロールでズーム',
				ASPECT_WARNING: '画像と図面のサイズが異なります。枠がずれている可能性があります。',
				HISTORIAN_TAG: 'ヒストリアンタグ',
				NOT_LINKED: '未リンク',
				CLICK_HINT: 'クリックして選択',
				UNTAGGED: 'タグなしの項目',
			},
			TAG_SEARCH: {
				SEARCHING: '検索中…',
				FAILED: 'タグ検索に失敗しました。もう一度お試しください。',
				NO_RESULTS: '「{{query}}」に一致するヒストリアンタグはありません。',
				HAS_DATA: 'データあり',
				NO_DATA: 'データなし',
				ALREADY_ADDED: '選択済み',
			},
			TELEMETRY: {
				ACTIVE_TAGS: 'チャートのタグ（{{count}} / {{max}}）',
				SEARCH_PLACEHOLDER: '追加するヒストリアンタグを検索…',
				DROPPED: '最大 {{max}} タグ：{{tag}} を削除しました。',
				REMOVE: 'チャートから削除',
				WINDOW: '期間',
				WINDOW_7D: '7日',
				WINDOW_30D: '30日',
				WINDOW_90D: '90日',
				WINDOW_1Y: '1年',
				CHART_TITLE: 'ヒストリアン時系列',
				POINTS: '{{count}} ポイント',
				LOADING: '時系列を読み込み中…',
				NO_DATA: 'この期間に選択したタグの測定値はありません。',
				NO_TAGS: 'タグを検索するか、上から選択してプロットします。',
				SUMMARY: '概要',
				LATEST: '最新',
				MIN: '最小',
				MAX: '最大',
				MEAN: '平均',
			},
		},
		TRIAGE: {
			RULE_SIGNALS: {
				TITLE: 'What this rule measures',
				MEASURED: 'Measured',
				CONTEXT: 'Context',
				HAS_READINGS: 'Readings before the alert',
				NO_READINGS: 'No readings in the 24 h before the alert',
				SOURCE: 'Mapping from {{source}}',
				GUESSED: 'Shell\'s configuration does not list this rule\'s inputs; the charted signals were chosen by the agent from the well\'s sensors.',
			},
			BASIS: {
				NO_RESULT: 'No decision yet: run the agent on this alert.',
				RECOMMENDATIONS: 'Recommendations',
				NO_RECOMMENDATIONS: 'The agent made no recommendations for this alert.',
				FINAL_HYPOTHESES: 'Final hypotheses (adjudicator)',
				NO_FACT_SPAN: 'This run did not record which evidence it read.',
				LINK_RCA: 'Deep RCA · {{count}} verified facts',
				LINK_EVIDENCE: 'Evidence used',
			},
			PFLOW: {
				ALERT_DRAWINGS: 'Drawings the alert equipment is on (open with the alert context)',
				TAB: 'Process flow',
				TITLE: 'Block flow (process units)',
				CHECKED_LEGEND: 'Checked by the agent ({{n}})',
				OPEN_MAP: 'Open process map',
				OPEN_ON_MAP: 'Show on process map',
				ALERT_UNIT: 'Alert\'s unit',
				STATE_MOVED: 'Moved',
				STATE_HELD: 'Steady',
				STATE_NODATA: 'No data',
				TIMING_BEFORE: 'before the alert',
				TIMING_TOGETHER: 'with the alert',
				TIMING_AFTER: 'after the alert',
				TIMING_EARLIER: '> 48 h earlier',
				KEY_SENSORS: 'Key sensors (click to chart)',
				CHART_IT: 'chart it on the right',
				ON_DRAWING: 'Equipment on the alert\'s drawing',
			},
			STEP_PANEL: {
				DQ: 'Data quality of the readings before the alert',
				NO_DQ: 'No data-quality assessment was recorded for this alert.',
				STATE: 'Alert tag with the machine\'s run indicator',
				LIMITS: 'Limits of this tag and when they applied',
				RULE: 'The detector and the tags it watches',
				EQUIPMENT: 'Sensors on this equipment — click one to chart it on the right',
				PROCESS: 'Live P&ID — click a tag to chart it on the right',
				NO_ANOMALY: 'The run has no anomaly-model analysis for this alert.',
			},
			DOCPAGE: {
				MAXIMIZE: 'Maximize',
				RESTORE: 'Restore',
				MARKING: 'Finding the cited passage on this page…',
				MARKING_TERMS: 'Finding the search words on this page…',
				MARK_FAILED: 'The page is shown, but the passage could not be located on it.',
				PAGE_OF: 'page {{page}} of {{pages}}',
				PREV: 'Previous page',
				NEXT: 'Next page',
				CITED_FOUND: 'The red box marks the passage the triage relied on.',
				OCR: 'This page is a scan, read by OCR, so the box position is approximate.',
				CITED_MISSING: 'The cited words could not be found on this page image (the scan reads differently); the passage is the one quoted in the triage.',
				CITED_ON: 'The cited passage is on page {{page}}.',
				LOADING: 'Loading the page…',
				CLOSE: 'Close',
			},
			DOCS: {
				REFERRED: 'Referred documents',
				ALL: 'All documents',
				SEARCH_PLACEHOLDER: 'Filter by name — press Enter to search inside the documents',
				SEARCH_INSIDE: 'Search inside',
				WHOLE_SITE: 'Whole site',
				RESULTS: 'Pages matching “{{q}}”',
				NO_RESULTS: 'No page matches these words.',
				PAGE: 'p.{{n}}',
				USED: 'Passages the triage used',
				USED_HINT: 'Click a passage to open its page with the passage in a red box',
				CITED: 'cited',
				VIEW_PAGE: 'View page',
			},
			SEE: {
				RULE: 'Rule, delay and replay: see Source Alert',
				SENSORS: 'Sensors on this machine: see System Details',
				TAGS: 'Plot them: see Tags',
				CONNECTED: 'Upstream and downstream units: see System details › Process flow',
				PID: 'P&ID drawings: see System details',
				WORK_ORDERS: 'Open work: see Work Orders',
				ALERTS: 'Earlier alerts: see Alerts',
				REPORTS: 'Shift reports: see Reports',
				REASONING: 'How the agent reasoned: see Reasoning',
			},
			PANE_SPLIT_HINT: 'Drag to resize; double-click to reset',
			RELATED: {
				TITLE: 'Related alerts',
				HELP: 'Found by the known-issue check: earlier alerts on this equipment known before this alert\'s cut-off, and later alerts that linked to this one. Each alert keeps its own label.',
				NONE: 'No related alert found.',
				ISSUE_SIZE: 'Issue of {{n}} alerts',
				REL_COVERED_BY: 'Service already raised',
				REL_SAME_CONDITION: 'Same condition',
				REL_SAME_EVENT: 'Same event',
				DIR_EARLIER: 'earlier alert',
				DIR_LATER: 'later alert',
				SCORE: 'score {{s}}',
				STATUS_PROPOSED: 'Proposed',
				STATUS_CONFIRMED: 'Confirmed',
				STATUS_REJECTED: 'Rejected',
				CONFIRM: 'Confirm',
				REJECT: 'Reject',
				CHIP: 'Same issue as {{n}} other alert(s)',
				CHIP_TIP: 'The known-issue check found {{n}} other alert(s) on the same condition. Open the alert to see them under Related alerts, and confirm or reject the link.',
				CHIP_PROPOSED: 'Some links still await review.',
			},
			QUEUE_RUN: {
				BUTTON: 'Triage selected',
				HINT: 'Run the Triage Agent on each selected alert, one alert at a time per run (never grouped); a few run at once.',
				STARTED: 'Triaging {{n}} alerts individually',
				PROGRESS: 'Triage: {{done}} of {{total}} done, {{running}} running',
				DONE: 'Triage finished for {{n}} alerts ({{failed}} failed)',
			},
			LABEL_SETTINGS: {
				PROPOSALS_TITLE: 'Proposed mapping changes ({{n}})',
				PROPOSALS_HELP: 'Reviewers agreed with the agent\'s finding but expected another customer label. Apply moves the finding in the editor below; it is accepted when you save the new version.',
				N_ALERTS: '{{n}} alerts',
				APPLY: 'Apply to mapping',
				APPLIED: 'Applied — save to accept',
				REJECT: 'Reject',
				TAB_SETTINGS: 'Settings',
				TAB_LABELS: 'Labels',
				INTRO: 'The agent decides an internal finding; the mapping turns it into the label the customer sees. A change saves a new version (v{{v}} is in force) and relabels every alert at once, without re-running triage.',
				EXTERNAL_TITLE: 'External labels',
				EXTERNAL_HELP: 'The labels shown in the queue and reported to the customer. The outcome drives the approve button: close, act (raise the action type) or hold for review. Saved labels cannot be deleted, only retired; their keys are permanent.',
				COL_NAME: 'Name / key',
				COL_CUSTOMER: 'Customer value',
				COL_OUTCOME: 'Outcome',
				COL_ACTION: 'Action type',
				COL_COLOR: 'Colour',
				COL_SCORED: 'Scored as',
				COL_ACTIVE: 'Active',
				UP: 'Move up',
				DOWN: 'Move down',
				REMOVE: 'Remove (never saved)',
				FALLBACK: 'fallback',
				CUSTOMER_NONE: 'Not exported',
				ACTION_PH: 'e.g. service_notification',
				OUTCOME_CLOSE: 'Close',
				OUTCOME_ACTION: 'Action',
				OUTCOME_HOLD: 'Hold for review',
				NOT_SCORED: 'Not scored',
				NEW_KEY: 'New key, e.g. valid_monitor',
				NEW_NAME: 'Name shown to users',
				ADD: 'Add label',
				KEY_RULE: 'Key: 3–41 lower-case letters, digits or underscores, starting with a letter.',
				KEY_TAKEN: 'That key is already used (keys are never reused, even after retiring).',
				NAME_REQUIRED: 'Give the label a name.',
				FALLBACK_LABEL: 'Fallback label',
				FALLBACK_HELP: 'Used when a finding has no mapping. Must be active and hold for review.',
				MAPPING_TITLE: 'Mapping: external label ← internal findings',
				MAPPING_HELP: 'Each external label (left) owns the agent findings on the right. Every finding belongs to exactly one label. Click a finding to move it. Amber findings differ from the default mapping.',
				UNMAPPED: '{{n}} findings are not mapped; they would show as the fallback label.',
				N_FINDINGS: '{{n}} findings',
				NONE: 'No findings mapped',
				RETIRED_NONE: 'Retired: owns no findings',
				DEFAULT_WAS: 'default: {{x}}',
				CHECK_N: 'Check {{n}}',
				MOVE_TO: 'Move “{{x}}” to',
				BY_CHECK: 'View by triage check',
				NO_CHANGES: 'No changes.',
				PREVIEWING: 'Checking the change…',
				MOVING: '{{n}} triaged alerts would change label.',
				DISCARD: 'Discard',
				SAVE: 'Save new version',
				SAVED: 'Label mapping v{{v}} saved',
				HISTORY: 'Versions',
				IN_FORCE: 'in force',
				RESTORE: 'Load into editor',
				RESTORE_REASON: 'Restore the mapping of v{{v}}',
			},
			LABELS: {
				FINDING_TIP: 'Shown to Shell as “{{label}}” (label mapping v{{v}}, Settings → Labels).',
				FINDING: 'Finding',
				SOURCE_AGENT: 'Agent',
				SOURCE_POLICY: 'Policy',
				SOURCE_HUMAN: 'Reviewer',
				SOURCE_DERIVED: 'Derived',
				MAPPING: 'Mapping v{{v}} → {{label}}',
				MAPPING_TIP: 'The finding is turned into the customer label by the label mapping in Settings › Labels. Changing the mapping relabels alerts without re-running triage.',
				ALSO_FOUND: 'Also found',
				CHECK: 'check {{n}}',
				SECONDARY_ACTION: 'Also found: {{names}}. That finding leads to an action, but the main finding closes the alert. Review before closing.',
				INTERNAL_COLUMN: 'Finding',
			},
			ACT: {
				APPROVED_CLOSED: 'Approved and closed',
				CLOSED: 'Closed – False alert',
				CLOSED_FLAGGED: 'Closed – False alert · rule flagged for tuning',
				CLOSE_ALERT: 'Close alert',
				CLOSE_CONFIRM: 'Close alert',
				CLOSE_TITLE: 'Close as False – No Action',
				CREATE_INSTRUMENT_WO: 'Create instrument WO',
				CREATE_SERVICE: 'Create Service',
				DUE_DATE: 'Due date',
				EQUIPMENT: 'Equipment',
				EVIDENCE_ATTACHED: 'Evidence attached (click to leave one out)',
				FEED_CONFIRM: 'Report issue',
				FEED_LEAD: 'The alert was raised on values that are not measurements. The issue goes to {{owner}}; no work order is raised because no transmitter is broken.',
				FEED_REPORTED: 'Data-feed issue reported to {{owner}}',
				FEED_TITLE: 'Report data-feed issue',
				FEWER_FIELDS: 'Show fewer fields',
				FLAG_RULE: 'Flag rule for tuning',
				FROM_AGENT: 'from the agent',
				FROM_DQ_POLICY: 'from DQ policy',
				LINKED: 'Linked to {{id}} and closed',
				LINKED_ALERT: 'Linked alert',
				LINK_CLOSE: 'Link & close',
				LINK_CONFIRM: 'Link & close',
				LINK_LEAD: 'This condition is already covered by an open record. The alert is linked to it and closed as Valid – No Action.',
				LINK_TITLE: 'Link to the known issue',
				LOADING: 'Preparing the form…',
				MORE_FIELDS: 'Show more fields',
				NOTE: 'Note (optional)',
				NOTE_PLACEHOLDER: 'Add context for the SME team…',
				NO_EVIDENCE: 'Nothing cited to attach',
				NO_REPLAY: 'The detector\'s rule could not be replayed on the raw data, so no fix is suggested.',
				OPEN_CASE: 'Open case',
				OWNER: 'Owner',
				OWNER_ME: 'Me',
				PREFILLED: 'prefilled',
				PRIORITY: 'Priority',
				PROBLEM: 'Problem',
				RECOMMENDATION: 'Recommendation',
				REPORT_FEED: 'Report data-feed issue',
				ROUTE_TO: 'Route to',
				SENT_TO: 'Sent to {{owner}}.',
				SERVICE_CONFIRM: 'Create Service',
				SERVICE_CREATED: 'Service case #{{id}} created',
				SERVICE_NAME: 'Title',
				SERVICE_TITLE: 'Create Service',
				TAG: 'Tag',
				UNDO: 'Undo',
				UNDONE: 'Action undone',
				WO_CONFIRM: 'Create work order',
				WO_CREATED: 'Work order {{id}} created · {{route}}',
				WO_TITLE: 'Create instrument work order',
			},
			CHIPS: {
				UNACK_HINT: '{{n}} not yet acknowledged',
			},
			RULE: {
				FLAGGED_SHORT: 'Rule flagged',
				FLAGGED_TIP: 'The detector rule was flagged for tuning',
			},
			SETTINGS: {
				DEFAULT: 'Default',
				FROM_DEFAULT: 'default',
				FROM_FACILITY: 'facility',
				FROM_EQUIPMENT: 'this equipment',
				HISTORY: 'Change history',
				LOADING: 'Loading settings…',
				NO_HISTORY: 'No change yet: every value is the code default.',
				N_CHANGED: '{{n}} changed',
				OPEN: 'Triage settings',
				OPEN_HINT: 'Flatline, delays, HIL in memory, routing',
				READ_ONLY: 'Only an administrator can change these settings.',
				REASON: 'Reason for the change (required)',
				RESET: 'Reset',
				RE_EVAL: 'changes results',
				RE_EVAL_CHANGED: 'Run the golden set before relying on this change',
				RE_EVAL_HINT: 'Changing this changes triage results: run the golden set before relying on it',
				RE_EVAL_NOTE: 'Each change is a new version; every triage run records the version it used. Settings marked "changes results" need a golden-set run before you rely on them.',
				SAVE: 'Save',
				SAVED: 'Settings saved as version {{v}}',
				SAVE_FAILED: 'The settings could not be saved',
				SCOPE: 'Applies to',
				SCOPE_FACILITY: 'The whole facility',
				SUBTITLE: 'Version {{v}}',
				TITLE: 'Alert Triage settings',
			},
			TREE: {
				ALL_OPEN: 'All open alerts',
				CLEAR_FILTER: 'Show all nodes',
				NO_ACTION_TOTAL: 'No action',
				SHOWING_ONLY: 'Showing: {{cls}} only',
				SHOW_NODES_WITH: 'Show nodes with',
			},
			KG: {
				CLICK_TO_COLLAPSE: 'クリックで折りたたむ',
				NO_EXACT: '「{{tag}}」という名前のノードはありません',
				PICK_MATCH: '部分一致したノード（プラントの部分ごとに1つ）— 探索するものを選択:',
				BREADCRUMB_OPS: 'オフショア操業',
				BREADCRUMB_TWINS: 'トポロジカルツイン',
				BREADCRUMB_GRAPH: 'Shell Vito ナレッジグラフ',
				TITLE: 'インタラクティブ・プラント・ナレッジグラフ',
				NODES: 'ノード {{n}}',
				RELATIONSHIPS: '関係 {{n}}',
				LIVE: 'Neo4j ライブ',
				CENTER_PLACEHOLDER: '中心タグ（例: PT-1502、MTR-0900）…',
				EXPLORE: '探索',
				HOPS: '深さ',
				HOPS_1: '1ホップ: 直接の隣接',
				HOPS_2: '2ホップ: 隣接機器',
				HOPS_3: '3ホップ: 広いトポロジー',
				SHOW_TYPE: 'この種類を表示',
				HIDE_TYPE: 'この種類を非表示',
				ZOOM_IN: '拡大',
				ZOOM_OUT: '縮小',
				FIT: '画面に合わせる',
				SHOWING: '{{total}} ノード中 {{shown}} を表示',
				SHOW_MORE: 'さらに {{n}} 件表示',
				EXPAND_ALL: 'すべてのグループを展開',
				COLLAPSE_ALL: 'グループを折りたたむ',
				HINT: 'ホバーで名前 · グループをクリックで展開 · ノードをクリックで詳細 · ドラッグで移動、スクロールでズーム',
				LOADING: 'ナレッジグラフを読み込み中…',
				LOAD_FAILED: 'ナレッジグラフを読み込めませんでした',
				CLICK_TO_EXPAND: 'クリックで一覧表示と展開',
				GROUP: 'グループ化されたノード',
				COLLAPSE_GROUP: 'グループを折りたたむ',
				CENTER_ON_NODE: 'このノードを中心に表示',
				PROPERTIES: 'ノードのプロパティ',
				LOADING_RELATIONS: '関係を読み込み中…',
				OUTGOING: '出力関係（{{n}}）',
				INCOMING: '入力関係（{{n}}）',
				TYPE: {
					Equipment: '機器',
					ControlValve: '制御弁',
					Instrument: '計器',
					Event: 'アラート',
					Event_PostJune2026: 'アラート（2026年6月以降）',
					Alert: 'アラート',
					TripEvent: 'トリップイベント',
					RootCause: '根本原因',
					PhaScenario: 'PHAシナリオ',
					Detector: '検出器',
					Measurement: '測定',
					Document: '文書',
					PIDDrawing: 'P&ID図面',
					FLOC: 'FLOC',
					ProcessLine: 'プロセスライン',
					System: 'システム',
				},
			},
			LIBRARY: {
				TITLE: 'ライブラリ担当',
				EXCERPTS_N: '抜粋 {{n}} 件 · 文書 {{docs}} 件',
				NONE: '対象範囲にマニュアルなし',
				LIMITS_N: '記載された制限値 {{n}} 件',
				SCOPE: '検索対象',
				HINT: 'この設備（FLOC）に登録されたメーカーマニュアル、データシート、警報・トリップ一覧を意味と語句で検索します。エージェントは LIB-n として引用します。',
				QUESTIONS: '検索した質問',
				NONE_HINT: 'この設備または上位 FLOC に登録されたマニュアル・データシートはありません。',
				STATED_LIMITS: 'この計器に記載された制限値',
				EXCERPTS: '抜粋',
			},
			LIMITS: {
				ROW_FOUND: 'The red box marks the row this limit was read from.',
				OPEN_PAGE: 'Open the source page',
				OPEN_ROW: 'Open the source row',
				HIDE_SOURCE: 'Hide the source',
				SHEET_TITLE: 'Source row in the Shell workbook',
				SHEET_UNAVAILABLE: 'The workbook could not be read.',
				SHEET_ROWS: '{{n}} row(s) name this tag, of {{total}}',
				SHEET_NO_ROW: 'No row in this sheet names the tag.',
				SHEET_ROW: 'Row {{n}}',
				AT_ALERT: 'In force at the alert ({{t}}) marked',
				IN_FORCE: 'in force',
				NOT_IN_FORCE: 'not in force then',
				FROM: 'from {{from}}',
				QUOTED_FROM: 'quoted {{from}} – {{to}}',
				MAPPING_REVIEW: 'instrument ↔ tag mapping under review',
				DCS: 'DCS limit tags (historian)',
				AT_ALERT_VALUE: 'at the alert: {{v}}',
				TITLE: '制限値',
				CLOSEST: '{{kind}} {{value}} · 余裕 {{headroom}}%',
				NONE: '既知の制限値なし',
				RULE_BREACHED: 'TMP 変化率ルールに該当',
				HINT: 'アラートタグの既知の技術的制限値（Shell TMP の PSV 設定値 / DCS / PTM、SimpleLimits、同じ単位のマニュアル値）を、アラート前の最新値と 24 時間の最大・最小と比較します。',
				NONE_HINT: 'このタグには TMP、SimpleLimits、検出器設定、マニュアル記載の制限値がありません。',
				SOURCE: '出典',
				LIMIT: '制限値',
				VALUE: '値',
				EXTREME_24H: '24 時間最大 / 最小',
				HEADROOM: '余裕',
				STATUS: '状態',
				RATE_RULES: 'TMP 変化率ルール',
				LARGEST_CHANGE: '最大変化 {{value}}',
				BREACHED: '該当',
				NOT_BREACHED: '非該当',
				DETECTOR: '検出器設定',
				CONFLICT: 'TMP の値が矛盾:',
				REACHED: '到達',
				NEAR: '接近',
				CLEAR: '余裕あり',
				NO_READING: '測定値なし',
			},
			PREFS: {
				TITLE: '設定',
				HEIGHT: 'グラフの推奨高さ',
				CONDENSED: 'コンパクト',
				NORMAL: '標準',
				EXPANDED: '拡大',
				LIMITS_AND_VALUES: 'タグのリミットと値',
				SHOW: '表示',
				HIDE: '非表示',
				OTHER: '既定で表示するリミット線',
				TRIP_LINE: 'トリップ線',
				ALARM_LINE: 'アラーム線',
				THRESHOLD_LINE: 'しきい値線',
				INSTRUMENT_LINE: '計器範囲線',
				NOTE: 'すべてのトリアージチャートに適用されます。網掛けは故障モードの期間（信号開始から正常復帰まで）です。リミットは読み込まれたShellデータ（TMP、SimpleLimits）のみから取得します。',
				RESET: '既定値に戻す',
			},
			PLAYBOOK: {
				TITLE: 'サイト運用手順チェック',
				META: '{{count}} 件のルールを評価',
				META_HINT: 'この検知器のサイト審査メモから抽出され、アラート時点で有効なルールを、カットオフ前の証拠で検証',
				LEGEND: '✓ 成立 · ✗ 不成立 · ? 評価不可。例外条件が成立するとルールは適用されません。チェックで表せない部分はエージェントが判断します。',
				OPEN_RULE: '学習ページでルールを開く',
				DISPOSITION_HINT: 'このルールが当てはまる場合のサイトでの処置',
				UNLESS_HINT: '例外：いずれかが成立するとルールは適用されません',
				JUDGED_BY_AGENT: 'エージェントが判断',
				JUDGED_HINT: 'この部分は機械チェックで表せないため、エージェントが証拠から判断します',
				VALUE_YES: '成立',
				VALUE_NO: '不成立',
				VALUE_UNKNOWN: '評価不可',
				ST_MATCHED: '一致',
				ST_MATCHED_HINT: 'すべての条件が成立し、例外は成立しない',
				ST_PARTLY: '一部一致',
				ST_PARTLY_HINT: '機械チェックは成立。完全に当てはまるかはエージェントが判断する部分で決まります',
				ST_EXCEPTED: '例外該当',
				ST_EXCEPTED_HINT: '当てはまるはずだが、例外条件が成立',
				ST_UNDETERMINED: '判定不能',
				ST_UNDETERMINED_HINT: 'カットオフ前の証拠では評価できないチェックがある',
				ST_NOT_MATCHED: '不一致',
				ST_NOT_MATCHED_HINT: '条件のいずれかが不成立',
			},
			LEARNING_CHECK: {
				OR: 'または',
				HOURS: '{{n}} 時間',
				DAYS: '{{n}} 日',
				ON_ITEM: '（この機器）',
				V_STOPPED: '停止した',
				V_STARTED: '起動した',
				V_RESTARTED: '再起動した',
				V_SHUTDOWN_OR_STARTUP: '停止または起動した',
				V_NO_SIGNIFICANT_CHANGE: '有意な変化なし',
				V_PROCESS_OR_OPERATING_CHANGE: 'プロセスまたは運転の変化',
				V_SINGLE_TAG_DEPARTURE: '単一タグのみの逸脱',
				V_MIXED: '混在したパターン',
				V_CONSISTENT: '正常と整合',
				V_MOVED_TOGETHER: '一緒に動いた',
				MACHINE_EVENT: '機械が {{window}} 以内に{{events}}',
				MACHINE_EVENT_NO_WINDOW: '機械が{{events}}',
				MACHINE_EVENT_ANY: '{{window}} 以内の機械の停止または起動',
				SINCE_RESTART: 'アラートの {{window}} 以内に機械が再起動',
				RUNNING: 'アラート時点で機械が運転中',
				NOT_RUNNING: 'アラート時点で機械が停止中',
				WITHIN_BASELINE: 'アラート時点でアラートタグが正常範囲内',
				OUTSIDE_BASELINE: 'アラート時点でアラートタグが正常範囲外',
				SUSTAINED: '正常からの持続的な逸脱',
				NOT_SUSTAINED: '正常からの持続的な逸脱なし',
				CHART_PATTERN: 'チャートが{{patterns}}を示す',
				CHART_PATTERN_ANY: 'チャートのパターンを読み取る',
				MULTIVARIATE: '多変量モデルが{{values}}と判定',
				MULTIVARIATE_ANY: '多変量モデルの判定がある',
				CONNECTED: '接続システム：{{values}}',
				CONNECTED_ANY: '接続システムを読み取った',
				MOVED_TOGETHER: '関連タグが一緒に動いた',
				NOT_MOVED_TOGETHER: '関連タグは一緒に動かなかった',
				OPEN_WORK: 'この機器に未完了の通知または作業指示がある',
				NO_OPEN_WORK: 'この機器に未完了の通知・作業指示はない',
				COHORT: '同じシステムで多数のアラートが同時発生（共通原因）',
				NO_COHORT: '同じシステムでのアラート集中はない',
				SENSOR_FAULT: 'センサー故障またはデータが使用不可',
				SENSOR_OK: 'センサーデータは使用可能',
				RETURNED: 'アラート時点より前に信号が正常に戻った',
				NOT_RETURNED: 'アラート時点までに信号は正常に戻っていない',
				SHIFT_LOG: '直近 {{window}} のシフト日誌に「{{query}}」の記載',
				NO_SHIFT_LOG: '直近 {{window}} のシフト日誌に「{{query}}」の記載なし',
				RECENT_WORK: '直近 {{window}} に「{{query}}」に該当する保全作業',
				NO_RECENT_WORK: '直近 {{window}} に「{{query}}」に該当する保全作業なし',
				OTHER_ALERTS: '{{window}} 以内に同じ検知器の他のアラートが {{n}} 件以上',
				PRIOR_ALERTS: '直近 {{window}} にこのタグの過去アラートが {{n}} 件以上',
				PRIOR_ALERTS_EVER: 'このタグの過去アラートが {{n}} 件以上',
			},
			LEARNING_EDIT: {
				TITLE: '学習を編集',
				ASOF_WARNING: '保存すると v{{next}} が作成され、今から有効になります。以前のアラートのトリアージは当時有効だった版を使い続けます（as-of）。',
				F_TITLE: 'タイトル',
				RECOMPILE: '新しい条件から機械チェックを再生成します。',
				ACTIVE_HINT: 'エージェントが参照する',
				RETIRED_HINT: '今後は使用しない',
				REASON: '変更理由',
				REASON_HINT: '新しい版と一緒に保存され、履歴に表示されます。',
				NO_CHANGES: 'まだ変更はありません。',
				SAVE: '新しい版を保存',
				SAVED: 'v{{version}} として保存し、今から有効です。以前のトリアージは前の版を使います。',
			},
			LEARNING_DETAIL: {
				TITLE: '学習',
				EDIT: '編集',
				CLOSE: '閉じる',
				EFFECTIVE: '{{date}} から有効',
				SUPPORT: '根拠件数：{{support}}',
				CONSISTENCY: '一貫性 {{pct}}',
				MANUAL_FIELDS: '手動設定：{{fields}}',
				CONDITION: '条件',
				EXCEPTIONS: '例外',
				CHECKS: '機械チェック',
				CHECKS_HINT: '条件を、アラート時点の証拠でエージェントが検証できる事実に変換したもの。残りはエージェントが判断します。',
				CHECKS_STALE: '条件が編集されました。機械チェックを再生成中で、完了するまで使用されません。',
				WHEN: '条件',
				UNLESS: '例外条件',
				MANUAL: 'エージェントが判断',
				NO_CHECKS: '機械で検証できる条件はありません',
				GROUPS: 'アラートが対象とするセンサーグループ',
				TYPICAL_TAGS: '代表的なタグ',
				QUOTES: '審査メモより',
				GRAPH: 'ナレッジグラフ上の近傍',
				GRAPH_MISSING: 'まだナレッジグラフにありません。',
				REL_DETECTOR: '対象検知器',
				REL_FLOC: '機能場所',
				REL_SUPERSEDES: '置き換え',
				NO_LINKS: '検知器・場所・旧版へのリンクはありません。',
				SIMILAR: '類似の学習',
				NO_SIMILAR: '意味の近い有効な学習はありません。',
				OPEN_SIMILAR: 'この学習を開く',
				ASOF_NOTE: 'バージョンは上書きされません。時点 t のトリアージは t に有効だった版を使います。',
				NOW: '現在',
				CHANGED: '変更点：',
				SHOW_DIFF: 'ルールの差分を表示',
				HIDE_DIFF: '差分を隠す',
				F_TITLE: 'タイトル',
				F_RULE: 'ルール',
				F_DISPOSITION: '処置',
				F_STATUS: 'ステータス',
				F_CONDITION: '条件',
				F_EXCEPTIONS: '例外',
				F_SUPPORT: '根拠件数',
				SHOW_ALL_SOURCES: '全 {{count}} 件を表示',
			},
			PID: {
				CLICK_TO_PLOT: 'クリックしてプロット',
				NO_HISTORIAN_DATA: 'ヒストリアンデータなし',
				MORE_TAGS: 'この項目にさらに {{count}} 個のタグ',
				NO_DATA_AT_ALERT: 'アラート前 72 時間に測定値なし',
				CLICKABLE_COUNT: '{{total}} 個中 {{clickable}} 個のタグにデータあり',
				TAGS_FAILED: 'この図面のタグを読み込めませんでした',
				HIDE_LEGEND: '凡例を隠す',
				SHOW_LEGEND: '凡例を表示',
				LEGEND_DATA: 'ヒストリアンデータあり（クリック可）',
				LEGEND_NO_DATA: 'ヒストリアンデータなし',
				LEGEND_ALERT: 'アラートタグ',
				LEGEND_RELATED: 'アラートと同じ設備／ループ',
				LEGEND_SUGGESTED: '確認を推奨',
				ONLY_WITH_DATA: 'データのあるタグのみ',
				SHEET_N: 'シート {{sheet}}',
				BACK: '戻る',
				BACK_TIP: '前のシートに戻る（履歴 {{count}} 件）',
				SHOW_PANEL: 'パネルを表示',
				HIDE_PANEL: 'パネルを隠す',
				FROM_UPSTREAM: '上流から',
				TO_DOWNSTREAM: '下流へ',
				RESIZE: 'ドラッグしてパネル幅を変更',
				ON_DRAWING: '図面上',
				LOCATE_ITEM: '図面上で表示',
				FROM_OTHER_SHEET: '別のシートで選択中',
				ITEM_TAGS: 'この項目のタグ（{{count}}）',
				SWITCH_TIP: 'クリックするとこのタグに切り替えてプロット',
				ADD_TO_CHART: 'チャートに追加',
				REMOVE_FROM_CHART: 'チャートから削除',
				ON_CHART: 'チャート {{count}} / {{max}}',
				ALERT_WINDOW: 'アラート {{asOf}} · 3 日前から 1 日後まで',
				LAST_DAYS: '利用可能なデータの直近 {{days}} 日',
				CHART_FULL: '一緒にプロットできるタグは最大 {{max}} 個です',
				TIME_SERIES: '時系列',
				LOOK_NEXT: '次に確認',
				CONTEXT_FAILED: '関連タグを読み込めませんでした',
				CONTEXT_UNKNOWN: 'このタグはセンサーカタログにありません',
				LOOP_N: 'ループ {{loop}}',
				SAME_LOOP: '同じループ',
				SAME_EQUIPMENT: '同じ設備',
				UPSTREAM: '上流ユニット',
				DOWNSTREAM: '下流ユニット',
				SERVICE: '供給ユーティリティ',
				NONE_WITH_DATA: 'ヒストリアンデータのあるものはありません',
				SHOW_MORE: 'さらに {{count}} 件表示',
				NO_UNITS: '接続ユニットなし',
				HOPS: '{{count}} ホップ',
				OPEN_DRAWING: '図面を開く',
				MORE_SENSORS: 'さらに {{count}} 個のセンサー',
				TWIN: '並列トレイン：{{unit}}',
				TWIN_ON_CHART: '並列トレインのタグはチャートにあります',
				COMPARE_TWIN: '並列トレインと比較',
				TWIN_NO_TAG: '{{unit}} に同じ位置のタグは不明です',
				TWIN_SAME_MEASURE: '{{unit}} の同じ測定量',
				LOCATE_ON_SHEET: 'このシートで表示',
				OTHER_CONNECTORS: 'ユーティリティ・放出（{{count}}）',
				OTHER_CONNECTORS_TIP: 'このシートの制御・ユーティリティ・放出コネクタ',
				SIDE_BY_SIDE: '横並び表示',
				SIDE_BY_SIDE_TIP: '全画面：図面とパネルを横並びで表示',
				REL: {
					ALERT: 'アラートタグ',
					LOOP: '同じループ',
					EQUIPMENT: '同じ設備',
				},
			},
			BATCH: {
				TOGGLE: 'バッチ',
				TOGGLE_HINT: 'バッチモード：同じ FLOC で時間枠内に発生したアラートのグループを一覧表示し、グループごとにまとめてトリアージします',
				TOGGLE_OFF_HINT: '個別アラートの一覧に戻る',
				WINDOW_LABEL: '{{hours}} 時間枠',
				WINDOW_HINT: 'バッチ時間枠：1 件目のアラートからこの時間内に同じ FLOC で発生したアラートを 1 グループにします',
				WINDOW_TITLE: 'バッチ時間枠',
				WINDOW_OPTION: '{{hours}} 時間',
				HELP: 'アラートは FLOC ごとにグループ化されます。時間枠はグループの最初のアラートを起点とし、カットオフは最新のメンバーです。そのため各メンバーはその時点で分かっていた情報で評価されます。1 回の調査でグループ全体を扱い、メンバーごとに個別の処置を付けます。グループには日付、検索、FLOC、対象、ステータスのフィルターが適用されます。',
				GROUPS_TITLE: 'バッチ · {{hours}} 時間枠',
				GROUPS_COUNT: '（{{groups}} グループ · {{considered}} 件中 {{alerts}} 件のアラート）',
				NEWEST_FIRST: '新しい順',
				EMPTY: 'バッチはありません',
				EMPTY_HINT: '現在のフィルターでは、時間枠内に 2 件以上のアラートがある FLOC はありません。',
				COL_SIZE: '件数',
				COL_SPAN: '期間',
				COL_DETECTORS: '検出器',
				COL_CLASSES: '現在の分類',
				COL_TAG: 'タグ',
				COL_AS_OF: '時点',
				TOGGLE_MEMBERS: 'このグループのアラートを表示／非表示',
				N_ALERTS: '{{count}} 件のアラート',
				SPAN: '{{span}} で {{count}} 件のアラート',
				MINUTES: '{{count}} 分',
				HOURS_MINUTES: '{{hours}} 時間 {{minutes}} 分',
				CUTOFF: 'カットオフ',
				N_UNTRIAGED: '未トリアージ {{count}} 件',
				ALL_TRIAGED: 'すべてトリアージ済み',
				RUNNING: 'バッチ実行中',
				TRIAGE_BATCH: 'バッチをトリアージ（{{count}}）',
				TRIAGE_SELECTED: '選択した {{count}} 件をトリアージ',
				TRIAGE_HINT: '最新メンバーの時点でこれらのアラートをまとめて 1 回調査し、アラートごとに個別の処置を付けます',
				SELECT_MIN: 'このグループのアラートを {{count}} 件以上選択してください',
				SELECT_MAX: 'バッチは最大 {{count}} 件です：{{count}} 件以内で選択してください',
				PAGE_HINT: 'ページはグループ単位で数えます',
				RANGE: '{{total}} グループ中 {{start}}–{{end}}',
				DONE: '{{count}} 件のアラートのバッチをトリアージしました',
				GATED: 'バッチは分析されませんでした：データ品質ゲートが実行をブロックしました（キャンバスを参照）',
				FAILED: 'バッチ実行が完了しませんでした',
				ROW_CHIP: '{{count}} 件のバッチ',
				ROW_CHIP_TIP: '最新の実行では、このアラートを同じ FLOC の {{count}} 件のアラートとまとめてトリアージしました（1 回の調査、アラートごとに 1 つの処置）',
				CARD_TITLE: 'グループトリアージ',
				CARD_META: '{{count}} 件のバッチ · {{hours}} 時間枠 · カットオフ {{time}}',
				EPISODE_CLASS: 'エピソード',
				EPISODE_HINT: 'グループ全体としての分類',
				THIS_MEMBER: 'このアラート',
				MEMBERS: 'バッチ内のアラート',
				THIS_ALERT: 'このアラート',
				NOW_IN_GROUP: 'このアラートは現在、同じ FLOC の {{count}} 件のグループに含まれています（{{hours}} 時間枠、{{span}} 分、未トリアージ {{untriaged}} 件）。',
				MORE_DETECTORS: '他 {{count}} 件',
				TRIAGE_WITH: 'この FLOC の {{count}} 件のアラートとまとめてトリアージ',
			},
			UEV: {
				TITLE: 'エビデンスとフィードバック',
				HINT: 'ここで追加した現場観察、SAP通知、ヒストリアンタグ、ファイルは、再実行時にユーザー提供として明示され、基準時点の記録とは別に重み付けされてエージェントに渡されます。',
				BADGE_N: '{{count}} 件',
				BADGE_CHANGED: '回答を変更',
				EMPTY: 'エビデンスはまだ追加されていません。',
				LOAD_ERROR: 'エビデンスを読み込めませんでした',
				ADD: 'エビデンスを追加',
				ADDED: 'エビデンスを追加しました',
				UPDATED: 'エビデンスを更新しました',
				REMOVED_NOTICE: 'エビデンスを削除しました',
				TYPE_OBSERVATION: 'フィードバック / 観察',
				TYPE_SAP: 'SAP通知',
				TYPE_TAG: 'ヒストリアンタグ',
				TYPE_FILE: 'ファイル',
				TEXT_LABEL: '観察または測定した内容',
				TEXT_PLACEHOLDER: '例：現場の圧力計は30 scfmを示す、ドレン弁のパスを確認',
				CONTEXT_LABEL: 'このアラートにとって重要な理由',
				CONTEXT_PLACEHOLDER: 'エージェント向けの補足メモ（任意）',
				NOTIF_LABEL: '通知番号',
				LOOKUP: '検索',
				NOTIF_NOT_FOUND: '通知が見つかりません',
				NOTIF_AFTER: 'アラートの {{hours}} 時間後に作成',
				NOTIF_BEFORE: 'アラート前に作成',
				NOTIF_NAMES_TAG: 'アラートのタグ {{tag}} に言及',
				FLOC_EQUIPMENT: '同一機器',
				FLOC_UNIT: '同一ユニット',
				FLOC_FACILITY: '別の機器',
				RAISED: '作成 {{time}}',
				COMPLETED: '完了 {{time}}',
				TAG_LABEL: 'ヒストリアンタグ',
				TAG_PLACEHOLDER: 'タグを検索（例：LIC0920）',
				TAG_HINT: 'エージェントは他のタグと同様に、このタグをアラート時点の値で読み取ります。',
				FILE_CHOOSE: 'ファイルを選択',
				FILE_HINT: 'PDF、画像、テキスト、CSV、Word、Excel（最大10 MB）',
				FILE_TYPE_ERROR: '未対応のファイル形式です：PDF、PNG、JPG、テキスト、CSV、Word、Excelをアップロードしてください',
				FILE_SIZE_ERROR: 'ファイルが10 MBを超えています',
				FILE_META: '{{pages}} ページ、{{size}} KB',
				FILE_NO_TEXT: 'テキストを抽出できません（{{note}}）',
				OPEN_FILE: 'ファイルを開く',
				SAVE: '追加',
				CANCEL: 'キャンセル',
				EDIT: '編集',
				REMOVE: '削除',
				REMOVE_CONFIRM: 'この項目を削除しますか？以前のバージョンは保持され、それを使用した実行には引き続き記録されます。',
				REASON: '理由（任意）',
				SAVE_EDIT: '新しいバージョンとして保存',
				VERSIONS: '履歴',
				REMOVED: '削除済み',
				SHOW_REMOVED: '削除済みを表示',
				HIDE_REMOVED: '削除済みを非表示',
				BY: '{{name}} が追加 · {{time}}',
				EDITED_BY: 'v{{n}}（{{name}}） · {{time}}',
				AFTER_CUTOFF: '基準時刻以降',
				RERUN: 'エビデンスを使って再実行',
				RERUN_HINT: '有効な {{count}} 件でトリアージエージェントを再実行し、実行キャンバスでライブ表示します',
				RERUN_BATCH: 'バッチを再実行（{{count}} 件のアラート）',
				RERUN_BATCH_HINT: '全メンバーの有効なエビデンスでバッチを再実行します',
				LAST_RUN: '前回の再実行で使用：{{refs}}',
				OUTCOME_CHANGED: '回答を変更：{{from}} → {{to}}',
				OUTCOME_UNCHANGED: '回答は変わらず',
				OUTCOME_NOT_ATTRIBUTED: '回答が変更（{{from}} → {{to}}）、エビデンスによるものではない',
				OUTCOME_NO_BASELINE: 'エージェントはエビデンスが回答を決定したとしています',
				AGENT_LINE: 'ユーザーエビデンス {{refs}} を使った再実行の回答',
				NODE: 'ユーザーエビデンス',
				CANVAS_BADGE: 'ユーザーエビデンス · {{count}}',
				CANVAS_HINT: 'ユーザー提供のエビデンスでの再実行：{{refs}}',
				PICKER: 'ユーザーエビデンス',
				INSPECTOR_ITEMS: '使用した項目（{{count}}）',
				INSPECTOR_BASELINE: 'このエビデンスなしの回答：{{cls}}',
				INSPECTOR_NO_BASELINE: 'ユーザーエビデンスなしの過去の実行はありません',
				INSPECTOR_AUDIT: 'ユーザー提供の項目は基準時点ビューの外に置かれ、リークチェックはハーネスの事実のみを対象とします。',
				ATTRIBUTION_USER_EVIDENCE: 'エビデンスにより変更：{{from}} → {{to}}',
				ATTRIBUTION_USER_EVIDENCE_NO_BASELINE: 'エビデンスにより決定（過去の実行なし）',
				ATTRIBUTION_NOT_ATTRIBUTED: '変更、帰属なし：{{from}} → {{to}}',
				ATTRIBUTION_UNCHANGED: '変更なし',
				EFFECT_CHANGED_ANSWER: '回答を変更',
				EFFECT_SUPPORTED_ANSWER: '回答を支持',
				EFFECT_CONTRADICTED: '矛盾、不採用',
				EFFECT_NO_BEARING: '関連なし',
				EFFECT_NOT_ADDRESSED: '未対応',
			},
			WATCH: {
				STATUS_WATCHING: 'ウォッチ中',
				ACTION: 'ウォッチ',
				ACTION_HINT: 'この評価の後に記録されたデータで、後からこのアラートを再確認します',
				UNWATCH: 'ウォッチ解除',
				DIALOG_TITLE: 'アラートをウォッチ',
				DIALOG_LEAD: 'アラートは期限までウォッチされます。その後、この評価以降に記録されたすべての情報で再評価できます。',
				ASSESSED_AS_OF: '現在の評価の時点',
				ASSESSED_HINT: '表示中の評価のカットオフです。プリセットは今日からではなく、この時刻から数えます。',
				LOOK_AGAIN: '再確認のタイミング',
				PRESET_HOURS: '+{{count}} 時間',
				PRESET_DAYS: '+{{count}} 日',
				PRESET_CUSTOM: '日時を指定',
				DUE_AT: '期限',
				DUE_LINE: '期限 {{time}}',
				DUE_BEFORE_ASSESSMENT: '評価より後である必要があります',
				SUGGESTED: 'エージェントの提案',
				USE_SUGGESTION: '理由として使用',
				REASON: '理由',
				REASON_HINT: '期限時に確認する内容（必須）',
				CONFIRM: 'ウォッチ',
				SET_NOTICE: 'アラートをウォッチに設定しました',
				BANNER_DUE: 'ウォッチ期限到来',
				BANNER_WAITING: 'ウォッチ中',
				CHIP_DUE: '期限到来 · {{time}}',
				CHIP_WAITING: 'ウォッチ中 · 期限 {{time}}',
				TIP_DUE: 'ウォッチ中、{{time}} に期限到来：新しいデータで再評価してください',
				TIP_WAITING: '{{time}} までウォッチ中',
				SET_BY: '{{name}} が {{date}} に設定',
				BASELINE: '{{time}} 時点の評価をウォッチ中',
				CHECKING: 'その後に記録された内容を確認しています…',
				NOTHING_NEW: '評価以降、新しい記録はまだありません。',
				LATER_ALERTS: '後続のアラート',
				BEYOND: 'その後 +{{count}} 件',
				OPEN_LATER: 'このアラートを開く',
				SAP_RECORDS: 'SAP レコード',
				SUPERVISOR_REPORTS: 'スーパーバイザー報告',
				HISTORIAN: 'Historian',
				HOURS: '{{count}} 時間',
				ON_TAGS: '{{count}} タグ',
				WINDOW: '{{from}} から {{to}} までの新しいデータ',
				REASSESS: '新しいデータで再評価',
				REASSESS_HINT: 'カットオフを期限（現在より後にはしない）に移して再トリアージします。キャンバスで実行を追跡します',
				REASSESS_WAIT: 'ウォッチの期限到来後に利用できます',
				NEW_DATA: '新しいデータ',
				NEW_DATA_DOT: '期限到来、評価以降に記録されたデータあり',
				FILTER_LABEL: 'ウォッチ',
				FILTER_DUE: '期限到来',
				FILTER_WAITING: 'ウォッチ中（期限前）',
				REASSESSED_HEADER: '{{time}} 時点で再評価（初回評価 {{previous}} 時点：{{cls}}）',
			},
			SHELL: {
				TOGGLE: 'HIL ラベルを表示',
				TOGGLE_HINT: '比較のため、HIL（ヒューマン・イン・ザ・ループ）の審査ラベルとコメントを列として追加します。検証データのみで、トリアージエージェントの入力には使いません。',
				VALIDATION_ONLY: 'HIL（ヒューマン・イン・ザ・ループ）ラベルは検証データです。トリアージエージェントの入力には使いません。',
				COLUMN: 'HIL ラベル',
				NOT_VETTED: '未審査',
				NOT_VETTED_TIP: 'このアラートには HIL ラベルがありません',
				STATE: 'HIL 状態',
				COMMENT: 'コメント',
				ACTION_TAKEN: '実施した対応',
				RELIABILITY: '信頼度',
				INHERITED: '親エピソードから継承',
				AGREES: 'HIL と一致',
				DIFFERS: 'HIL と相違',
				AGREES_TIP: '当社の分類は HIL ラベルと一致',
				DIFFERS_TIP: '当社: {{ours}} · HIL: {{shell}}',
				AGREEMENT: 'トリアージ済み {{compared}} 件中 {{agree}} 件が HIL と一致',
				AGREEMENT_TIP: '絞り込み後のトリアージ済み（保留以外）で HIL ラベルがあるアラートと、同じ分類の件数。\nHIL ラベルは検証データで、エージェントの入力には使いません。',
				CARD_TITLE: 'HIL 審査',
				FILTER_LABEL: 'HIL ラベル',
				FILTER_NONE: '未審査',
				COLUMN_COMMENT: 'HIL コメント',
			},
			FACTS: {
				TITLE: '読み取った証拠 — 最古 → 最新（すべてカットオフ前）',
				HINT: '実行が各ソースから読み取った事実の期間です。すべてのクエリはカットオフで止まります。',
				CUTOFF: 'カットオフ {{time}}',
				COL_SOURCE: 'ソース',
				COL_OLDEST: '最古',
				COL_NEWEST: '最新',
				COL_GAP: 'カットオフ前',
				SOURCE_HISTORIAN: 'Historian',
				SOURCE_SAP_NOTIFICATION: 'SAP 通知',
				SOURCE_SAP_WORKORDER: 'SAP 作業指示',
				SOURCE_SUPERVISOR_REPORT: 'スーパーバイザー報告',
				SOURCE_ALERTS: 'アラート',
				SOURCE_MEMORY: 'メモリー',
				NOT_READ: '読み取った事実なし',
				POST_ALERT: 'アラート後の記録',
				POST_ALERT_NONE: '取得なし：すべてのクエリはカットオフで止まります',
				AFTER_CUTOFF: 'カットオフ後',
				GAP_SECONDS: '{{count}} 秒',
				GAP_MINUTES: '{{count}} 分',
				GAP_HOURS: '{{count}} 時間',
				GAP_DAYS: '{{count}} 日',
			},
			SENSOR: {
				MEASURE: {
					temperature: '温度',
					pressure: '圧力',
					differential_pressure: '差圧',
					level: 'レベル',
					flow: '流量',
					vibration: '振動',
					axial_position: '軸方向位置',
					speed: '回転数',
					current: '電流',
					power: '電力',
					voltage: '電圧',
					valve_position: 'バルブ開度',
					status: 'ステータス',
					composition: '組成',
				},
				GROUP: {
					vibration: '振動',
					bearing_temperature: '軸受温度',
					axial_position: '軸方向位置',
					speed_run: '回転数・運転状態',
					lube_oil: '潤滑油',
					seal_gas: 'シールガス',
					suction: '吸込',
					discharge: '吐出',
					cooling: '冷却',
					anti_surge: 'サージ防止',
					scrubber_level: 'スクラバーレベル',
					control_valve: '制御弁',
					motor_electrical: 'モーター電気',
					turbine: 'タービン',
				},
				ROLE: {
					process_value: 'プロセス値',
					setpoint: '設定値',
					controller_output: 'コントローラ出力',
					limit: '制限値',
					mode: 'モード',
					totaliser: '積算値',
				},
				GROUP_NONE: 'その他',
				COL_SENSOR: 'センサー',
				CONVENTION_ONLY: 'タグ命名規則のみ',
				TIP_MEASURES: '測定対象: {{value}}',
				TIP_WHY: '監視の理由（技術監視計画）',
				TIP_NO_REASON: 'このセンサーの監視理由は記録されていません。',
				TIP_CONVENTION: 'P&ID のタグ命名規則でのみ説明され、監視計画には含まれません。',
				TIP_ACTION: '推奨対応',
				TIP_UNIT: '単位: {{unit}}',
				TIP_LIMITS: '制限値: {{value}}',
				TIP_SOURCES: '出典: {{value}}',
				TIP_LOW: 'このセンサーはタグ名でのみ説明されるため、意味の確度は低めです。',
				LIMIT_LOW: '下限',
				LIMIT_HIGH: '上限',
			},
			CONNECTED: {
				USUALLY_LEADS: '通常 {{t}} 先行（r {{r}}）',
				USUALLY_LAGS: '通常 {{t}} 遅れる（r {{r}}）',
				USUALLY_WITH: '通常同時に動く（r {{r}}）',
				NOT_COUPLED: '通常は連動しない（r {{r}}）',
				USUAL_DELAY: '通常の遅れで動いた',
				NOT_USUAL_DELAY: '通常の遅れとは異なる',
				COUPLING_HINT: '運転中ベースラインでのこのセンサーとアラートタグの通常の関係：相関が最大となる遅れとその r。「通常の遅れ」は今回のタイミングと比較します。',
				TITLE: '接続システム',
				VERDICT: {
					upstream_led: '上流が先に変化した',
					service_related: '供給ユーティリティが同時に変化した',
					downstream_followed: '下流が追随した——変化はここから始まっている',
					moved_together: '接続ユニットが同時に変化した',
					isolated: '接続システムは安定——この機器に限定',
					background_drift: '接続ユニットは数日前からベースライン外（背景）',
					moved_unordered: '接続ユニットが変化、順序は不明',
					insufficient: '判断するにはセンサーが不足',
				},
				UPSTREAM: '上流',
				DOWNSTREAM: '下流',
				SERVICE: '供給ユーティリティ',
				REL_UPSTREAM: '上流',
				REL_DOWNSTREAM: '下流',
				REL_SERVICE: 'ユーティリティ',
				AS_OF: 'アラート時点で読み取り——アラート後の記録は使用しません',
				OF_SENSORS: '/ {{total}} センサーにデータあり',
				RATIO_HINT: '隣接ユニットのインターフェースセンサーのうち、アラート前に利用可能な読み値があったもの',
				ANCHOR_ONSET: 'アラートタグの開始',
				PLOT: 'アラートタグとインターフェースセンサー',
				PLOT_TITLE: '接続システムのプロット',
				PLOT_CAPTION: '黒 = アラートタグ · 灰色の網掛け = 機械停止 · 破線 = アラートタグの開始 · 灰色の帯 = 運転時ベースラインの ±3 sd 以内。クリックで拡大。',
				NEIGHBOURS: '接続ユニット',
				NEIGHBOURS_META: '{{total}} 個の接続ユニットを読み取り、{{moved}} 個が変化',
				EXPAND_ALL: 'すべて展開',
				COLLAPSE_ALL: '変化なしを折りたたむ',
				NO_NEIGHBOURS: '接続ユニットは読み取られませんでした。',
				OPEN_UNIT: 'このユニットをプロセスビューで開く',
				LINK_HIGH: 'リンク: 高',
				LINK_MEDIUM: 'リンク: 中',
				LINK_LOW: 'リンク: 低',
				LINK_HINT: '図面がこの2つのユニットの接続をどの程度確認できているか',
				STATE_MOVED: '変化',
				STATE_HELD: '安定',
				STATE_NO_DATA: 'データなし',
				SENSORS_N: '{{count}} センサー',
				COL_SENSOR: 'インターフェースセンサー',
				COL_STATE: '状態',
				COL_Z_LAST: 'z 直近',
				COL_Z_LAST_HINT: 'アラート前の最後の読み値の運転時ベースラインからの偏差（標準偏差単位）',
				COL_Z_DAY: 'z 24 時間',
				COL_Z_DAY_HINT: 'アラート前24時間の運転時ベースラインからの中央値偏差（標準偏差単位）',
				COL_ONSET: '逸脱の開始',
				NO_READINGS: 'アラート前に利用可能な読み値なし',
				RELIEF: '放出ヘッダー',
				MORE: 'もっと見る',
				LESS: '折りたたむ',
				DUR_MIN: '{{n}} 分',
				DUR_H: '{{n}} 時間',
				DUR_D: '{{n}} 日',
				TIMING_BEFORE: 'アラートタグの {{t}} 前に変化',
				TIMING_BEFORE_SHORT: '{{t}} 前',
				TIMING_AFTER: 'アラートタグの {{t}} 後に変化',
				TIMING_AFTER_SHORT: '{{t}} 後',
				TIMING_TOGETHER: 'アラートタグと同時に変化',
				TIMING_TOGETHER_SHORT: '同時',
				TIMING_EARLIER: 'アラートタグの {{t}} 前に開始——背景',
				TIMING_EARLIER_SHORT: '{{t}} 前 · 背景',
				TIMING_EARLIER_NO_DUR: 'アラートタグよりかなり前に開始——背景',
				TIMING_EARLIER_NO_DUR_SHORT: 'かなり前 · 背景',
				TIMING_HELD: 'ベースライン付近で安定',
				TIMING_NO_DATA: 'アラート前に利用可能な読み値なし',
				TIMING_UNCLEAR: '変化、タイミング不明',
			},
			GAPS: {
				TITLE: 'タグのない想定センサー（{{count}}）',
				LINK: 'タグのない想定センサー（{{count}}）',
				LINK_HINT: 'マシンテンプレートが想定するがヒストリアンのタグがないセンサー',
				EXPLAIN: 'これらは C3 アセットテンプレートがこのマシンに想定するセンサーですが、ヒストリアンのタグ ID に対応付けられなかったため、データを読み取れません。この一覧は参考情報であり、ここでは編集できません。',
				NONE: '未対応のセンサーはありません。',
				COL_MACHINE: 'マシン',
				COL_SENSOR: '想定センサー',
				COL_FAILURE_GROUP: '故障グループ',
				COL_UNIT_TYPE: '単位タイプ',
			},
			FLOC: {
				LEVEL_1: 'アセット',
				LEVEL_2: '施設',
				LEVEL_3: 'システム',
				LEVEL_4: 'サブシステム',
				LEVEL_5: '機器',
				PATH: 'FLOC パス',
				LEGEND_TITLE: 'FLOC レベル',
				LEGEND_HINT: 'すべての場所は SAP 機能場所（FLOC）コードで識別されます。レベルはアセットから機器までです。',
				TREE_FILTER_PLACEHOLDER: 'システムまたは機器を検索（名称または FLOC）…',
				SCOPE_N: '{{count}} 件の FLOC',
				SCOPE_TIP: 'キューはこの FLOC とその配下で絞り込まれています',
				SCOPE_CLEAR: '場所フィルターを解除',
				UNPLACED_TIP: '機能場所のないアラート',
				ALERTS_TOTAL: '{{count}} 件のアラート',
				SOURCE_ASSET_CODE: 'アセット名のコードから配置',
				SOURCE_WELL: '海底坑井番号から配置',
				SOURCE_TRAIN: 'トレインまたはパッケージのコードから配置',
				SOURCE_TAG_MAPPING: 'ヒストリアンのタグ対応から配置',
				EXTRACT_HAD: 'アラート抽出の FLOC は {{floc}}',
			},
			PMAP: {
				KEY_SENSORS: '主要センサー（{{count}}）',
				KEY_SENSORS_HINT: 'このユニットの状態を最もよく表すセンサー',
				TITLE: 'プロセスビュー',
				BUTTON: 'プロセスビュー',
				OPEN: 'プロセスビューを開く',
				OPEN_HINT: 'プラントエリアとプロセスユニット（P&ID の接続どおり）',
				BACK: 'キューに戻る',
				UNITS_META: '{{areas}} エリアの {{units}} プロセスユニット',
				LAYERS: '接続レイヤー',
				SECONDARY: '二次リンクを表示（{{count}}）',
				RELIEF: '放出 / フレア（{{count}}）',
				UTILITY: 'ユーティリティ（{{count}}）',
				CONTROL: '制御信号（{{count}}）',
				TARGET_ONLY: 'ターゲットのみ',
				LEGEND_BACKBONE: 'プロセスリンク',
				LEGEND_LINK: '二次リンク',
				LEGEND_RELIEF: '放出 / フレア',
				LEGEND_UTILITY: 'ユーティリティ',
				LEGEND_CONTROL: '制御信号',
				LEGEND_UP: '上流',
				LEGEND_DOWN: '下流',
				LEGEND_TARGET: 'ターゲット FLOC を含む',
				LEGEND_LOAD: 'アラート量',
				LANE_META: 'ユニット: {{units}} · アラート: {{alerts}}',
				LANE_TIP: '{{units}} ユニット、{{alerts}} 件のアラート、ターゲット FLOC を含むユニット {{targets}}',
				EXPAND_LANE: '{{name}} を展開',
				COLLAPSE_LANE: '{{name}} を折りたたむ',
				LINKS: 'プロセスユニット間の接続',
				EDGE_ARIA: '{{from}} から {{to}} への接続、{{medium}}',
				UNIT_ALERTS: '{{total}} 件のアラート（対象内 {{scope}}）',
				IN_SCOPE_N: '対象内 {{count}}',
				TARGETS_N: 'ターゲット FLOC {{count}} 件',
				SHEET_N: 'シート {{sheet}}',
				CHIP: 'プロセス: {{name}}',
				CHIP_HINT: 'このユニットでプロセスビューを開く',
				UNITS_LABEL: 'プロセスユニット',
				N_MORE: 'ほか {{count}} 件',
				FROM_TO: '{{from}} → {{to}}',
				MEDIUM: '媒体',
				CONFIDENCE: '信頼度',
				CONF_HIGH: '高',
				CONF_MEDIUM: '中',
				CONF_LOW: '低',
				WEAK: '弱いリンク',
				ONE_END: '1 枚の図面でのみ確認',
				TYPE: 'タイプ',
				LAYER_BACKBONE: 'プロセスリンク',
				LAYER_LINK: '二次リンク',
				LAYER_RELIEF: '放出 / フレア',
				LAYER_UTILITY: 'ユーティリティ',
				LAYER_CONTROL: '制御信号',
				CONNECTORS_N: '図面上のコネクター {{count}} 件',
				EVIDENCE_LOADING: '図面の根拠を読み込み中…',
				PANEL_ARIA: 'プロセスユニットの詳細',
				LOADING: '読み込み中…',
				SHOW_ALERTS: 'このユニットのアラートを表示',
				OPEN_EXPLORER: 'アセットエクスプローラーで開く',
				ALERTS: 'アラート',
				NO_ALERTS: 'アラートなし',
				DRAWINGS: '図面（{{count}}）',
				NO_DRAWINGS: 'このユニットに関連する図面はありません',
				OPEN_DRAWING: 'P&ID を開く',
				FLOCS: 'FLOC（{{count}}）',
				NO_FLOCS: 'このユニットに配置された FLOC はありません',
				OPEN_NODE: 'アセットエクスプローラーで開く',
				SHOW_FLOC_ALERTS: 'この FLOC のアラートを表示',
				SHARED_FLOCS: '他のユニットと共有（{{count}}）',
				INBOUND: '流入（{{count}}）',
				OUTBOUND: '流出（{{count}}）',
				NO_CONNECTIONS: '図面上に接続が見つかりません',
				SHOW_ALL: 'すべて表示（{{count}}）',
				SHOW_FEWER: '表示を減らす',
			},
			SEARCH_ALERTS_PLACEHOLDER: 'アラート、ID、定義 ID、タグ、FLOC を検索…',
			CANVAS: {
				CAUSAL: {
					QUERIES: '質問（{{n}}）',
					COL_HYPOTHESIS: '仮説',
					COL_FACET: '観点',
					COL_QUERY: '質問',
					COL_ADMITTED: '採用',
					NOTHING: '採用なし',
					ADMITTED: '採用された抜粋（{{n}}）',
					EXCERPTS_FROM_TRACE: '抜粋はステップのトレースから表示しています（先頭6件）。却下された結果は実行ドキュメントの読み込み後に表示されます。',
					REJECTED: '却下された結果（{{n}}）',
					NONE_REJECTED: '却下された結果はありません。',
					FACET_DESIGN_BASIS: '設計基準・運転範囲',
					FACET_ORIGINATING_CHANGE: '発端となった変更',
					FACET_MECHANISM_SENSITIVITY: 'メカニズムの感度',
					FACET_PROTECTION_DETECTION: '保護・検知',
					FACET_SYMPTOM_DIAGNOSTIC: '症状・診断',
					FACET_CORRECTIVE_ACTION: '是正措置',
				},
				TIER: {
					STAGE_QUICK: 'ステージ 1 · クイックトリアージ（ミニエージェント）',
					STAGE_DEEP: 'ステージ 2 · 詳細調査',
					QUICK_ANSWER: 'クイック回答',
					FINAL_ANSWER: '最終回答',
					OUTCOME: '結果',
					ACCEPTED: '採用',
					ESCALATED: 'エスカレーション',
					ROUTE_ACCEPTED: '採用 → 結果',
					ROUTE_ESCALATED: 'エスカレーション → ステージ 2',
					NO_GATE: 'ゲートなし（クイックのみの実行）',
					DECIDING: 'クイック回答を確認中…',
					WAITING: 'クイック回答を待機中',
					NOT_NEEDED: '不要 — クイック回答がゲートを通過したため、詳細調査の時間とトークンを節約しました。',
					NOT_RUN: '未実行 — この実行はクイックトリアージのみでした。',
					WOULD_HAVE_RUN: '実行されるはずだった処理',
					DEEP_SPECIALISTS: '低速スペシャリスト',
					SKIP_VERDICTS: '判定の再確認',
					SKIP_ADJUDICATION: '網羅性チェックと 2 回目の判定',
					CHECK_NO_ACTION: '対応不要の回答',
					CHECK_CONFIDENCE: '信頼度',
					CHECK_NOT_CAPPED: '上限なし',
					CHECK_MODEL: 'モデルが回答',
					CHECK_NO_REAL_EVENT: '実事象の判定なし',
					CEILING: '上限 {{pct}}',
					RULE_FALLBACK: 'ルールによる代替',
					QUICK_NODE_NOTE: 'ステージ 1 · クイックトリアージ：ゲート前のミニエージェントの処理です。',
					ESCALATED_NOTE: 'エスカレーション：少なくとも 1 つのチェックが不合格のため、詳細調査を実行しました。',
					ACCEPTED_NOTE: '採用：すべてのチェックに合格し、クイック回答が結果になりました。',
					CHECKS: 'ゲートチェック',
					COL_CHECK: 'チェック',
					COL_VALUE: '値',
					COL_THRESHOLD: 'しきい値',
					COL_RESULT: '結果',
					PASSED: '合格',
					FAILED: '不合格',
					REASONS: 'エスカレーションの理由',
					QUICK_VS_FINAL: 'クイック回答と最終回答',
				},
				TITLE: '実行キャンバス',
				OPEN: 'キャンバスを開く',
				OPEN_HINT: '実行を段階ごとに追跡：各エージェント、モデル呼び出し、照会',
				BACK: 'アラートに戻る',
				RUN_PICKER: '実行',
				RUN_PICKER_EMPTY: '実行履歴はまだありません',
				LIVE: 'ライブ',
				LIVE_HINT: '実行をリアルタイムで追跡中（1.5秒ごとに更新）',
				ELAPSED: '経過時間',
				DURATION: '所要時間',
				TOKENS: '入力 {{input}} / 出力 {{output}} トークン',
				EVALUATION: '評価',
				EVENTS_N: '{{count}}件のイベント',
				EVENTS_HINT: 'モデル呼び出し{{llm}}回 · 照会{{lookups}}回',
				ZOOM_FIT: '幅に合わせる',
				ZOOM_100: '実際のサイズ',
				POLL_ERROR: '新しいイベントを取得できません：{{error}} — 再試行中',
				LOADING: '実行を読み込み中…',
				NO_RUNS: 'このアラートには実行履歴がありません',
				NO_EVENTS: 'この実行にはイベントが記録されていません（実行キャンバス導入前の実行です）',
				PICK_NODE: 'ノードを選択すると、入力と出力を確認できます',
				IN_PROGRESS: 'トリアージエージェントを実行中です。このページを離れても実行は続きます。',
				STALLED_NOTICE: '実行との接続が失われました。ページを更新すると結果が表示されます。',
				RECONSTRUCTED: '保存されたトレースから再構成：この実行はイベントストリーム導入前のため、入力・出力・モデル呼び出し・照会は利用できません。',
				PASS_N: 'パス {{n}}',
				ROUND_N: 'ラウンド {{n}}',
				STATUS: {
					RUNNING: '実行中',
					COMPLETED: '完了',
					FAILED: '失敗',
					GATED: '未分析',
					PENDING: '待機中',
					NO_DATA: 'データなし',
					SKIPPED: 'スキップ',
					STALLED: '接続断',
				},
				COL: {
					PRE_RUN: '事前処理',
					RESOLVE: '解決とシグナル',
					SPECIALISTS: '専門エージェント',
					VERDICTS: '判定',
					LOOP: '推論ループ',
					DECISION: '決定',
				},
				NODE: {
					LIBRARY_CAUSAL: 'ライブラリ・因果的根拠付け',
					ESCALATION: 'エスカレーションゲート',
					LIBRARY: 'ライブラリ担当',
					CONNECTED: '接続システム',
					GATE: 'DQゲート',
					TOPOLOGY: 'トポロジー',
					EVIDENCE: 'エビデンス',
					VIEW: '時点ビュー',
					FINAL: '結果',
					RESOLVER: 'リゾルバー',
					SIGNAL: 'シグナル',
					COHORT: 'コホート',
					MAINTENANCE: '保全',
					MANUAL_PRECEDENT: 'アラートの先例',
					LEARNINGS: 'ラーニング',
					PROFILE: 'プロファイル',
					MULTIVARIATE: '多変量',
					TMP: 'TMP',
					SHIFT_DPR: 'シフト・DPR',
					VISUAL: 'ビジュアル分析',
					VERDICTS: '判定',
					HYPOTHESIZE: '仮説',
					INVESTIGATE: '調査',
					COMPLETENESS: '完全性',
					ADJUDICATOR: '裁定',
					SUPERVISOR: 'スーパーバイザー',
				},
				BADGE: {
					CAUSAL_N: '抜粋 {{admitted}} 件・質問 {{queries}} 件',
					HEADROOM: '{{kind}} {{value}} · {{pct}}%',
					LIBRARY_N: '抜粋 {{n}} 件 · 文書 {{docs}} 件',
					LIBRARY_LIMITS: '抜粋 {{n}} 件 · 制限値 {{limits}} 件',
					GATE_PASS: '合格',
					GATE_FAIL: '不合格',
					TAGS_N: '{{count}}タグ',
					RECORDS_N: '{{count}}件のレコード',
					WITHHELD_N: '{{count}}件除外',
					RESOLVED: '解決済み',
					NOT_RESOLVED: '未解決',
					ALERTS_N: '{{count}}件のアラート',
					FACTS_N: '{{count}}件の事実',
					PRIOR_N: '{{count}}件の先行',
					LEARNINGS_N: '{{count}}件のラーニング',
					LOADED: '読み込み済み',
					NONE: 'なし',
					MOVED_N: '{{of}}件中{{moved}}件が変動',
					VERDICTS_N: '{{count}}件の判定',
					LOOKUPS_N: '{{count}}回の照会',
					CHECKS_N: '{{of}}件中{{ran}}件のチェック',
					SPECIALISTS_N: '{{of}}件中{{n}}件の専門エージェント',
				},
				BATCH_BADGE: '{{floc}} の {{count}} 件のアラートのバッチ',
				BATCH_HINT: '1 つのエピソードとしてまとめてトリアージ: {{ids}}',
				REASSESS_BADGE: '{{t}} 時点での再評価',
				REASSESS_HINT: '以前の評価: {{cls}}',
				ZONE: {
					EVIDENCE: '証拠収集',
					PARALLEL: '並列',
					LOOP: '推論ループ',
					DECISION: '判定',
				},
				LOOP: {
					CAUSAL_HINT: 'ボードの最初のパスの後、ライブラリは仮説ごとに技術的な質問（設計基準、変更、感度、保護、診断、是正措置）を行い、この計器または機器に関する抜粋のみを LIB-n の証拠として採用します',
					BOARD: '仮説ボード',
					INVESTIGATOR: '調査担当',
					ROUND_OF: 'ラウンド {{n}}（最大 {{max}}）',
					HINT: 'ボードが仮説を立てて照会し、調査担当が調べ、ボードが重みを付け直す',
					ROUNDS_USED: '{{n}} / 最大 {{max}} ラウンド',
					REQUESTS_N: '{{count}} 件の依頼',
					REWEIGH: '結果 → 再評価',
					LEAD_HINT: '首位の仮説、その重み、前のパスからの変化',
					WEIGHING: '仮説を評価中…',
					NEXT_PASS: '次のパス: 再評価',
					CALL_NO_HINT: 'この実行での {{tool}} の {{n}} 回目の呼び出し',
					CITED_HINT: '次のパスで引用: {{hyps}}',
					REPEAT_OF: 'ラウンド {{n}} と同じ',
					CALLING: '照会を実行中…',
					MOVED: 'パス {{n}}:',
					MOVED_HINT: 'このラウンドの結果を読んだ後のボードの変化',
					SETTLED_FIRST: 'パス {{n}} で確定: 照会は不要',
					SETTLED_AT: 'パス {{n}} で確定: これ以上の照会は不要',
					BUDGET_SPENT: 'ラウンドの上限に到達（{{max}}/{{max}}）',
					SHELF: 'ツール棚',
					SHELF_HINT: '調査担当はどのツールも、引数を変えて何度でも呼び出せる',
					UNUSED: 'この実行では未使用',
				},
				TOOL: {
					SEARCH_LIBRARY: 'ライブラリ検索',
					SEARCH_LEARNINGS: '学習を検索',
					CONNECTED_EQUIPMENT: '接続機器',
					UNIT_SENSORS: 'ユニットのセンサー',
					FIND_SENSORS: 'センサー検索',
					PARALLEL_SYSTEMS: '並列系統',
					SISTER_TRAIN: '姉妹トレイン',
					UNIT_ALERTS: 'ユニットのアラート',
					TAG_WINDOW: 'タグの時間窓',
					TAG_HISTORY: 'タグ履歴',
					SEARCH_RECORDS: '記録検索',
					SEARCH_REPORTS: 'レポート検索',
				},
				TOOL_HINT: {
					SEARCH_LEARNINGS: 'アラート時点で有効な学習とサイト運用手順のルールを、質問との意味の近さで並べ替えます。',
					CONNECTED_EQUIPMENT: '上流・下流・隣接するプロセスユニット（フロー図のコネクタから）、そのインターフェースセンサー、およびアラートタグの前・同時・後のいずれで変化したか。',
					UNIT_SENSORS: '指定したプロセスユニットが、依頼された測定量についてセンサーごとにどう振る舞ったか。',
					FIND_SENSORS: 'ある問いに対してどのセンサーがあり、それぞれ何を測定しているか。',
					PARALLEL_SYSTEMS: '双子トレイン（FGC A ↔ B、GLC A ↔ B …）: 同じ時間帯のセンサーとアラート — 共通原因か局所的か？',
					SISTER_TRAIN: 'もう一方のトレイン、または同じループの冗長プローブ: 共通原因か局所的か？',
					UNIT_ALERTS: 'アラート前の数時間にユニット（上流・下流・双子）で発生した監視アラート。',
					TAG_WINDOW: 'アラート前の直近 N 時間における任意のタグの統計。',
					TAG_HISTORY: '最大 180 日間にタグが通常範囲を外れた頻度と、その後に作業があったか。',
					SEARCH_RECORDS: 'SAP 通知・作業指示（1 年）とシフト報告（6 か月）のキーワード検索。',
					SEARCH_REPORTS: '最大 1 年前までの監督者・生産レポート。すべての語が一致する必要があり、該当箇所を返す。',
				},
				CALL: {
					NTH: 'この実行での {{tool}} の #{{n}} 回目の呼び出し',
					ARGS: '引数',
					NO_ARGS: '引数なし',
					REPEAT_NOTE: 'ラウンド {{n}} の依頼と同一: 再実行せず、以前の結果を引き継ぎました。',
					CITED: 'パス {{n}} で引用',
					CALLS_N: '{{count}} 回の呼び出し',
					ROUNDS_LIST: 'ラウンド {{rounds}}',
					NOT_USED: 'この実行では調査担当はこのツールを使用していません。',
					GROUPED: '{{count}} 件の照会 · 使用ツール数: {{tools}}',
					CARRIED: '以前のラウンドの観察 {{count}} 件を引き継ぎ',
				},
				EVO: {
					TITLE: '証拠が確信をどう動かしたか: パスごとの仮説の重み',
					HYPOTHESIS: '仮説',
					AFTER_N: 'ラウンド {{n}} 後 · {{count}} 件の照会',
					NOT_ON_BOARD: 'このパスではボードにない',
					AFTER_ROUND: 'ラウンド {{n}} 後（{{count}} 件の照会）',
					CITES: '新しい証拠が {{calls}} を引用',
					MOVE_AFTER: 'ラウンド {{n}} 後:',
					PRECEDED_BY: '先行した照会:',
				},
				INSPECTOR: {
					TAB_INPUT: '入力',
					TAB_OUTPUT: '出力',
					TAB_MODEL_CALLS: 'モデル呼び出し',
					TAB_LOOKUPS: '照会',
					TAB_TRACE: 'トレース',
					EMPTY: '空',
					NOT_STARTED: 'このステップはまだ開始していません',
					NO_INPUT: 'このステップの入力は記録されていません',
					STILL_RUNNING: '実行中 — ステップ完了後に出力が表示されます',
					NO_OUTPUT: '出力は記録されていません',
					HYPOTHESES_N: '{{count}}件の仮説',
					REQUESTS: '要求された照会',
					WINDOWS: 'ウィンドウ別の読み取り',
					LEAK_CHECK: 'リークチェック：{{value}}',
					MACHINE_STATE: '機器の運転状態',
					PACKAGE_TEXT: 'モデルが読むシグナルパッケージ',
					ANOMALY_TEXT: '異常モデルのテキスト',
					NO_LOOKUPS: 'このステップに照会はありません',
					RAW: '出力全体（データ）',
					NO_MODEL_CALLS: 'このステップにモデル呼び出しはありません',
					ATTEMPT_N: '試行 {{n}}',
					PROMPT: 'プロンプト',
					PROMPT_SIZE: '{{chars}}文字、画像{{images}}枚',
					IMAGE_PART: '画像（{{kb}} KB）',
					RESPONSE: '応答',
					NO_TRACE: 'このノードにトレース行はありません',
				},
			},
			VALIDATION: {
				COLUMN: '検証',
				FILTER: '検証',
				HUMAN: '人',
				AGENT: 'エージェント',
				NONE: '未トリアージ',
				HUMAN_VALIDATED: '人が検証済み',
				HUMAN_CORRECTED: '人が修正済み',
				AGENT_VALIDATED: 'エージェントが検証済み',
				TIP_AGENT: 'エージェントがトリアージ済み。まだ人による確認はありません',
				TIP_HUMAN_UNKNOWN: '人が検証済み',
				TIP_REPLAY: 'HIL ラベルを {{reviewer}} が {{date}} に再生',
				TIP_UI: '{{reviewer}} が {{date}} に UptimeAI で確認',
				TIP_CORRECTED: '人がエージェントを修正：{{agent}} → {{human}}',
				TIP_ABSTAINED: 'エージェントは人による確認に委ねました。人の分類：{{human}}',
				TIP_AGREED: '人がエージェントに同意：{{human}}',
				CSV: {
					VALIDATED_BY: '検証者',
					REVIEWER: '確認者',
					REVIEW_SOURCE: '確認元',
				},
			},
			REVIEW: {
				TITLE: 'SMEレビュー',
				SOURCE_REPLAY: 'HILラベル（再生）',
				SOURCE_UI: 'UptimeAI で確認',
				BY: '{{reviewer}} · {{date}}',
				N_REVIEWS: '確認 {{count}} 件',
				LABEL: 'ラベル',
				RELIABILITY: '信頼度：{{value}}',
				RELIABILITY_HIGH: '高',
				RELIABILITY_MEDIUM: '中',
				RELIABILITY_LOW: '低',
				RELIABILITY_HINT: 'このラベルを正解としてどこまで信頼できるか（人のラベルも誤ることがあります）',
				ACTION_TAKEN: '実施した対応',
				NO_LABEL: 'ラベルの記録なし',
				AGENT_VS_HUMAN: 'エージェント vs 人',
				AGREEMENT_AGREE: '一致',
				AGREEMENT_DISAGREE: '不一致',
				AGREEMENT_ABSTAINED: '判断保留',
				AGENT_CONFIDENCE: 'エージェントの確信度 {{value}}',
				OUTCOMES: 'その後 30 日間の SAP 通知（事後）',
				REASONS: '理由',
				AGENT_SAW_CHART: 'エージェントのチャート判断',
				AGENT_SAW_STATE: '当時の機械状態',
				LEARNINGS_CHANGED: 'この確認で更新された学習（{{count}}）',
				EARLIER: '以前の確認',
				VERDICT: {
					CONFIRMED: '確認済み',
					CONFIRMED_HINT: 'エージェントと人が同じ分類を選択しました。',
					AGENT_WRONG: 'エージェントの誤り',
					AGENT_WRONG_HINT: '確認者の分類がエージェントより優先され、エージェントは修正されました。',
					AGENT_ABSTAINED: 'エージェントは判断保留',
					AGENT_ABSTAINED_HINT: 'エージェントは人による確認に委ね、人のラベルで分類が決まります。',
					HUMAN_LIKELY_WRONG: '人の誤りの可能性',
					HUMAN_LIKELY_WRONG_HINT: '対応不要とラベル付けされましたが、30 日以内にこの設備で SAP 通知が発生したため、メモリには含めません。',
					CONTESTED: '係争中',
					CONTESTED_HINT: 'エージェントと人の判断が異なり、その後の証拠でも決着していません。',
					HUMAN_OVERRIDE: '人による上書き',
					HUMAN_OVERRIDE_HINT: 'UptimeAI で人がエージェントと異なる分類を選択し、その判断が優先されます。',
				},
			},
			MEMORY: {
				SIMILAR: '類似 {{sim}}',
				SIMILAR_HINT: 'このアラート自体の範囲外ですが、意味がアラートに近いため追加されました（類似度0〜1）',
				PROFILE: '検知器プロファイル',
				TITLE: '使用した運用メモリ',
				CHIP: 'メモリ：学習 {{learnings}} 件、確認済みの前例 {{precedents}} 件',
				CHIP_HINT: 'このアラート以前に判明していた、エージェントが参照した学習と人が確認した前例',
				NO_LEARNINGS: '適用された学習なし',
				PRECEDENTS: '確認済みの前例 {{count}} 件',
				SHOW_TRACE: 'トレースで表示',
			},
			LEARNINGS: {
				STATUS_RETIRED: '廃止',
				SCOPE_PLAYBOOK: 'サイト運用手順',
				SCOPE_PROFILE: '検知器プロファイル',
				ALL_SCOPES: 'すべての範囲タイプ',
				MEANING_PLACEHOLDER: '意味で検索（例：再起動後の軸受温度）',
				MEANING_SEARCH: '検索',
				MEANING_HINT: '入力した語句と意味がどれだけ近いか（埋め込み）で現在の学習を並べ替えます。完全一致ではありません。Enterで検索、空欄にすると全件表示します。',
				RANKED_BY: '意味で並べ替え：「{{q}}」',
				COL_SIMILARITY: '類似度',
				SIMILARITY_HINT: '意味のコサイン類似度（0〜1）。約0.8以上で近い一致',
				COL_LEARNING: '学習',
				COL_EDITED: '編集者',
				EDITED_BY: '{{name}} が編集',
				EDIT_REASON: '理由：{{reason}}',
				NO_DISPOSITION: 'なし（参考情報）',
				N_ALERTS: 'アラート {{count}} 件',
				NO_MATCH: '意味の近い学習はありません',
				NO_MATCH_HINT: '別の語句を試すか、検索を消去してすべての学習を表示してください。',
				BUTTON: '学習',
				BUTTON_HINT: '人による確認から得た学習と運用メモリ',
				TITLE: '学習と運用メモリ',
				SUBTITLE: '類似アラートに対する人の確認から得たルール。エージェントは各アラート以前に判明していたものだけを参照します',
				REFRESH: '更新',
				STAT_REVIEWS: '人による確認',
				STAT_REPLAYED: 'HIL ラベル再生 {{count}} 件',
				STAT_IN_APP: 'UptimeAI で {{count}} 件',
				STAT_AGREEMENT: 'エージェント vs 人',
				STAT_RECONCILIATION: '照合結果',
				STAT_LEARNINGS: '学習',
				STATUS_ACTIVE: '有効',
				STATUS_CANDIDATE: '候補',
				STATUS_CONTESTED: '係争中',
				SCOPE_SIGNAL: 'シグナル',
				SCOPE_EQUIPMENT: '設備 + 検知器',
				SCOPE_DETECTOR: '検知器',
				SEARCH: '範囲・検知器・ルールを検索',
				N_SHOWN: '{{total}} 件中 {{shown}} 件',
				EMPTY: '学習はまだありません',
				EMPTY_HINT: '人がトリアージ済みアラートを確認すると学習が表示されます。',
				COL_SCOPE: '範囲',
				COL_SCOPE_TYPE: '範囲の種類',
				COL_DISPOSITION: '処置',
				COL_SUPPORT: '支持',
				COL_SUPPORT_HINT: '処置と一致する確認数 / 範囲内の確認数 · 一貫性',
				COL_STATUS: 'ステータス',
				COL_EFFECTIVE: '有効開始',
				COL_CORRECTED: 'エージェント修正',
				COL_CORRECTED_HINT: '人がエージェントを修正した確認の数',
				COL_VERSION: 'バージョン',
				RULE: '運用ルール',
				AUTHOR: '作成者：{{author}}',
				CLASS_COUNTS: '人の分類',
				REASONS: '理由',
				CHART_PATTERNS: 'チャートのパターン',
				MACHINE_STATES: '機械状態',
				SOURCE_ALERTS: '元のアラート（{{count}}）',
				OPEN_ALERT: 'アラートを開く',
				VERSIONS: 'バージョン履歴',
				SUPERSEDED: '置き換え',
				CURRENT: '現行',
			},
			PROCESS: {
				TITLE: 'プロセストポロジーと階層',
				FLOW_SUMMARY: '上流 {{up}} · 下流 {{down}}',
				FLOW_SUMMARY_UNITS: '上流 {{up}} · 下流 {{down}}（プロセスユニット）',
				PROCESS_UNITS: 'プロセスユニット（PEFS）',
				NO_PID_LINE: 'デジタル化P&IDで配管が追跡されていません。フロー図の接続子からのリンクです',
				IN_UNIT: 'プロセスユニット: {{name}}',
				SERVING: '供給ユーティリティ',
				RELIEF: '放出',
				UNIT_TIP: '{{hops}} ホップ · {{media}} · 信頼度 {{confidence}}',
				SOURCE_PID: 'デジタル化P&IDの機器フロー（1図面内で追跡した配管）。',
				SOURCE_BOTH: 'デジタル化P&IDの機器フロー（図面ごと）と、PEFSの図面間接続子によるプロセスユニット（接続システム分析と同じ情報）。',
				HIERARCHY: '資産階層',
				LEVEL_SITE: 'サイト',
				LEVEL_SYSTEM: 'システム',
				LEVEL_SUBSYSTEM: 'サブシステム',
				LEVEL_EQUIPMENT: '設備',
				LEVEL_PACKAGE: 'パッケージ',
				LEVEL_OTHER: '階層',
				NOT_IN_TREE: '資産ツリーにありません',
				NOT_IN_TREE_HINT: 'アラート設備には SAP 資産ツリー上の機能場所がありません。',
				PARTIAL_TREE: 'パスの一部のみ資産ツリーに配置できました。',
				SIBLINGS: '{{parent}} 内の他の設備 {{count}} 件',
				SHOW_ALL: '{{count}} 件すべて表示',
				SHOW_FEWER: '表示を減らす',
				N_TAGS: '{{count}} タグ',
				NO_TREE_TAGS: 'このノードにはヒストリアンタグがありません',
				FLOW: 'プロセスフロー',
				UPSTREAM: '上流',
				DOWNSTREAM: '下流',
				ALERT_EQUIPMENT: 'アラート設備',
				MEASURED_BY: 'アラート計器',
				HOPS: '{{count}} ホップ先',
				NONE_UPSTREAM: '上流なし',
				NONE_DOWNSTREAM: '下流なし',
				NO_FLOW: 'デジタル化された P&ID に、この設備のプロセスフロー接続はありません',
				NOT_IN_PIDS: 'デジタル化された P&ID に設備が見つかりません',
				NOT_IN_PIDS_HINT: 'アラート設備に一致する P&ID がないため、上流・下流を表示できません。',
				CONNECTED: '接続項目',
				NO_CONNECTED: 'デジタル化された P&ID で、この設備に接続された他の項目はありません。',
				EDGE_SERVES: '供給先',
				EDGE_SENSES: '検出',
				EDGE_CONTROLS: '制御',
				EDGE_PROTECTS: '保護',
				EDGE_SAME_LINE: '同一プロセスライン',
				EDGE_MEASURES: '計測',
				EDGE_FLOWS_TO: '流れ先',
				EDGE_OTHER: 'その他の接続',
				CHART_TAGS: 'この項目のタグを「タグ」タブにチャート表示',
				NO_TAGS_FOR_ITEM: 'この項目に紐づくヒストリアンタグはありません',
				NO_DATA_TAGS: '資産ツリーではこの項目にタグが割り当てられていません',
				TAGS_FAILED: 'この項目のタグを読み込めませんでした',
				FROM_TREE: '資産ツリーによるタグ数',
				CLICK_HINT: '項目をクリックするとヒストリアンタグをチャート表示します（最大 8 件、データのあるタグを優先）。',
			},
			ANALYSIS: {
				FOUND_BY_MEANING: '意味検索で発見',
				FOUND_BY_MEANING_SIM: '意味検索で発見 · {{sim}}',
				FOUND_BY_MEANING_HINT: 'ハイブリッド検索：記録は語句と意味（埋め込み）の両方で検索されます。この記録は同じサブシステムから意味検索で追加されました。数値はアラートとの類似度（0〜1）です。',
				LEVEL_SHIFTS: 'レベルシフト',
				LEVEL_SHIFTS_HINT: 'カットオフ前に、モデル化したタグが新しい水準へ移り、そのまま留まった時点（大きさはベースライン標準偏差、前の平均 → 後の平均）。',
				MODEL_CACHED: 'モデル再利用（機械ごとに1日1回学習）',
				MODEL_CACHED_HINT: '同じ機械にはこの日の学習済みモデルがあり、学習データはすべて今回のカットオフより前で終わっています。再学習せずに再利用しました。',
				REGIMES: '{{tag}} の運転状態ごとに適合：{{parts}}（{{sep}} sd 離れている）',
				REGIMES_HINT: '運転タグに2つの異なる運転水準（時間比率 @ 水準）があったため、それぞれ別に正常状態を学習しました。',
				TRAINED_ON: '学習期間：{{from}} – {{to}}',
				WINDOW_3M: '3 か月',
				WINDOW_1W: '1 週間',
				WINDOW_1D: '1 日',
				REASONING: '推論',
				SETTLED: '結論済み',
				UNSETTLED: '未結論',
				SETTLED_HINT: 'これ以上の照会で有力仮説が変わらないため、仮説ボードは終了しました',
				UNSETTLED_HINT: '照会の要求が残ったまま、ボードはパス上限で終了しました',
				BOARD_META: '{{passes}} パス · {{lookups}} 件の照会',
				HYPOTHESES: '仮説',
				WEIGHT_HINT: 'ボード上でのこの仮説の重み（全仮説の合計は 100%）',
				IMPLIES_HINT: 'この仮説が成り立つ場合の分類',
				STATUS_VALIDATED: '検証済み',
				STATUS_REFINED: '修正済み',
				STATUS_DEBUNKED: '否定',
				STATUS_OPEN: '未確定',
				FOR: '支持',
				AGAINST: '反証',
				NONE: 'なし',
				CONFLICTS: '矛盾点',
				LOOKUPS: '調査担当の照会',
				ROUND_N: 'ラウンド {{n}}',
				ROUND_OTHER: 'その他の照会',
				WHY_ASKED: '照会理由：',
				RESULT: '結果',
				SIGNAL_TITLE: 'シグナルと設備',
				N_TAGS: '{{n}} タグ',
				RUNNING_AT_CUTOFF: '基準時刻に運転中',
				STOPPED_AT_CUTOFF: '基準時刻に停止中',
				SINCE_RESTART: '再起動から',
				SINCE_STOP: '停止から',
				HOURS: '{{n}} 時間',
				LAST_SHUTDOWN: '直近の停止',
				ONGOING: '継続中',
				RUN_SOURCE: '運転状態：{{source}}（{{tag}}）',
				RUNNING_PCT_HINT: 'ウィンドウ内で設備が運転していた割合（緑）と停止していた割合（赤）',
				RUNNING: '運転',
				SHUTDOWNS: '回停止',
				DOWN: '停止',
				MACHINE_UNKNOWN: '運転状態は不明です：この設備には運転状態タグがありません。',
				CHARTS_READ: 'モデルが読み取ったチャート',
				ANOMALY_SCORE: '異常スコア',
				ENLARGE: 'クリックで拡大',
				READ_ALERT_TAG: 'アラートタグ',
				READ_RELATED: '関連タグ',
				READ_MACHINE: '設備',
				READ_ANOMALY: 'モデルの読み取り',
				CONSISTENT_WITH_HISTORY: '履歴と整合',
				NOT_CONSISTENT_WITH_HISTORY: '履歴と不整合',
				STATS_TITLE: '統計とベースラインの比較',
				STATS_HINT: '— セルにカーソルを合わせると p5–p95、傾き、初めて 3 sd を超えた時刻を表示',
				COL_TAG: 'タグ',
				COL_MEDIAN: '中央値',
				COL_LAST: '最新',
				COL_Z: 'z（中央値）',
				COL_Z_HINT: 'ウィンドウ中央値をベースラインの標準偏差で表した値',
				COL_OUT: '範囲外 %',
				COL_OUT_HINT: 'ベースラインの p5–p95 帯の外にある読み取り値の割合',
				ALERT_TAG: 'アラート',
				RUN_TAG: '運転',
				TIP_BASELINE: 'ベースライン：中央値 {{median}} ± {{sd}} sd、p5–p95 {{p5}}–{{p95}} {{unit}}',
				TIP_SPIKES: '除去したスパイク：{{value}}',
				TIP_MASKED: 'マスクした異常読み取り値：{{n}}',
				TIP_RANGE: 'p5–p95：{{p5}} – {{p95}} {{unit}}',
				TIP_SLOPE: '傾き：{{value}} {{unit}}/日',
				TIP_Z_LAST: 'z（最新）：{{value}} · 最大 |z|：{{max}}',
				TIP_FIRST_3SD: '初めて 3 sd を超えた時刻：{{value}} UTC',
				TIP_NEVER_3SD: 'このウィンドウでは 3 sd を超えていません',
				FOOT_SPIKES: '統計の前に除去した孤立スパイク：{{value}}。',
				FOOT_MASKED: '異常読み取り値 {{n}} 件（品質不良 / 範囲外）をマスクしました。',
				ANOMALY_TITLE: '異常検知モデル',
				NOT_AVAILABLE: '利用不可',
				VERDICT_CONSISTENT: '整合',
				VERDICT_CHANGED: '変化あり',
				VERDICT_STARTUP: '起動時の過渡状態',
				VERDICT_INSUFFICIENT: 'データ不足',
				MODEL_META: 'PCA {{k}} 成分 · 分散 {{pct}} · 学習データ {{rows}} 行',
				ONSET: '持続的な逸脱の開始',
				NO_ONSET: 'なし',
				FIRST_TO_DEVIATE: '最初に逸脱したタグ',
				ABOVE_LIMIT_24H: '直近 24 時間の限界超過率',
				T2_SPE_HINT: 'スコアは学習データの 99.5 パーセンタイルに対する相対値です（1.0 = 限界）。T² が高い = タグが連動して通常と異なる運転点へ移動；SPE が高い = あるタグが他のタグと合わなくなった（局所的な故障または計器）；AE = オートエンコーダの再構成誤差。',
				AT_CUTOFF: '基準時刻',
				AT_PEAK: '直近 24 時間のピーク',
				IN_TRANSIENT: '起動時の過渡状態内',
				SCORE: 'スコア',
				KIND_NORMAL: '正常範囲内',
				KIND_SPE: '関係の崩れ（SPE）：あるタグが他のタグと合わない',
				KIND_T2: '運転点の移動（T²）：タグが連動して変化し、関係は維持',
				KIND_BOTH: '通常と異なる運転点かつ関係の崩れ',
				ACTUAL_VS_EXPECTED: '実測値と他タグからの期待値',
				NOT_MODELLED: 'モデル対象外（運転履歴が不足）：{{tags}}',
				RECORDS_TITLE: '読み取った記録',
				OPEN_KNOWN_ISSUE: '未完了の既知の問題あり',
				NO_OPEN_KNOWN_ISSUE: '未完了の既知の問題なし',
				OPEN_KNOWN_ISSUE_HINT: 'アラート時点で、未完了の通知または作業指示がこの状態をすでにカバーしているか',
				RECORDS_COUNT: '{{total}} 件中 {{read}} 件を読み取り · {{cited}} 件を引用',
				RECORDS_COUNT_HINT: 'アラート前の記録：保全 {{work}} 件、シフトレポート {{reports}} 件、生産損失 {{deferments}} 件。上位の記録を読み取りました',
				OPERATING_EVENTS: 'アラート前の運転イベント',
				FACTS: '引用した事実',
				NO_FACTS: 'このアラートに関係する記録はありません。',
				RELEVANCE_DIRECT: '直接',
				RELEVANCE_RELATED: '関連',
				RELEVANCE_BACKGROUND: '背景',
				IMPL_KNOWN_ISSUE: '既知の問題が未完了',
				IMPL_RECENT_WORK: '最近の作業で説明可能',
				IMPL_OPERATING_EVENT: '運転イベント',
				IMPL_INSTRUMENT: '計器の問題',
				IMPL_DEGRADATION: '劣化の兆候',
				DIR_NO_ACTION: '対応不要を支持',
				DIR_SERVICE: 'サービス作成を支持',
				DIR_NEUTRAL: '中立',
				OPEN_IN_MAINTENANCE: '「保全」タブで表示',
				OPEN_IN_REPORTS: '「レポート」タブで表示',
				DROPPED: '読み取ったが関係なし {{n}} 件：{{ids}}',
			},
			VISUAL: {
				TITLE: 'チャートレビュー',
				PATTERN_TOGETHER: 'タグが連動して変化',
				PATTERN_DEPARTED: '1 つのタグのみ逸脱',
				PATTERN_SHUTDOWN: '停止 / 起動',
				PATTERN_NO_CHANGE: '有意な変化なし',
				PATTERN_SPLIT: '関連タグの挙動が分かれる',
				PATTERN_INSUFFICIENT: 'データ不足で判断不可',
				PATTERN_UNKNOWN: '未分類',
				CONFIDENCE: '信頼度 {{value}}',
				CONFIDENCE_HINT: '最終判断の信頼度',
				MOVED_TOGETHER_YES: '連動あり',
				MOVED_TOGETHER_NO: '連動なし',
				DISAGREE: '統計とチャートの判断が一致しません。この判断に頼る前にチャートを確認してください。',
				AGREE: 'チャートは統計と一致',
				STATISTICS_SAY: '統計の判断',
				CHARTS_SAY: 'チャートの判断',
				LED_BY: '先行タグ',
				LED_BY_HINT: '最初に変化したタグ',
				DEPARTED_ALONE: '単独逸脱',
				DEPARTED_ALONE_HINT: '関連タグが安定している間に変化したタグ',
				REASONING: '根拠',
				CHARTS: 'モデルが読み取ったチャート（{{count}}）',
				NO_CHARTS: 'この実行ではチャート画像が保存されていません。',
				OPEN_CHART: 'チャート {{n}} を開く',
				CHART_ALT: 'アラート時刻までのチャート {{n}}',
				CHART_FAILED: 'チャート画像を読み込めませんでした',
				CHART_N_OF: 'チャート {{n}} / {{total}}',
				CHART_DIALOG_HINT: 'チャートはアラート時刻の直前で終わります。← / → で切り替えます。',
				PREV_CHART: '前のチャート',
				NEXT_CHART: '次のチャート',
				REVIEWS: 'タグ別レビュー（{{count}}）',
				LEVEL: 'レベル: {{value}}',
				FLUCTUATION: '変動: {{value}}',
				MODEL: 'レビュー: {{model}}',
			},
			CONTEXT: {
				MODE_PID: 'P&ID',
				MODE_GRAPH: 'コンテキストグラフ',
				CHOOSE_DRAWING: '図面を選択',
				ITEMS_COUNT: 'ハイライト {{count}} 件',
				HAS_INSTRUMENT: 'アラート計器',
				HAS_EQUIPMENT: 'アラート機器',
				TITLE_INSTRUMENT: '{{tag}} の計器位置（ハイライト）',
				TITLE_EQUIPMENT: '{{tag}} の機器位置（ハイライト）',
				LOADING: 'プロセスコンテキストを読み込み中…',
				LOAD_FAILED: 'このアラートのプロセスコンテキストを読み込めませんでした。',
				UNRESOLVED: 'アラートの機器と計器がナレッジグラフにありません',
				UNRESOLVED_HINT: 'P&ID 上の位置や接続資産は表示できません。',
				NO_DRAWING: 'この機器を含むデジタル化済み P&ID はありません',
				NO_DRAWING_HINT: '接続資産はコンテキストグラフで確認できます。',
				SAME_LINE: '同一ライン上',
				SAME_LINE_EMPTY: '同一プロセスライン上の項目はありません。',
				CONNECTED_ON_DRAWING: '図面上の接続項目',
				CONNECTED_EMPTY: 'この図面に接続項目はありません。',
				CONNECTED_ELSEWHERE: '接続済み（この図面外）',
				LOCATE: '図面上に表示',
				ADD_TO_CHART: '{{tag}} をチャートに追加',
				NOT_LINKED: '未リンク',
				GRAPH_EMPTY: 'このアラートの接続資産は見つかりませんでした。',
				GRAPH_HINT: 'サイズ = タグ数・ヒストリアンタグのあるノードをクリックするとチャートに追加',
				ROLE: {
					ALERT_EQUIPMENT: 'アラート機器',
					ALERT_INSTRUMENT: 'アラート計器',
					CONNECTED: '接続',
					SAME_LINE: '同一プロセスライン',
					OTHER: 'その他',
				},
				EDGE: {
					FLOWS_TO: '流れ先',
					SERVES: '供給先',
					SENSES: '検知',
					CONTROLS: '制御',
					PROTECTS: '保護',
					SAME_LINE: '同一ライン',
					MEASURES: '測定',
					RELATED: '関連',
				},
				NODE_TYPE: {
					EQUIPMENT: '機器',
					INSTRUMENT: '計器',
					CONTROLVALVE: '調節弁',
					PROCESSLINE: 'プロセスライン',
				},
				TOOLTIP: {
					TAG: 'タグ',
					HISTORIAN_TAG: 'ヒストリアンタグ',
					TYPE: '種類',
					ROLE: '役割',
					TAG_COUNT: 'ヒストリアンタグ数',
					LINE: 'ライン',
					DRAWING: '図面',
				},
			},
			PAGE_TITLE: 'アラート',
			ENTERPRISE: 'Shell',
			SEARCH_PLACEHOLDER: '検索...',
			SEARCH_OWNER: '担当者を検索...',
			OWNER_FILTER: '担当者で絞り込み',
			CHOOSE_STATUSES: '表示するステータスを選択',
			ALL_STATUSES: 'すべてのステータス',
			FILTERS: '絞り込み',
			MORE: 'その他',
			WATCHERS: '監視者',
			COLLAPSE_PANEL: 'パネルを折りたたむ',
			EXPAND_PANEL: 'パネルを展開',
			RETRY: '再試行',
			CLOSE: '閉じる',
			PREVIOUS: '前のアラート',
			NEXT: '次のアラート',
			SCORE: 'スコア',
			SEE_MORE: '詳細を表示',
			SEE_LESS: '表示を減らす',
			CLASS: {
				FALSE_NO_ACTION: '誤報 – 対応不要',
				FALSE_DQ: '誤報 – データ品質 (DQ)',
				VALID_NO_ACTION: '有効 – 対応不要',
				CREATE_SERVICE: '有効 – サービス作成',
				HUMAN_REVIEW: 'SME レビュー',
				PENDING: '未判定',
			},
			CLASS_OPTION: {
				FALSE_DQ: 'False – DQ (raised on bad data: instrument or data feed)',
				HUMAN_REVIEW: 'SME レビュー（手動評価が必要）',
				CREATE_SERVICE: 'ケース作成（調査と対応を開始）',
				VALID_NO_ACTION: '有効・対応不要（イベント終了・保全依頼なし）',
				FALSE_NO_ACTION: '誤検知・対応不要（イベント終了・保全依頼なし）',
			},
			STATUS: {
				ACKNOWLEDGED: 'Acknowledged',
				UNACKNOWLEDGED: 'Unacknowledged',
				DEFECT_RAISED: 'Pending – Defect Raised',
				UNACTIONED: '未対応',
				APPROVED: '承認済み',
				RELEARNED: '再学習済み',
			},
			STATE: {
				ACTIVE: '発生中',
				RETURNED_TO_NORMAL: '正常復帰',
			},
			TELEMETRY: {
				TITLE: '時系列',
				AVAILABLE: 'あり',
				MISSING: 'なし',
				TIP_AVAILABLE: 'アラート前 24 時間に {{tag}} のヒストリアン値があります',
				TIP_NO_DATA: 'アラート前 24 時間に {{tag}} のヒストリアン値がありません',
				TIP_NOT_IN_HISTORIAN: '{{tag}} はヒストリアンに存在しません',
				TIP_NO_TAG: 'アラートにヒストリアンタグが指定されていません',
				UNUSABLE: '使用不可',
				TIP_UNKNOWN: '可用性を確認できませんでした',
			},
			TAGX: {
				THIS_EQUIPMENT: 'この設備',
				ALL_EQUIPMENT: '関連するすべての設備 ({{count}})',
				FILTER: 'フィルター',
				HISTORIAN_RESULTS: 'ヒストリアン検索',
				MODE_FUNCTION: '機能別',
				MODE_RELATION: '関係別',
				FILTER_MEASURE: '測定量で絞り込み',
				FILTER_GROUP: '機能グループで絞り込み',
				CLEAR_FILTERS: 'フィルターを解除',
				SHOW_ALL: 'すべて表示（あと {{count}} 件）',
				NO_MATCHES_FILTERED: '選択したフィルターに一致するものはありません',
				TITLE: '他のタグを表示',
				SEARCH_PLACEHOLDER: '名前または説明でタグを検索',
				MIN_CHARS: '2文字以上入力してください',
				SEARCHING: '検索中…',
				NO_MATCHES: '一致するタグがありません',
				HAS_DATA: 'ヒストリアンデータあり',
				NO_DATA: 'ヒストリアンデータなし',
				SELECTED: '{{count}} / {{max}} 選択中',
				MAX_REACHED: '選択できるタグは最大 {{max}} 件です',
				CLEAR: '選択をクリア',
				CHART_TOGETHER: 'まとめて表示',
				HIDE_CHART: 'チャートを非表示',
				IN_LIST: 'リスト内',
				VIA: '経由：{{via}}',
				GROUP_ALERT: 'アラートタグ',
				GROUP_COMPONENT: '同一コンポーネント',
				GROUP_EQUIPMENT: '同一パッケージ / 設備',
				GROUP_CONNECTED: '接続設備',
				GROUP_PID: 'P&ID 計器',
				GROUP_OTHER: 'その他の関連',
				GROUP_SEARCH: '検索から追加',
				NO_TAGS: '関連タグが見つかりません',
				LOADING: '関連タグを読み込み中…',
				FILTER_EMPTY: '「{{q}}」に一致する関連タグはありません',
			},
			QUEUE: {
				DATE_FIELD: '日付フィールドで絞り込み',
				DATE_FIELD_EVENT: '発生日時',
				DATE_FIELD_RAISED: '発報日時',
				SORT_OLDEST: '古い順（クリックで反転）',
				SORT_NEWEST: '新しい順（クリックで反転）',
				PAGE_SIZE: '1ページの行数',
				RANGE: '{{total}}件中 {{start}}–{{end}}件',
				FIRST_PAGE: '最初のページ',
				PREV_PAGE: '前のページ',
				NEXT_PAGE: '次のページ',
				LAST_PAGE: '最後のページ',
				GROUPED_PAGE_HINT: 'グループはこのページのアラートから作成されます',
				ON_THIS_PAGE: 'このページ内',
				SIGNAL_START: 'イベント開始',
				RAISED: '作成日時',
				RETURNED_TO_NORMAL_AT: '最終アクティブ（正常復帰）',
				BASELINE_REF: 'ベースライン基準',
				BASELINE_REF_TIP: '検知器のベースライン基準時刻（{{time}}）：アラート説明文中の「last recorded on …」の時刻です。発生日時ではありません。',
				NOT_ANALYSED: '未解析：{{reason}}',
				NOT_ON_PAGE: 'この再発アラートはこのページにありません。開いて詳細を確認してください。',
				COLUMNS: '列',
				RESET_COLUMNS: 'すべての列を表示',
				SET_STATUS: '選択したアラートのステータスを設定',
				CSV: {
					PROCESS_UNIT: 'プロセスユニット',
					FLOC: 'FLOC',
					POINTS: 'タグ',
					DEFINITION_ID: '定義ID',
					NUMBER: '#',
					ALERT_ID: 'アラートID',
					SYSTEM_NAME: 'システム名',
					SYSTEM: 'システム',
					STATUS: 'ステータス',
					CLASSIFICATION: '分類',
					CONFIDENCE: '確度',
					ALERT_NAME: 'アラート名',
					SOURCE: 'ソース',
					EVENT_TIME: 'イベント開始（信号開始）',
					RAISED: '作成日時',
					RETURNED_TO_NORMAL: '最終アクティブ（正常復帰）',
					BASELINE_REF: 'ベースライン基準',
					STATE: '状態',
					TIME_SERIES: '時系列',
					ANCHOR_TAG: 'アンカータグ',
					NOT_ANALYSED: '未解析（DQゲート）',
					OWNER: '担当者',
				},
				COLUMN_NUMBER: '番号',
				SORT_BY_COLUMN: 'この列で並べ替え',
				DATE_ON_EVENT: '期間はイベント開始に適用',
				DATE_ON_CREATED: '期間は作成日時（並べ替え列）に適用',
				SHOW_COLUMNS: '列を表示',
				SEARCH_COLUMNS: '検索...',
				SELECT_ALL_COLUMNS: 'すべて選択',
				RESET_DEFAULT_COLUMNS: '既定に戻す',
				RESIZE_COLUMN: 'ドラッグして幅を変更',
				STILL_ACTIVE: 'アクティブ中',
			},
			GROUP_BY: {
				TITLE: 'グループ化',
				EQUIPMENT: 'Equipment',
				NONE: 'なし',
				SYSTEM: 'システム',
				FACILITY: '施設',
				SOURCE: 'ソース',
				CLASSIFICATION: '分類',
				ALERT_STATUS: 'アラートステータス',
			},
			MENU: {
				EXPORT: 'データのエクスポート',
				COLLAPSE_GROUPS: 'すべてのグループを折りたたむ',
				EXPAND_WITHIN_GROUP: 'グループ内をすべて展開',
				AUTO_REFRESH: '自動更新',
			},
			AUTO_REFRESH: {
				OFF: 'オフ',
				LIVE: 'ライブ',
				MIN_5: '5分',
				MIN_15: '15分',
				MIN_30: '30分',
				HOUR_1: '1時間',
			},
			FILTER: {
				TITLE: '絞り込み条件',
				SEARCH_ALERT_NAME: 'アラート名で検索...',
				START_TYPING: '入力して検索',
				APPLY: '適用',
				CLEAR_ALL: 'すべてクリア',
				TARGET_ONLY: '対象 FLOC のみ',
				TARGET_TIP: '資産階層 → FLOC 階層に記載された対象 FLOC のアラートのみ',
				TARGET_COUNT: '現在のビューに {{count}} 件のアラート',
			},
			TABLE: {
				STEP: 'Step',
				STEP_HINT: 'The triage-path step that decided the alert (amber: held for SME review)',
				TYPE: 'Type',
				PLUS_TAGS: '+{{count}} タグ',
				DEFINITION_ID: '定義 ID',
				ALERTS: 'アラート',
				N_ALERTS: '{{count}}件のアラート',
				SYSTEM_NAME: 'システム名',
				STATUS: 'ステータス',
				CLASSIFICATION: '分類',
				CONFIDENCE: '確度',
				ALERT_NAME: 'アラート名',
				SOURCE: 'ソース',
				EVENT_TIME: 'イベント開始',
				STATE: '状態',
				OWNER: '担当者',
				EMPTY: '現在の条件に一致するアラートが見つかりません',
				RECURRING: '再発：このエピソードで{{count}}回発生',
				TOGGLE_RECURRING: '再発アラートを表示',
				CREATED_ON: '作成日時',
				LAST_ACTIVE: '最終アクティブ',
			},
			BULK: {
				ITEMS: '件',
				ASSIGN_OWNER: '選択したアラートに担当者を割り当て',
				CHANGE_CLASSIFICATION: '分類を変更',
				DONE: '{{count}}件のアラートを更新しました',
				PARTIAL: '{{ok}}件を更新、{{failed}}件は更新できませんでした',
			},
			ACTIONS: {
				APPROVE: '承認',
				APPROVED: '承認済み',
				RELEARN: '再学習',
				RELEARNED: '再学習済み',
				CLASSIFY: '分類',
			},
			DETECTOR: {
				POINTS_FROM_SIGNAL_TEXT: 'タグは SignalMeasurementText から取得',
				POINTS_FROM_DESCRIPTION: 'タグはアラートの説明から取得',
				PRIMARY: '主',
				TAGS_TIP: 'このアラートの対象タグ（{{count}}）:',
				TAGS_N: 'タグ（{{count}}）',
				LABEL: '検知器',
				MECHANISM: '検知方式',
				MONITORED_TAG: '監視タグ',
				CLUSTER_SIZE: 'クラスタサイズ',
				FREQUENCY: '頻度',
				WINDOW_SPAN: '期間',
				N_ALERTS: '{{count}}件',
				PER_HOUR: '{{value}}件/h',
				HOURS: '{{value}}時間',
			},
			DQ: {
				STATUS_UNUSABLE: 'Unusable',
				PENDING_DEFECT: 'Defect raised',
				PENDING_DEFECT_TIP: 'Instrument work order {{wo}}: pending',
				TITLE: 'データ品質（DQ）評価',
				FROZEN: 'フラットライン',
				IMPOSSIBLE_ROC: '変化率',
				DOMAIN_RANGE: '範囲外',
				JITTER: '不規則',
				PASS_FROZEN: '合格（変動あり）',
				PASS_IMPOSSIBLE_ROC: '合格',
				PASS_DOMAIN_RANGE: '範囲内',
				PASS_JITTER: '正常信号',
				FAIL_FROZEN: '固着',
				FAIL_IMPOSSIBLE_ROC: '不合格',
				FAIL_DOMAIN_RANGE: '範囲外',
				FAIL_JITTER: '不安定な信号',
				NOT_ASSESSED: '未評価',
				STATUS_PASS: '合格',
				STATUS_WARN: '警告',
				STATUS_FAIL: '不合格',
				STATUS_NO_DATA: 'データなし',
				STATUS_UNKNOWN: '未評価',
				NOT_ANALYSED: '未分析',
				READINGS: '測定値 {{n}} 件 · マスク {{bad}} 件',
				CHECK_INFO: '参考情報',
				NO_GATE: 'このアラートのデータ品質は評価されていません',
				SCORE: 'DQスコア: {{status}}',
			},
			AGENT: {
				NO_RUN: 'Not triaged yet',
				TIER_ACCEPTED: 'クイックトリアージ · {{pct}} で採用（{{time}} · {{tokens}} トークン）— 詳細調査は不要',
				TIER_QUICK_ONLY: 'クイックトリアージのみ · {{pct}}（{{time}} · {{tokens}} トークン）',
				TIER_ESCALATED: '詳細調査へエスカレーション：',
				TIER_QUICK_WAS: 'クイック回答：{{cls}} {{pct}}（{{time}} · {{tokens}} トークン）',
				TIER_FINAL_IS: '最終：{{cls}} {{pct}}',
				MANUAL_CHIP: 'マニュアル · {{label}}',
				TITLE: 'トリアージエージェント',
				RECOMMENDATION: '推奨事項',
				NOT_RUN: 'このアラートはまだトリアージエージェントで判定されていません。「トリアージエージェントを実行」をクリックすると自動分類します。',
				NO_RECOMMENDATION: '推奨事項は登録されていません。',
				RUN: 'トリアージエージェントを実行',
				RUNNING: '実行中…',
				RERUN: 'トリアージエージェントを再実行',
				CREATES_CASE: 'ケースを作成',
				CONFIDENCE: '確度 {{value}}',
				CAPPED: '上限適用',
				CAPPED_HINT: '一部の根拠確認が実行できなかったため、確度の上限は{{value}}です',
				VERIFIED_FACTS: '検証済み事実・計測データ',
				N_VERIFIED: '{{count}}件検証済み',
				HYPOTHESIS: '作業仮説・物理メカニズム（要因）',
				SUPPORTING_TAGS: '根拠タグ',
				FMEA: '動的FMEA',
				FAILURE_MODE: '故障モード',
				MECHANISM: '物理メカニズム',
				IMPACT: 'システムへの影響',
				REMEDIATION: '対策',
				DISCIPLINE: '担当分野',
				ACTIONABLE: '実施可能なエンジニアリング推奨事項',
				WHAT_WOULD_CHANGE: '判定が変わる条件',
				DECIDED_BY: '{{model}}による判定',
				HARNESS_VERSION: 'ハーネス {{v}}',
				STALE_RUN: "古い実行：{{date}} のハーネス更新より前の実行です。最新のエージェントを見るには再実行してください",
				DEGRADED: 'ルールによる代替判定',
				DEGRADED_HINT: '判定用LLMが利用できなかったため、決定論的ルールで判定しました。承認前に確認してください。',
			},
			DIALOG: {
				APPROVE_TITLE: 'Approve classification',
				APPROVING: 'You agree with the agent: {{x}}',
				FEEDBACK_OPTIONAL: 'Optional: anything the agent should learn from this case',
				CORRECT_FINDING: 'Correct finding',
				SELECT_FINDING: 'Select the finding…',
				MAPS_TO: 'Shown to the customer as: {{x}} (mapping in force)',
				PROPOSE_TOGGLE: 'The finding “{{x}}” is right; the customer label should be different',
				PROPOSE_HELP: 'The alert keeps its finding. An administrator sees the proposal in Settings › Labels; a mapping change relabels every alert with this finding.',
				WANTED_LABEL: 'Label the customer expects',
				PROPOSED: 'Mapping change proposed to the administrators',
				RELEARN_TITLE: '分類の再学習',
				CLASSIFY_TITLE: '分類',
				CORRECT_CLASSIFICATION: '正しい分類',
				SELECT_CLASS: '新しい分類を選択...',
				FEEDBACK: 'フィードバック',
				FEEDBACK_REQUIRED: '修正時は必須です',
				CANCEL: 'キャンセル',
				CONFIRM: '確定',
			},
			EVIDENCE: {
				GROUP: {
					SERIES: 'Time series',
					RECORDS: 'Plant records',
				},
				ALL_TAGS: 'All tags',
				ON_DRAWING: 'Picked on the drawing:',
				CONTEXT_GRAPH: 'Context graph',
				SEARCH_REPORTS: 'Search the reports (any word in any section)',
				SEARCH_MATCHES: '{{n}} report(s) match',
				CITED_HERE: 'cited',
				AXES_UNIT: 'Axis per unit',
				AXES_TAG: 'Axis per tag',
				AXES_HINT: 'Overlay y-axes: share one axis per unit, or give every tag its own',
				SOURCE_ALERT: 'Source Alert',
				SOURCE_ALERT_FROM: 'Source alert · {{source}}',
				SYSTEM_DETAILS: 'System Details',
				REASONING_NOT_IN_RUN: 'この実行には記録されていません（このセクション導入前の実行）。',
				DROP_TAGS_HINT: '「タグを表示」パネルからタグをドラッグしてチャートを追加',
				TAGS: 'タグ',
				MAINTENANCE: '保全',
				REPORTS: 'レポート',
				ALERTS: 'アラート',
				DOCUMENTS: 'ドキュメント',
				REASONING: '推論',
				REASONING_SECTION: {
					DECISION: 'Decision',
					BOARD: 'Hypothesis board',
					EVIDENCE: 'Evidence used',
					MEMORY: 'Learnings used',
					LIBRARY: 'ライブラリ',
					LIMITS: '制限値',
					REASONING: '推論',
					PLAYBOOK: 'プレイブックチェック',
					SIGNAL: '信号と機械',
					CONNECTED: '接続システム',
					ANOMALY: '異常モデル',
					RECORDS: '参照した記録',
				},
				NO_TELEMETRY: 'これらのタグのヒストリアンデータが見つかりません',
				NO_TELEMETRY_HINT: 'ヒストリアンに根拠タグのアラート期間のデータがありません。',
				NO_DATA_FOR: 'ヒストリアンデータなし',
				NOTIFICATIONS: '保全通知',
				NOTIFICATION: '保全通知',
				WORK_ORDERS: '作業指示',
				WORK_ORDER: '作業指示',
				NONE: '記録が見つかりません',
				ON_THIS_ITEM: '当該設備',
				DESCRIPTION: '説明',
				NOTIFICATION_NO: '保全通知番号',
				TYPE: '種別',
				PRIORITY: '優先度',
				RAISED_ON: '起票日',
				COMPLETED_ON: '完了日',
				FLOC: '機能場所',
				HIERARCHY_TIER: '階層レベル',
				SUPERVISOR_REPORTS: '監督者レポート',
				SHIFT_LOGS: 'シフト日誌',
				RECENT_ALERTS: '最近のアラート',
				RELATED_ALERTS: '関連アラート',
				FIRED_AT: '発報日時',
				CONTEXT: 'コンテキスト',
				SHOW_AFTER_ALERT: 'アラート後の記録を表示',
				HINDSIGHT_HINT: 'オフ：アラート発生時点で記録されていた内容のみ（エージェントが参照した状態）。オン：その後に作成された記録も表示。',
				HINDSIGHT_ON: '事後表示オン：アラート後に作成された記録を「アラート後」として表示しています。エージェントはこれらを参照していません。',
				AFTER_ALERT: 'アラート後',
				HIDDEN_AFTER_ALERT: 'アラート後に記録された {{n}} 件を非表示',
				NONE_AT_ALERT: 'アラート時点の記録はありません',
				NOT_ANALYSED: '未分析',
				NO_TIME_SERIES: '時系列データなし：{{reason}}',
				TELEMETRY_NO_DATA: 'アラート前 24 時間にアラートタグのヒストリアン値がありません',
				TELEMETRY_NOT_IN_HISTORIAN: 'アラートタグがヒストリアンに存在しません',
				TELEMETRY_NO_TAG: 'アラートに監視対象タグがありません',
				TELEMETRY_UNKNOWN: 'ヒストリアンのデータ有無が不明です',
				ADD_TAGS: 'タグを追加',
				HIDE_TAG_LIST: 'タグ一覧を隠す',
				INCLUDE_BASELINE: 'ベースライン基準を含める',
				ALERT_WINDOW: 'アラート期間',
				BASELINE_REF_AT: '検出器のベースライン基準：{{at}}',
				CHARTED_TOGETHER: 'タグをまとめて表示',
				NO_TAGS_CHARTED: 'グラフ表示中のタグはありません',
				NO_TAGS_CHARTED_HINT: 'タグ一覧で関連タグを検索または選択するとグラフに表示されます。',
				TAG_LOAD_FAILED: 'このタグを読み込めませんでした',
				OVERLAY: '重ね表示 – 実測値、単位ごとにY軸',
				OVERLAY_NORMALISED: '全タグを 1 軸に表示（Z スコア、単位が異なる）',
				STATUS_AT_ALERT: 'アラート時のステータス',
				STATUS_NOW: '現在',
				OPEN_AT_ALERT: 'アラート時オープン',
				CLOSED_AT_ALERT: 'アラート時クローズ',
				NOT_RAISED_AT_ALERT: 'アラート時は未作成',
				SCOPE_ITEM: 'この機器',
				SCOPE_PARENT: '上位',
				BREAKDOWN: '故障停止',
				NUMBER: '番号',
				EQUIPMENT: '機器',
				REPORTED_BY: '報告者',
				PLANNING_GROUP: '計画グループ',
				WORK_CENTER: '作業区',
				SYMPTOM: '症状',
				CREATED_ON: '作成日',
				SCHEDULED_START: '予定開始',
				SCHEDULED_FINISH: '予定終了',
				ESTIMATED_DURATION: '見積所要時間',
				HOURS_N: '{{n}} 時間',
				COST_ESTIMATE: '見積コスト',
				KNOWN_AT: '記録日時',
				LONG_TEXT: '詳細',
				STATUS_HISTORY: 'ステータス履歴',
				PRODUCTION_REPORTS: '生産レポート',
				DEFERMENT_REPORTS: '減産レポート',
				SUPERVISOR_REPORT: 'スーパーバイザーレポート',
				PRODUCTION_REPORT: '日次生産レポート',
				DEFERMENT_REPORT: '減産レポート',
				FULL_SCREEN: '全画面',
				EXIT_FULL_SCREEN: '全画面を終了',
				BACK_TO_DOCUMENTS: 'ドキュメントに戻る',
				DOWNLOAD: 'ダウンロード',
				HSSE: 'HSSE',
				PRODUCTION: '生産',
				HSSE_GRADE: 'HSSE 評価',
				PRODUCTION_GRADE: '生産評価',
				REPORT_DATE: 'レポート日',
				SOURCE_FILE: 'ソースファイル',
				SUMMARY: '概要',
				PRODUCTION_COMMENT: '生産コメント',
				SUPERVISOR_COMMENTS: 'スーパーバイザーコメント',
				ACTIVITIES: '作業内容',
				FORECAST: '予測・今後の予定',
				ALARMS: 'アラーム',
				DEFERMENT: '減産',
				OOS: '停止中の機器',
				IOW: 'DOW / IOW 逸脱',
				MOCS: '一時的 MOC',
				NO_REPORT_TEXT: 'レポート本文なし',
				CATEGORY: 'カテゴリ',
				MAIN_CAUSE: '主原因',
				SUB_CAUSE: '副原因',
				EQUIPMENT_SYSTEM: '機器システム',
				EQUIPMENT_TYPE: '機器タイプ',
				EVENT_START: 'イベント開始',
				EVENT_END: 'イベント終了',
				ENDED_BEFORE_ALERT: 'アラート前に終了',
				ONGOING_AT_ALERT: 'アラート時に継続中',
				RECENT_ALERTS_HINT: 'このタグ／機能場所',
				RELATED_ALERTS_HINT: '±60 分以内、同一システムを優先',
				SUB_ALERTS: 'エピソードのサブアラート',
				SUB_ALERTS_HINT: 'このエピソードにまとめられたもの',
				SAME_SYSTEM: '同一システム',
				OPEN_ALERT: 'このアラートを開く',
				NO_DOCUMENTS: 'この機器に関連付けられたドキュメントはありません',
				PID: 'P&ID',
				PAGES_N: '{{n}} ページ',
				UPDATED: '更新日',
				SOURCE: 'ソース',
				REVISION: '改訂',
				DOCUMENT_TYPE: 'ドキュメント種別',
				DOCUMENT_PREVIEW: 'ドキュメントのプレビュー',
				FILE_NAME: 'ファイル名',
				PREVIEW_UNAVAILABLE: 'プレビューを表示できません',
				PREVIEW_UNAVAILABLE_HINT: 'このドキュメントのファイルはドキュメントストアにありません。',
				SHOWING_ALL_WO: 'Showing all {{shown}} of {{total}} work orders & notifications',
				SHOWING_EVIDENCE_WO: 'Showing {{shown}} condition-evidence records (of {{total}} total)',
				SHOW_ALL_EQUIPMENT_WO: 'Show all work orders for {{equipment}}',
				CITED_IN_PATH: 'Cited',
				LINKED_WO: 'Linked WO',
				ROOT_CAUSE: 'Root Cause',
				AGENT_READ_SUMMARY: '最新の実行でエージェントは監督者レポートを{{read}}件読み、{{cited}}件を引用しました。引用されたものから読んでください。',
				ONLY_AGENT_READ: 'エージェントが読んだレポートのみ',
				AGENT_CITED: 'エージェントが引用 · {{relevance}}',
				AGENT_READ: 'エージェントが閲覧 · 引用なし',
			},
			CHART: {
				JUDGED_AT: 'Judged at (raised later)',
				NO_DATA: 'No data in the historian',
				SEPARATE: 'Separate',
				OVERLAY: 'Overlay',
				SEPARATE_HINT: 'One panel per tag, sharing the time axis',
				OVERLAY_HINT: 'All tags on one panel, one y-axis per unit',
				ALL_READINGS: '*All good readings in the window',
				INSTRUMENT_RANGE: 'Instrument range',
				MEDIAN: 'Median',
				STEADY_ONLY: '*Steady running only (shutdown and start-up excluded)',
				THRESHOLD_LIMIT: 'Threshold limit',
				TRIP_LIMIT: 'Trip limit',
				LIMIT_TRIP: 'トリップ',
				LIMIT_ALARM: 'アラーム',
				LIMIT_THRESHOLD: 'しきい値',
				LIMIT_INSTRUMENT: '計器範囲',
				LIMIT: 'リミット',
				LIMIT_NONE: 'このタグの値は読み込まれていません',
				TAG_LEGEND: 'タグ凡例',
				MASKED_HIDDEN: '{{count}} 件のマスクされた読み取り値（データ品質）を除外',
				NO_UNIT: '単位なし',
				HIGH: 'High',
				LOW: 'Low',
				AVERAGE: 'Average',
				ACTUAL: '実測値',
				BASELINE: 'ベースライン',
				SIGNAL_START: '信号開始',
				RAISED: '発報',
				RTN: '最終アクティブ',
				BASELINE_REF: 'ベースライン基準',
				NORMAL_MIN: '正常下限',
				NORMAL_MAX: '正常上限',
				MASKED: 'マスクされた測定値（DQ）',
				MASKED_HOVER: 'マスクされた測定値',
				ARTEFACT: '代替値 / データアーティファクト',
				ARTEFACT_HOVER: 'データアーティファクト（プロセス値ではありません）',
				TIME_AXIS: '時刻（{{zone}}）',
				OFF_SCALE: 'スケール外',
				MIN: '最小',
				MAX: '最大',
				RANGE_BAND: '最小〜最大',
				LOADING: 'データを読み込み中…',
				LOAD_ERROR: 'この範囲のデータを読み込めませんでした',
				NO_DATA_IN_WINDOW: 'この期間に測定値がありません',
				HISTORIAN_SPAN: 'ヒストリアンのデータ期間：{{first}}〜{{last}}',
				CLOSE: 'チャートを閉じる',
				ZOOM_HINT: 'ドラッグでズームまたはパン。追加データは自動で読み込まれます。ダブルクリックでリセット。',
				LAYOUT_STACKED: '積み重ね',
				LAYOUT_OVERLAY: '重ね合わせ',
				NORM_NONE: '生データ',
				NORM_ZSCORE: 'Zスコア',
				NORM_RANGE: '範囲に対する%',
				NORMALISED_Z: 'Zスコア（σ）',
				NORMALISED_PCT: '範囲に対する%',
				REMOVE_TAG: 'タグを削除',
				NO_TAGS: 'まとめて表示するタグを選択',
				TOGETHER_TITLE: 'まとめて表示中のタグ',
			},
			DETAIL: {
				CHANGE_STATUS: 'Change status',
				ACK_HINT: 'Approve the current classification',
				REOPEN_HINT: 'Undo the last decision',
				REOPENED: 'Alert reopened',
				TARGET_FLOC: '対象 FLOC',
				OPEN_ALERT: 'アラートを開く',
				BACK_TO_QUEUE: 'アラート一覧に戻る',
				ALERT_ANALYSIS: 'アラート分析',
				EVIDENCE: 'エビデンス',
				EVENT_TIME: 'イベント発生時刻',
				EVENT_TIME_HINT: '信号が開始した時刻（逸脱の開始）',
				RAISED: '発報時刻',
				RAISED_HINT: '監視システムがアラートを作成した時刻。エージェントはこの時点で判明していた情報のみを使用します。',
				RTN: '正常復帰',
				BASELINE_REF: 'ベースライン参照',
				BASELINE_REF_HINT: '検知器の参照時刻（ベースラインが最後に記録された時刻）であり、イベント発生時刻ではありません',
				CLASSIFICATION_HINT: '現在の分類です。別の分類を選ぶと、このアラートを分類または再学習できます。',
				CHANGE_CLASS: '分類を変更',
				CURRENT_CLASS: '現在の分類：{{value}}',
				PREVIOUSLY_APPROVED: '承認済み（以前）',
				PREVIOUSLY_RELEARNED: '再学習済み（以前）',
				HUMAN_REVIEW_REQUIRED: 'SMEレビュー — 手動評価が必要',
				NOT_CLASSIFIED: '未分類',
				AGENT_PROPOSED: 'トリアージエージェントによる提案',
				NOT_ANALYSED_HINT: 'トリアージエージェントはこのアラートを分析しません。データがアラート前のチェックを通過しませんでした。必要に応じて手動で分類してください。',
				NOT_ANALYSED_REASON: '未分析：{{reason}}',
				RUN_BLOCKED: '分析不可',
				RUN_BLOCKED_WHY: '分析しません：{{reason}}',
				RUN_GATED: '未分析',
				EVENT_START: 'イベント開始',
				CREATED_ON: '作成日時',
				LAST_ACTIVE: '最終アクティブ',
				LAST_ACTIVE_HINT: 'アラートが正常に戻った時刻（最終アクティブ）。アクティブ中は「アクティブ」',
			},
			CASE: {
				CHIP: 'ケース #{{id}}',
				CREATE: 'ケースを作成',
				MANAGE_HINT: 'フォローアップを管理するためにケースを作成',
				CREATED: 'ケース #{{id}} を作成しました',
				EXISTS: 'ケース #{{id}} はすでにこのアラートに紐付いています',
				CREATE_FAILED: 'ケースを作成できませんでした',
				BULK_CREATED: '{{count}} 件のケースを作成しました。',
			},
			RAIL: {
				LIMITS: 'Limits',
				ACTIVITY: 'アラート履歴',
				DISCUSSION: 'ディスカッション',
				TRACES: 'トレース',
				PREFERENCES: '表示設定',
				ANALYSIS: '分析とビュー',
				OTHER_TAGS: 'タグを表示',
				OTHER_TAGS_HINT: 'タグをクリックするかチャートにドラッグして「タグ」タブに追加します。',
				DOCUMENTS: 'ドキュメント',
				NO_DOCUMENTS: 'このアラートに紐付くドキュメントはありません',
				NO_DOCUMENTS_HINT: 'この設備を参照するマニュアル、P&ID、レポートはありません。',
				OPEN_IN_DOCUMENTS: '「ドキュメント」タブで表示',
				REVISION: '改訂 {{value}}',
				PID: 'P&ID',
				EXPORT_TAGS: '選択したタグを外部システムにエクスポート',
				SAVED_ANALYSIS: '保存済み分析',
				SAVED_VIEWS: '保存済みビュー',
				SAVED_DASHBOARDS: '保存済みダッシュボード',
				NOT_AVAILABLE: 'トリアージアラートではまだ利用できません',
				PREFERENCES_NOTE: '停止区間のシェーディングおよびトリップ／警報／しきい値ラインは、トリアージのチャートではまだ利用できません。',
			},
			ACTIVITY: {
				N_ACTIONS: '操作（{{count}}）',
				EMPTY: '履歴が見つかりません',
			},
			DISCUSSION: {
				N_COMMENTS: 'コメント（{{count}}）',
				EMPTY: 'コメントが見つかりません',
				PLACEHOLDER: 'コメントを入力...',
				REPLY: '返信',
				REPLY_PLACEHOLDER: '返信を入力...',
				SEND: '送信',
			},
			TRACE: {
				SEARCH: 'Search the trace (agent, finding, record id…)',
				SEARCH_MATCHES: '{{n}} agent(s) match',
				TMP_NOT_APPLIED: 'TMP行は{{component}}に登録されており、適用されていません',
				TITLE: 'エージェントパイプライントレース',
				EXPAND_ALL: 'すべて展開',
				COLLAPSE_ALL: 'すべて折りたたむ',
				COMPLETED: '完了',
				FAILED: '失敗',
				N_AGENTS: '{{count}}エージェント',
				NO_RUN: 'パイプラインの実行履歴が見つかりません',
				NO_RUN_HINT: 'トリアージエージェントを実行すると、14エージェントの処理過程を確認できます。',
				STATUS_COMPLETED: '完了',
				STATUS_NO_DATA: 'データなし',
				STATUS_FAILED: '失敗',
				STATUS_SKIPPED: 'スキップ',
				TOKENS: 'LLMトークン：入力{{input}}／出力{{output}}',
			},
			ERRORS: {
				LOAD: 'トリアージデータを読み込めませんでした',
				ACTION: '操作を完了できませんでした',
				RUN_FAILED: 'トリアージエージェントの実行に失敗しました',
			},
			TIMELINE: {
				TITLE: 'イベントタイムライン',
				N_EVENTS: '{{n}}件のイベント',
				RELATED_ALERTS: '最近・関連アラート',
				RANGE_ALL: 'すべて',
				RANGE_90D: '90日',
				RANGE_30D: '30日',
				RANGE_7D: '7日',
				RANGE_1D: '24時間',
				RESET_ZOOM: 'ズームをリセット',
				ZOOM_IN: '拡大',
				N_MORE: '他{{n}}件',
				EMPTY: 'このアラートには作業指示、通知、レポート、減産の記録がありません。',
				CLICK_TO_OPEN: 'クリックすると下に表示されます',
				MINUTES: '{{n}}分',
				HOURS: '{{n}}時間',
				DAYS: '{{n}}日',
				N_ALERTS_IN: '{{span}}以内に{{n}}件のアラート',
				N_EVENTS_IN: '{{span}}以内に{{n}}件のイベント',
				KIND_SELF: 'このアラート',
				KIND_ALERT: 'アラート',
				KIND_WORK_ORDER: '作業指示',
				KIND_NOTIFICATION: '通知',
				KIND_SUPERVISOR: '監督者レポート',
				KIND_PRODUCTION: '生産レポート',
				KIND_DEFERMENT: '減産',
			},
			CANCEL: 'Cancel',
			SAVE: 'Save',
			PATH: {
				CITE_HINT: 'Open this record on the right',
				LAST_RECORDED: 'Detector: last recorded',
				LAST_RECORDED_TIP: 'The time the detector states in its text ("last recorded on …"); its meaning depends on the detector.',
				PLAIN_PENDING: 'A plain-language explanation is being written; reopen in a moment.',
				WHY: 'Why',
				STEP: 'Decided at',
				SHOW_DATA: 'Show data',
				HIDE_DATA: 'Hide data',
				DATA: 'Data',
				DETECTOR_CROSSED: 'crossed: why the alert fired',
				DETECTOR_OWN: 'the detector\'s rule',
				DETECTOR_OWN_TIP: 'The detector\'s own threshold. Crossing it is what raised the alert, so it is not evidence for a service; only an independent engineering limit is.',
				AGENT_DECIDED: 'agent decided',
				AGENT_DECISION: 'Agent decision',
				BASELINE: 'Baseline',
				CHECK: {
					FROZEN: 'Frozen',
					IMPOSSIBLE_ROC: 'Spikes',
					DOMAIN_RANGE: 'Out of range / codes',
					JITTER: 'Jitter',
					NODE_SUBSTITUTION: 'Feed substitution',
					TRIGGER_READINGS: 'Trigger readings',
				},
				CLEAR: 'clear',
				CONF_HIGH: 'High',
				CONF_LOW: 'Low',
				CONF_MEDIUM: 'Medium',
				DECIDED_AT: 'Decided at step {{n}} · {{title}}',
				DELAY: 'Delay',
				DISAGREE: 'The first check that matched (step {{n}}) points to {{outcome}}; the agent chose {{agent}}.',
				DISAGREE_SHORT: 'differs from path',
				DISAGREE_SHORT_TIP: 'The first matching check (step {{n}}) gives another class than the agent chose',
				DQ_ROUTE_FEED: 'Route: data-feed issue for the PI / historian owner (no work order)',
				DQ_ROUTE_INSTRUMENT: 'Route: instrument work order (I&E)',
				EXPORT_PDF: 'Export as PDF',
				FIRST_MATCH_AT: 'First match at step {{n}} · {{title}}',
				HELD_AT: 'Held at step {{n}} · {{title}}',
				JUSTIFICATION_STEP: 'Agent justification · step {{n}}',
				LIMIT: 'Limit',
				LINK_CLOSE: 'Valid – No Action (link)',
				MACHINE_SENSORS: 'Sensors on the machine',
				MATCHED: 'matched',
				NEAR: 'near',
				NONE: 'none',
				NOT_RUNNING: 'Not running steadily:',
				NO_FINDING: 'No finding recorded for this check',
				NO_LIMITS: 'No engineering limit is known for this tag',
				PEAK_24H: '24 h peak',
				PILL_ABNORMAL: 'Abnormal → continue',
				PILL_DECIDED: 'Decided',
				PILL_HELD: 'Held: not enough evidence',
				PILL_MATCHED: 'Matched',
				PILL_NOT_REACHED: 'Not reached',
				PILL_NO_MATCH: 'No match → continue',
				PROCESS_TOPOLOGY: 'Process topology',
				REACHED: 'reached',
				RECOMMENDATIONS: 'Recommendations ({{n}})',
				REPLAY_NO: 'Rule did not reproduce on raw data',
				REPLAY_YES: 'Rule reproduced on raw data',
				RULE: 'Rule',
				RUN_AT: 'Run {{at}}',
				RUN_INDICATOR: 'Run indicator',
				SELECT_SENSOR: 'select a sensor to chart it',
				SME_INTERNAL: 'SME / HIL label (internal, validation only; never an agent input)',
				STEP_AGREE: 'This check is right',
				STEP_DISAGREE: 'This check is wrong',
				STEP_EVIDENCE: '{{tags}} tags, {{records}} records, {{docs}} docs',
				SUBTITLE: '{{n}} checks · select a step',
				TITLE: 'Triage path',
				TRUST: 'Status',
				UNTRUSTED: 'not trusted',
				VALUE: 'Value',
				DECISION_TITLE: 'Decision',
				RCA_TITLE: 'Decision & Triage Path',
				RCA_PANE_TITLE: 'Decision & Triage Path',
				PROPOSED_EVIDENCE_TITLE: 'Proposed Evidence',
				MINI_TITLE: '8-Step Triage Path',
				JUSTIFICATION: 'Justification',
				ORDERED_TITLE: 'Ordered 8-Step Triage Path',
				ORDERED_SUBTITLE: '7 checks in order — the first check that matches decides the outcome',
				STEP_PASSED: 'Passed',
				STEP_NOT_REACHED: 'Not Reached',
				RULE_FLAGGED: 'Rule Flagged for Tuning',
				RULE_FLAGGED_NOTICE: 'Alert approved & detector rule flagged for tuning',
				FLAG_RULE_CTA: 'Close & Flag Rule for Tuning',
				CREATE_INSTRUMENT_WO: 'Create Instrument Work Order',
				INSTRUMENT_WO_TITLE: 'Create Instrument Work Order (Data Quality Policy)',
				INSTRUMENT_WO_POLICY: 'Routed to I&E Discipline',
				INSTRUMENT_TAG: 'Instrument Tag',
				DEFECT_DESCRIPTION: 'Defect Description',
				SUBMIT_INSTRUMENT_WO: 'Create Instrument Work Order',
				INSTRUMENT_WO_CREATED: 'Instrument Work Order {{id}} raised — Status moved to Pending – Defect Raised',
				ROOTY: 'Rooty',
				ROOTY_HINT: 'Ask Rooty or open discussion on this alert',
				ASK_ROOTY_STEP: 'Ask Rooty about this step',
				STEP_COMMENT: 'Comment on this step',
				STEP_COMMENT_PLACEHOLDER: 'Add a note on this triage step…',
				PLOT_TAG_HINT: 'Plot this tag in Proposed Evidence',
				PLOT_ALL_STEP_TAGS: 'Plot all {{count}} step tags',
				OPEN_WO_HINT: 'Open this Work Order in the Work Orders tab',
				OPEN_ALERT_EVIDENCE_HINT: 'Open this alert in the Alerts tab',
				STEP3_VISUAL_TITLE: 'Machine Diagram & Operating State',
				STEP3_VISUAL_HINT: 'Click any sensor to plot it on the right',
				STEP4_VISUAL_TITLE: 'P&ID Process Flow & Event Timeline',
				STEP4_VISUAL_HINT: 'Driver and response tags are plotted on the right',
				STEP5_VISUAL_TITLE: 'Event Timeline — Cited Work Orders & Open Alerts',
				STEP5_VISUAL_HINT: 'Click a marker or chip to inspect the Work Order or Alert on the right',
				DEEP_DETAILS: 'Deep RCA Details (Verified Facts, Hypotheses & FMEA)',
			},
		},
	}
};
